import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Flex, FormControl,
  FormErrorMessage,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import i18n from '../../utils/i18n';
import { BarElement, CategoryScale, Chart as ChartJS, Filler, Legend, LegendItem, LineElement, LinearScale, PointElement, Tooltip } from "chart.js";
import annotationPlugin, { LabelPosition } from 'chartjs-plugin-annotation';
import Decimal from 'decimal.js';
import React, { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { Chart, Line } from "react-chartjs-2";
import { v4 } from 'uuid';
import { WebAPIContext } from '../../contexts/WebAPIContext';
import { useExistingLineCapacity } from '../../hooks/useExistingLineCapacity';
import { createExistingLineCapacitySectionRows, TExistingLineCapacitySource, TExistingLineCapacityVersion } from '../../utils/existingLineCapacityChart';
import { ExistingLineCapacityPanel } from './ExistingLineCapacityPanel';
import ConfirmDialog from '../../components/ConfirmDialog';
import ReadOnlyExemptButton from '../../components/ReadOnlyExemptButton';
import {
  CurrencyNameJPY,
  CustomerIndustry,
  DownsideItems,
  DownsideItemsTitle,
  Messages,
  ProfitAndLossItems,
  ProfitRateChartYAxisMax,
  ProfitRateChartYAxisMin,
  PurposeType,
  WorkflowId,
  getCustomerIndustryTypeNameByCode,
  EquipmentUsageType,
  RecoverySimulationItems,
  isSimpleApplicationForm,
  isProfitLossHidden,
  FlowKb,
} from '../../contexts/constants';
import {
  BomData,
  ConfirmorInfo,
  Currency,
  CycleTimeImprovement,
  DevelopmentMonthCostTable,
  DownsideIndex,
  DownsideIndexEnableType,
  DownsideIndexType,
  EquipmentExtType,
  EquipmentType,
  Errors,
  LaborCostScenario,
  MoldMonthTable,
  MonthData,
  MonthPriceData,
  MonthlyExpenseData,
  MonthlyProfitAndLossData,
  NonWorkingHoursType,
  OriginalProfitAndLossByMonthTable,
  PagePermissions,
  PartNo,
  PricingAgreementFormType,
  ProductionLineType,
  ProjectContextType,
  ProjectWithRdsData,
  QuantityAndPriceMonthTable,
  RationalizationProfitLossItem,
  RationalizationProfitLossItemType,
  RationalizationSummaryInputData,
  SalesByPartNo,
  SavedSimulationConfig,
  TScenario,
  UniqueProcessType,
  UpdateSummaryInputData,
  WorkingDaysType,
  YearData,
  YearPriceData,
  YieldRateImprovement,
  competitiorCondition,
  competitorType
} from '../../contexts/types';

import {
  calcEquipmentQuantity,
  calcProfitRate,
  isSameFiscalYear
} from "../../utils/calculation";
import { getBilingualDisplayName } from "../../utils/i18nDisplay";

import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';
import Draggable from "react-draggable";
import { useAppSelector } from "../../store/hooks";
import { convertCurrency, convertChartDatasets } from '../../utils/CurrencyConverter';
import type { ConvertFn } from '../../utils/reviewCalculation';
import { convertCurrencyByMonth } from '../../utils/reviewCalculation';
import { calcMonthsBetweenDates, convertEquipmentData, getMaterialCostByPartNoByMonth, calcEquipmentDepreciationByYearMonth, getTotalFiscalYearsByPartNo, calcTotalCycleTimeByMonth, applyBaseUpRateToLaborCost, getQuantitiesByPartNoMonth, calcTotalQuantityByMonth, calcCycleTimeBasedCost, applyScenarioLaborCostToProjectData, getFiscalYearsByProjectDates, calcRecoverySimulation, calcAggregateCapexByMonth, calcCapexAmountByMonth, } from "../../utils/calculation";
import { formatNumber, formatRecoveryMonths, hasDecimal, getLocalCurrencyId, getLocationCountry, formatYearMonthByLocale, splitEscapedList, resolveChartDatasetLabels } from '../../utils/utils';
import { findMissingPastPartNos } from '../../utils/partNoConsistency';
import { getConfirmor, updateConfirm } from "../../utils/workflow";
import '../common.css';
import ConfirmorList from "./ConfirmorList";
import SalesDataLinkage from "./TabPanels/SalesDataLinkage";
import { FactorDef } from "./TabPanels/types";
import EquipmentPersonnelChangeSection from "./EquipmentPersonnelChangeSection";
import PhasedEquipmentInvestmentSection from "./PhasedEquipmentInvestmentSection";
import ProductionFactoryCostSection from "./ProductionFactoryCostSection";

// コンテキスト
import { FaPlusCircle } from "react-icons/fa";
import { FaCircleMinus } from "react-icons/fa6";
import NonWorkingHours from "./NonWorkingHours";
import WorkingDays from "./WorkingDays";
import { calcMaterialCost, calcMergedChartDataSet, calcDownsideCombinedChartDataSet, calcDownsideSalesChartDataSet, calcMonthlyProfitAndLossDetails, calcOriginalCombinedChartDataSet, calcOriginalSalesChartDataSet, calcQuantitiesChartDataSet, calcTotalProfitAndRate, calcYearlyRoundedProfitTotal, calcMonthlyProfitInDisplayCurrency, calcYAxisRange, computeCommonScaleSalesChart, generateAnnotationStarLabels, generateRecoveryPointAnnotationOptions, getDownsideIndexToQuantity, calcRealProfitRate, calcRealProfitRateByMonth, calcRealProfitRateCommon, restoreEquipmentAmounts } from "../../utils/chartDataCalculation";
import * as XLSX from "xlsx";
import GoogleAPI, { GoogleAPIBatchCollector } from '../../utils/GoogleAPI';
import HelpIcon from "./HelpIcon";

// SpreadSheet同期用カスタムフック
import {
  workingDaysToSpreadSheetData,
  spreadSheetDataToWorkingDays,
  nonWorkingHoursToSpreadSheetData,
  spreadSheetDataToNonWorkingHours,
  equipmentStaffingToSpreadSheetData,
  spreadSheetDataToEquipmentStaffing,
  setupEquipmentStaffingSheet,
  phasedCapitalInvestmentToSpreadSheetData,
  spreadSheetDataToPhasedCapitalInvestment,
  setupPhasedCapitalInvestmentSheet,
  yieldImprovementToSpreadSheetData,
  spreadSheetDataToYieldImprovement,
  setupYieldImprovementSheet,
  cycleTimeReductionToSpreadSheetData,
  spreadSheetDataToCycleTimeReduction,
  setupCycleTimeReductionSheet,
  laborCostToSpreadSheetData,
  spreadSheetDataToLaborCost,
  setupLaborCostSheet,
  SHEET_NAME_EQUIPMENT_STAFFING,
  SHEET_NAME_PHASED_CAPITAL_INVESTMENT,
  SHEET_NAME_OPERATING_DAYS,
  SHEET_NAME_DOWNTIME,
  SHEET_NAME_YIELD_IMPROVEMENT,
  SHEET_NAME_CYCLE_TIME_REDUCTION,
  SHEET_NAME_LABOR_COST,
  type WorkingDaysYearData,
  type NonWorkingHoursYearData,
} from '../../hooks';
import { ProjectContext, getPermissions } from "./InvestmentScreeningDetail";
import { fetchProcess } from "./ProcessFlow";
import YieldImprovementRow from "./YieldImprovementRow";
import CycleTimeImprovementRow from "./CycleTimeImprovementRow";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, BarElement, annotationPlugin, Tooltip, Legend, Filler);

/**
 * 条件テーブル
 */
interface ConditionTable {

  /** 顧客業界(コード) */
  customerIndustry: string,

  /** 顧客業界(名称) */
  customerIndustryName: string,

  /** 顧客国籍 */
  customerNationality: string,

  /** 顧客名 */
  customerName: string,

  /** エンドユーザ名 */
  endUserName: string,

  /** 工場為替 */
  factoryExchange?: Currency,

  /** 販売為替 */
  salesExchange?: Currency,

  /** 工場拠点国 */
  factoryLocationCountry: string[],

}

/**
 * ストレス指数(画面表示用)
 */
interface DownsideIndexDisplay {

  /** 数量経時変化(画面表示用) */
  quantityChangeOverTimeString: string,

  /** 数量上下変動(画面表示用) */
  fluctuationInQuantityString: string,

  /** 単価経時変化(画面表示用) */
  priceChangeOverTimeString: string,

  /** 顧客製品寿命(画面表示用) */
  customerProductLifecycleString: string,

  /** 為替変動(画面表示用) */
  currencyFluctuationString: string,

  /** 材料高騰(画面表示用) */
  risingMaterialCostsString: string,

  /** 労務費高騰(画面表示用) */
  risingLaborCostsString: string,

  /** 競合状態(画面表示用) */
  competitorConditionString: string,

}

/**
 * ストレス指数(表)(画面表示用)
 */
interface DownsideIndexTableRowDisplay {

  /** 年(画面表示用) */
  yearString: string,
  /** 年index(更新用) */
  yearIndex: number,

  /** 数量経時変化(画面表示用) */
  quantityChangeOverTimeString: string,
  quantityChangeOverTimeId: string,
  quantityChangeOverTime: number,

  /** 数量上下変動(画面表示用) */
  fluctuationInQuantityString: string,
  fluctuationInQuantityId: string,
  fluctuationInQuantity: number,

  /** 単価経時変化(画面表示用) */
  priceChangeOverTimeString: string,
  priceChangeOverTimeId: string,
  priceChangeOverTime: number,

  /** 顧客製品寿命(画面表示用) */
  customerProductLifecycleString: string,
  customerProductLifecycleId: string,
  customerProductLifecycle: number,

  /** 為替変動（単価）(画面表示用) */
  currencyFluctuationToPriceString: string,
  currencyFluctuationToPriceId: string,
  currencyFluctuationToPrice: number,

  /** 為替変動（原価）(画面表示用) */
  currencyFluctuationToCostString: string,
  currencyFluctuationToCostId: string,
  currencyFluctuationToCost: number,

  /** 材料高騰(画面表示用) */
  risingMaterialCostsString: string,
  risingMaterialCostsId: string,
  risingMaterialCosts: number,

  /** 労務費高騰(画面表示用) */
  risingLaborCostsString: string,
  risingLaborCostsId: string,
  risingLaborCosts: number,

  /** 競合状態（数量）(画面表示用) */
  competitorConditionToQuantityString: string,
  competitorConditionToQuantityStringPre: string,
  competitorConditionToQuantityId: string,
  competitorConditionToQuantity: number,

  /** 競合状態（単価）(画面表示用) */
  competitorConditionToPriceString: string,
  competitorConditionToPriceStringPre: string,
  competitorConditionToPriceId: string,
  competitorConditionToPrice: number,
}

/**
 * ストレス指数(有効・無効)
 */
interface DownsideIndexEnable {
  /** 数量経時変化(有効/無効) */
  isEnabledQuantityChangeOverTime: boolean,

  /** 数量上下変動(有効/無効) */
  isEnabledFluctuationInQuantity: boolean,

  /** 単価経時変化(有効/無効) */
  isEnabledPriceChangeOverTime: boolean,

  /** 顧客製品寿命(有効/無効) */
  isEnabledCustomerProductLifecycle: boolean,

  /** 為替変動（単価）(有効/無効) */
  isEnabledCurrencyFluctuationToPrice: boolean,

  /** 為替変動（原価）(有効/無効) */
  isEnabledCurrencyFluctuationToCost: boolean,

  /** 材料高騰(有効/無効) */
  isEnabledRisingMaterialCosts: boolean,

  /** 労務費高騰(有効/無効) */
  isEnabledRisingLaborCosts: boolean,

  /** 競合状態（数量）(有効/無効) */
  isEnabledCompetitorConditionToQuantity: boolean,

  /** 競合状態（単価）(有効/無効) */
  isEnabledCompetitorConditionToPrice: boolean
}

/**
 * Simulation（生産性向上）パラメータ
 */
interface SimulationProductivityImprovementProps {
  /** プロジェクトID */
  projectId: string;
  /** 月別レートMap（振り返りモード用） */
  monthlyRateMap?: Map<string, Currency[]>;
  /** 親から渡される初期目的（projectData取得前の判定用） */
  initialPurpose?: string;
  /** 親から渡される初期申請書様式（projectData取得前の判定用） */
  initialApplicationFormType?: string;
  /** 親から渡される初期損益表示区分（projectData取得前の判定用） */
  initialProfitLossDisplayType?: string;
}

/**
 * 確認担当者
 */
interface Confirmor {
  simulationProductivityImprovement?: {
    companyDivision?: string[];
    companyHeadDivision?: string[];
  };
}

/**
 * 数量・単価データを指定した年月を起点として切り出す
 * @param targetData QuantityAndPriceMonthTable型のJSONパース済みデータ
 * @param projectStartDate 量産開始日(プロジェクト開始日)（例: "2025/02" or "2025-02-01"）
 * @param newStartYearMonth 切り出し開始年月（例: "2028/04"）
 * @returns 切り出し後の数量・単価データ（新しい1年目からのデータ）
 *   ※years[0]=1はprojectStartDateが属する年度（4月始まり）を表す
 *   例: projectStartDate=2025/02 → years[0]=1は2024/04～2025/03
 */
const sliceQuantityAndPriceByStartYearMonth = (
  targetData: QuantityAndPriceMonthTable,
  projectStartDate: string,
  newStartYearMonth: string
): QuantityAndPriceMonthTable | null => {
  if (!targetData || !projectStartDate || !newStartYearMonth) {
    return null;
  }

  // 量産開始日から年月を取得（例: "2025/02" → 年=2025, 月=2）
  const [startYear, startMonth] = projectStartDate.split(/[-\/]/).map(v => Number(v));

  // 量産開始日が属する年度の開始年を計算（4月始まり）
  const fiscalStartYear = startMonth >= 4 ? startYear : startYear - 1;

  // 切り出し開始年月から年月を取得（例: "2028/04"）
  const [targetYear, targetMonth] = newStartYearMonth.split(/[-\/]/).map(v => Number(v));

  // 切り出し開始年月が属する年度の開始年を計算
  const targetFiscalStartYear = targetMonth >= 4 ? targetYear : targetYear - 1;

  // 年度の差を計算（何年目から切り出すか）
  // 例: fiscalStartYear=2024, targetFiscalStartYear=2028 → 差=4 → startYearKey=5
  const yearDiff = targetFiscalStartYear - fiscalStartYear;
  const startYearKey = yearDiff + 1; // 1-indexed

  // 年度内の月オフセットを計算（4月=0, 5月=1, ..., 3月=11）
  // 例: targetMonth=4 → monthWithinYear=0（年度の最初の月）
  // 例: targetMonth=7 → monthWithinYear=3
  const monthWithinYear = targetMonth >= 4 ? targetMonth - 4 : targetMonth + 8;

  // 元データ
  const originalData = targetData.data;

  // 新しいyearsとdataを構築
  const newYears: number[] = [];
  const newData: { [key: number]: YearData } = {};
  let newYearIndex = 1;

  // 元データの年数
  const maxYear = Math.max(...targetData.years);

  for (let i = startYearKey; i <= maxYear; i++) {
    if (originalData[i]) {
      newYears.push(newYearIndex);

      // 最初の年で月オフセットがある場合、該当月以前のデータを0にする
      if (i === startYearKey && monthWithinYear > 0) {
        const monthsData = originalData[i].months;
        const newMonths: { [key: number]: MonthData } = {};

        // 全月分のデータを作成
        for (let m = 1; m <= 12; m++) {
          if (monthsData[m]) {
            if (m <= monthWithinYear) {
              // 開始月より前の月はquantityとpriceを0にする
              newMonths[m] = {
                month: monthsData[m].month,
                quantity: 0,
                price: 0
              };
            } else {
              // 開始月以降はそのままコピー
              newMonths[m] = { ...monthsData[m] };
            }
          }
        }

        // 年間の数量・単価・売上を再計算
        let totalQuantity = 0;
        let totalSalesPrice = 0;
        Object.values(newMonths).forEach(m => {
          totalQuantity += m.quantity;
          totalSalesPrice += m.quantity * m.price;
        });

        newData[newYearIndex] = {
          quantity: totalQuantity,
          unitPrice: totalQuantity > 0 ? totalSalesPrice / totalQuantity : 0,
          salesPrice: totalSalesPrice,
          months: newMonths
        };
      } else {
        // そのままコピー
        newData[newYearIndex] = JSON.parse(JSON.stringify(originalData[i]));
      }

      newYearIndex++;
    }
  }

  return {
    ...targetData,
    years: newYears,
    data: newData
  };
};

/**
 * MoldMonthTableデータをincreasedProductionStartYearMonthを起点として切り出す
 * @param targetData MoldMonthTable型のデータ
 * @param projectStartDate プロジェクト開始日（例: "2025/02"）
 *   ※years[0]=1はprojectStartDateが属する年度（4月始まり）を表す
 * @param newStartYearMonth 増産投資量産開始年月
 * @returns 切り出し後のMoldMonthTableデータ
 */
const sliceMoldTableByStartYearMonth = (
  targetData: MoldMonthTable,
  projectStartDate: string,
  newStartYearMonth: string
): MoldMonthTable | null => {
  if (!targetData || !projectStartDate || !newStartYearMonth) {
    return null;
  }

  // 量産開始日から年月を取得（例: "2025/02" → 年=2025, 月=2）
  const [startYear, startMonth] = projectStartDate.split(/[-\/]/).map(v => Number(v));

  // 量産開始日が属する年度の開始年を計算（4月始まり）
  const fiscalStartYear = startMonth >= 4 ? startYear : startYear - 1;

  // 切り出し開始年月から年月を取得（例: "2028/04"）
  const [targetYear, targetMonth] = newStartYearMonth.split(/[-\/]/).map(v => Number(v));

  // 切り出し開始年月が属する年度の開始年を計算
  const targetFiscalStartYear = targetMonth >= 4 ? targetYear : targetYear - 1;

  // 年度の差を計算（何年目から切り出すか）
  const yearDiff = targetFiscalStartYear - fiscalStartYear;
  const startYearKey = yearDiff + 1; // 1-indexed

  // 年度内の月オフセットを計算（4月=0, 5月=1, ..., 3月=11）
  const monthWithinYear = targetMonth >= 4 ? targetMonth - 4 : targetMonth + 8;

  // 元データ
  const originalData = targetData.data;

  // 新しいyearsとdataを構築
  const newYears: number[] = [];
  const newData: { [key: number]: YearPriceData } = {};
  let newYearIndex = 1;

  // 元データの年数
  const maxYear = Math.max(...targetData.years);

  for (let i = startYearKey; i <= maxYear; i++) {
    if (originalData[i]) {
      newYears.push(newYearIndex);

      // 最初の年で月オフセットがある場合、該当月以前のデータを0にする
      if (i === startYearKey && monthWithinYear > 0) {
        const monthsData = originalData[i].months;
        const newMonths: { [key: number]: MonthPriceData } = {};

        for (let m = 1; m <= 12; m++) {
          if (monthsData[m]) {
            if (m <= monthWithinYear) {
              newMonths[m] = {
                month: monthsData[m].month,
                price: 0
              };
            } else {
              newMonths[m] = { ...monthsData[m] };
            }
          }
        }

        // 年間の金額を再計算
        let totalPrice = 0;
        Object.values(newMonths).forEach(m => {
          totalPrice += m.price;
        });

        newData[newYearIndex] = {
          price: totalPrice,
          months: newMonths
        };
      } else {
        newData[newYearIndex] = JSON.parse(JSON.stringify(originalData[i]));
      }

      newYearIndex++;
    }
  }

  return {
    ...targetData,
    years: newYears,
    data: newData
  };
};

/**
 * DevelopmentMonthCostTableデータをincreasedProductionStartYearMonthを起点として切り出す
 * @param targetData DevelopmentMonthCostTable型のデータ
 * @param projectStartDate プロジェクト開始日（例: "2025/02"）
 *   ※years[0]=1はprojectStartDateが属する年度（4月始まり）を表す
 * @param newStartYearMonth 増産投資量産開始年月
 * @returns 切り出し後のDevelopmentMonthCostTableデータ
 */
const sliceDevelopmentTableByStartYearMonth = (
  targetData: DevelopmentMonthCostTable,
  projectStartDate: string,
  newStartYearMonth: string
): DevelopmentMonthCostTable | null => {
  if (!targetData || !projectStartDate || !newStartYearMonth) {
    return null;
  }

  // 量産開始日から年月を取得（例: "2025/02" → 年=2025, 月=2）
  const [startYear, startMonth] = projectStartDate.split(/[-\/]/).map(v => Number(v));

  // 量産開始日が属する年度の開始年を計算（4月始まり）
  const fiscalStartYear = startMonth >= 4 ? startYear : startYear - 1;

  // 切り出し開始年月から年月を取得（例: "2028/04"）
  const [targetYear, targetMonth] = newStartYearMonth.split(/[-\/]/).map(v => Number(v));

  // 切り出し開始年月が属する年度の開始年を計算
  const targetFiscalStartYear = targetMonth >= 4 ? targetYear : targetYear - 1;

  // 年度の差を計算（何年目から切り出すか）
  const yearDiff = targetFiscalStartYear - fiscalStartYear;
  const startYearKey = yearDiff + 1; // 1-indexed

  // 年度内の月オフセットを計算（4月=0, 5月=1, ..., 3月=11）
  const monthWithinYear = targetMonth >= 4 ? targetMonth - 4 : targetMonth + 8;

  // 元データ
  const originalData = targetData.data;

  // 新しいyearsとdataを構築
  const newYears: number[] = [];
  const newData: { [key: number]: YearPriceData } = {};
  let newYearIndex = 1;

  // 元データの年数
  const maxYear = Math.max(...targetData.years);

  for (let i = startYearKey; i <= maxYear; i++) {
    if (originalData[i]) {
      newYears.push(newYearIndex);

      // 最初の年で月オフセットがある場合、該当月以前のデータを0にする
      if (i === startYearKey && monthWithinYear > 0) {
        const monthsData = originalData[i].months;
        const newMonths: { [key: number]: MonthPriceData } = {};

        for (let m = 1; m <= 12; m++) {
          if (monthsData[m]) {
            if (m <= monthWithinYear) {
              newMonths[m] = {
                month: monthsData[m].month,
                price: 0
              };
            } else {
              newMonths[m] = { ...monthsData[m] };
            }
          }
        }

        // 年間の金額を再計算
        let totalPrice = 0;
        Object.values(newMonths).forEach(m => {
          totalPrice += m.price;
        });

        newData[newYearIndex] = {
          price: totalPrice,
          months: newMonths
        };
      } else {
        newData[newYearIndex] = JSON.parse(JSON.stringify(originalData[i]));
      }

      newYearIndex++;
    }
  }

  return {
    ...targetData,
    years: newYears,
    data: newData
  };
};

/**
 * PartNoのquantityAndPrice、moldSalesByPartNo、developmentSalesByPartNoを
 * increasedProductionStartYearMonthを起点として切り出す
 * @param partNo PartNo型のデータ
 * @param projectStartDate プロジェクト開始日（年度の起点）
 * @param increasedProductionStartYearMonth 増産投資量産開始年月
 * @returns 切り出し後のPartNoデータ（元のオブジェクトを変更せず、新しいオブジェクトを返す）
 */
const slicePartNoDataByStartYearMonth = (
  partNo: PartNo,
  projectStartDate: string,
  increasedProductionStartYearMonth: string
): PartNo => {
  const result = { ...partNo };

  // quantityAndPriceの切り出し
  if (partNo.quantityAndPrice) {
    try {
      const qapData: QuantityAndPriceMonthTable = JSON.parse(partNo.quantityAndPrice);
      const slicedQap = sliceQuantityAndPriceByStartYearMonth(qapData, projectStartDate, increasedProductionStartYearMonth);
      if (slicedQap) {
        result.quantityAndPrice = JSON.stringify(slicedQap);
      }
    } catch (error) {
      console.error("Failed to parse/slice quantityAndPrice:", error);
    }
  }

  // moldSalesByPartNoの切り出し
  if (partNo.moldSalesByPartNo) {
    try {
      const moldData: MoldMonthTable[] = JSON.parse(partNo.moldSalesByPartNo);
      if (Array.isArray(moldData)) {
        const slicedMoldData = moldData.map(mold => {
          const sliced = sliceMoldTableByStartYearMonth(mold, projectStartDate, increasedProductionStartYearMonth);
          return sliced || mold;
        });
        result.moldSalesByPartNo = JSON.stringify(slicedMoldData);
      }
    } catch (error) {
      console.error("Failed to parse/slice moldSalesByPartNo:", error);
    }
  }

  // developmentSalesByPartNoの切り出し
  if (partNo.developmentSalesByPartNo) {
    try {
      const devData: DevelopmentMonthCostTable[] = JSON.parse(partNo.developmentSalesByPartNo);
      if (Array.isArray(devData)) {
        const slicedDevData = devData.map(dev => {
          const sliced = sliceDevelopmentTableByStartYearMonth(dev, projectStartDate, increasedProductionStartYearMonth);
          return sliced || dev;
        });
        result.developmentSalesByPartNo = JSON.stringify(slicedDevData);
      }
    } catch (error) {
      console.error("Failed to parse/slice developmentSalesByPartNo:", error);
    }
  }

  return result;
};

/**
 * 投資分回収チャートのラベルを取得
 * @param purpose 目的コード
 * @param suffix サフィックス（"当初計画" または "ダウンサイド"）
 * @returns 投資分回収チャートのラベル
 */
const getInvestmentRecoveryLabel = (purpose: string | null | undefined, suffix: string): string => {
  if (purpose === PurposeType.IncreasedProduction.code) {
    return i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.chart.increaseProductionRecovery', { suffix });
  } else if (purpose === PurposeType.Rationalization.code) {
    return i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.chart.rationalizationRecovery', { suffix });
  } else {
    return i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.chart.updateRecovery', { suffix });
  }
};

/**
 * 生産能力（プロセス）チャートの前/後ラベルを取得
 * @param purpose 目的コード
 * @param isBefore 更新前/合理化前かどうか
 * @param isDownside ダウンサイドかどうか
 * @returns 生産能力チャートのラベル
 */
const getProcessCapacityLabel = (purpose: string | null | undefined, isBefore: boolean, isDownside: boolean): string => {
  const prefix = purpose === PurposeType.Rationalization.code
    ? (isBefore ? i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationBefore') : i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationAfter'))
    : (isBefore ? i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateBefore') : i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateAfter'));
  return isDownside ? `${prefix}${i18n.t('features.InvestmentScreening.SimulationProductivityImprovement.label.downsideSuffix')}` : prefix;
};

/** テキストエリアのref型定義 */
interface TextareaHandle {
  getValue: () => string | null;
  setValue: (value: string | null) => void;
}

/** ダウンサイドリスク対応テキストエリア（親の再レンダリングから隔離） */
const DownsideRiskTextarea = forwardRef<TextareaHandle, {
  initialValue?: string | null;
  /** 入力値変更時に親へ通知するコールバック（親のドラフトref更新用） */
  onValueChange?: (value: string) => void;
}>(
  ({ initialValue, onValueChange }, ref) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string | null>(initialValue ?? null);

    useImperativeHandle(ref, () => ({
      getValue: () => value,
      setValue: (v: string | null) => setValue(v),
    }));

    return (
      <Box mt={4}>
        <Heading size="md" mb={2}>
          {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downsideRiskMeasures')}
        </Heading>
        <Textarea
          value={value ?? ""}
          onChange={(e) => {
            setValue(e.target.value);
            onValueChange?.(e.target.value);
          }}
          width="70%"
        />
      </Box>
    );
  }
);

/** 最終的な投資判断の理由テキストエリア（親の再レンダリングから隔離） */
const FinalInvestmentReasonTextarea = forwardRef<TextareaHandle, {
  initialValue?: string | null;
  /** 入力値変更時に親へ通知するコールバック（親のドラフトref更新用） */
  onValueChange?: (value: string) => void;
  error: { isError: boolean; errorMessage: string };
}>(
  ({ initialValue, onValueChange, error }, ref) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<string | null>(initialValue ?? null);

    useImperativeHandle(ref, () => ({
      getValue: () => value,
      setValue: (v: string | null) => setValue(v),
    }));

    return (
      <FormControl mt={2} isInvalid={error.isError}>
        <Box mt={4}>
          <VStack spacing={4} align="stretch">
            <Heading size="md" mb={2}>
              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.finalInvestmentReason')}
            </Heading>
            <Box display="flex" justifyContent="flex-start">
              <Textarea
                name="finalInvestmentReason"
                value={value ?? ""}
                onChange={(e) => {
                  setValue(e.target.value);
                  onValueChange?.(e.target.value);
                }}
                placeholder={t('features.InvestmentScreening.SimulationProductivityImprovement.placeholder.finalInvestmentReason')}
                width="88%"
                isInvalid={error.isError}
              />
            </Box>
            <FormErrorMessage mt={0}>{error.errorMessage}</FormErrorMessage>
          </VStack>
        </Box>
      </FormControl>
    );
  }
);

/**
 * 新規投資申請画面(Simulation（生産性向上）)
 */
const SimulationProductivityImprovement: React.FC<SimulationProductivityImprovementProps> = ({ projectId, monthlyRateMap = new Map(), initialPurpose, initialApplicationFormType, initialProfitLossDisplayType }) => {

  /** トースト表示用 */
  const toast = useToast();

  /** 通信オブジェクト */
  const WebAPI = useContext(WebAPIContext);

  /** ログインユーザー：従業員ID */
  const employeeId = useAppSelector((state) => state.employee.employeeId);

  /** ログインユーザー：部署ID */
  const divisionId = useAppSelector((state) => state.employee.divisionId);

  const { t, i18n } = useTranslation();

  /** 画面タイトル */
  const TITLE = t('features.InvestmentScreening.SimulationProductivityImprovement.title');

  /** i18n: validation.registerFrom */

  /** ストレス指数ポップアップ本体幅 */
  // 多言語対応: 英語は「Competitor Status」列見出しが長くなるため、
  // 列幅・テーブル幅・ポップアップ幅を言語に応じて広げ、モーダルからの
  // はみ出し（突き抜け）を防ぐ
  const DOWNSIDE_INDEX_POPUP_WIDTH = i18n.language === "en" ? 1868 : 1768;

  /** ストレス指数ポップアップ本体幅 */
  const DOWNSIDE_INDEX_TABLE_WIDTH = i18n.language === "en" ? "1810px" : "1730px";

  /** ストレス指数列幅 */
  const DOWNSIDE_INDEX_COLUMN_WIDTH = "130px";

  /** サイクルタイムの最大値 */
  const CYCLE_TIME_MAX = 9999;

  /** アノテーション位置 */
  const positions: LabelPosition[] = ["start", "center", "end"];

  /** 設備入力用ヘッダスタイル */
  const equipmentHeaderStyle = {
    fontSize: "16px",
  };

  /** 設備入力用ヘッダスタイル */
  const equipmentBodyStyle = {
    padding: "7px",
  };

  // 精度を50桁に設定
  Decimal.set({ precision: 50 });

  // #region TODO AI分析

  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  const [adjustedOrders, setAdjustedOrders] = useState<number[]>([]); // 月ごとの受注数量データ
  const [productionCapacityData, setProductionCapacityData] = useState<number[]>([]); // 月ごとの生産キャパデータ

  // #endregion

  /** 条件テーブル */
  const [conditionTable, setConditionTable] = useState<ConditionTable>();

  /** ストレス指数 */
  const [downsideIndex, setDownsideIndex] = useState<DownsideIndex>({

    /** 数量経時変化 */
    quantityChangeOverTime: [],

    /** 数量上下変動 */
    quantityFluctuation: [],

    /** 単価経時変化 */
    priceChangeOverTime: [],

    /** 顧客製品寿命 */
    customerProductLifecycle: 0,

    /** 為替変動（単価） */
    exchangeRateFluctuationToPrice: [],

    /** 為替変動（原価） */
    exchangeRateFluctuationToCost: [],

    /** 材料高騰 */
    materialCostIncrease: [],

    /** 労務費高騰 */
    laborCostIncrease: [],

    /** 競合状態（数量） */
    competitorStatusToQuantity: [],

    /** 競合状態（単価） */
    competitorStatusToPrice: [],

  });

  /** ストレス指数（リセット用） */
  const [downsideIndexForReset, setDownsideIndexForReset] = useState<DownsideIndex>({
    quantityChangeOverTime: [],
    quantityFluctuation: [],
    priceChangeOverTime: [],
    customerProductLifecycle: 0,
    exchangeRateFluctuationToPrice: [],
    exchangeRateFluctuationToCost: [],
    materialCostIncrease: [],
    laborCostIncrease: [],
    competitorStatusToQuantity: [],
    competitorStatusToPrice: []
  });

  /** ストレス指数（有効・無効）（リセット用） */
  const [downsideIndexEnableForReset, setDownsideIndexEnableForReset] = useState<DownsideIndexEnable>({
    // 数量経時変化
    isEnabledQuantityChangeOverTime: true,
    // 数量上下変動
    isEnabledFluctuationInQuantity: true,
    // 単価経時変化
    isEnabledPriceChangeOverTime: true,
    // 顧客製品寿命
    isEnabledCustomerProductLifecycle: true,
    // 為替変動（単価）
    isEnabledCurrencyFluctuationToPrice: true,
    // 為替変動（原価）
    isEnabledCurrencyFluctuationToCost: true,
    // 材料高騰
    isEnabledRisingMaterialCosts: true,
    // 労務費高騰
    isEnabledRisingLaborCosts: true,
    // 競合状態（数量）
    isEnabledCompetitorConditionToQuantity: true,
    // 競合状態（単価）
    isEnabledCompetitorConditionToPrice: true
  });

  /** ストレス指数（グラフ用） */
  const [downsideIndexGraph, setDownsideIndexGraph] = useState<DownsideIndex>({

    /** 数量経時変化 */
    quantityChangeOverTime: [],

    /** 数量上下変動 */
    quantityFluctuation: [],

    /** 単価経時変化 */
    priceChangeOverTime: [],

    /** 顧客製品寿命 */
    customerProductLifecycle: 0,

    /** 為替変動（単価） */
    exchangeRateFluctuationToPrice: [],

    /** 為替変動（原価） */
    exchangeRateFluctuationToCost: [],

    /** 材料高騰 */
    materialCostIncrease: [],

    /** 労務費高騰 */
    laborCostIncrease: [],

    /** 競合状態（数量） */
    competitorStatusToQuantity: [],

    /** 競合状態（単価） */
    competitorStatusToPrice: [],

  });

  // ストレス反映トグルの入力状態（設定タブ用）
  const [applyDownsideInput, setApplyDownsideInput] = useState<boolean>(true);

  // ストレスOFF時に使用する全値ゼロのダウンサイドインデックス
  const neutralDownsideIndex = useMemo(() => ({
    quantityChangeOverTime: downsideIndexGraph.quantityChangeOverTime.map(() => 0),
    quantityFluctuation: downsideIndexGraph.quantityFluctuation.map(() => 0),
    priceChangeOverTime: downsideIndexGraph.priceChangeOverTime.map(() => 0),
    customerProductLifecycle: 0,
    exchangeRateFluctuationToPrice: downsideIndexGraph.exchangeRateFluctuationToPrice.map(() => 0),
    exchangeRateFluctuationToCost: downsideIndexGraph.exchangeRateFluctuationToCost.map(() => 0),
    materialCostIncrease: downsideIndexGraph.materialCostIncrease.map(() => 0),
    laborCostIncrease: downsideIndexGraph.laborCostIncrease.map(() => 0),
    competitorStatusToQuantity: downsideIndexGraph.competitorStatusToQuantity.map(() => 0),
    competitorStatusToPrice: downsideIndexGraph.competitorStatusToPrice.map(() => 0),
  }), [downsideIndexGraph]);

  // ストレス指数入力欄にフォーカスした際の一時的な値を保持するRef
  const focusedValueRef = useRef<number | null>(null);

  /** ストレス指数の最大値 */
  const DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH = "80px";

  /** ストレス指数の最大値 */
  const DOWNSIDE_INDEX_MAX = 999;

  /** ストレス指数の最小値 */
  const DOWNSIDE_INDEX_MIN = -999;

  /** ストレス指数(顧客製品寿命)の最大値 */
  const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX = 0;

  /** ストレス指数(顧客製品寿命)の最小値 */
  //const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN = 1;
  const DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN = -98;

  /** ストレス指数（画面表示用） */
  const [downsideIndexDisplay, setDownsideIndexDisplay] = useState<DownsideIndexDisplay>({

    /** 数量経時変化 */
    quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 数量上下変動 */
    fluctuationInQuantityString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 単価経時変化 */
    priceChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 顧客製品寿命 */
    customerProductLifecycleString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 為替変動 */
    currencyFluctuationString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 材料高騰 */
    risingMaterialCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 労務費高騰 */
    risingLaborCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),

    /** 競合状態 */
    competitorConditionString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor'),

  });

  /** ストレス指数(表)（画面表示用） */
  const [downsideIndexTableDisplay, setDownsideIndexTableDisplay] = useState<DownsideIndexTableRowDisplay[]>([]);

  /** ストレス指数(表)（リセット用） */
  const [downsideIndexTableDisplayForReset, setDownsideIndexTableDisplayForReset] = useState<DownsideIndexTableRowDisplay[]>([]);

  /** ストレス指数（有効/無効） */
  const [downsideIndexEnable, setDownsideIndexEnable] = useState<DownsideIndexEnable>({

    /** 数量経時変化 */
    isEnabledQuantityChangeOverTime: true,

    /** 数量上下変動 */
    isEnabledFluctuationInQuantity: true,

    /** 単価経時変化 */
    isEnabledPriceChangeOverTime: true,

    /** 顧客製品寿命 */
    isEnabledCustomerProductLifecycle: true,

    /** 為替変動（単価） */
    isEnabledCurrencyFluctuationToPrice: true,

    /** 為替変動（原価） */
    isEnabledCurrencyFluctuationToCost: true,

    /** 材料高騰 */
    isEnabledRisingMaterialCosts: true,

    /** 労務費高騰 */
    isEnabledRisingLaborCosts: true,

    /** 競合状態（数量） */
    isEnabledCompetitorConditionToQuantity: true,

    /** 競合状態（単価） */
    isEnabledCompetitorConditionToPrice: true,

  });

  /** 【参照データ】プロジェクト情報 */
  const [projectData, setProjectData] = useState<ProjectWithRdsData | null>();
  /** ローカル通貨ID（会社/工場スナップショットから取得） */
  const localCurrencyId = getLocalCurrencyId(projectData?.companyPlantSnapshot);

  /** 簡易モード判定（projectData未取得時は親から渡された初期値で判定 → ちらつき防止） */
  const isSimpleMode = isSimpleApplicationForm(
    projectData?.purpose ?? initialPurpose,
    projectData?.applicationFormType ?? initialApplicationFormType,
  );
  /** 損益非表示モード判定（簡易様式かつ「表示しない」選択時。表・グラフを一切表示しない） */
  const isProfitLossHiddenMode = isProfitLossHidden(
    projectData?.purpose ?? initialPurpose,
    projectData?.applicationFormType ?? initialApplicationFormType,
    projectData?.profitLossDisplayType ?? initialProfitLossDisplayType,
  );
  /** 汎用設備かどうか */
  const isGeneralPurpose = projectData?.equipmentUsageType === EquipmentUsageType.GeneralPurpose.code;
  const labelQuantity = isGeneralPurpose ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.estimatedQuantity') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.salesQuantity');
  const labelPrice = isGeneralPurpose ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.estimatedPrice') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.salesPrice');
  const labelQuantityAndPrice = isGeneralPurpose ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.estimatedQuantityAndPrice') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.salesQuantityAndPrice');
  /** 【参照データ】過去プロジェクト情報 */
  const [pastProjectData, setPastProjectData] = useState<ProjectWithRdsData | null>();
  /** 【参照データ】「数量・単価」で登録したデータ(過去プロジェクト) */
  const [pastCapexPartNo, setPastCapexPartNo] = useState<PartNo[]>([]);
  /** 過去プロジェクトのPart Noのうち、本プロジェクトに含まれないPart No（データ取得時の判定結果。不整合なしは空配列） */
  const [missingPastPartNoList, setMissingPastPartNoList] = useState<string[]>([]);
  /** データ取得時の不整合トーストを表示済みかどうか（再レンダリングでの重複表示を防ぐ） */
  const pastPartNoToastShownRef = useRef<boolean>(false);
  /** 増産投資量産開始年月（縦線表示位置） */
  const [increasedProductionStartYearMonth, setIncreasedProductionStartYearMonth] = useState<string>("");
  /** 更新投資量産開始年月（縦線表示位置） */
  const [updateAndOtherStartYearMonth, setUpdateAndOtherStartYearMonth] = useState<string>("");
  /** 合理化投資量産開始年月（縦線表示位置） */
  const [rationalizationStartYearMonth, setRationalizationStartYearMonth] = useState<string>("");

  /** 投資開始年月（増産投資、更新投資、または合理化に応じて切り替え） */
  const investmentStartYearMonth = useMemo(() => {
    if (projectData?.purpose === PurposeType.UpdateAndOther.code) {
      return updateAndOtherStartYearMonth;
    }
    if (projectData?.purpose === PurposeType.Rationalization.code) {
      return rationalizationStartYearMonth;
    }
    return increasedProductionStartYearMonth;
  }, [projectData?.purpose, increasedProductionStartYearMonth, updateAndOtherStartYearMonth, rationalizationStartYearMonth]);

  /** 【参照データ】プロジェクト情報（オリジナル(当初損益)）（「対象プロジェクトの利益試算」で登録データ） */
  // const [originalProfitAndLoss, setOriginalProfitAndLoss] = useState<OriginalProfitAndLossTable>();//おそらく不要

  /** 【参照データ】プロジェクト情報（オリジナル月別(当初損益月別)）（「対象プロジェクトの利益試算」で登録データ） */
  const [originalProfitAndLossByMonth, setOriginalProfitAndLossByMonth] = useState<OriginalProfitAndLossByMonthTable>();

  /** 【参照データ】JPY版オリジナル月別（対象PJ画面で保存したJPY版の売上合計・営業利益） */
  const [displayOriginalProfitAndLossByMonth, setDisplayOriginalProfitAndLossByMonth] = useState<OriginalProfitAndLossByMonthTable | null>(null);

  /** displayOriginalProfitAndLossByMonthの通貨名（常にJPY固定） */
  const savedDisplayCurrencyName = CurrencyNameJPY;

  /** JPY版月別材料単価（displayOriginalProfitAndLossByMonthから計算） */
  const [displayVersionPartNoToMonthlyMaterialCost, setDisplayVersionPartNoToMonthlyMaterialCost] = useState<Map<string, Record<string, Decimal>> | null>(null);

  /** JPY版価格と材料単価チャートデータ（当初計画） */
  const [displayVersionMergedChartDataOriginal, setDisplayVersionMergedChartDataOriginal] = useState<any>(null);

  /** 【参照データ】設備情報（M_CEAS_EQUIPMENT）（「設備投資」で登録したデータ） */
  const [equipmentAmounts, setEquipmentAmounts] = useState<EquipmentExtType[]>([]);
  /** 初期表示の設備情報（当初計画・ダウンサイド用） */
  const [originalEquipmentAmounts, setOriginalEquipmentAmounts] = useState<EquipmentExtType[]>([]);

  /** 初期表示の過去設備情報（当初投資・回収用） */
  const [pastEquipmentAmounts, setPastEquipmentAmounts] = useState<EquipmentExtType[]>([]);

  /** 初期表示のシミュレーション設定（当初計画・ダウンサイド用） */
  const [originalImprovedWorkingDaysData, setOriginalImprovedWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  const [originalImprovedNonWorkingHoursData, setOriginalImprovedNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);
  const [originalImprovedYieldRateList, setOriginalImprovedYieldRateList] = useState<YieldRateImprovement[]>([]);
  const [originalImprovedCycleTimeList, setOriginalImprovedCycleTimeList] = useState<CycleTimeImprovement[]>([]);

  /** シミュレーション設定（労務費）：生産工場労務費（月別） */
  const [scenarioLaborCostByMonth, setScenarioLaborCostByMonth] = useState<number[]>([]);
  /** シミュレーション設定（労務費）：償却費以外の工場経費（月別） */
  const [scenarioOverseasFactoryExpensesByMonth, setScenarioOverseasFactoryExpensesByMonth] = useState<number[]>([]);
  /** 労務費自動算出中フラグ */
  const [isLaborCostCalculating, setIsLaborCostCalculating] = useState<boolean>(false);

  /** シミュレーション設定（労務費）：生産工場労務費単価（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioProductionFactoryLaborUnitPrice, setScenarioProductionFactoryLaborUnitPrice] = useState<number | null>(null);
  /** シミュレーション設定（労務費）：生産工場経費単価（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioProductionFactoryExpenseUnitPrice, setScenarioProductionFactoryExpenseUnitPrice] = useState<number | null>(null);
  /** シミュレーション設定（労務費）：労務費ベースアップ率（費用画面の設定値を初期表示、シミュレーション変更可） */
  const [scenarioBaseLaborCostIncreaseRate, setScenarioBaseLaborCostIncreaseRate] = useState<number | null>(null);

  /**
   * 費用画面で設定した「生産工場労務費単価・生産工場経費単価・労務費ベースアップ率」を
   * シミュレーション設定の初期値として反映する（projectData取得時に一度だけ設定）
   */
  useEffect(() => {
    setScenarioProductionFactoryLaborUnitPrice(projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(projectData?.baseLaborCostIncreaseRate ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectData?.productionFactoryLaborUnitPrice, projectData?.productionFactoryExpenseUnitPrice, projectData?.baseLaborCostIncreaseRate]);

  /**
   * 費用画面で登録された月別「生産工場労務費」「償却費以外の工場経費」を
   * originalProfitAndLossByMonth.labels の年月順に並べた配列を返す。
   * （オリジナルデータを初期表示・リセットの基準値として使用）
   */
  const getOriginalLaborCostArrays = (): { laborCost: number[]; overseasExpenses: number[] } => {
    const labels = originalProfitAndLossByMonth?.labels ?? [];
    let monthly: MonthlyExpenseData[] = [];
    try {
      monthly = projectData?.monthlyExpenseData ? JSON.parse(projectData.monthlyExpenseData) : [];
    } catch {
      monthly = [];
    }
    const laborCost = labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return monthly.find((d) => d.year === year && d.month === month)?.productionLaborCost ?? 0;
    });
    const overseasExpenses = labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return monthly.find((d) => d.year === year && d.month === month)?.overseasFactoryExpenses ?? 0;
    });
    return { laborCost, overseasExpenses };
  };

  /**
   * 画面初期表示時、月別「生産工場労務費」「償却費以外の工場経費」に
   * 費用画面で登録済みのオリジナル値を初期表示する（未設定=空配列のときのみ）。
   */
  useEffect(() => {
    const labels = originalProfitAndLossByMonth?.labels ?? [];
    if (labels.length === 0) return;
    // 既に値がある場合（自動算出・シナリオ読込・ユーザー編集後）は上書きしない
    if (scenarioLaborCostByMonth.length > 0 || scenarioOverseasFactoryExpensesByMonth.length > 0) return;
    const { laborCost, overseasExpenses } = getOriginalLaborCostArrays();
    setScenarioLaborCostByMonth(laborCost);
    setScenarioOverseasFactoryExpensesByMonth(overseasExpenses);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalProfitAndLossByMonth?.labels, projectData?.monthlyExpenseData]);

  /** 合計設備金額 */
  const sumEquipmentAmount = useMemo(() => equipmentAmounts.reduce((sum: Decimal, e) =>
    sum.plus(new Decimal(e.amount || 0) || 0), new Decimal(0)) ?? 0, [equipmentAmounts]);

  /** 合計設備金額(選択) */
  const sumSelectedEquipmentAmount = useMemo(() => equipmentAmounts.reduce((sum: Decimal, e) =>
    sum.plus(e.selected ? (new Decimal(e.amount || 0)) : 0), new Decimal(0)) ?? 0, [equipmentAmounts]);

  /** 増減率(設備投資金額) */
  const rateOfChangeAmount = useMemo(() =>
    sumSelectedEquipmentAmount.div(sumEquipmentAmount).mul(100).round().minus(100).toNumber(),
    [sumSelectedEquipmentAmount, sumEquipmentAmount]);

  /** 製造ライン情報 */
  const [productionLine, setProductionLine] = useState<ProductionLineType>({});
  /** 過去プロジェクトの稼働率（月別） */
  const [pastAvailabilityRateByMonth, setPastAvailabilityRateByMonth] = useState<{ fiscalYear: string, availabilityRate: number[] }[]>([]);
  /** 過去PJのBOMデータ（仕損費計算用） */
  const [pastBomData, setPastBomData] = useState<BomData[]>([]);
  /** 過去PJのプロセスデータ（仕損費計算用） */
  const [pastProcessCodeData, setPastProcessCodeData] = useState<UniqueProcessType[]>([]);

  // ▼ 生産能力（プロセス）用データ
  /** プロセス情報（工程ごとのサイクルタイム含む） */
  const [processCodeData, setProcessCodeData] = useState<UniqueProcessType[]>([]);
  /** 更新前後サマリーデータ（プロセスごとのpartsCount含む） */
  const [updateSummaryDataList, setUpdateSummaryDataList] = useState<UpdateSummaryInputData[]>([]);
  /** 更新前後サマリーチェック結果（生産能力（プロセス）表示制御用） */
  const [hasProcessCapacityData, setHasProcessCapacityData] = useState<boolean>(false);

  /** BOMデータ */
  const [bomData, setBomData] = useState<BomData[]>([]);

  // ▼ 通貨
  /** 通貨情報 */
  const [pastCurrencyData, setPastCurrencyData] = useState<Currency[]>([]);
  /** 販売通貨名 */
  const [salesCurrencyName, setSalesCurrencyName] = useState<string>("");
  /** ローカル通貨名 */
  const [localCurrencyName, setLocalCurrencyName] = useState<string>("");
  /** 表示通貨 */
  const [selectedCurrency, setSelectedCurrency] = useState<{ id: string; name: string }>({ id: "", name: "" });

  // ▼ 売上チャートデータ
  /** 売上（プロジェクト全体投資回収） */
  const [salesChartDataAll, setSalesChartDataAll] = useState<any>(null);
  /** 売上（当初投資・回収） */
  const [salesChartDataPast, setSalesChartDataPast] = useState<any>(null);
  /** 売上（当初計画） */
  const [salesChartData, setSalesChartData] = useState<any>(null);
  /** 売上（ダウンサイド） */
  const [salesChartDataModified, setSalesChartDataModified] = useState<any>(null);
  /** 売上（保存済み設定用）配列形式 */
  const [salesChartDataForSavedConfig, setSalesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);
  /** 売上（ダウンサイド）パーツNo別 */
  const [monthlySalesModifiedByPartNo, setMonthlySalesModifiedByPartNo] = useState<SalesByPartNo>({});

  /** 増産投資分回収用 - 売上（当初計画） */
  const [salesChartData2, setSalesChartData2] = useState<any>(null);
  /** 増産投資分回収用 - 売上（ダウンサイド） */
  const [salesChartDataModified2, setSalesChartDataModified2] = useState<any>(null);

  // ▼ 投資回収チャートデータ
  /** 投資回収（プロジェクト全体投資回収） */
  const [combinedChartDataAll, setCombinedChartDataAll] = useState<any>(null);
  /** 投資回収（当初投資・回収） */
  const [combinedChartDataPast, setCombinedChartDataPast] = useState<any>(null);
  /** 増産投資分回収（当初計画） */
  const [combinedChartData, setCombinedChartData] = useState<any>(null);
  /** 増産投資分回収（ダウンサイド） */
  const [combinedChartDataModified, setCombinedChartDataModified] = useState<any>(null);
  /** 投資回収（保存済み設定用）配列形式 */
  const [combinedChartDataForSavedConfig, setCombinedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 増分キャッシュフロー Excel出力用データ
  /** 増分キャッシュフロー PJ全体投資回収 Excel出力用 */
  const [incrementalCashFlowAll, setIncrementalCashFlowAll] = useState<any>(null);
  /** 増分キャッシュフロー 当初投資・回収 Excel出力用 */
  const [incrementalCashFlowPast, setIncrementalCashFlowPast] = useState<any>(null);
  /** 増分キャッシュフロー 増産/合理化/更新投資分回収（当初計画）Excel出力用 */
  const [incrementalCashFlowOriginal, setIncrementalCashFlowOriginal] = useState<any>(null);
  /** 増分キャッシュフロー 増産/合理化/更新投資分回収（ダウンサイド）Excel出力用 */
  const [incrementalCashFlowDownside, setIncrementalCashFlowDownside] = useState<any>(null);
  /** 増分キャッシュフロー（保存済み設定）Excel出力用 */
  const [incrementalCashFlowForSavedConfig, setIncrementalCashFlowForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 営業利益合計と営業利益率（当初計画）
  /** 営業利益合計（当初計画） */
  const [totalProfitOriginal, setTotalProfitOriginal] = useState<Decimal | null>(null);
  /** 営業利益率（当初計画） */
  const [profitRateOriginal, setProfitRateOriginal] = useState<string | null>(null);

  // ▼ 営業利益合計と営業利益率（ダウンサイド）
  /** 営業利益合計（ダウンサイド） */
  const [totalProfitModified, setTotalProfitModified] = useState<Decimal | null>(null);
  /** 営業利益率（ダウンサイド） */
  const [profitRateModified, setProfitRateModified] = useState<string | null>(null);

  // ▼ 実質的営業利益率（当初計画・ダウンサイド）- DB保存用
  /** 実質的営業利益率（当初計画） */
  const [realProfitRateOriginal, setRealProfitRateOriginal] = useState<string | null>(null);
  /** 実質的営業利益率（ダウンサイド） */
  const [realProfitRateModifiedState, setRealProfitRateModifiedState] = useState<string | null>(null);
  /** 実質的営業利益率 月次データ（当初計画） */
  const [realProfitRateByMonthOriginal, setRealProfitRateByMonthOriginal] = useState<number[]>([]);
  /** 実質的営業利益率 月次データ（ダウンサイド） */
  const [realProfitRateByMonthModifiedState, setRealProfitRateByMonthModifiedState] = useState<number[]>([]);

  // ▼ 実質的営業利益率 キャッシュフロー用（投資開始以降）- DB保存用
  /** 実質的営業利益率 キャッシュフロー（当初計画・投資開始以降） */
  const [realProfitRateCashflowOriginal, setRealProfitRateCashflowOriginal] = useState<string | null>(null);
  /** 実質的営業利益率 キャッシュフロー（ダウンサイド・投資開始以降） */
  const [realProfitRateCashflowModifiedState, setRealProfitRateCashflowModifiedState] = useState<string | null>(null);
  /** 実質的営業利益率 月次データ キャッシュフロー（当初計画・投資開始以降） */
  const [realProfitRateByMonthCashflowOriginal, setRealProfitRateByMonthCashflowOriginal] = useState<number[]>([]);
  /** 実質的営業利益率 月次データ キャッシュフロー（ダウンサイド・投資開始以降） */
  const [realProfitRateByMonthCashflowModifiedState, setRealProfitRateByMonthCashflowModifiedState] = useState<number[]>([]);

  // ▼ 数量（Part別 月次数量）チャートデータ (オリジナル / 修正後) の2種類
  /** 数量（当初計画） */
  const [quantitiesChartDataOriginal, setQuantitiesChartDataOriginal] = useState<any>(null);
  /** 数量（ダウンサイド） */
  const [quantitiesChartDataModified, setQuantitiesChartDataModified] = useState<any>(null);
  /** 数量（保存済み設定用）配列形式 */
  const [quantitiesChartDataForSavedConfig, setQuantitiesChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 価格と材料単価（Price & Material）チャートデータ (オリジナル / 修正後) の2種類
  /** 価格と材料単価（当初計画） */
  const [mergedChartDataOriginal, setMergedChartDataOriginal] = useState<any>(null);
  /** 価格と材料単価（ダウンサイド） */
  const [mergedChartDataModified, setMergedChartDataModified] = useState<any>(null);
  /** 価格と材料単価（保存済み設定用）配列形式 */
  const [mergedChartDataForSavedConfig, setMergedChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);

  // ▼ 選択される顧客製品
  /** 選択顧客製品（顧客業界）|「ダウンサイド」ボタン押下時に設定 */
  const [selectedCustomerProduct, setSelectedCustomerProduct] = useState<string | null>(null);

  /** 回収時期ｎヶ月目（当初計画） */
  const [monthOfRecoveryOriginal, setMonthOfRecoveryOriginal] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（ダウンサイド） */
  const [monthOfRecoveryModified, setMonthOfRecoveryModified] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（プロジェクト全体投資回収） */
  const [monthOfRecoveryAll, setMonthOfRecoveryAll] = useState<number[]>([]);
  /** 回収時期ｎヶ月目（当初投資・回収） */
  const [monthOfRecoveryPast, setMonthOfRecoveryPast] = useState<number[]>([]);
  /** 回収時期（保存済み設定用）配列形式 */
  const [monthOfRecoveryForSavedConfig, setMonthOfRecoveryForSavedConfig] = useState<{ configId: string; data: number[] }[]>([]);

  /** 最終的な投資判断の理由（ref経由で子コンポーネントにアクセス） */
  const finalInvestmentReasonRef = useRef<TextareaHandle>(null);

  /** ダウンサイドリスク対応（ref経由で子コンポーネントにアクセス） */
  const downsideRiskRef = useRef<TextareaHandle>(null);

  /** 最終的な投資判断の理由の入力値（タブ切替でテキストエリアがアンマウントされても保持する） */
  const finalInvestmentReasonDraftRef = useRef<string | null>(null);
  /** ダウンサイドリスク対応の入力値（同上） */
  const downsideRiskDraftRef = useRef<string | null>(null);

  // ▼ 生産能力（ライン全体）チャートデータ
  /** 生産能力（ライン全体） */
  const [productionCapacityChartData, setProductionCapacityChartData] = useState<any>(null);
  /** 生産能力（ライン全体）ダウンサイド */
  const [productionCapacityChartDataModified, setProductionCapacityChartDataModified] = useState<any>(null);
  /** 生産能力（保存済み設定用）配列形式 */
  const [productionCapacityChartDataForSavedConfig, setProductionCapacityChartDataForSavedConfig] = useState<{ configId: string; data: any }[]>([]);
  // ▼ 生産キャパグラフ（既存ライン含む）の元データ（増産のみ。「生産能力（ライン全体）」の計算から切り出し）
  // キャパ＝稼働日分（ストレス指数なし）、案件品＝顧客需要のPartNo別数量（ダウンサイド・保存済み設定は数量グラフ由来）
  const [elqVersionOriginal, setElqVersionOriginal] = useState<TExistingLineCapacityVersion | null>(null);
  const [elqVersionModified, setElqVersionModified] = useState<TExistingLineCapacityVersion | null>(null);
  const [elqVersionsForSavedConfig, setElqVersionsForSavedConfig] = useState<TExistingLineCapacitySource["savedConfigs"]>([]);

  // ▼ 生産能力（プロセス）チャートデータ
  /** 生産能力（プロセス）プロセスID, プロセス名, 更新前/更新後 × 当初計画/ダウンサイド チャートデータの配列 */
  const [productionCapacityProcessChartDataList, setProductionCapacityProcessChartDataList] = useState<{
    processId: string;
    processName: string;
    beforeData: any;           // 更新前
    beforeDownsideData: any;   // 更新前（ダウンサイド）
    afterData: any;            // 更新後
    afterDownsideData: any;    // 更新後（ダウンサイド）
  }[]>([]);
  /** 生産能力（プロセス）保存済み設定用 */
  const [productionCapacityProcessChartDataForSavedConfig, setProductionCapacityProcessChartDataForSavedConfig] = useState<{
    configId: string;
    processData: {
      processId: string;
      processName: string;
      afterData: any;          // 更新後（シミュレーション設定）
    }[];
  }[]>([]);

  // ▼ 合理化前後サマリーチャートデータ
  /**
   * 合理化前後サマリーチャート用データ型
   * - itemName: 項目名（人件費、修繕費など）
   * - beforeData: 合理化前のデータ（年月ごと）
   * - afterData: 合理化後のデータ（年月ごと）
   * - group: グループ（cost: 費用グループ, indicator: 指標グループ）
   */
  interface RationalizationSummaryChartItem {
    itemId: string;
    itemName: string;
    unit: string;
    beforeData: number[];
    afterData: number[];
    group: "cost" | "indicator" | "improvementEffect";
    /** 減価償却費データ（改善効果チャートでのみ使用） */
    depreciationData?: number[];
  }
  /** 合理化前後サマリーチャートデータ（processId単位） */
  const [rationalizationSummaryChartDataList, setRationalizationSummaryChartDataList] = useState<{
    processId: string;
    itemNo: string;
    labels: string[];  // 年月ラベル（X軸）
    items: RationalizationSummaryChartItem[];
  }[]>([]);

  /** 合理化前後サマリーデータ（APIから取得したデータ） */
  const [rationalizationSummaryDataList, setRationalizationSummaryDataList] = useState<RationalizationSummaryInputData[]>([]);

  // 【参照データ】 月別稼働日数
  const [workingDayByYear, setWorkingDayByYear] = useState<{ fiscalYear: string, workingDay: number[] }[]>([]);
  // 【参照データ】 改善後月別稼働日数
  const [improvedWorkingDayByYear, setImprovedWorkingDayByYear] = useState<{ fiscalYear: string, workingDay: number[] }[]>([]);
  // 【参照データ】 月別ライン数
  const [lineCountByYear, setLineCountByYear] = useState<{ fiscalYear: string, lineCount: number[] }[]>([]);
  // 【参照データ】 改善後月別ライン数
  const [improvedLineCountByYear, setImprovedLineCountByYear] = useState<{ fiscalYear: string, lineCount: number[] }[]>([]);
  // 【参照データ】 休日出勤日数
  const [holidayByYear, setHolidayByYear] = useState<{ fiscalYear: string, holiday: number[] }[]>([]);
  // 【参照データ】 改善後月別休日出勤日数
  const [improvedHolidayByYear, setImprovedHolidayByYear] = useState<{ fiscalYear: string, holiday: number[] }[]>([]);
  // 【参照データ】 稼働率
  const [availabilityRateByMonth, setAvailabilityRateByMonth] = useState<{ fiscalYear: string, availabilityRate: number[] }[]>([]);
  // 【参照データ】 改善後稼働率
  const [improvedAvailabilityRateByMonth, setImprovedAvailabilityRateByMonth] = useState<{ fiscalYear: string, availabilityRate: number[] }[]>([]);
  // 【参照データ】 改善後歩留リスト (日付別)
  const [improvedYieldRateList, setImprovedYieldRateList] = useState<YieldRateImprovement[]>([]);
  // 【参照データ】 改善後歩留 (後方互換用 - 最初の改善値または基本値)
  const [improvedYieldRate, setImprovedYieldRate] = useState<number>(0);
  // 【参照データ】 改善後歩留 画面表示用 (後方互換用)
  const [improvedYieldRateText, setImprovedYieldRateText] = useState<string>("0.0");
  // 【参照データ】 短縮後サイクルタイムリスト (日付別)
  const [improvedCycleTimeList, setImprovedCycleTimeList] = useState<CycleTimeImprovement[]>([]);
  // 【参照データ】 短縮後サイクルタイム (後方互換用 - 最初の改善値または基本値)
  const [improvedCycleTime, setImprovedCycleTime] = useState<number>(0);
  // 【参照データ】 短縮後サイクルタイムテキスト (後方互換用)
  const [improvedCycleTimeText, setImprovedCycleTimeText] = useState<string>("0.0");
  // 【参照データ】 稼働日数
  const [workingDaysData, setWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  // 【参照データ】 改善後稼働日数
  const [improvedWorkingDaysData, setImprovedWorkingDaysData] = useState<{ fiscalYear: string, workingDaysData: WorkingDaysType }[]>([]);
  // 【参照データ】 稼働日数入力チェック結果
  const [isValidWorkingDays, setIsValidWorkingDays] = useState<boolean>(false);
  // 【参照データ】 非稼働時間
  const [nonWorkingHoursData, setNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);
  // 【参照データ】 改善後非稼働時間
  const [improvedNonWorkingHoursData, setImprovedNonWorkingHoursData] = useState<{ fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]>([]);

  // SpreadSheet同期用状態変数（1つのSpreadSheetで稼働日数・非稼働時間を管理）
  const [spreadSheetWindow, setSpreadSheetWindow] = useState<Window | null>(null);
  const [isSpreadSheetLoading, setIsSpreadSheetLoading] = useState<boolean>(false);
  const [inputModeSimulation, setInputModeSimulation] = useState<"google" | "manual">("manual");
  const [activeSpreadsheetId, setActiveSpreadsheetId] = useState<string | null>(null);
  const [esSyncError, setEsSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [lcSyncError, setLcSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [pciSyncError, setPciSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [workingDaysSyncError, setWorkingDaysSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [nonWorkingHoursSyncError, setNonWorkingHoursSyncError] = useState<{ workingHoursErrors: string[]; nonWorkingHourErrors: string[]; invalidValueErrors: string[] }>({ workingHoursErrors: [], nonWorkingHourErrors: [], invalidValueErrors: [] });
  const [yiSyncError, setYiSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });
  const [ctrSyncError, setCtrSyncError] = useState<{ invalidValueErrors: string[] }>({ invalidValueErrors: [] });

  // Google API インスタンス
  const googleAPI = useMemo(() => new GoogleAPI(), []);

  // Google API 初期化
  useEffect(() => {
    const initGapi = async () => {
      try {
        if (!await googleAPI.initGapi()) {
          throw new Error("initGapi error");
        }
      } catch (error) {
        console.error("Google API 初期化エラー:", error);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.googleApiInitFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };
    initGapi();
  }, [googleAPI, toast]);

  /**
   * スプレッドシートのシートにデータを書き込む
   */
  const writeSheetData = async (api: GoogleAPI, spreadsheetId: string, sheetName: string, data: any[][], sheetId: number) => {
    // 初期化は呼び出し元の googleAPI.clear（シート全体）で実施済みのため、ここではデータ書き込みのみ行う
    await api.spreadSheetSetValue(spreadsheetId, sheetName, 1, 1, data);
  };

  /**
   * 「画面で入力」ボタン押下
   */
  const handleManualClick = () => {
    spreadSheetWindow?.close();
  };

  /**
   * 「GoogleSpread」ボタン押下
   * 1つのSpreadSheetに以下のシートを作成してデータを書き込む
   * シート順: ES → PCI → OD → DT → YI → CTR
   */
  const handleGoogleSpreadClick = async () => {
    if (inputModeSimulation === "google") {
      return;
    }

    try {
      setIsSpreadSheetLoading(true);
      setInputModeSimulation("google");

      // ポップアップブロック回避：非同期処理より前にユーザー操作起因でウィンドウを確保
      const newWindow = window.open("", "_blank");

      if (!await googleAPI.signIn()) {
        throw new Error("signIn error");
      }

      const fileName = "SimulationSettings";
      const folderPath = `CEAS/SpreadSheet/Simulation/${projectId}`;

      let folderId = await googleAPI.createFolderPath(folderPath, null);
      if (!folderId) { folderId = ""; }

      const spreadsheetId = await googleAPI.createSpreadSheet(fileName, folderId, null);
      setActiveSpreadsheetId(spreadsheetId);

      if (spreadsheetId) {
        // シートを追加（デフォルトシートは自動削除される。簡易モードは画面非表示のためLaborCostシートを除外）
        const sheetNames = isSimpleMode
          ? [SHEET_NAME_EQUIPMENT_STAFFING, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, SHEET_NAME_OPERATING_DAYS, SHEET_NAME_DOWNTIME, SHEET_NAME_YIELD_IMPROVEMENT, SHEET_NAME_CYCLE_TIME_REDUCTION]
          : [SHEET_NAME_EQUIPMENT_STAFFING, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, SHEET_NAME_OPERATING_DAYS, SHEET_NAME_DOWNTIME, SHEET_NAME_LABOR_COST, SHEET_NAME_YIELD_IMPROVEMENT, SHEET_NAME_CYCLE_TIME_REDUCTION];
        // シートIDは addSheets の戻り値を使用（シート情報の再取得を省略。並べ替えではIDは変わらない）
        const sheetNameToId = await googleAPI.addSheets(spreadsheetId, sheetNames);

        // シートを並べ替え
        await googleAPI.reorderSheets(spreadsheetId, sheetNames);

        const equipmentStaffingSheetId = sheetNameToId[SHEET_NAME_EQUIPMENT_STAFFING] ?? 0;
        const phasedCapitalInvestmentSheetId = sheetNameToId[SHEET_NAME_PHASED_CAPITAL_INVESTMENT] ?? 0;
        const workingDaysSheetId = sheetNameToId[SHEET_NAME_OPERATING_DAYS] ?? 0;
        const nonWorkingHoursSheetId = sheetNameToId[SHEET_NAME_DOWNTIME] ?? 0;
        const laborCostSheetId = isSimpleMode ? 0 : (sheetNameToId[SHEET_NAME_LABOR_COST] ?? 0);
        const yieldImprovementSheetId = sheetNameToId[SHEET_NAME_YIELD_IMPROVEMENT] ?? 0;
        const cycleTimeReductionSheetId = sheetNameToId[SHEET_NAME_CYCLE_TIME_REDUCTION] ?? 0;

        // 前回設定した書式・入力規則を初期化（列構成変更時に古い設定が残らないようにする）。
        // 値の書き込みより前に送る必要があるため、batch に溜めず即時送信する
        await googleAPI.resetSheetFormatAndValidation(spreadsheetId, Object.values(sheetNameToId));

        // 値・書式・入力規則の書き込みを溜め、最後に flush() でまとめて送信する
        const batch = new GoogleAPIBatchCollector(spreadsheetId);

        // --- 各シートにデータを書き込む（シート順: ES → PCI → OD → DT → YI → CTR） ---

        // [ES] 設備・人員構成変更シートにデータを書き込む
        const equipmentStaffingSheetData = equipmentStaffingToSpreadSheetData(equipmentAmounts);
        await batch.clear(spreadsheetId, SHEET_NAME_EQUIPMENT_STAFFING);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_EQUIPMENT_STAFFING, equipmentStaffingSheetData, equipmentStaffingSheetId);
        await setupEquipmentStaffingSheet(batch, spreadsheetId, equipmentStaffingSheetId, equipmentAmounts);

        // [PCI] 段階的設備投資シートにデータを書き込む
        const phasedCapitalInvestmentSheetData = phasedCapitalInvestmentToSpreadSheetData(equipmentAmounts);
        await batch.clear(spreadsheetId, SHEET_NAME_PHASED_CAPITAL_INVESTMENT);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_PHASED_CAPITAL_INVESTMENT, phasedCapitalInvestmentSheetData, phasedCapitalInvestmentSheetId);
        await setupPhasedCapitalInvestmentSheet(batch, spreadsheetId, phasedCapitalInvestmentSheetId, equipmentAmounts);

        // [OD] 稼働日数シートにデータを書き込む
        const workingDaysSheetData = workingDaysToSpreadSheetData(improvedWorkingDaysData as WorkingDaysYearData[]);
        await batch.clear(spreadsheetId, SHEET_NAME_OPERATING_DAYS);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_OPERATING_DAYS, workingDaysSheetData, workingDaysSheetId);

        // [DT] 非稼働時間シートにデータを書き込む
        const nonWorkingHoursSheetData = nonWorkingHoursToSpreadSheetData(improvedNonWorkingHoursData as NonWorkingHoursYearData[]);
        await batch.clear(spreadsheetId, SHEET_NAME_DOWNTIME);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_DOWNTIME, nonWorkingHoursSheetData, nonWorkingHoursSheetId);

        // [LC] 生産工場費用設定シートにデータを書き込む（簡易モードは画面非表示のためスキップ）
        if (!isSimpleMode) {
          const laborCostSheetData = laborCostToSpreadSheetData(
            originalProfitAndLossByMonth?.labels ?? [],
            scenarioLaborCostByMonth,
            scenarioOverseasFactoryExpensesByMonth,
            scenarioProductionFactoryLaborUnitPrice,
            scenarioProductionFactoryExpenseUnitPrice,
            scenarioBaseLaborCostIncreaseRate,
          );
          await batch.clear(spreadsheetId, SHEET_NAME_LABOR_COST);
          await writeSheetData(batch, spreadsheetId, SHEET_NAME_LABOR_COST, laborCostSheetData, laborCostSheetId);
          await setupLaborCostSheet(batch, spreadsheetId, laborCostSheetId);
        }

        // [YI] 歩留改善シートにデータを書き込む
        const yieldImprovementSheetData = yieldImprovementToSpreadSheetData(improvedYieldRateList);
        await batch.clear(spreadsheetId, SHEET_NAME_YIELD_IMPROVEMENT);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_YIELD_IMPROVEMENT, yieldImprovementSheetData, yieldImprovementSheetId);
        await setupYieldImprovementSheet(batch, spreadsheetId, yieldImprovementSheetId);

        // [CTR] サイクルタイム短縮シートにデータを書き込む
        const cycleTimeReductionSheetData = cycleTimeReductionToSpreadSheetData(improvedCycleTimeList);
        await batch.clear(spreadsheetId, SHEET_NAME_CYCLE_TIME_REDUCTION);
        await writeSheetData(batch, spreadsheetId, SHEET_NAME_CYCLE_TIME_REDUCTION, cycleTimeReductionSheetData, cycleTimeReductionSheetId);
        await setupCycleTimeReductionSheet(batch, spreadsheetId, cycleTimeReductionSheetId);

        // 溜めた書き込みをまとめて送信（クリア → 値 → 書式・入力規則 の順）
        await batch.flush();

        // --- データ設定完了後にSpreadSheetを新しいタブで表示する ---
        // 事前確保したウィンドウをスプレッドシートに遷移
        if (newWindow) {
          newWindow.location.href = googleAPI.getOpenSpradSheetUrl(spreadsheetId);
          setSpreadSheetWindow(newWindow);

          // GoogleSpreadシートウィンドウを手動で閉じられた場合
          const interval = setInterval(() => {
            if (newWindow.closed) {
              clearInterval(interval); // 監視を停止
              setInputModeSimulation("manual");
            }
          }, 500); // 500ms ごとに監視
        }

        setInputModeSimulation("google");
      }

    } catch (error) {
      console.error("Change GoogleSpread Error.", error);
      spreadSheetWindow?.close();
      setInputModeSimulation("manual");

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.googleSpreadUnavailable'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSpreadSheetLoading(false);
    }
  };

  /**
   * 「データ連携」ボタン押下
   * 各シートからデータを取得して画面に反映する
   * 取得順: ES → PCI → OD → DT → YI → CTR
   */
  const handleSyncData = async () => {
    if (!activeSpreadsheetId || inputModeSimulation !== "google") {
      return;
    }

    try {
      setIsSpreadSheetLoading(true);

      // トークンの有効性を確認
      if (!await googleAPI.ensureValidToken()) {
        googleAPI.signIn();
      }

      // --- 各シートからデータを取得して反映（シート順: ES → PCI → OD → DT → YI → CTR） ---

      // [ES] 設備・人員構成変更データを取得（A3:G、ヒント行+ヘッダー行をスキップ）
      const equipmentStaffingRange = `${SHEET_NAME_EQUIPMENT_STAFFING}!A3:G`;
      const equipmentStaffingResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, equipmentStaffingRange);
      const { data: equipmentStaffingData, errors: esErrors } = spreadSheetDataToEquipmentStaffing(
        equipmentStaffingResult.values || [],
        equipmentAmounts
      );
      setEsSyncError({ invalidValueErrors: esErrors });

      // [PCI] 段階的設備投資データを取得（A3:H、ヒント行+ヘッダー行をスキップ）
      const phasedCapitalInvestmentRange = `${SHEET_NAME_PHASED_CAPITAL_INVESTMENT}!A3:H`;
      const phasedCapitalInvestmentResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, phasedCapitalInvestmentRange);
      const { data: phasedCapitalInvestmentData, errors: pciErrors } = spreadSheetDataToPhasedCapitalInvestment(
        phasedCapitalInvestmentResult.values || [],
        equipmentStaffingData.length > 0 ? equipmentStaffingData : equipmentAmounts
      );
      setPciSyncError({ invalidValueErrors: pciErrors });

      // [ES/PCI] 設備データを更新（段階的設備投資の結果を優先、なければ設備・人員構成変更の結果）
      if (phasedCapitalInvestmentData.length > 0) {
        setEquipmentAmounts(phasedCapitalInvestmentData);
      } else if (equipmentStaffingData.length > 0) {
        setEquipmentAmounts(equipmentStaffingData);
      }

      // [OD] 稼働日数データを取得
      const workingDaysRange = `${SHEET_NAME_OPERATING_DAYS}!B1:M`;
      const workingDaysResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, workingDaysRange);
      const { data: workingDaysData, errors: workingDaysErrors } = spreadSheetDataToWorkingDays(
        workingDaysResult.values || [],
        improvedWorkingDaysData as WorkingDaysYearData[]
      );
      setWorkingDaysSyncError({ invalidValueErrors: workingDaysErrors });
      if (workingDaysData.length > 0) {
        setImprovedWorkingDaysData(workingDaysData);
      }

      // [DT] 非稼働時間データを取得
      const nonWorkingHoursRange = `${SHEET_NAME_DOWNTIME}!B2:M`;
      const nonWorkingHoursResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, nonWorkingHoursRange);
      const nonWorkingHoursConvResult = spreadSheetDataToNonWorkingHours(
        nonWorkingHoursResult.values || [],
        improvedNonWorkingHoursData as NonWorkingHoursYearData[]
      );
      const { data: nonWorkingHoursData, errors: nonWorkingHoursErrors } = nonWorkingHoursConvResult;
      setNonWorkingHoursSyncError({
        workingHoursErrors: nonWorkingHoursErrors.workingHoursErrors,
        nonWorkingHourErrors: nonWorkingHoursErrors.nonWorkingHourErrors,
        invalidValueErrors: nonWorkingHoursErrors.invalidValueErrors
      });
      if (nonWorkingHoursData.length > 0) {
        setImprovedNonWorkingHoursData(nonWorkingHoursData);

        // improvedWorkingDaysDataのrequiredOverTimesも同期（残業時間欄に値が入っているかどうかから算出する）
        setImprovedWorkingDaysData(prev => prev.map(wd => {
          const match = nonWorkingHoursData.find(r => isSameFiscalYear(r.fiscalYear, wd.fiscalYear));
          if (match) {
            return {
              ...wd,
              workingDaysData: {
                ...wd.workingDaysData,
                requiredOverTimes: match.nonWorkingHoursByMonth.map(
                  (monthData) => !!monthData.overTime && monthData.overTime !== "00:00"
                ),
              },
            };
          }
          return wd;
        }));
      }

      let lcErrors = [];

      // [LC] 生産工場費用設定データを取得（A1:ZZ、ヘッダー行含む。簡易モードは画面非表示のためスキップ）
      if (!isSimpleMode) {
        const laborCostRange = `${SHEET_NAME_LABOR_COST}!A1:ZZ`;
        const laborCostResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, laborCostRange);
        const laborCostConv = spreadSheetDataToLaborCost(
          laborCostResult.values || [],
          (originalProfitAndLossByMonth?.labels ?? []).length,
        );
        lcErrors = laborCostConv.errors;
        setLcSyncError({ invalidValueErrors: lcErrors });
        setScenarioLaborCostByMonth(laborCostConv.productionLaborCostByMonth);
        setScenarioOverseasFactoryExpensesByMonth(laborCostConv.overseasFactoryExpensesByMonth);
        setScenarioProductionFactoryLaborUnitPrice(laborCostConv.productionFactoryLaborUnitPrice);
        setScenarioProductionFactoryExpenseUnitPrice(laborCostConv.productionFactoryExpenseUnitPrice);
        setScenarioBaseLaborCostIncreaseRate(laborCostConv.baseLaborCostIncreaseRate);
      }

      // [YI] 歩留改善データを取得（A2:B、ヘッダー行をスキップ）
      const yieldImprovementRange = `${SHEET_NAME_YIELD_IMPROVEMENT}!A2:B`;
      const yieldImprovementResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, yieldImprovementRange);
      const { data: yieldImprovementData, errors: yiErrors } = spreadSheetDataToYieldImprovement(
        yieldImprovementResult.values || [],
        projectData?.projectStartDate,
        projectData?.projectEndDate,
      );
      setYiSyncError({ invalidValueErrors: yiErrors });
      setImprovedYieldRateList(yieldImprovementData);
      if (yieldImprovementData.length > 0) {
        setImprovedYieldRate(yieldImprovementData[0].yieldRate);
        setImprovedYieldRateText(yieldImprovementData[0].yieldRateText);
      }

      // [CTR] サイクルタイム短縮データを取得（A2:B、ヘッダー行をスキップ）
      const cycleTimeReductionRange = `${SHEET_NAME_CYCLE_TIME_REDUCTION}!A2:B`;
      const cycleTimeReductionResult = await googleAPI.spreadSheetGetValues(activeSpreadsheetId, cycleTimeReductionRange);
      const { data: cycleTimeReductionData, errors: ctrErrors } = spreadSheetDataToCycleTimeReduction(
        cycleTimeReductionResult.values || [],
        projectData?.projectStartDate,
        projectData?.projectEndDate,
      );
      setCtrSyncError({ invalidValueErrors: ctrErrors });
      setImprovedCycleTimeList(cycleTimeReductionData);
      if (cycleTimeReductionData.length > 0) {
        setImprovedCycleTime(cycleTimeReductionData[0].cycleTime);
        setImprovedCycleTimeText(cycleTimeReductionData[0].cycleTimeText);
      }

      const hasAnyError = esErrors.length > 0
        || pciErrors.length > 0
        || workingDaysErrors.length > 0
        || nonWorkingHoursErrors.workingHoursErrors.length > 0
        || nonWorkingHoursErrors.nonWorkingHourErrors.length > 0
        || nonWorkingHoursErrors.invalidValueErrors.length > 0
        || yiErrors.length > 0
        || ctrErrors.length > 0
        || lcErrors.length > 0;

      toast({
        title: TITLE,
        description: hasAnyError
          ? t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataSyncPartialFailed')
          : t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataSyncCompleted'),
        status: hasAnyError ? 'warning' : 'success',
        duration: hasAnyError ? 5000 : 3000,
        isClosable: true,
      });

    } catch (error) {
      console.error("Sync Data Error.", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataSyncFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSpreadSheetLoading(false);
    }
  };

  // SpreadSheetウィンドウの状態監視
  useEffect(() => {
    if (spreadSheetWindow) {
      setInputModeSimulation("google");
    } else {
      setInputModeSimulation("manual");
    }
  }, [spreadSheetWindow]);

  // アンマウント時（画面遷移等）にGoogleSpreadを閉じる（cleanupで最新の参照を使うためrefに保持）
  const spreadSheetWindowRef = useRef<Window | null>(null);
  useEffect(() => {
    spreadSheetWindowRef.current = spreadSheetWindow;
  }, [spreadSheetWindow]);
  useEffect(() => {
    return () => {
      if (spreadSheetWindowRef.current && !spreadSheetWindowRef.current.closed) {
        spreadSheetWindowRef.current.close();
      }
    };
  }, []);

  // manualモードに切り替わったらエラーメッセージをクリア
  useEffect(() => {
    if (inputModeSimulation === "manual") {
      setEsSyncError({ invalidValueErrors: [] });
      setPciSyncError({ invalidValueErrors: [] });
      setWorkingDaysSyncError({ invalidValueErrors: [] });
      setNonWorkingHoursSyncError({ workingHoursErrors: [], nonWorkingHourErrors: [], invalidValueErrors: [] });
      setYiSyncError({ invalidValueErrors: [] });
      setCtrSyncError({ invalidValueErrors: [] });
      setLcSyncError({ invalidValueErrors: [] });
    }
  }, [inputModeSimulation]);

  /** ストレス指数（表）をリセットする */
  const resetStressIndex = (): void => {

    // ストレス指数(表)をリセット
    updateDownsideIndexTableDisplay(JSON.parse(JSON.stringify(downsideIndexTableDisplayForReset)));

    // ストレス指数をリセット
    setDownsideIndex(JSON.parse(JSON.stringify(downsideIndexForReset)));

    // ストレス指数(表)のヘッダー(有効・無効)をリセット
    setDownsideIndexEnable(downsideIndexEnableForReset);
  };

  /**
   * TScenarioデータをSavedSimulationConfig形式に変換する
   * @param scenario TScenario型のデータ
   * @returns SavedSimulationConfig形式のデータ
   */
  const convertTScenarioToSavedConfig = (scenario: TScenario): SavedSimulationConfig => {
    // workingDaysが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const workingDays = typeof scenario.workingDays === 'string'
      ? JSON.parse(scenario.workingDays)
      : scenario.workingDays;

    // nonWorkingHoursが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const nonWorkingHours = typeof scenario.nonWorkingHours === 'string'
      ? JSON.parse(scenario.nonWorkingHours)
      : scenario.nonWorkingHours;

    // yieldRateが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const yieldRate = typeof scenario.yieldRate === 'string'
      ? JSON.parse(scenario.yieldRate)
      : scenario.yieldRate;

    // cycleTimeが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const cycleTime = typeof scenario.cycleTime === 'string'
      ? JSON.parse(scenario.cycleTime)
      : scenario.cycleTime;

    // equipmentが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const equipment = typeof scenario.equipment === 'string'
      ? JSON.parse(scenario.equipment)
      : scenario.equipment;

    // laborCostが文字列の場合はパース、オブジェクトの場合はそのまま使用
    const laborCost: LaborCostScenario | undefined = typeof scenario.laborCost === 'string'
      ? JSON.parse(scenario.laborCost)
      : scenario.laborCost;

    return {
      id: scenario.scenarioId,
      name: scenario.scenarioName,
      updateDate: scenario.updateDate,
      improvedWorkingDayByYear: workingDays?.workingDay || [],
      improvedHolidayByYear: workingDays?.holiday || [],
      improvedLineCountByYear: workingDays?.lineCount || [],
      improvedOverTimeByYear: nonWorkingHours?.overTime || [],
      improvedAvailabilityRateByMonth: nonWorkingHours?.availabilityRate || [],
      improvedYieldRateList: yieldRate?.yieldRateData ? JSON.parse(yieldRate.yieldRateData) : [],
      improvedCycleTimeList: cycleTime?.cycleTimeData ? JSON.parse(cycleTime.cycleTimeData) : [],
      improvedWorkingDaysData: workingDays?.workingDaysData || [],
      improvedNonWorkingHoursData: nonWorkingHours?.nonWorkingHoursData || [],
      equipmentAmounts: equipment?.equipmentsData ? JSON.parse(equipment.equipmentsData) : [],
      quantityAndPrice: [],
      scenarioLaborCostByMonth: laborCost?.productionLaborCostByMonth ?? [],
      scenarioOverseasFactoryExpensesByMonth: laborCost?.overseasFactoryExpensesByMonth ?? [],
      scenarioProductionFactoryLaborUnitPrice: laborCost?.productionFactoryLaborUnitPrice ?? null,
      scenarioProductionFactoryExpenseUnitPrice: laborCost?.productionFactoryExpenseUnitPrice ?? null,
      scenarioBaseLaborCostIncreaseRate: laborCost?.baseLaborCostIncreaseRate ?? null,
      applyDownside: scenario.applyDownside ?? true,
    };
  };

  /**
   * シミュレーション設定の入力値を初期値にリセットする
   * @param showToast トーストメッセージを表示するかどうか（デフォルト: false）
   */
  const resetSimulationConfigInputs = (showToast: boolean = false) => {
    // 設定名をクリア
    setConfigNameInput("");

    // ストレス反映フラグを初期値に戻す
    setApplyDownsideInput(true);

    // 設備・人員構成を初期値に戻す
    setEquipmentAmounts(originalEquipmentAmounts);

    // 稼働日数関連を初期値に戻す
    setImprovedWorkingDaysData(originalImprovedWorkingDaysData);
    if (originalImprovedWorkingDaysData && originalImprovedWorkingDaysData.length > 0) {
      const workingDayByYearData = originalImprovedWorkingDaysData.map((workingDays) => ({
        fiscalYear: workingDays.fiscalYear,
        workingDay: workingDays.workingDaysData.workingDays,
      }));
      setImprovedWorkingDayByYear(workingDayByYearData);

      setImprovedHolidayByYear(
        originalImprovedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
        }))
      );

      setImprovedLineCountByYear(
        originalImprovedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
        }))
      );
    }

    // 非稼働時間を初期値に戻す
    setImprovedNonWorkingHoursData(originalImprovedNonWorkingHoursData);
    if (originalImprovedNonWorkingHoursData && originalImprovedNonWorkingHoursData.length > 0) {
      const availabilityRates = originalImprovedNonWorkingHoursData.map(({ fiscalYear, nonWorkingHoursByMonth }) => ({
        fiscalYear,
        availabilityRate: nonWorkingHoursByMonth.map((item) => Number(item?.availabilityRate ?? 0)),
      }));
      setImprovedAvailabilityRateByMonth(availabilityRates);
    }

    // 歩留改善を初期値に戻す
    setImprovedYieldRateList(originalImprovedYieldRateList);
    if (originalImprovedYieldRateList && originalImprovedYieldRateList.length > 0) {
      setImprovedYieldRate(originalImprovedYieldRateList[0].yieldRate);
      setImprovedYieldRateText(originalImprovedYieldRateList[0].yieldRateText);
    }

    // サイクルタイム改善を初期値に戻す
    setImprovedCycleTimeList(originalImprovedCycleTimeList);
    if (originalImprovedCycleTimeList && originalImprovedCycleTimeList.length > 0) {
      setImprovedCycleTime(originalImprovedCycleTimeList[0].cycleTime);
      setImprovedCycleTimeText(originalImprovedCycleTimeList[0].cycleTimeText);
    }

    // 労務費（月別）を費用画面のオリジナル値に戻す
    {
      const { laborCost, overseasExpenses } = getOriginalLaborCostArrays();
      setScenarioLaborCostByMonth(laborCost);
      setScenarioOverseasFactoryExpensesByMonth(overseasExpenses);
    }
    // 単価・ベースアップ率を費用画面の設定値（初期値）に戻す
    setScenarioProductionFactoryLaborUnitPrice(projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(projectData?.baseLaborCostIncreaseRate ?? null);

    // 保存済み設定一覧の選択状態をクリア
    setSelectedConfigIdForInput(null);

    // トーストメッセージを表示
    if (showToast) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.resetCompleted'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.resetSimulation'),
        status: "info",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /**
   * 保存された設定をシミュレーション設定の入力項目に反映する
   */
  const loadConfigToInputFields = (config: SavedSimulationConfig) => {
    // 設定名を反映
    setConfigNameInput(config.name);

    // ストレス反映フラグを反映
    setApplyDownsideInput(config.applyDownside ?? true);

    // 設備・人員構成を反映（初期値をベースに、保存済み設定に含まれる設備のみを有効にする）
    const mergedEquipments = originalEquipmentAmounts.map(equipment => {
      const savedConfig = config.equipmentAmounts.find(e => e.equipmentId === equipment.equipmentId);
      if (savedConfig) {
        // 保存済み設定に含まれている設備の場合、初期値に保存済みの拡張フィールドをマージ
        return {
          ...equipment,
          selected: true,
          changeInQuantity: savedConfig.changeInQuantity,
          changedAcceptanceMonth: savedConfig.changedAcceptanceMonth,
          changedDepreciationStartMonth: savedConfig.changedDepreciationStartMonth
        };
      } else {
        // 保存済み設定に含まれていない設備の場合、初期値をベースに無効化
        return { ...equipment, selected: false };
      }
    });
    setEquipmentAmounts(mergedEquipments);

    // 稼働日数関連を反映
    setImprovedWorkingDaysData(config.improvedWorkingDaysData);
    if (config.improvedWorkingDaysData && config.improvedWorkingDaysData.length > 0) {
      const workingDayByYearData = config.improvedWorkingDaysData.map((workingDays) => ({
        fiscalYear: workingDays.fiscalYear,
        workingDay: workingDays.workingDaysData.workingDays,
      }));
      setImprovedWorkingDayByYear(workingDayByYearData);

      setImprovedHolidayByYear(
        config.improvedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
        }))
      );

      setImprovedLineCountByYear(
        config.improvedWorkingDaysData.map((workingDays) => ({
          fiscalYear: workingDays.fiscalYear,
          lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
        }))
      );
    }

    // 非稼働時間を反映
    setImprovedNonWorkingHoursData(config.improvedNonWorkingHoursData);
    if (config.improvedNonWorkingHoursData && config.improvedNonWorkingHoursData.length > 0) {
      const availabilityRates = config.improvedNonWorkingHoursData.map(({ fiscalYear, nonWorkingHoursByMonth }) => ({
        fiscalYear,
        availabilityRate: nonWorkingHoursByMonth.map((item) => Number(item?.availabilityRate ?? 0)),
      }));
      setImprovedAvailabilityRateByMonth(availabilityRates);
    }

    // 歩留改善を反映
    setImprovedYieldRateList(config.improvedYieldRateList);
    if (config.improvedYieldRateList && config.improvedYieldRateList.length > 0) {
      setImprovedYieldRate(config.improvedYieldRateList[0].yieldRate);
      setImprovedYieldRateText(config.improvedYieldRateList[0].yieldRateText);
    }

    // サイクルタイム改善を反映
    setImprovedCycleTimeList(config.improvedCycleTimeList);
    if (config.improvedCycleTimeList && config.improvedCycleTimeList.length > 0) {
      setImprovedCycleTime(config.improvedCycleTimeList[0].cycleTime);
      setImprovedCycleTimeText(config.improvedCycleTimeList[0].cycleTimeText);
    }

    // 労務費を反映
    setScenarioLaborCostByMonth(config.scenarioLaborCostByMonth ?? []);
    setScenarioOverseasFactoryExpensesByMonth(config.scenarioOverseasFactoryExpensesByMonth ?? []);
    // 単価・ベースアップ率を反映（旧データにない場合は費用画面の値を初期値とする）
    setScenarioProductionFactoryLaborUnitPrice(config.scenarioProductionFactoryLaborUnitPrice ?? projectData?.productionFactoryLaborUnitPrice ?? null);
    setScenarioProductionFactoryExpenseUnitPrice(config.scenarioProductionFactoryExpenseUnitPrice ?? projectData?.productionFactoryExpenseUnitPrice ?? null);
    setScenarioBaseLaborCostIncreaseRate(config.scenarioBaseLaborCostIncreaseRate ?? projectData?.baseLaborCostIncreaseRate ?? null);

    toast({
      title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.configLoaded'),
      description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.configReflected', { configName: config.name }),
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  /**
   * 保存済み設定の入力項目反映用チェックボックスの変更ハンドラー
   */
  const handleConfigSelectionForInput = (configId: string) => {
    if (selectedConfigIdForInput === configId) {
      // 既に選択されている場合は解除
      setSelectedConfigIdForInput(null);
    } else {
      // 選択されていない場合は選択して入力項目に反映
      const config = savedConfigs.find(c => c.id === configId);
      if (config) {
        setSelectedConfigIdForInput(configId);
        loadConfigToInputFields(config);
      }
    }
  };

  /**
   * シミュレーション設定を保存する
   */
  const saveSimulationConfig = async () => {
    if (!configNameInput.trim()) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.enterConfigName'),
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // 保存前のデータ妥当性チェック
    if (
      !improvedWorkingDaysData ||
      improvedWorkingDaysData.length === 0 ||
      !improvedNonWorkingHoursData ||
      improvedNonWorkingHoursData.length === 0
    ) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataError'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.incompleteWorkingDays'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // 各要素にnonWorkingHoursByMonthが存在することを確認
    const hasValidNonWorkingHoursData = improvedNonWorkingHoursData.every(
      item => item.nonWorkingHoursByMonth && item.nonWorkingHoursByMonth.length > 0
    );

    if (!hasValidNonWorkingHoursData) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataError'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.incompleteNonWorkingHours'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error('Invalid nonWorkingHoursData before save:', improvedNonWorkingHoursData);
      return;
    }

    // 既存の設定を更新する場合は、savedConfigsから該当する設定を取得
    let scenarioId: string | undefined;
    let updateDate: string | undefined;

    if (selectedConfigIdForInput) {
      // savedConfigsから選択された設定を検索
      const targetConfig = savedConfigs.find((config) => config.id === selectedConfigIdForInput);

      if (targetConfig) {
        // 既存の設定を更新する場合は、scenarioIdとupdateDateを使用
        scenarioId = targetConfig.id;
        updateDate = targetConfig.updateDate;
      } else {
        toast({
          title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.configNotFound'),
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.configDeletedNewSave'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    }

    // DB保存
    const result = await saveScenarioData(false, updateDate, scenarioId);

    // 処理失敗時は中止
    if (!result) return;

    // 初期化
    resetSimulationConfigInputs();

    // DB取得
    const scenarioData = await fetchScenarioData();

    // DB から取得したデータを SavedSimulationConfig 形式に変換
    const convertedConfigs = scenarioData.map(convertTScenarioToSavedConfig);

    // 保存済み設定一覧を更新
    setSavedConfigs(convertedConfigs);

    // 入力項目反映用の選択状態もクリア
    setSelectedConfigIdForInput(null);

  };

  /**
   * シミュレーション設定を削除する
   */
  const deleteSimulationConfig = async (configId: string) => {
    const functionName = "deleteSimulationConfig";

    // DB から最新のシナリオデータを取得
    const scenarioData = await fetchScenarioData();

    // 削除対象のシナリオを検索（hasDeleted: falseで取得しているので、削除済みは含まれない）
    const targetScenario = scenarioData.find((scenario: TScenario) => scenario.scenarioId === configId);

    if (!targetScenario) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.deleteFailed'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.scenarioNotFound'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // GraphQL mutation（物理削除）
    const query = `
      mutation deleteScenario($input: DeleteScenarioInput!) {
        deleteScenario(input: $input) {
          status
        }
      }
    `;

    try {
      const result = await WebAPI.request({
        query: query,
        variables: {
          input: {
            projectId: targetScenario.projectId,
            scenarioId: targetScenario.scenarioId,
            ...(reviewDate && { reviewDate }),
          },
        },
      });

      // console.log(`${functionName} result: `, JSON.stringify(result));

      // APIレスポンスのステータスチェック
      const status = result?.data?.deleteScenario?.status;

      if (status === "success") {
        toast({
          title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.configDeleted'),
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        console.log(`${functionName}: 削除成功`);

        // シミュレーション設定の入力値を初期値にリセット
        resetSimulationConfigInputs();

        // 最新データを再取得して保存済み設定一覧を更新
        const updatedScenarioData = await fetchScenarioData();
        const convertedConfigs = updatedScenarioData.map(convertTScenarioToSavedConfig);

        setSavedConfigs(convertedConfigs);

        // 削除された設定が選択中の場合、選択状態から除外
        setSelectedConfigIds(prev => prev.filter(id => id !== configId));

        // 削除された設定のグラフデータを配列から削除
        setSalesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setQuantitiesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setMergedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setCombinedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setMonthOfRecoveryForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setIncrementalCashFlowForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setProductionCapacityChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
        setProductionCapacityProcessChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));

        // 削除された設定が入力項目反映用に選択されていた場合、クリア
        if (selectedConfigIdForInput === configId) {
          setSelectedConfigIdForInput(null);
        }
      } else if (status === "expired") {
        toast({
          title: TITLE,
          description: Messages.expiredMessage,
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        console.warn(`${functionName}: Conflict error. データが期限切れです。`);
      } else {
        toast({
          title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.deleteFailed'),
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.deleteProcessFailed'),
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        console.error(`${functionName}: Failed to call API. Errors: `, result?.errors);
      }
    } catch (error) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.systemError'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.errorDuringDelete'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
    }
  };

  /**
   * シミュレーション設定の選択をトグルする（最大2つ）
   */
  const toggleConfigSelection = (configId: string) => {
    if (selectedConfigIds.includes(configId)) {
      // 既に選択されている場合は解除
      const newSelectedIds = selectedConfigIds.filter(id => id !== configId);
      setSelectedConfigIds(newSelectedIds);

      // 解除された設定のグラフデータを配列から削除
      setSalesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setQuantitiesChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setMergedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setCombinedChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setMonthOfRecoveryForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setIncrementalCashFlowForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setProductionCapacityChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
      setProductionCapacityProcessChartDataForSavedConfig(prev => prev.filter(item => item.configId !== configId));
    } else {
      // 選択されていない場合
      if (selectedConfigIds.length >= 2) {
        toast({
          title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.maxTwoSelection'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // 選択を追加（useEffectで自動的にグラフが生成される）
      const newSelectedIds = [...selectedConfigIds, configId];
      setSelectedConfigIds(newSelectedIds);
    }
  };

  /** 「ストレス指数」モーダル制御用 */
  const [isOpenDownsideIndex, setIsOpenDownsideIndex] = useState<boolean>(false);

  /**
   * エラー情報をクリアする。
   * @returns デフォルトエラー情報
   */
  const clearErrors = (): Errors => {
    return {
      yieldRate: {
        isError: false,
        errorMessage: "",
      },
      cycleTime: {
        isError: false,
        errorMessage: "",
      },
      finalInvestmentReason: {
        isError: false,
        errorMessage: "",
      },

    };
  }

  /**
   * エラー情報を変更する。
   * @param propertyName プロパティ名
   * @param isError true：入力エラー、false：入力正常
   * @param errorMessage エラーメッセージ
   */
  const changeErrors = (propertyName: string, isError: boolean, errorMessage: string) => {
    setErrors((prevState => ({
      ...prevState,
      [propertyName]: {
        isError: isError,
        errorMessage: errorMessage,
      },
    })));
  }

  /** バリデーションエラー情報 */
  const [errors, setErrors] = useState<Errors>(clearErrors());

  /**
   * 年度調整された年月を取得する関数
   * 稼働日数・休日・稼働率データの取得に使用（年度ベースのデータ配列用）
   * @param labels 年月ラベル配列
   * @param index インデックス
   * @returns 年度調整された年月（1-3月の場合、yearを-1する）
   */
  const getFiscalYearMonth = (labels: string[], index: number): { year: number, month: number } => {
    const year = parseInt(labels[index].split("/")[0]);
    const month = parseInt(labels[index].split("/")[1]);
    const adjustedYear = month >= 1 && month <= 3 ? year - 1 : year;
    return { year: adjustedYear, month: month };
  };

  /**
   * グラフの開始月を取得する
   * @returns 開始月 (YYYY-MM形式)
   */
  const getGraphStartMonth = useCallback((): string => {
    if (originalProfitAndLossByMonth?.labels && originalProfitAndLossByMonth.labels.length > 0) {
      return originalProfitAndLossByMonth.labels[0].replace("/", "-");
    }
    return "";
  }, [originalProfitAndLossByMonth]);

  /**
   * グラフの終了月を取得する
   * @returns 終了月 (YYYY-MM形式)
   */
  const getGraphEndMonth = useCallback((): string => {
    if (originalProfitAndLossByMonth?.labels && originalProfitAndLossByMonth.labels.length > 0) {
      return originalProfitAndLossByMonth.labels[originalProfitAndLossByMonth.labels.length - 1].replace("/", "-");
    }
    return "";
  }, [originalProfitAndLossByMonth]);

  /**
   * 指定した年月に適用すべき歩留を取得する
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param yieldRateList 改善後歩留リスト
   * @param getBomYieldRate BOMから月別歩留を取得する関数（改善適用前に使用）
   * @returns 適用すべき歩留 (0-1の範囲)
   */
  const getApplicableYieldRate = (
    targetYearMonth: string,
    yieldRateList: YieldRateImprovement[],
    getBomYieldRate?: (targetYearMonth: string) => number | null
  ): number => {
    // 常に現在の改善データを使用
    const yieldRateListToUse = yieldRateList || [];

    // targetYearMonthをYYYY-MM形式に変換
    const targetMonth = targetYearMonth.replace("/", "-");

    // 適用可能な歩留改善を日付順にソート
    const sortedImprovements = [...yieldRateListToUse]
      .filter(item => item.month !== "")
      .sort((a, b) => a.month.localeCompare(b.month));

    // 改善リストが空、または最初の改善適用月より前の場合はBOMデータを使用
    if (sortedImprovements.length === 0) {
      if (getBomYieldRate) {
        const bomValue = getBomYieldRate(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 最初の改善適用月より前の場合はBOMデータを使用
    const firstImprovementMonth = sortedImprovements[0].month;
    if (targetMonth < firstImprovementMonth) {
      if (getBomYieldRate) {
        const bomValue = getBomYieldRate(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 改善適用月以降は、対象月以前で最も新しい改善値を使用
    let applicableYieldRate = sortedImprovements[0].yieldRate;
    for (const improvement of sortedImprovements) {
      if (improvement.month <= targetMonth) {
        applicableYieldRate = improvement.yieldRate;
      } else {
        break;
      }
    }

    return applicableYieldRate;
  };

  /**
   * 歩留改善項目を追加する
   */
  const addYieldRateImprovement = useCallback(() => {
    // 日付未選択時は0を初期値とする（月選択時にBOM歩留を取得して設定）
    // ※対応D: 関数型更新にすることでuseCallbackを依存配列なしで安定化し、行コンポーネントのReact.memoを効かせる
    setImprovedYieldRateList(prev => [
      ...prev,
      {
        month: "",
        yieldRate: 0,
        yieldRateText: "0.0",
      }
    ]);
  }, []);

  /**
   * 歩留改善項目を削除する
   * @param index 削除する項目のインデックス
   */
  const removeYieldRateImprovement = useCallback((index: number) => {
    setImprovedYieldRateList(prev => prev.filter((_, i) => i !== index));
  }, []);

  /**
   * BOMデータ全件から「年月キー（YYYY-MM）→ 歩留累積値（0-1の範囲）」の事前計算Mapを生成する
   * ※ `bomData`が変化した時のみ再計算する（毎レンダリングでのBOM全走査＋JSON.parseを回避するための対応A）
   * 既存の`getYieldRateFromBom`が行っていた「全工程の積をDecimalで積算する」ロジックをそのまま踏襲する
   */
  const yieldRateByYearMonthMap = useMemo(() => {
    const productMap = new Map<string, Decimal>();
    const hasValueMap = new Map<string, boolean>();
    if (!bomData || bomData.length === 0) {
      return new Map<string, number>();
    }

    for (const bom of bomData) {
      if (bom.yieldMonthly) {
        try {
          const monthlyData = JSON.parse(bom.yieldMonthly);
          for (const [yearMonthKey, value] of Object.entries(monthlyData)) {
            if (value !== undefined && value !== null && value !== "") {
              const yieldValue = parseFloat(value as string);
              if (!isNaN(yieldValue)) {
                const currentProduct = productMap.get(yearMonthKey) ?? new Decimal(1);
                productMap.set(yearMonthKey, currentProduct.mul(new Decimal(yieldValue).div(100)));
                hasValueMap.set(yearMonthKey, true);
              }
            }
          }
        } catch (e) {
          console.warn("Failed to parse yieldMonthly:", e);
        }
      }
    }

    const map = new Map<string, number>();
    for (const [yearMonthKey, hasValue] of hasValueMap.entries()) {
      if (hasValue) {
        map.set(yearMonthKey, productMap.get(yearMonthKey)!.toNumber());
      }
    }

    return map;
  }, [bomData]);

  /**
   * BOMデータ全件から「年月キー（YYYY-MM）→ サイクルタイム最大値（秒）」の事前計算Mapを生成する
   * ※ `bomData`が変化した時のみ再計算する（毎レンダリングでのBOM全走査＋JSON.parseを回避するための対応A）
   * 既存の`getCycleTimeFromBom`が行っていた「複数BOMがある場合は最大値＝ネック工程を採用する」ロジックをそのまま踏襲する
   */
  const cycleTimeByYearMonthMap = useMemo(() => {
    const map = new Map<string, number>();
    if (!bomData || bomData.length === 0) {
      return map;
    }

    for (const bom of bomData) {
      if (bom.cycleTimeMonthly) {
        try {
          const monthlyData = JSON.parse(bom.cycleTimeMonthly);
          for (const [yearMonthKey, value] of Object.entries(monthlyData)) {
            if (value !== undefined && value !== null && value !== "") {
              const cycleTimeValue = parseFloat(value as string);
              const currentMax = map.get(yearMonthKey);
              if (!isNaN(cycleTimeValue) && (currentMax === undefined || cycleTimeValue > currentMax)) {
                map.set(yearMonthKey, cycleTimeValue);
              }
            }
          }
        } catch (e) {
          console.warn("Failed to parse cycleTimeMonthly:", e);
        }
      }
    }

    return map;
  }, [bomData]);

  /**
   * BOMデータから指定した年月の歩留（累積＝全工程の積）を取得する
   * ※事前計算済みの`yieldRateByYearMonthMap`を参照するだけの軽量関数（対応A：Map lookup化）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @returns 歩留（0-1の範囲）、データがない場合はnull
   */
  const getYieldRateFromBom = useCallback(
    (targetYearMonth: string): number | null => {
      // YYYY/MM → YYYY-MM 形式に変換
      const yearMonthKey = targetYearMonth.replace("/", "-");
      return yieldRateByYearMonthMap.has(yearMonthKey) ? yieldRateByYearMonthMap.get(yearMonthKey)! : null;
    },
    [yieldRateByYearMonthMap]
  );

  /**
   * 歩留改善項目の月を更新する
   * @param index 更新する項目のインデックス
   * @param month 新しい月
   */
  const updateYieldRateMonth = useCallback((index: number, month: string) => {
    // 選択された月のBOM歩留を取得して初期値として設定（YYYY-MM → YYYY/MM形式に変換）
    const bomYieldRate = (month ? getYieldRateFromBom(month.replace("-", "/")) : null) || 0;
    const yieldRateValue = bomYieldRate * 100;
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        month,
        yieldRate: bomYieldRate,
        yieldRateText: yieldRateValue.toFixed(1)
      };
      return updated;
    });
  }, [getYieldRateFromBom]);

  /**
   * 歩留改善項目の歩留テキストのみを更新する（入力中の再レンダリング範囲を最小化するため）
   * @param index 更新する項目のインデックス
   * @param yieldRateText 歩留テキスト
   */
  const updateYieldRateText = useCallback((index: number, yieldRateText: string) => {
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], yieldRateText };
      return updated;
    });
  }, []);

  /**
   * 歩留改善項目の歩留を更新する
   * @param index 更新する項目のインデックス
   * @param yieldRateText 歩留テキスト
   */
  const updateYieldRateValue = useCallback((index: number, yieldRateText: string) => {
    const parsedValue = Number(yieldRateText);
    const clampedValue = Math.min(Math.max(parsedValue, 0), 100);
    const formattedValue = Number(clampedValue || 0).toFixed(1);
    const newYieldRate = Number(new Decimal(formattedValue).div(100));
    setImprovedYieldRateList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        yieldRateText: formattedValue,
        yieldRate: newYieldRate
      };

      // 後方互換用の値も更新（最初の項目の値を使用）
      if (index === 0 || prev.length === 1) {
        setImprovedYieldRate(newYieldRate);
        setImprovedYieldRateText(formattedValue);
      }
      return updated;
    });
  }, []);

  /**
   * 指定した年月に適用すべきサイクルタイムを取得する
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param cycleTimeList 改善後サイクルタイムリスト
   * @param getBomCycleTime BOMから月別サイクルタイムを取得する関数（改善適用前に使用）
   * @returns 適用すべきサイクルタイム (秒)
   */
  const getApplicableCycleTime = (
    targetYearMonth: string,
    cycleTimeList: CycleTimeImprovement[],
    getBomCycleTime?: (targetYearMonth: string) => number | null
  ): number => {
    // 常に現在の改善データを使用
    const cycleTimeListToUse = cycleTimeList || [];

    // targetYearMonthをYYYY-MM形式に変換
    const targetMonth = targetYearMonth.replace("/", "-");

    // 適用可能なサイクルタイム改善を日付順にソート
    const sortedImprovements = [...cycleTimeListToUse]
      .filter(item => item.month !== "")
      .sort((a, b) => a.month.localeCompare(b.month));

    // 改善リストが空、または最初の改善適用月より前の場合はBOMデータを使用
    if (sortedImprovements.length === 0) {
      if (getBomCycleTime) {
        const bomValue = getBomCycleTime(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 最初の改善適用月より前の場合はBOMデータを使用
    const firstImprovementMonth = sortedImprovements[0].month;
    if (targetMonth < firstImprovementMonth) {
      if (getBomCycleTime) {
        const bomValue = getBomCycleTime(targetYearMonth);
        return bomValue ?? 0;
      }
      return 0;
    }

    // 改善適用月以降は、対象月以前で最も新しい改善値を使用
    let applicableCycleTime = sortedImprovements[0].cycleTime;
    for (const improvement of sortedImprovements) {
      if (improvement.month <= targetMonth) {
        applicableCycleTime = improvement.cycleTime;
      } else {
        break;
      }
    }

    return applicableCycleTime;
  };

  /**
   * サイクルタイム改善項目を追加する
   */
  const addCycleTimeImprovement = useCallback(() => {
    // BOMがない場合の初期値は0
    // ※対応D: 関数型更新にすることでuseCallbackを依存配列なしで安定化し、行コンポーネントのReact.memoを効かせる
    setImprovedCycleTimeList(prev => [
      ...prev,
      {
        month: "", // 日付入力フィールドはそのまま（空欄）
        cycleTime: 0,
        cycleTimeText: "0.0",
      }
    ]);
  }, []);

  /**
   * サイクルタイム改善項目を削除する
   * @param index 削除する項目のインデックス
   */
  const removeCycleTimeImprovement = useCallback((index: number) => {
    setImprovedCycleTimeList(prev => prev.filter((_, i) => i !== index));
  }, []);

  /**
   * BOMデータから指定した年月のサイクルタイム（最大値＝ネック工程）を取得する
   * ※事前計算済みの`cycleTimeByYearMonthMap`を参照するだけの軽量関数（対応A：Map lookup化）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @returns サイクルタイム（秒）、データがない場合はnull
   */
  const getCycleTimeFromBom = useCallback(
    (targetYearMonth: string): number | null => {
      // YYYY/MM → YYYY-MM 形式に変換
      const yearMonthKey = targetYearMonth.replace("/", "-");
      return cycleTimeByYearMonthMap.has(yearMonthKey) ? cycleTimeByYearMonthMap.get(yearMonthKey)! : null;
    },
    [cycleTimeByYearMonthMap]
  );

  /**
   * サイクルタイム改善項目の月を更新する
   * @param index 更新する項目のインデックス
   * @param month 新しい月
   */
  const updateCycleTimeMonth = useCallback((index: number, month: string) => {
    // 選択された月のBOMサイクルタイムを取得、なければ0
    const bomCycleTime = (month ? getCycleTimeFromBom(month.replace("-", "/")) : null) || 0;
    const cycleTimeValue = bomCycleTime;
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        month,
        cycleTime: bomCycleTime,
        cycleTimeText: cycleTimeValue.toFixed(1)
      };
      return updated;
    });
  }, [getCycleTimeFromBom]);

  /**
   * サイクルタイム改善項目のサイクルタイムテキストのみを更新する（入力中の再レンダリング範囲を最小化するため）
   * @param index 更新する項目のインデックス
   * @param cycleTimeText サイクルタイムテキスト
   */
  const updateCycleTimeText = useCallback((index: number, cycleTimeText: string) => {
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], cycleTimeText };
      return updated;
    });
  }, []);

  /**
   * サイクルタイム改善項目のサイクルタイムを更新する
   * @param index 更新する項目のインデックス
   * @param cycleTimeText サイクルタイムテキスト
   */
  const updateCycleTimeValue = useCallback((index: number, cycleTimeText: string) => {
    const parsedValue = Number(cycleTimeText);
    const clampedValue = Math.max(parsedValue, 0);
    const formattedValue = Number(clampedValue || 0).toFixed(1);
    setImprovedCycleTimeList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        cycleTimeText: formattedValue,
        cycleTime: Number(formattedValue)
      };

      // 後方互換用の値も更新（最初の項目の値を使用）
      if (index === 0 || prev.length === 1) {
        setImprovedCycleTime(Number(formattedValue));
        setImprovedCycleTimeText(formattedValue);
      }
      return updated;
    });
  }, []);

  // ▼ 保存されたシミュレーション設定
  /** 保存されたシミュレーション設定リスト */
  const [savedConfigs, setSavedConfigs] = useState<SavedSimulationConfig[]>([]);
  /** 選択されたシミュレーション設定のID（最大2つ） */
  const [selectedConfigIds, setSelectedConfigIds] = useState<string[]>([]);
  /** 設定保存時の名前入力値（onBlurで更新し、入力中の再レンダリングを防ぐ） */
  const [configNameInput, setConfigNameInput] = useState<string>("");
  /** シミュレーション設定の入力項目に反映する設定ID */
  const [selectedConfigIdForInput, setSelectedConfigIdForInput] = useState<string | null>(null);
  /** 選択状態復元済みフラグ（初回のみ実行） */
  const [hasRestoredSelection, setHasRestoredSelection] = useState<boolean>(false);

  // ▼ PartNo データ
  /** 【参照データ】「数量・単価」で登録したデータ */
  const [capexPartNo, setCapexPartNo] = useState<PartNo[]>([]);
  /** 【参照データ】「数量・単価」で登録したデータ(過去プロジェクト) */

  /** 月別材料費単価（パーツNo別、キー: YYYY-MM形式） */
  const [partNoToMonthlyMaterialCost, setPartNoToMonthlyMaterialCost] = useState<Map<string, Record<string, Decimal>> | null>(null);

  /** どの部署の確認かを表す */
  const [confirmSource, setConfirmSource] = useState<string>("");

  /** モーダル表示制御用：確認モーダル */
  const { isOpen: isOpenConfirmModal, onOpen: onOpenConfirmModal, onClose: onCloseConfirmModal } = useDisclosure()

  /** モーダル保存ボタンの活性制御 */
  const [isSaving, setIsSaving] = useState(false);

  // 数量・単価で入力した通貨の小数有無を管理
  const [decimalCurrency, setDecimalCurrency] = useState<boolean>(false);
  /** 表示通貨の小数点有無 */
  const displayDecimalCurrency = useMemo(() => hasDecimal(selectedCurrency.name), [selectedCurrency.name]);

  // -----------------------------
  // 権限情報（displayFromCurrency より前に宣言が必要）
  // -----------------------------
  const { userPermissions, reviewDate, currencyData, currencyStatus } = useContext(ProjectContext) as ProjectContextType;

  // ▼ 表示通貨変換済みチャートデータ（表示用）
  /**
   * 振り返りモード時は calcXxx 関数がすでに表示通貨で計算済み。
   * convertChartDatasets の from に表示通貨を渡すことで from===to となり変換をスキップ（二重変換防止）。
   * 通常モードは従来どおり localCurrencyName から変換する。
   */
  const displayFromCurrency = reviewDate ? selectedCurrency.name : localCurrencyName;

  /** 売上チャート（当初計画）表示用 */
  const displaySalesChartData = useMemo(() => {
    if (!salesChartData) return null;
    return convertChartDatasets(salesChartData, displayFromCurrency, selectedCurrency.name, currencyData, undefined, ["profitRate"]);
  }, [salesChartData, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 売上チャート（ダウンサイド）表示用 */
  const displaySalesChartData2 = useMemo(() => {
    if (!salesChartData2) return null;
    return convertChartDatasets(salesChartData2, displayFromCurrency, selectedCurrency.name, currencyData, undefined, ["profitRate"]);
  }, [salesChartData2, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 販売単価・材料単価（当初計画）表示用 */
  const displayMergedChartDataOriginal = useMemo(() => {
    if (!mergedChartDataOriginal) return null;
    return convertChartDatasets(mergedChartDataOriginal, localCurrencyName, selectedCurrency.name, currencyData);
  }, [mergedChartDataOriginal, localCurrencyName, selectedCurrency.name, currencyData]);

  /** 販売単価・材料単価（ダウンサイド）表示用 */
  const displayMergedChartDataModified = useMemo(() => {
    if (!mergedChartDataModified) return null;
    return convertChartDatasets(mergedChartDataModified, localCurrencyName, selectedCurrency.name, currencyData);
  }, [mergedChartDataModified, localCurrencyName, selectedCurrency.name, currencyData]);

  /** 増分キャッシュフロー（PJ全体）表示用 */
  const displayCombinedChartDataAll = useMemo(() => {
    if (!combinedChartDataAll) return null;
    return convertChartDatasets(combinedChartDataAll, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartDataAll, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 増分キャッシュフロー（当初投資）表示用 */
  const displayCombinedChartDataPast = useMemo(() => {
    if (!combinedChartDataPast) return null;
    return convertChartDatasets(combinedChartDataPast, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartDataPast, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 増分キャッシュフロー（増産投資回収：当初計画）表示用 */
  const displayCombinedChartData = useMemo(() => {
    if (!combinedChartData) return null;
    return convertChartDatasets(combinedChartData, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartData, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 増分キャッシュフロー（増産投資回収：ダウンサイド）表示用 */
  const displayCombinedChartDataModified = useMemo(() => {
    if (!combinedChartDataModified) return null;
    return convertChartDatasets(combinedChartDataModified, displayFromCurrency, selectedCurrency.name, currencyData);
  }, [combinedChartDataModified, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 保存済み設定用売上チャート表示用 */
  const displaySalesChartDataForSavedConfig = useMemo(() => {
    return salesChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: item.data ? convertChartDatasets(item.data, displayFromCurrency, selectedCurrency.name, currencyData, undefined, ["profitRate"]) : item.data,
    }));
  }, [salesChartDataForSavedConfig, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 保存済み設定用販売単価・材料単価チャート表示用 */
  const displayMergedChartDataForSavedConfig = useMemo(() => {
    return mergedChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: item.data ? convertChartDatasets(item.data, localCurrencyName, selectedCurrency.name, currencyData) : item.data,
    }));
  }, [mergedChartDataForSavedConfig, localCurrencyName, selectedCurrency.name, currencyData]);

  /** 保存済み設定用増分キャッシュフローチャート表示用 */
  const displayCombinedChartDataForSavedConfig = useMemo(() => {
    return combinedChartDataForSavedConfig.map(item => ({
      configId: item.configId,
      data: item.data ? convertChartDatasets(item.data, displayFromCurrency, selectedCurrency.name, currencyData) : item.data,
    }));
  }, [combinedChartDataForSavedConfig, displayFromCurrency, selectedCurrency.name, currencyData]);

  /**
   * 営業利益合計を算出。
   * chartData.costBreakdown がある場合、対象PJと同じ年度丸め方式で計算。
   * costBreakdown がない場合はフォールバック（合計→変換方式）。
   */
  const calcDisplayTotalProfit = (chartData: any): Decimal => {
    if (!chartData?.datasets) return new Decimal(0);
    // 振り返りモード: profit[] は月別レートで表示通貨に変換済み。
    // calcYearlyRoundedProfitTotal はソース通貨+単一レートで再計算するため使用不可。
    // calcTotalProfitAndRate でprofit[]を合計し、そのまま返す（既に表示通貨）。
    if (reviewDate) {
      return calcTotalProfitAndRate(chartData).totalProfit;
    }
    // 通常モード: costBreakdownがある場合は対象PJと同じ年度丸め方式で計算
    if (chartData.costBreakdown) {
      // 対象PJと一致させるため、changedDepreciationStartMonth適用前の元の設備データで計算
      const inputs = chartData.equipmentDepreciationInputs;
      const equipInputs = inputs?.originalEquipments
        ? { ...inputs, equipments: inputs.originalEquipments }
        : inputs;
      return calcYearlyRoundedProfitTotal(
        chartData.costBreakdown,
        localCurrencyName,
        selectedCurrency.name,
        currencyData,
        equipInputs,
        chartData.scrapCostInputs,
      );
    }
    // フォールバック: costBreakdownがない場合（合計→変換方式）
    const chartTotal = calcTotalProfitAndRate(chartData).totalProfit;
    if (localCurrencyName === selectedCurrency.name) {
      return chartTotal;
    }
    const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
    return convertCurrency(chartTotal, localCurrencyName, selectedCurrency.name, currencyData)
      .toDecimalPlaces(dp);
  };

  /** 確認担当者 */
  const [confirmor, setConfirmor] = useState<Confirmor | null>(null);

  /** 確認ボタン横幅 */
  const [buttonWidths, setButtonWidths] = useState<Record<string, number>>({});

  /** 確認ボタン下担当者名 */
  const [names, setNames] = useState<Record<string, ConfirmorInfo[]>>({
    companyDivision: [],
    companyHeadDivision: [],
  });

  /** 表示位置制御用 */
  const [position, setPosition] = useState({ x: 0, y: 0 });

  /** 表示状態管理 */
  const [mode, setMode] = useState("view"); // 初期表示状態は「シミュレーション表示」

  /** 営業データ連携タブの入力内容が未保存（初期値から変更あり）かどうか */
  const [isSalesDataLinkageDirty, setIsSalesDataLinkageDirty] = useState(false);
  /** タブ切替時の破棄確認ダイアログの開閉制御 */
  const { isOpen: isTabSwitchConfirmOpen, onOpen: onOpenTabSwitchConfirm, onClose: onCloseTabSwitchConfirm } = useDisclosure();
  /** 確認ダイアログで承認された場合に実際に遷移する先のmode */
  const pendingModeRef = useRef<string | null>(null);

  /** タブ切替要求。営業データ連携タブに未保存の入力がある場合は確認ダイアログを挟む */
  const requestModeChange = (nextMode: string) => {
    if (mode === "salesDataLinkage" && isSalesDataLinkageDirty && nextMode !== "salesDataLinkage") {
      pendingModeRef.current = nextMode;
      onOpenTabSwitchConfirm();
      return;
    }
    setMode(nextMode);
  };

  /** 権限用 画面パーミッション */
  const [pagePermissions, setPagePermissions] = useState<PagePermissions>();

  /** 振り返りモード用月別レート変換関数。reviewDate が null の場合は通常の convertCurrency を使用 */
  const convertWithRate = useCallback<ConvertFn>(
    (amount, from, to, yearMonth) => {
      if (yearMonth) {
        return convertCurrencyByMonth(amount, from, to, yearMonth, monthlyRateMap, currencyData);
      }
      return convertCurrency(amount, from, to, currencyData);
    },
    [monthlyRateMap, currencyData]
  );

  /** 設備データ（通貨変換前）。振り返りモードで月別レート到着後に再変換するために保持 */
  const rawEquipmentDataRef = useRef<EquipmentType[] | null>(null);

  /**
   * 振り返りモード: 設備金額を検収月の月別レートでローカル通貨に再変換する
   * fetchData が月別レート取得前に実行された場合でも、レート到着後に損益試算画面と同じレートへ揃える。
   * 選択状態・増減数等のユーザー編集項目は保持し、金額・単価・通貨のみ差し替える。
   */
  useEffect(() => {
    const rawEquipmentData = rawEquipmentDataRef.current;
    if (!reviewDate || monthlyRateMap.size === 0 || !rawEquipmentData || !localCurrencyName) {
      return;
    }
    const convertedById = new Map(
      convertEquipmentData(rawEquipmentData, localCurrencyName, currencyData, convertWithRate)
        .map(e => [e.equipmentId, e])
    );
    const applyConverted = (list: EquipmentExtType[]) => {
      let changed = false;
      const next = list.map(e => {
        const c = convertedById.get(e.equipmentId);
        if (!c || (c.amount === e.amount && c.unitPrice === e.unitPrice)) return e;
        changed = true;
        return { ...e, unitPrice: c.unitPrice, amount: c.amount, currencyId: c.currencyId, currencyName: c.currencyName };
      });
      // 差分がなければ同一参照を返し、不要な再計算を防ぐ
      return changed ? next : list;
    };
    setEquipmentAmounts(prev => applyConverted(prev));
    setOriginalEquipmentAmounts(prev => applyConverted(prev));
    // originalEquipmentAmounts: fetchData による設備読込完了をトリガーにする（差分なしなら同一参照のためループしない）
  }, [reviewDate, monthlyRateMap, localCurrencyName, currencyData, convertWithRate, originalEquipmentAmounts]);

  /** 「営業利益合計」ラベル横のヘルプアイコン（EOL後の残存減価償却費を含む旨を説明） */
  const operatingProfitTotalHelpIcon = (
    <Box as="span" display="inline-block" mx={1} verticalAlign="middle">
      <HelpIcon size="14" placement="top">
        <Text>{t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotalHelp')}</Text>
      </HelpIcon>
    </Box>
  );

  /** 実質的営業利益率（当初計画・売上セクション） */
  const realProfitRateOriginalMemo = useMemo((): { realProfitRate: string; realProfitRateByMonth: number[] } => {
    if (!salesChartData?.datasets || !mergedChartDataOriginal || !quantitiesChartDataOriginal || !originalProfitAndLossByMonth?.labels) {
      return { realProfitRate: "", realProfitRateByMonth: [] };
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return { realProfitRate: "", realProfitRateByMonth: [] };

    const salesDataset = salesChartData.datasets.find((d: any) => d.id === "sales");
    if (!salesDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] };
    }
    return calcRealProfitRateCommon({
      salesData: salesDataset.data.map((v: string | number) => new Decimal(v)),
      mergedData: mergedChartDataOriginal,
      quantitiesData: quantitiesChartDataOriginal,
      labels: originalProfitAndLossByMonth.labels,
      capexPartNo,
      equipments: originalEquipmentAmounts,
      projectData: projectData!,
      isDownside: false,
      localCurrencyName,
      currencyData,
      // 振り返りモード: salesChartDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      moldSales: projectData?.moldSalesByProject,
      developmentSales: projectData?.developmentSalesByProject,
      equipmentSales: projectData?.equipmentSalesByProject,
      convertFn: reviewDate ? convertWithRate : undefined,
    });
  }, [salesChartData, mergedChartDataOriginal, quantitiesChartDataOriginal, originalProfitAndLossByMonth, capexPartNo, originalEquipmentAmounts, projectData, localCurrencyName, currencyData, reviewDate, selectedCurrency.name, downsideIndexGraph, decimalCurrency, processCodeData, bomData, convertWithRate]);

  /** 実質的営業利益率（ダウンサイド・売上セクション） */
  const realProfitRateDownsideMemo = useMemo((): { realProfitRate: string; realProfitRateByMonth: number[] } => {
    if (!salesChartDataModified?.datasets || !mergedChartDataModified || !quantitiesChartDataModified || !originalProfitAndLossByMonth?.labels) {
      return { realProfitRate: "", realProfitRateByMonth: [] };
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return { realProfitRate: "", realProfitRateByMonth: [] };

    const salesDataset = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
    if (!salesDataset) {
      return { realProfitRate: "", realProfitRateByMonth: [] };
    }
    const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
    const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
    return calcRealProfitRateCommon({
      salesData: sales,
      mergedData: mergedChartDataModified,
      quantitiesData: quantitiesChartDataModified,
      labels: downsideLabels,
      capexPartNo,
      equipments: originalEquipmentAmounts,
      projectData: projectData!,
      isDownside: true,
      localCurrencyName,
      currencyData,
      // 振り返りモード: salesChartDataModifiedは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      moldSales: projectData?.moldSalesByProject,
      developmentSales: projectData?.developmentSalesByProject,
      equipmentSales: projectData?.equipmentSalesByProject,
      convertFn: reviewDate ? convertWithRate : undefined,
    });
  }, [salesChartDataModified, mergedChartDataModified, quantitiesChartDataModified, originalProfitAndLossByMonth, capexPartNo, originalEquipmentAmounts, projectData, localCurrencyName, currencyData, reviewDate, selectedCurrency.name, downsideIndexGraph, decimalCurrency, processCodeData, bomData, convertWithRate]);

  /** 実質的営業利益率（保存済み設定ごと・売上セクション） */
  const realProfitRateForConfigsMemo = useMemo(() => {
    return selectedConfigIds.map((configId): { configId: string; realProfitRate: string; realProfitRateByMonth: number[] } => {
      const config = savedConfigs.find(c => c.id === configId);
      const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
      const savedMergedData = mergedChartDataForSavedConfig.find(m => m.configId === configId);
      const originalSalesData = salesChartDataForSavedConfig.find(s => s.configId === configId);

      if (!config || !savedQuantitiesData?.data || !savedMergedData?.data || !originalSalesData?.data || !originalProfitAndLossByMonth?.labels) {
        return { configId, realProfitRate: "", realProfitRateByMonth: [] };
      }
      // 顧客指定部品の有無判断
      const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
      if (!a) return { configId, realProfitRate: "", realProfitRateByMonth: [] as number[] };

      const originalSalesDataset = originalSalesData.data.datasets?.find((d: any) => d.id === "sales");
      if (!originalSalesDataset) {
        return { configId, realProfitRate: "", realProfitRateByMonth: [] };
      }
      const sales = originalSalesDataset.data.map((v: string | number) => new Decimal(v));
      const savedConfigLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);

      const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
        ? capexPartNo.map(partNo => {
          const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
          return matched
            ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
            : partNo;
        })
        : capexPartNo;

      const savedEquipmentConfig = config.equipmentAmounts || [];
      const configEquipments = originalEquipmentAmounts
        .map(eq => {
          const savedEq = savedEquipmentConfig.find(se => se.equipmentId === eq.equipmentId);
          return savedEq ? { ...eq, selected: true } : null;
        })
        .filter((eq): eq is EquipmentExtType => eq !== null);

      const cfgApplyDownside = config.applyDownside !== false;
      const cfgDownsideIndex = cfgApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

      const result = calcRealProfitRateCommon({
        salesData: sales,
        mergedData: savedMergedData.data,
        quantitiesData: savedQuantitiesData.data,
        labels: savedConfigLabels,
        capexPartNo: savedConfigCapexPartNo,
        equipments: configEquipments,
        projectData: applyScenarioLaborCostToProjectData(
          projectData!,
          config.scenarioLaborCostByMonth,
          config.scenarioOverseasFactoryExpensesByMonth,
          savedConfigLabels
        ),
        isDownside: cfgApplyDownside,
        localCurrencyName,
        currencyData,
        // 振り返りモード: salesChartDataForSavedConfigは表示通貨(selectedCurrency)で月別レート変換済みのため、
        // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
        // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
        targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
        downsideIndexGraph: cfgDownsideIndex,
        decimalCurrency,
        processCodeData,
        bomData,
        moldSales: projectData?.moldSalesByProject,
        developmentSales: projectData?.developmentSalesByProject,
        equipmentSales: projectData?.equipmentSalesByProject,
        convertFn: reviewDate ? convertWithRate : undefined,
      });
      return { configId, ...result };
    });
  }, [selectedConfigIds, savedConfigs, salesChartDataForSavedConfig, mergedChartDataForSavedConfig, quantitiesChartDataForSavedConfig, originalProfitAndLossByMonth, capexPartNo, originalEquipmentAmounts, downsideIndexGraph, neutralDownsideIndex, projectData, localCurrencyName, currencyData, reviewDate, selectedCurrency.name, decimalCurrency, processCodeData, bomData, convertWithRate]);

  /** 実質的営業利益率（増産投資分回収：当初計画）— 増産・合理化開始以降の期間で算出 */
  const realProfitRateCashflowOriginalMemo = useMemo((): string => {
    if (!salesChartData2?.datasets || !salesChartData?.datasets || !mergedChartDataOriginal || !quantitiesChartDataOriginal || !originalProfitAndLossByMonth?.labels || !investmentStartYearMonth) {
      return "";
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return "";

    // salesChartData2 から totalSales / totalProfit を取得（ヘッダーの営業利益合計と同じソース）
    const salesDataset2 = salesChartData2.datasets.find((d: any) => d.id === "sales");
    const profitDataset2 = salesChartData2.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset2 || !profitDataset2) return "";
    const totalSalesVal = salesDataset2.data.reduce((sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0));
    const totalProfitVal = profitDataset2.data.reduce((sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0));

    // customerSpecifiedPartsCost を全期間データで算出
    const salesDatasetFull = salesChartData.datasets.find((d: any) => d.id === "sales");
    if (!salesDatasetFull) return "";
    const salesFull = salesDatasetFull.data.map((v: string | number) => new Decimal(v));

    // 投資開始以降でcustomerSpecifiedPartsCostのみsliceして合計、totalSales/totalProfitはsalesChartData2由来の値を使用
    const investmentStartPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);
    return calcRealProfitRateCommon({
      salesData: salesFull,
      mergedData: mergedChartDataOriginal,
      quantitiesData: quantitiesChartDataOriginal,
      labels: originalProfitAndLossByMonth.labels,
      capexPartNo,
      equipments: originalEquipmentAmounts,
      projectData: projectData!,
      isDownside: false,
      localCurrencyName,
      currencyData,
      // 振り返りモード: salesChartDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      moldSales: projectData?.moldSalesByProject,
      developmentSales: projectData?.developmentSalesByProject,
      equipmentSales: projectData?.equipmentSalesByProject,
      convertFn: reviewDate ? convertWithRate : undefined,
      investmentStartPos,
      // No.411追加対応: residualDepreciationTotalはsalesChartData2自身が持つ値
      // （投資開始以降のlabelsを基準に算出）を渡し、「営業利益率」側と基準を揃える
      totalsOverride: {
        totalSales: totalSalesVal,
        totalProfit: totalProfitVal,
        residualDepreciationTotal: salesChartData2.residualDepreciationTotal
          ? new Decimal(salesChartData2.residualDepreciationTotal)
          : new Decimal(0),
      },
    }).realProfitRate;
  }, [salesChartData2, salesChartData, mergedChartDataOriginal, quantitiesChartDataOriginal, originalProfitAndLossByMonth, investmentStartYearMonth, capexPartNo, originalEquipmentAmounts, projectData, localCurrencyName, currencyData, reviewDate, selectedCurrency.name, downsideIndexGraph, decimalCurrency, processCodeData, bomData, convertWithRate]);

  /** 実質的営業利益率（増産投資分回収：ダウンサイド）— 増産・合理化開始以降の期間で算出 */
  const realProfitRateCashflowModifiedMemo = useMemo((): string => {
    if (!salesChartDataModified2?.datasets || !salesChartDataModified?.datasets || !mergedChartDataModified || !quantitiesChartDataModified || !originalProfitAndLossByMonth?.labels || !investmentStartYearMonth) {
      return "";
    }
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (!a) return "";

    // salesChartDataModified2 から totalSales / totalProfit を取得（ヘッダーの営業利益合計と同じソース）
    const salesDataset2 = salesChartDataModified2.datasets.find((d: any) => d.id === "sales");
    const profitDataset2 = salesChartDataModified2.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset2 || !profitDataset2) return "";
    const totalSalesVal = salesDataset2.data.reduce((sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0));
    const totalProfitVal = profitDataset2.data.reduce((sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0));

    // customerSpecifiedPartsCost を全期間データで算出
    const salesDatasetFull = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
    if (!salesDatasetFull) return "";
    const salesFull = salesDatasetFull.data.map((v: string | number) => new Decimal(v));
    const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, salesFull.length);

    // 投資開始以降でcustomerSpecifiedPartsCostのみsliceして合計、totalSales/totalProfitはsalesChartDataModified2由来の値を使用
    const investmentStartPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);
    return calcRealProfitRateCommon({
      salesData: salesFull,
      mergedData: mergedChartDataModified,
      quantitiesData: quantitiesChartDataModified,
      labels: downsideLabels,
      capexPartNo,
      equipments: originalEquipmentAmounts,
      projectData: projectData!,
      isDownside: true,
      localCurrencyName,
      currencyData,
      // 振り返りモード: salesChartDataModifiedは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      moldSales: projectData?.moldSalesByProject,
      developmentSales: projectData?.developmentSalesByProject,
      equipmentSales: projectData?.equipmentSalesByProject,
      convertFn: reviewDate ? convertWithRate : undefined,
      investmentStartPos,
      // No.411追加対応: residualDepreciationTotalはsalesChartDataModified2自身が持つ値
      // （投資開始以降のlabelsを基準に算出）を渡し、「営業利益率」側と基準を揃える
      totalsOverride: {
        totalSales: totalSalesVal,
        totalProfit: totalProfitVal,
        residualDepreciationTotal: salesChartDataModified2.residualDepreciationTotal
          ? new Decimal(salesChartDataModified2.residualDepreciationTotal)
          : new Decimal(0),
      },
    }).realProfitRate;
  }, [salesChartDataModified2, salesChartDataModified, mergedChartDataModified, quantitiesChartDataModified, originalProfitAndLossByMonth, investmentStartYearMonth, capexPartNo, originalEquipmentAmounts, projectData, localCurrencyName, currencyData, reviewDate, selectedCurrency.name, downsideIndexGraph, decimalCurrency, processCodeData, bomData, convertWithRate]);

  /** useRef */
  const refs: Record<string, React.RefObject<HTMLButtonElement>> = {
    companyDivision: useRef<HTMLButtonElement>(null),
    companyHeadDivision: useRef<HTMLButtonElement>(null),
    salesDivision: useRef<HTMLButtonElement>(null),
    procurementDivision: useRef<HTMLButtonElement>(null),
  };

  /** 条件テーブル/ダウンサイドテーブルヘッダーセル */
  // 多言語対応: 英語など日本語より長いラベルが入っても隣列に被らないよう、
  // nowrap(横一列固定)ではなく折返し表示にする
  const thStyle = {
    whiteSpace: "normal",
    overflowWrap: "break-word" as const,
    wordBreak: "break-word" as const,
  };

  /** 条件テーブル/ダウンサイドテーブルボディセル */
  const tdStyle = {
    // whiteSpace: "nowrap"
  };

  /**
 * データ取得
 */
  const fetchData = async (options?: { preserveTextDraft?: boolean }) => {

    try {
      const payload = {
        query: `
          query fetchSimulationProductivityData($projectId: String, $useRDSData: Boolean, $reviewDate: String) {
            getProjectById(projectId: $projectId, useRDSData: $useRDSData, reviewDate: $reviewDate) {
              projectId
              pastProjectId
              pastReviewDate
              customerId
              customerName
              endUserName
              customerIndustry
              customerIndustryHierarchy
              customerNationality
              currencyId
              baseLaborCostIncreaseRate
              salesManagementRate
              otherEquipmentCost
              otherEquipmentCostCurrencyId
              devCost
              devCostCurrencyId
              otherCost
              otherCostCurrencyId
              monthlyExpenseData
              productionLaborCostCurrencyId
              overseasFactoryExpensesCurrencyId
              outsourcingProcessingCostCurrencyId
              pastEquipmentCostCurrencyId
              factoryBuildingDepreciationCurrencyId
              royaltyCurrencyId
              domesticLaborCostCurrencyId
              domesticSgaExpensesCurrencyId
              productionSgaExpensesCurrencyId
              domesticFactoryExpensesCurrencyId
              domesticInvestmentDepreciationCurrencyId
              domesticFactoryBuildingDepreciationCurrencyId
              domesticOtherDepreciationCurrencyId
              salesCompanySgaCurrencyId
              originalProfitAndLoss
              originalProfitAndLossByMonth
              displayOriginalProfitAndLossByMonth
              equipmentUsageType
              currencyId
              companyPlantId
              companyPlantSnapshot
              downsideRisk
              downsideIndex
              downsideIndexEnable
              registrantDivisionId
              updateDate
              productionLineId
              pricingAgreement
              finalInvestmentReason
              moldSalesByProject
              developmentSalesByProject
              equipmentSalesByProject
              projectStartDate
              projectEndDate
              increasedProductionStartDate
              updateAndOtherStartDate
              rationalizationStartDate
              selectedSimulationConfigIds
              purpose
              applicationFormType
              profitLossDisplayType
              productionFactoryLaborUnitPrice
              productionFactoryExpenseUnitPrice
            }
            getEquipmentByProjectId(projectId: $projectId, reviewDate: $reviewDate) {
              equipmentId
              equipmentName
              unitPrice
              quantity
              amount
              currencyId
              numberOfPeopleRequiredForEquipment
              unskilledWorker
              multiSkilledWorker
              technician
              numberOfPeopleRequiredForWithoutEquipment
              depreciationPeriod
              depreciationStartMonth
              acceptanceMonth
              processId
            }
            getPartNo(projectId: $projectId, reviewDate: $reviewDate) {
              partNo
              displayPartNo
              quantityAndPrice
              moldSalesByPartNo
              developmentSalesByPartNo
              inhousePart
              processes
              basicInfoRegistered
            }
          }`,
        variables: {
          projectId: projectId,
          useRDSData: true,
          ...(reviewDate && { reviewDate })
        }
      };

      // プロジェクト情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);
      let project: ProjectWithRdsData | null = null;
      let pastProjectData: ProjectWithRdsData | null = null;
      let pastPartNo: PartNo[] = [];
      let pastEquipment: EquipmentExtType[] = [];
      let labels = [];

      if (response?.data?.getProjectById?.projectId) {
        // プロジェクト情報
        project = response.data.getProjectById;

        // プロジェクト情報セット
        setProjectData(project);

        if (!options?.preserveTextDraft) {
          // 最終的な投資判断の理由セット（ドラフトrefとテキストエリアの両方）
          finalInvestmentReasonDraftRef.current = project?.finalInvestmentReason ?? null;
          finalInvestmentReasonRef.current?.setValue(project?.finalInvestmentReason ?? null);

          // ダウンサイドリスク対応セット（同上）
          downsideRiskDraftRef.current = project?.downsideRisk ?? null;
          downsideRiskRef.current?.setValue(project?.downsideRisk ?? null);
        }

        // オリジナル月別(当初損益月別) ⇒（対象プロジェクトの利益試算で登録）
        if (project?.originalProfitAndLossByMonth) {
          const tempOriginalProfitAndLossByMonth = JSON.parse(project?.originalProfitAndLossByMonth);

          // EOL予定日までの月数でフィルタリング
          const visibleMonths = calcMonthsBetweenDates(
            project.projectStartDate,
            project.projectEndDate
          );

          if (visibleMonths > 0 && tempOriginalProfitAndLossByMonth.labels &&
            visibleMonths < tempOriginalProfitAndLossByMonth.labels.length) {
            // labels をフィルタリング
            tempOriginalProfitAndLossByMonth.labels = tempOriginalProfitAndLossByMonth.labels.slice(0, visibleMonths);
            // totalSales をフィルタリング
            if (tempOriginalProfitAndLossByMonth.totalSales) {
              tempOriginalProfitAndLossByMonth.totalSales = tempOriginalProfitAndLossByMonth.totalSales.slice(0, visibleMonths);
            }
            // profit をフィルタリング
            if (tempOriginalProfitAndLossByMonth.profit) {
              tempOriginalProfitAndLossByMonth.profit = tempOriginalProfitAndLossByMonth.profit.slice(0, visibleMonths);
            }
            // quantityByPartNo を各PartNo毎にフィルタリング
            if (tempOriginalProfitAndLossByMonth.quantityByPartNo) {
              Object.keys(tempOriginalProfitAndLossByMonth.quantityByPartNo).forEach(partNo => {
                tempOriginalProfitAndLossByMonth.quantityByPartNo[partNo] =
                  tempOriginalProfitAndLossByMonth.quantityByPartNo[partNo].slice(0, visibleMonths);
              });
            }
          }

          labels = tempOriginalProfitAndLossByMonth.labels;

          if (response?.data?.getPartNo) {
            // パーツNoの整合性チェック（簡易モード時はPartNoごとの数量が未入力のためスキップ）
            const isSimpleModeNow = isSimpleApplicationForm(project?.purpose, project?.applicationFormType);
            const isPartNoIntegrity = isSimpleModeNow ? true : response.data.getPartNo.every((p: PartNo) => {
              const hasPartNo = tempOriginalProfitAndLossByMonth?.quantityByPartNo?.hasOwnProperty(p.partNo) || false;
              if (!hasPartNo) {
                console.warn(`Simuration unmatch partNo. BasicInfo PartNo = ${p.partNo}`);
              }
              return hasPartNo;
            })

            if (isPartNoIntegrity) {
              setOriginalProfitAndLossByMonth(tempOriginalProfitAndLossByMonth);
            }
          }
        }

        // JPY版データの読み込み（二重通貨変換回避用）
        if (project?.displayOriginalProfitAndLossByMonth) {
          const tempDisplayProfitAndLossByMonth = JSON.parse(project.displayOriginalProfitAndLossByMonth);

          // EOL予定日までの月数でフィルタリング（ローカル通貨版と同様）
          const visibleMonths = calcMonthsBetweenDates(
            project.projectStartDate,
            project.projectEndDate
          );

          if (visibleMonths > 0 && tempDisplayProfitAndLossByMonth.labels &&
            visibleMonths < tempDisplayProfitAndLossByMonth.labels.length) {
            tempDisplayProfitAndLossByMonth.labels = tempDisplayProfitAndLossByMonth.labels.slice(0, visibleMonths);
            if (tempDisplayProfitAndLossByMonth.totalSales) {
              tempDisplayProfitAndLossByMonth.totalSales = tempDisplayProfitAndLossByMonth.totalSales.slice(0, visibleMonths);
            }
            if (tempDisplayProfitAndLossByMonth.profit) {
              tempDisplayProfitAndLossByMonth.profit = tempDisplayProfitAndLossByMonth.profit.slice(0, visibleMonths);
            }
          }

          setDisplayOriginalProfitAndLossByMonth(tempDisplayProfitAndLossByMonth);
        }

        // 増産投資量産開始年月ライン（縦線表示位置）
        if (project?.increasedProductionStartDate) {
          const increasedProductionStartDate = new Date(project?.pastProjectId ? project?.increasedProductionStartDate : project?.projectStartDate!);
          const starLabel = `${increasedProductionStartDate.getFullYear()}/${String(increasedProductionStartDate.getMonth() + 1).padStart(2, "0")}`;
          setIncreasedProductionStartYearMonth(starLabel);
        }

        // 更新投資量産開始年月ライン（縦線表示位置）
        if (project?.updateAndOtherStartDate) {
          const updateAndOtherStartDate = new Date(project?.pastProjectId ? project?.updateAndOtherStartDate : project?.projectStartDate!);
          const updateLabel = `${updateAndOtherStartDate.getFullYear()}/${String(updateAndOtherStartDate.getMonth() + 1).padStart(2, "0")}`;
          setUpdateAndOtherStartYearMonth(updateLabel);
        }

        // 合理化投資量産開始年月ライン（縦線表示位置）
        if (project?.rationalizationStartDate) {
          const rationalizationStartDate = new Date(project?.pastProjectId ? project?.rationalizationStartDate : project?.projectStartDate!);
          const rationalizationLabel = `${rationalizationStartDate.getFullYear()}/${String(rationalizationStartDate.getMonth() + 1).padStart(2, "0")}`;
          setRationalizationStartYearMonth(rationalizationLabel);
        }

        if (project?.pastProjectId) {
          // 紐づけ時点の承認済み振り返り日（保存済みの pastReviewDate、申請のみの場合は null）
          const pastReviewDate = project.pastReviewDate ?? null;

          // 過去プロジェクト情報取得
          pastProjectData = await fetchProject(project.pastProjectId, t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastProjectInfo'), pastReviewDate, projectId);

          // mergedChartDataOriginalはupdateProfitAndLossでDynamoDB側がクリアされるため、RDSから補完する
          // （チャートデータはupdateChartData経由でRDS r_ceas_project_additional_infoに保存済み）
          if (pastProjectData && !pastProjectData.mergedChartDataOriginal) {
            const rdsMergedChartDataOriginal = await fetchPastSimulationChartData(project.pastProjectId, projectId);
            if (rdsMergedChartDataOriginal) {
              pastProjectData = { ...pastProjectData, mergedChartDataOriginal: rdsMergedChartDataOriginal };
            }
          }
          setPastProjectData(pastProjectData);

          // 過去パーツ情報取得
          pastPartNo = await fetchPartNo(project.pastProjectId, t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastPartNoInfo'), pastReviewDate, projectId);
          setPastCapexPartNo(pastPartNo);

          // 過去通貨情報取得（通貨はプロジェクト単位マスタのため振り返り対応不要）
          const pastCurrencyData = await fetchCurrency(project.pastProjectId, t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastCurrencyInfo'), projectId);
          setPastCurrencyData(pastCurrencyData);

          const tempFactoryExchange = currencyData.find(c => c.currencyId === getLocalCurrencyId(project?.companyPlantSnapshot));

          // 過去プロジェクトの設備投資情報
          pastEquipment = await fetchEquipments(project.pastProjectId, t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastEquipmentInfo'), tempFactoryExchange?.currencyName, currencyData, pastReviewDate, projectId);
          setPastEquipmentAmounts(pastEquipment);

          // 過去プロジェクトの製造ライン情報取得
          if (pastProjectData?.productionLineId) {
            const pastProductLine = await fetchProductLine(pastProjectData.productionLineId, pastReviewDate, project.pastProjectId);

            // 過去プロジェクトの稼働率データを抽出
            if (pastProductLine?.nonWorkingHours) {
              const pastNonWorkingHours: { fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]
                = JSON.parse(pastProductLine.nonWorkingHours);
              const pastAvailabilityRates = pastNonWorkingHours.map(item => ({
                fiscalYear: item.fiscalYear,
                availabilityRate: item.nonWorkingHoursByMonth.map((monthData) => Number(monthData?.availabilityRate ?? 0)),
              }));
              setPastAvailabilityRateByMonth(pastAvailabilityRates);
            }
          }

          // 過去PJのBOMデータ取得（仕損費計算用）
          // getBomByProjectIdはコンポーネントのreviewDateを使うため、過去PJはpastReviewDateで直接取得
          const pastBomResponse = await WebAPI.request({
            query: `
              query getBomByProjectId($projectId: String, $reviewDate: String, $referencingProjectId: String) {
                getBomByProjectId(projectId: $projectId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
                  projectId partNo seq level isCustomerSpecifiedParts
                  purchaseCurrencyId amountMonthly cycleTimeMonthly yieldMonthly
                }
              }`,
            variables: { projectId: project.pastProjectId, ...(pastReviewDate && { reviewDate: pastReviewDate }), referencingProjectId: projectId }
          });
          setPastBomData(pastBomResponse?.data?.getBomByProjectId || []);

          // 過去PJのプロセスデータ取得（仕損費計算用）
          const pastProcessData = await fetchProcess(project.pastProjectId, TITLE, WebAPI, toast, pastReviewDate, projectId);
          if (pastProcessData) {
            setPastProcessCodeData(pastProcessData);
          }
        }
      } else {
        showApiError(t('features.InvestmentScreening.SimulationProductivityImprovement.message.projectInfo'), `getProjectById`, response.errors);
        return;
      }

      // #region ストレス指数の初期化

      if (project?.downsideIndex) {
        // console.log("project downsideIndex exists.");

        // T_CEAS_PROJECT ストレス指数を取得
        const downsideIndex = JSON.parse(project.downsideIndex) as DownsideIndexType[];

        // T_CEAS_PROJECT 顧客取り決め事項を取得
        const agreement: PricingAgreementFormType =
          project?.pricingAgreement ? JSON.parse(project?.pricingAgreement) : [];

        // ストレス指数（画面表示用）の初期化
        setInitialDownsideIndexDisplay(downsideIndex, agreement);

        // ストレス指数(表)（画面表示用）の初期化
        setInitialDownsideIndexTableDisplay(downsideIndex, agreement, labels);

        // ストレス指数の初期化
        setInitialDownsideIndex(downsideIndex, agreement);

        if (project?.downsideIndexEnable) {
          let enDwnidx = JSON.parse(project.downsideIndexEnable) as DownsideIndexEnableType[];
          // ストレス指数(表)のヘッダー(有効・無効)を設定
          updateEnabledDownsideIndex(enDwnidx);
          // リセット用にコピーを保持
          setDownsideIndexEnableForReset(downsideIndexEnable);
        };

      } else {

        // M_CEAS_DOWNSIDE_INDEX データを取得
        const mDownsideIndex = await fetchDownsideIndex("001");

        // T_CEAS_PROJECT 顧客取り決め事項を取得
        const agreement: PricingAgreementFormType =
          project?.pricingAgreement ? JSON.parse(project?.pricingAgreement) : [];

        // ストレス指数（画面表示用）の初期化
        setInitialDownsideIndexDisplayNew(mDownsideIndex, agreement);

        // ストレス指数(表)（画面表示用）の初期化
        setInitialDownsideIndexTableDisplayNew(mDownsideIndex, agreement, labels);

        // ストレス指数の初期化
        setInitialDownsideIndexNew(mDownsideIndex, agreement);

      }

      // #endregion

      // 通貨マスタ（ProjectContextで一括取得済みのものを利用）
      if (currencyStatus === 'empty') {
        // 案件コピー直後など、基本情報が未保存で通貨情報が存在しない場合は保存を案内する
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.registerFromBasicInfo'),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      if (!currencyData || currencyData.length === 0) {
        showApiError(t('features.InvestmentScreening.SimulationProductivityImprovement.message.currencyInfo'), `getCurrencyById`, undefined);
        return;
      }

      // 各通貨を取得
      const salesExchange = currencyData.find(c => c.currencyId === project?.currencyId);
      const factoryExchange = currencyData.find(c => c.currencyId === getLocalCurrencyId(project?.companyPlantSnapshot));

      // 通貨名を設定
      const salesCurrencyName = salesExchange?.currencyName || '';
      const localCurrencyName = factoryExchange?.currencyName || '';

      // 販売通貨設定
      setSalesCurrencyName(salesCurrencyName);
      // ローカル通貨設定
      setLocalCurrencyName(localCurrencyName);

      // 小数点以下が必要かどうか ⇒ TODO シミュレーション計算に対するものなので、PLの通貨にすべきか要検討
      setDecimalCurrency(hasDecimal(localCurrencyName));

      // 表示通貨の初期値をJPYに設定
      if (localCurrencyName && currencyData.length > 0) {
        const jpyCurrency = currencyData.find(currency => currency.currencyName === CurrencyNameJPY);
        if (jpyCurrency?.currencyId && jpyCurrency?.currencyName) {
          setSelectedCurrency({ id: jpyCurrency.currencyId, name: jpyCurrency.currencyName });
        }
      }

      // 製造ライン情報取得
      let productionLine: ProductionLineType = {};
      if (project?.productionLineId) {
        productionLine = await fetchProductLine(project.productionLineId);
        // 製造ライン情報を更新
        setProductionLine(productionLine);
        // 稼働日数を更新
        if (productionLine?.workingDays) {
          const workingDaysData: { fiscalYear: string, workingDaysData: WorkingDaysType }[]
            = JSON.parse(productionLine.workingDays);
          // ポップアップ
          setWorkingDaysData(workingDaysData);
          setImprovedWorkingDaysData(workingDaysData);
          setOriginalImprovedWorkingDaysData(workingDaysData); // 初期値として保存
          // 稼働日数
          const workingDayByYearData = workingDaysData.map((workingDays) => ({
            fiscalYear: workingDays.fiscalYear,
            workingDay: workingDays.workingDaysData.workingDays,
          }));
          setWorkingDayByYear(workingDayByYearData);
          setImprovedWorkingDayByYear(workingDayByYearData);
          // 休日出勤
          setHolidayByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
            }))
          );
          setImprovedHolidayByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              holiday: workingDays.workingDaysData.workOnWeekendAndHolidays,
            }))
          );
          // ライン数
          setLineCountByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
            }))
          );
          setImprovedLineCountByYear(
            workingDaysData.map((workingDays) => ({
              fiscalYear: workingDays.fiscalYear,
              lineCount: workingDays.workingDaysData.lineCount || Array(12).fill(1),
            }))
          );
        }
        // 非稼働時間を更新
        if (productionLine?.nonWorkingHours) {
          const nonWorkingHours: { fiscalYear: string, nonWorkingHoursByMonth: NonWorkingHoursType[] }[]
            = JSON.parse(productionLine.nonWorkingHours);
          // ポップアップ
          setNonWorkingHoursData(nonWorkingHours);
          setImprovedNonWorkingHoursData(nonWorkingHours);
          setOriginalImprovedNonWorkingHoursData(nonWorkingHours); // 初期値として保存

          const availabilityRates: {
            fiscalYear: string;
            availabilityRate: number[];
          }[] = []; // 新しい構造：年度ごとの稼働率

          if (productionLine?.workingDays) {
            const workingDaysData: {
              fiscalYear: string;
              workingDaysData: WorkingDaysType;
            }[] = JSON.parse(productionLine.workingDays);

            // 稼働日数情報の年度でループ処理
            workingDaysData.forEach(({ fiscalYear, workingDaysData }) => {
              // 年度に紐づく非稼働時間情報を取得（会計年度文字列は表示言語で変わるため年数値で判定する）
              const matchingNonWorkingHours = nonWorkingHours.find((data) => isSameFiscalYear(data.fiscalYear, fiscalYear));
              if (matchingNonWorkingHours) {
                // 月度に紐づく稼働率を取得
                const availabilityRateByMonth = workingDaysData.requiredOverTimes.map((_, index) => {
                  return Number(matchingNonWorkingHours.nonWorkingHoursByMonth[index]?.availabilityRate ?? 0);
                });
                // 結果を配列に格納
                availabilityRates.push({
                  fiscalYear,
                  availabilityRate: availabilityRateByMonth,
                });
              }
            });
          }

          setAvailabilityRateByMonth(availabilityRates);
          setImprovedAvailabilityRateByMonth(availabilityRates);
        }
        // 歩留を更新
        // 歩留改善リストを初期化（BOMから取得するため初期値は0）
        const initialYieldRateList = [{
          month: "",
          yieldRate: 0,
          yieldRateText: "0.0"
        }];
        setImprovedYieldRateList(initialYieldRateList);
        setOriginalImprovedYieldRateList(initialYieldRateList);
        // サイクルタイム改善リストを初期化（BOMから取得するため初期値は0）
        const initialCycleTimeList = [{
          month: "",
          cycleTime: 0,
          cycleTimeText: "0.0"
        }];
        setImprovedCycleTimeList(initialCycleTimeList);
        setOriginalImprovedCycleTimeList(initialCycleTimeList);
      }

      // 設備情報取得
      let equipmentData: EquipmentExtType[] = [];
      if (response && response.data && response.data.getEquipmentByProjectId) {
        const rawEquipmentData: EquipmentType[] = response.data.getEquipmentByProjectId;
        // 月別レート到着後の再変換用に変換前データを保持
        rawEquipmentDataRef.current = rawEquipmentData;
        // 設備の通貨変換
        // 振り返りモード: 対象PJの損益試算画面と同じく検収月の月別レートで変換（利益計算時の逆変換とレートを揃える）
        const convertedData: EquipmentType[] = convertEquipmentData(rawEquipmentData, localCurrencyName, currencyData,
          reviewDate && monthlyRateMap.size > 0 ? convertWithRate : undefined);
        // EquipmentType => EquipmentExtType へのマッピング
        equipmentData = convertedData.map(item => ({
          ...item,
          selected: false,       // 初期化（拡張プロパティ）
          changeInQuantity: 0,   // 初期化（拡張プロパティ）
        }));

        // 数量（増減数）設定
        equipmentData = calcEquipmentQuantity(equipmentData, (e) => {
          // デフォルト選択
          e.selected = true;
        });

        setEquipmentAmounts(equipmentData);
        setOriginalEquipmentAmounts(equipmentData); // 初期表示用に保存
      } else {
        showApiError(t('features.InvestmentScreening.SimulationProductivityImprovement.message.equipmentInfo'), `getEquipmentByProjectId`, response.errors);
        return;
      }

      // プロジェクトIDからパーツNoを取得
      let partNo: PartNo[] = [];
      if (response && response.data && response.data.getPartNo) {
        const partNoList: PartNo[] = response.data.getPartNo;

        // 各PartNoのmaterialCostを取得してマージ
        partNo = await Promise.all(
          partNoList.map(async (part) => {
            const materialCostData = await getMaterialCost(projectId, part.partNo!);
            return {
              ...part,
              materialCost: materialCostData?.materialCost,
              materialCostWithInhouseProfit: materialCostData?.materialCostWithInhouseProfit,
            };
          })
        );

        setCapexPartNo(partNo);
      } else {
        showApiError(`Part No.`, `getPartNo`, response.errors);
        return;
      }

      // 顧客国籍名を取得
      let customerNationalityName = "";
      if (project?.customerNationality) {
        try {
          const natPayload = {
            query: `
              query getNationalityById($nationalityId: String) {
                getNationalityById(nationalityId: $nationalityId) {
                  nationalityId
                  nationalityNameJpn
                  nationalityNameEng
                }
              }
            `,
            variables: { nationalityId: project.customerNationality },
          };
          const natResponse = await WebAPI.request(natPayload);
          customerNationalityName = getBilingualDisplayName(
            natResponse?.data?.getNationalityById,
            'nationalityNameJpn',
            'nationalityNameEng',
          );
        } catch (error) {
          console.error("getNationalityById error:", error);
        }
      }

      // 条件テーブル設定
      setConditionTable({
        /** 顧客業界（コード） */
        customerIndustry: project?.customerIndustry || "",
        /** 顧客業界（名称） */
        customerIndustryName: project?.customerIndustryHierarchy || getCustomerIndustryTypeNameByCode(project?.customerIndustry || "") || project?.customerIndustry || "",
        /** 顧客国籍 */
        customerNationality: customerNationalityName,
        /** 顧客名 */
        customerName: (project?.customerName && project?.customerName === project?.customerId
          ? splitEscapedList(project?.customerName)[0]
          : project?.customerName) || "",
        /** エンドユーザ名 */
        endUserName: project?.endUserName || "",
        /** 工場為替 */
        factoryExchange: factoryExchange,
        /** 販売為替 */
        salesExchange: salesExchange,
        /** 工場拠点国 */
        factoryLocationCountry: getLocationCountry(project?.companyPlantSnapshot, true),
      });

      // ストレスシナリオが常にONとするため、選択顧客製品を設定
      setSelectedCustomerProduct(project?.customerIndustryHierarchy || getCustomerIndustryTypeNameByCode(project?.customerIndustry || "") || project?.customerIndustry || "");

      // 表示対象選択の選択状態を保持（ストレス指数保存時は選択状態を維持）
      // setSelectedConfigIds([]); // コメントアウト：選択状態を保持

      // ▼ 生産能力（プロセス）用データ取得
      // プロセス情報取得（工程ごとのサイクルタイム含む）
      if (project?.projectId) {
        const processData = await fetchProcess(project.projectId, TITLE, WebAPI, toast, reviewDate);
        if (processData) {
          setProcessCodeData(processData);
        }
      }

      // 更新前後サマリー/合理化前後サマリーデータ取得（プロセスごとのpartsCount含む）
      const additionalInfoCheckResult = await fetchProjectAdditionalInfo(project?.projectId || "", equipmentData, project?.purpose ?? undefined);
      // 生産能力（プロセス）表示制御用に結果を保存
      setHasProcessCapacityData(additionalInfoCheckResult);

      // BOMデータ取得
      if (project?.projectId) {
        const bomDataResult = await getBomByProjectId(project.projectId);
        setBomData(bomDataResult);
      }

      // 必須データチェック
      requiredDataNotice(project as ProjectWithRdsData, partNo, equipmentData, productionLine, pastProjectData, additionalInfoCheckResult);

      // 過去プロジェクトとのPart No整合性判定（トースト表示はpagePermissions確定後にuseEffectで行う）
      if (project?.pastProjectId) {
        setMissingPastPartNoList(findMissingPastPartNos(partNo, pastPartNo));
      } else {
        setMissingPastPartNoList([]);
      }
    } catch (error) {
      console.error("データ取得エラー:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  /**
   * ストレス指数情報取得
   * 
   * @param {string} customerProductCategoryId 顧客製品分類ID
   * @returns {DownsideIndexType[]} M_CEAS_DOWNSIDE データ
   */
  const fetchDownsideIndex = async (customerProductCategoryId: string): Promise<DownsideIndexType[]> => {

    try {

      // 変数宣言
      const payload = {
        query: `
          query getDownsideIndexById($customerProductCategoryId: String) {
            getDownsideIndexById(customerProductCategoryId: $customerProductCategoryId) {
              downsideId
              customerProductCategoryId
              customerProductCategoryName
              itemId
              itemName
              yearIndex
              stressIndex
              updateDate
            }
          }`,
        variables: { customerProductCategoryId }
      };

      // DBデータ取得
      const response = await WebAPI.request(payload);

      // データ取得失敗の場合
      if (!response?.data?.getDownsideIndexById) {
        console.error(`Failed to call API getDownsideIndexById. errors = `, response?.errors);
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.downsideIndexFetchFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return [];
      }

      // データ取得結果を返却
      return response.data.getDownsideIndexById;

    } catch (error) {
      console.error("データ取得失敗:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return [];
    }

  }

  /**
   * プロジェクト追加情報取得
   * @param projectId プロジェクトID
   * @param equipmentData 設備情報
   * @param purpose 投資目的コード
   * @returns チェック結果（true: OK, false: NG）
   */
  const fetchProjectAdditionalInfo = async (projectId: string, equipmentData: EquipmentType[], purpose?: string): Promise<boolean> => {
    try {
      const payload = {
        query: `
          query getProjectAdditionalInfoById($projectId: String, $reviewDate: String) {
            getProjectAdditionalInfoById(projectId: $projectId, reviewDate: $reviewDate) {
              projectId
              updateSummaryData
              rationalizationSummaryData
              updateDate
            }
          }`,
        variables: { projectId, ...(reviewDate && { reviewDate }) }
      };

      // DB情報取得
      const response = await WebAPI.request(payload);
      const additionalInfo = response?.data?.getProjectAdditionalInfoById;

      // 合理化の場合は合理化前後サマリーデータを使用
      if (purpose === PurposeType.Rationalization.code) {
        if (additionalInfo?.rationalizationSummaryData) {
          try {
            const parsedRationalizationSummaryData: RationalizationSummaryInputData[] = JSON.parse(additionalInfo.rationalizationSummaryData);
            // 合理化前後サマリーデータを保存（チャート表示用）
            setRationalizationSummaryDataList(parsedRationalizationSummaryData);
            // 設備数と合理化前後サマリー数が存在しない場合終了
            if (!parsedRationalizationSummaryData?.length || !equipmentData?.length) return true;
            // 全件登録必須チェック（設備の全processIdが合理化前後サマリーに一致していないと通過できない仕様）は
            // 「1件以上必須チェック」のみ残す方針のためコメントアウト
            // 設備に紐づくプロセスIDを取得（ユニーク）
            // const processIds = [...new Set(equipmentData.map((eq: any) => eq.processId).filter((id: any) => id))];
            // 合理化前後サマリーのプロセスIDを取得
            // const rationalizationSummaryProcessIds = parsedRationalizationSummaryData.map((data: RationalizationSummaryInputData) => data.processId);
            // 両方のID配列が完全一致かチェック
            // const allMatch =
            //   processIds.length === rationalizationSummaryProcessIds.length && // 要素数が同じ
            //   processIds.every((id: any) => rationalizationSummaryProcessIds.includes(id)); // processIdが全てrationalizationSummaryにある
            // Booleanを返す
            // 上記の全件一致チェックは撤廃し、1件以上登録されていればtrueを返す
            return true;
          } catch (e) {
            console.error("rationalizationSummaryData parse error:", e);
            return false;
          }
        }
        return true;
      }

      // 更新前後サマリーデータが存在する場合
      if (additionalInfo?.updateSummaryData) {
        try {
          const parsedUpdateSummaryData: UpdateSummaryInputData[] = JSON.parse(additionalInfo.updateSummaryData);
          setUpdateSummaryDataList(parsedUpdateSummaryData);
          // 設備数と更新前後サマリー数が存在しない場合終了
          if (!parsedUpdateSummaryData?.length || !equipmentData?.length) return true;
          // 全件登録必須チェック（設備の全processIdが更新前後サマリーに一致していないと通過できない仕様）は
          // 「1件以上必須チェック」のみ残す方針のためコメントアウト
          // 設備に紐づくプロセスIDを取得（ユニーク）
          // const processIds = [...new Set(equipmentData.map((eq: any) => eq.processId).filter((id: any) => id))];
          // 更新前後サマリーのプロセスIDを取得
          // const updateSummaryProcessIds = parsedUpdateSummaryData.map((data: UpdateSummaryInputData) => data.productionLineId);
          // 両方のID配列が完全一致かチェック
          // const allMatch =
          //   processIds.length === updateSummaryProcessIds.length && // 要素数が同じ
          //   processIds.every((id: any) => updateSummaryProcessIds.includes(id)); // processIdが全てupdateSummaryにある
          // Booleanを返す
          // 上記の全件一致チェックは撤廃し、1件以上登録されていればtrueを返す
          return true;
        } catch (e) {
          console.error("updateSummaryData parse error:", e);
          return false;
        }
      }

      return true;

    } catch (error) {
      console.error("プロジェクト追加情報取得エラー:", error);
      return false;
    }
  }

  /**
   * 製造ライン情報取得
   * @param productionLineId 製造ラインID
   * @param reviewDateOverride 振り返り日の上書き（過去ライン参照時）
   * @param ownerProjectId 製造ラインを保持するプロジェクトID（過去ライン参照時は過去プロジェクトID）
   */
  const fetchProductLine = async (productionLineId: string, reviewDateOverride?: string | null, ownerProjectId: string = projectId): Promise<ProductionLineType> => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getProductionLineById($projectId: String, $productionLineId: String, $reviewDate: String, $referencingProjectId: String) {
            getProductionLineById(projectId: $projectId, productionLineId: $productionLineId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              productionLineId
              cycleTime
              workingDays
              nonWorkingHours
              yieldRate
              bestProductionQuantity
            }
          }`,
        variables: {
          projectId: ownerProjectId,
          productionLineId,
          ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }),
          ...(ownerProjectId !== projectId && { referencingProjectId: projectId })
        }
      };

      // DB情報取得
      const response = await WebAPI.request(payload);

      // 製造ライン情報取得
      if (!response?.data?.getProductionLineById?.productionLineId) {
        console.error(`Failed to call API getProductionLineById. errors = `, response?.errors);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.productionLineFetchFailed'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }

      return response.data.getProductionLineById;

    } catch (error) {
      console.error("データ取得失敗:", error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.fetchDataFailed'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return {};
    }
  }

  /**
   * プロジェクト情報取得（投資回収チャートデータなど）
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchProject = async (projectId: string | null | undefined, dataLabel?: string, reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getProjectById($projectId: String!, $useRDSData: Boolean, $targets: [String!]!, $reviewDate: String, $referencingProjectId: String) {
            getProjectById(projectId: $projectId, useRDSData: $useRDSData, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              projectId
              pastProjectId
              customerId
              customerName
              endUserName
              customerIndustry
              customerIndustryHierarchy
              customerNationality
              currencyId
              baseLaborCostIncreaseRate
              salesManagementRate
              otherEquipmentCost
              otherEquipmentCostCurrencyId
              devCost
              devCostCurrencyId
              otherCost
              otherCostCurrencyId
              monthlyExpenseData
              productionLaborCostCurrencyId
              overseasFactoryExpensesCurrencyId
              outsourcingProcessingCostCurrencyId
              pastEquipmentCostCurrencyId
              factoryBuildingDepreciationCurrencyId
              royaltyCurrencyId
              domesticLaborCostCurrencyId
              domesticSgaExpensesCurrencyId
              productionSgaExpensesCurrencyId
              domesticFactoryExpensesCurrencyId
              domesticInvestmentDepreciationCurrencyId
              domesticFactoryBuildingDepreciationCurrencyId
              domesticOtherDepreciationCurrencyId
              salesCompanySgaCurrencyId
              originalProfitAndLossByMonth
              currencyId
              companyPlantSnapshot
              downsideRisk
              downsideIndex
              downsideIndexEnable
              registrantDivisionId
              updateDate
              productionLineId
              pricingAgreement
              finalInvestmentReason
              moldSalesByProject
              developmentSalesByProject
              equipmentSalesByProject
              projectStartDate
              projectEndDate
              increasedProductionStartDate
              updateAndOtherStartDate
              selectedSimulationConfigIds
              pastProjectId
              mergedChartDataOriginal
              productionFactoryLaborUnitPrice
              productionFactoryExpenseUnitPrice
            }
            getLargeChartDataById(projectId: $projectId, targets: $targets, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              simulationChartData
            }
          }`,
        variables: {
          projectId, useRDSData: false,
          ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }),
          targets: ["simulationChartData"],
          ...(referencingProjectId && { referencingProjectId }),
        }
      };

      // プロジェクト情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      const rdsSimulationChartData =
        response?.data?.getLargeChartDataById?.simulationChartData ? JSON.parse(response?.data?.getLargeChartDataById?.simulationChartData) : null;

      if (response?.data?.getProjectById?.projectId) {
        let projectData = response.data.getProjectById;
        projectData = rdsSimulationChartData ? { ...projectData, ...rdsSimulationChartData } : projectData;

        return projectData;
      } else {
        console.error(`Failed to call API getProjectById. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.projectInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getProjectById. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.projectInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return {};
  }

  /**
   * 過去プロジェクトの大容量チャートデータ取得（RDS: r_ceas_project_additional_info）
   * mergedChartDataOriginalはupdateProfitAndLossでDynamoDBがクリアされるため、RDSから補完する
   * @param projectId 過去プロジェクトID
   */
  const fetchPastSimulationChartData = async (projectId: string, referencingProjectId?: string | null): Promise<string | null> => {
    try {
      const payload = {
        query: `
          query getLargeChartDataById($projectId: String!, $targets: [String!]!, $referencingProjectId: String) {
            getLargeChartDataById(projectId: $projectId, targets: $targets, referencingProjectId: $referencingProjectId) {
              projectId
              simulationChartData
            }
          }`,
        variables: { projectId, targets: ["simulationChartData"], ...(referencingProjectId && { referencingProjectId }) }
      };
      const response = await WebAPI.request(payload);
      const largeChartResult = response?.data?.getLargeChartDataById;
      const simulationChartData = largeChartResult?.simulationChartData;
      if (simulationChartData) {
        const parsed = JSON.parse(simulationChartData);
        const mergedChartDataOriginal = parsed?.mergedChartDataOriginal;
        return mergedChartDataOriginal || null;
      }
      return null;
    } catch (error) {
      console.error(`fetchPastSimulationChartData error:`, error);
      return null;
    }
  };

  // 材料費情報取得API（PartNo単位）
  const getMaterialCost = async (projectId: string, partNo: string, reviewDateOverride?: string | null, referencingProjectId?: string | null): Promise<{ materialCost?: string, materialCostWithInhouseProfit?: string } | null> => {
    const functionName = "getMaterialCost";
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const response = await WebAPI.request({
        query: `
          query getMaterialCost($projectId: String, $partNo: String, $reviewDate: String, $referencingProjectId: String) {
            getMaterialCost(projectId: $projectId, partNo: $partNo, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              materialCost
              materialCostWithInhouseProfit
            }
          }`,
        variables: { projectId, partNo, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      });

      if (!response?.data?.getMaterialCost) {
        // console.log(`${functionName} データなし: partNo=${partNo}`);
        return null;
      }

      return response?.data?.getMaterialCost;
    } catch (error) {
      console.error(`${functionName} error: partNo=${partNo}`, error);
      return null;
    }
  };

  /**
   * パーツ情報取得（投資回収チャートデータなど）
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchPartNo = async (projectId: string | null | undefined, dataLabel?: string, reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getPartNo($projectId: String, $reviewDate: String, $referencingProjectId: String) {
            getPartNo(projectId: $projectId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              partNo
              displayPartNo
              quantityAndPrice
              moldSalesByPartNo
              developmentSalesByPartNo
              inhousePart
              processes
              basicInfoRegistered
            }
          }`,
        variables: { projectId, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      };

      // パーツ情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      if (response?.data?.getPartNo) {
        const partNoList: PartNo[] = response.data.getPartNo;

        // 各PartNoのmaterialCostを取得してマージ
        const partNoWithMaterialCost = await Promise.all(
          partNoList.map(async (part) => {
            const materialCostData = await getMaterialCost(projectId!, part.partNo!, reviewDateOverride, referencingProjectId);
            return {
              ...part,
              materialCost: materialCostData?.materialCost,
              materialCostWithInhouseProfit: materialCostData?.materialCostWithInhouseProfit,
            };
          })
        );

        return partNoWithMaterialCost;
      } else {
        console.error(`Failed to call API getPartNo. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.projectInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getPartNo. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.partNoInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return [];
  }

  /**
   * BOMデータ取得
   * @param projectId プロジェクトID
   */
  const getBomByProjectId = async (projectId: string): Promise<BomData[]> => {
    const functionName = "getBomByProjectId";
    try {
      const response = await WebAPI.request({
        query: `
          query getBomByProjectId($projectId: String, $reviewDate: String) {
            getBomByProjectId(projectId: $projectId, reviewDate: $reviewDate) {
              projectId
              partNo
              seq
              level
              isCustomerSpecifiedParts
              purchaseCurrencyId
              amountMonthly
              cycleTimeMonthly
              yieldMonthly
            }
          }`,
        variables: { projectId, ...(reviewDate && { reviewDate }) }
      });
      if (!response?.data[functionName]) {
        // console.log(`${functionName} データなし`);
        return [];
      }
      return response?.data[functionName];
    } catch (error) {
      console.error(`${functionName} エラー:`, error);
      return [];
    }
  };

  /**
   * 通貨情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   */
  const fetchCurrency = async (projectId: string | null | undefined, dataLabel?: string, referencingProjectId?: string | null) => {
    try {
      const payload = {
        query: `
          query getCurrencyById($projectId: String, $referencingProjectId: String) {
            getCurrencyById(projectId: $projectId, referencingProjectId: $referencingProjectId) {
              currencyId
              currencyName
              exchangeRate
            }
          }`,
        variables: { projectId, ...(referencingProjectId && { referencingProjectId }) }
      };

      // 通貨情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      if (response?.data?.getCurrencyById) {
        return response.data.getCurrencyById;
      } else {
        console.error(`Failed to call API getCurrencyById. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.currencyInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getCurrencyById. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.currencyInfo') }),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return {};
  }

  /**
   * 
   * 設備情報取得
   * @param projectId プロジェクトID
   * @param dataLabel データラベル
   * @param currencyNameArg 表示通貨名
   * @param currencyDataArg 通貨情報
   * @returns 設備情報
   */
  const fetchEquipments = async (projectId: string | null | undefined, dataLabel?: string, currencyNameArg?: string, currencyDataArg?: Currency[], reviewDateOverride?: string | null, referencingProjectId?: string | null) => {
    try {
      const effectiveReviewDate = reviewDateOverride === undefined ? reviewDate : reviewDateOverride;
      const payload = {
        query: `
          query getEquipmentByProjectId($projectId: String, $reviewDate: String, $referencingProjectId: String) {
            getEquipmentByProjectId(projectId: $projectId, reviewDate: $reviewDate, referencingProjectId: $referencingProjectId) {
              equipmentId
              equipmentName
              unitPrice
              quantity
              amount
              currencyId
              numberOfPeopleRequiredForEquipment
              unskilledWorker
              multiSkilledWorker
              technician
              numberOfPeopleRequiredForWithoutEquipment
              depreciationPeriod
              depreciationStartMonth
              acceptanceMonth
              processId
            }
          }`,
        variables: { projectId, ...(effectiveReviewDate && { reviewDate: effectiveReviewDate }), ...(referencingProjectId && { referencingProjectId }) }
      };

      // 設備情報取得（dynamodb、RDS）
      const response = await WebAPI.request(payload);

      if (response?.data?.getEquipmentByProjectId) {
        const rawEquipmentData: EquipmentType[] = response.data.getEquipmentByProjectId;

        if (!(currencyNameArg || null)) {
          currencyNameArg = localCurrencyName;
        }
        if (!(currencyDataArg || null)) {
          currencyDataArg = currencyData;
        }

        // 設備の通貨変換
        const convertedData = convertEquipmentData(rawEquipmentData, currencyNameArg!, currencyDataArg!);
        // EquipmentType => EquipmentExtType へのマッピング
        const equipmentData: EquipmentExtType[] = convertedData.map((e: EquipmentType) => {

          let changeInQuantity = 0;
          if (e.unitPrice && e.unitPrice) {
            const amount = new Decimal(e.amount || 0);
            const quantity = amount.div(e.unitPrice!);
            // 数量(増減数)
            changeInQuantity = quantity.toNumber();
          }

          return {
            ...e,
            selected: true,
            changeInQuantity: changeInQuantity,
          }
        });

        return equipmentData;

      } else {
        console.error(`Failed to call API getEquipmentByProjectId. response = `, response);
        // データ取得失敗の場合
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.equipmentInfo') }),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(`Exception to call API getEquipmentByProjectId. errors = `, error);
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName: dataLabel ?? t('features.InvestmentScreening.SimulationProductivityImprovement.message.equipmentInfo') }),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    // データ取得失敗時
    return [];
  }

  // 共通関数
  const updateStateIfNeeded = (
    sourceArray: any[],
    targetArray: any[],
    index: number,
    compareFunc: (sourceItem: any, targetItem: any) => boolean,
    updateFunc: (updater: (prev: any[]) => any[]) => void,
    updatedFields: (sourceItem: any) => any
  ) => {
    const sourceItem = sourceArray[index];
    const targetItem = targetArray[index];

    if (targetItem && compareFunc(sourceItem, targetItem)) {
      // 差分がある場合のみ状態を更新
      updateFunc((prev) => {
        const updated = [...prev];
        updated[index] = updatedFields(sourceItem);
        return updated;
      });
    }
  };

  /**
   * シミュレーション設定「労務費」の自動算出ボタン押下
   * 生産工場労務費単価・経費単価、C/T、販売数量から生産工場労務費・償却費以外の工場経費（生産）を算出
   */
  const handleSimulationAutoCalculateLaborCost = useCallback(async () => {
    if (isLaborCostCalculating) {
      return;
    }

    try {
      setIsLaborCostCalculating(true);

      // 前提値チェック（シミュレーション設定の単価・ベースアップ率を使用）
      if (
        scenarioProductionFactoryLaborUnitPrice === null || scenarioProductionFactoryLaborUnitPrice === undefined ||
        scenarioProductionFactoryExpenseUnitPrice === null || scenarioProductionFactoryExpenseUnitPrice === undefined ||
        scenarioBaseLaborCostIncreaseRate === null || scenarioBaseLaborCostIncreaseRate === undefined
      ) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.laborCostAutoCalcRequiresUnitPrice'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const startDate = projectData?.projectStartDate || "";
      if (!startDate || !originalProfitAndLossByMonth?.labels || originalProfitAndLossByMonth.labels.length === 0) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.projectStartDateNotSet'),
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      // 年月リストを取得（費用画面のfiscalMonthsLabelless相当）
      const yearMonthList = originalProfitAndLossByMonth.labels.map((label) => {
        const [year, month] = label.split("/").map(Number);
        return { year, month };
      });

      // 月別のC/T合計を計算
      const totalCycleTimeByMonth: Decimal[] = calcTotalCycleTimeByMonth(processCodeData, yearMonthList);

      // PartNo別月別数量を取得
      const quantitiesByPartNoMonth = getQuantitiesByPartNoMonth(capexPartNo, startDate);

      // 月別販売数量合計を計算
      const totalSalesQuantityByMonth: Decimal[] = calcTotalQuantityByMonth(
        quantitiesByPartNoMonth,
        yearMonthList.length
      );

      // 生産工場労務費の通貨情報を取得
      const laborCostCurrencyName = currencyData?.find(
        c => c.currencyId === projectData?.productionLaborCostCurrencyId
      )?.currencyName;
      const laborCostDecimalCurrency = laborCostCurrencyName !== CurrencyNameJPY;

      // 生産工場労務費を計算
      const laborCostByMonth = calcCycleTimeBasedCost(
        totalCycleTimeByMonth,
        new Decimal(scenarioProductionFactoryLaborUnitPrice ?? 0),
        laborCostCurrencyName,
        laborCostCurrencyName, // 同じ通貨（変換なし）
        currencyData,
        totalSalesQuantityByMonth,
        laborCostDecimalCurrency,
        "monthly",
        "calcSimulationProductionLaborCost"
      );

      // ベースアップ率を適用（シミュレーション設定値。単価からの新規算出なので二重適用の心配はない）
      applyBaseUpRateToLaborCost(laborCostByMonth, scenarioBaseLaborCostIncreaseRate, startDate);

      // 償却費以外の工場経費の通貨情報を取得
      const overseasExpensesCurrencyName = currencyData?.find(
        c => c.currencyId === projectData?.overseasFactoryExpensesCurrencyId
      )?.currencyName;
      const overseasExpensesDecimalCurrency = overseasExpensesCurrencyName !== CurrencyNameJPY;

      // 償却費以外の工場経費を計算
      const overseasExpensesByMonth = calcCycleTimeBasedCost(
        totalCycleTimeByMonth,
        new Decimal(scenarioProductionFactoryExpenseUnitPrice ?? 0),
        overseasExpensesCurrencyName,
        overseasExpensesCurrencyName, // 同じ通貨（変換なし）
        currencyData,
        totalSalesQuantityByMonth,
        overseasExpensesDecimalCurrency,
        "monthly",
        "calcSimulationOverseasFactoryExpenses"
      );

      setScenarioLaborCostByMonth(laborCostByMonth.map(d => d.toNumber()));
      setScenarioOverseasFactoryExpensesByMonth(overseasExpensesByMonth.map(d => d.toNumber()));

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.laborCostAutoCalcSuccess'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (err: any) {
      console.error("handleSimulationAutoCalculateLaborCost error:", err);
      toast({
        title: TITLE,
        description: err.message || t('features.InvestmentScreening.SimulationProductivityImprovement.message.laborCostAutoCalcFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLaborCostCalculating(false);
    }
  }, [
    isLaborCostCalculating,
    scenarioProductionFactoryLaborUnitPrice,
    scenarioProductionFactoryExpenseUnitPrice,
    scenarioBaseLaborCostIncreaseRate,
    projectData,
    originalProfitAndLossByMonth,
    processCodeData,
    capexPartNo,
    currencyData,
    t,
    toast,
    TITLE,
  ]);

  /**
   * 改善後稼働日数更新
   */
  useEffect(() => {

    // 稼働日数入力チェック結果がTRUE(OK)の場合
    if (isValidWorkingDays) {

      // 改善後稼働日数の年度ごとに処理
      improvedWorkingDaysData.forEach((_, index) => {
        // 改善後月別稼働日数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedWorkingDayByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.workingDays) !== JSON.stringify(target.workingDay),
          setImprovedWorkingDayByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            workingDay: source.workingDaysData.workingDays,
          })
        );
        // 改善後月別休日出勤日数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedHolidayByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.workOnWeekendAndHolidays) !== JSON.stringify(target.holiday),
          setImprovedHolidayByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            holiday: source.workingDaysData.workOnWeekendAndHolidays,
          })
        );
        // 改善後月別ライン数の更新
        updateStateIfNeeded(
          improvedWorkingDaysData,
          improvedLineCountByYear,
          index,
          (source, target) =>
            isSameFiscalYear(source.fiscalYear, target.fiscalYear) &&
            JSON.stringify(source.workingDaysData.lineCount) !== JSON.stringify(target.lineCount),
          setImprovedLineCountByYear,
          (source) => ({
            fiscalYear: source.fiscalYear,
            lineCount: source.workingDaysData.lineCount || Array(12).fill(1),
          })
        );
      });

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isValidWorkingDays,
    improvedWorkingDaysData,
    // 以下は出力側の状態のため依存配列から除外（無限ループ防止）パフォーマンス改善
    // improvedWorkingDayByYear,
    // improvedHolidayByYear,
    // improvedLineCountByYear,
  ]);

  /**
   * 増産前生産数量過去ベストデータ生成
   * @param labels ラベル情報
   * @param productionStartIndex 増産開始年月のインデックス
   * @returns 増産前生産数量過去ベストデータ
   */
  const calcPreProductionBest = (labels: string[], productionStartIndex: number) => {
    // 増産前生産数量過去ベスト
    const preProductionBest: (number | null)[] = labels.map((label, index) => {
      // 増産開始年月以降のみ表示
      if (index >= productionStartIndex) {
        return Number(productionLine.bestProductionQuantity) || 0
      }
      return null;
    });

    return preProductionBest;
  }

  /**
   * 顧客需要データ作成
   * @param labels ラベル情報
   * @param quantityByPartNo パーツ別数量
   * @returns 顧客需要データ
   */
  const calcCustomerDemandData = (labels: string[], quantityByPartNo: Record<string, string[]>) => {
    const customerDemand: Decimal[] = Array(labels.length).fill(new Decimal(0));

    for (const [_, values] of Object.entries(quantityByPartNo)) {
      const quantities = values.map(value => new Decimal(value));

      quantities.forEach((quantity, idx) => {
        customerDemand[idx] = customerDemand[idx].plus(quantity);
      });
    }

    return customerDemand;
  }

  /**
   * 数量チャートデータ（calcQuantitiesChartDataSet の戻り値）から PartNo別数量と短縮後の月数を取り出す
   * ダウンサイドの顧客需要・期間短縮を「数量（ダウンサイド）」グラフと一致させるために使用
   * @param quantitiesChart 数量チャートデータ
   * @param fallbackLength データがない場合の月数
   * @returns PartNo別数量と月数
   */
  const extractQuantityByPartNoFromChart = (quantitiesChart: any, fallbackLength: number) => {
    const quantityByPartNo: Record<string, string[]> = {};
    let length = 0;
    for (const ds of quantitiesChart?.datasets || []) {
      quantityByPartNo[ds.partNoKey] = ds.data;
      length = Math.max(length, ds.data?.length || 0);
    }
    return { quantityByPartNo, length: length || fallbackLength };
  }

  /**
   * 生産キャパグラフ（既存ライン含む）1版分の元データを作成する（増産の「生産能力（ライン全体）」の計算から切り出し）
   * @param quantityByPartNo 案件品のPartNo別数量（顧客需要の内訳）
   * @param weekdays 稼働日分（キャパ）
   * @param length 表示する月数（ダウンサイドの期間短縮後）
   */
  const toExistingLineCapacityVersion = (
    quantityByPartNo: Record<string, any[]>,
    weekdays: Decimal[],
    length: number,
  ): TExistingLineCapacityVersion => ({
    quantityByPartNo: Object.fromEntries(Object.entries(quantityByPartNo).map(([partNo, values]) => [
      partNo,
      values.slice(0, length).map(value => Number(value) || 0),
    ])),
    capacity: weekdays.map(value => value.toNumber()),
    length,
  });

  /**
   * BOMデータから指定した年月のサイクルタイム（最大値＝ネック工程）を取得する（汎用）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param bomDataSource BOMデータ配列
   * @returns サイクルタイム（秒）、データがない場合はnull
   */
  const getCycleTimeFromBomData = (targetYearMonth: string, bomDataSource: BomData[]): number | null => {
    if (!bomDataSource || bomDataSource.length === 0) {
      return null;
    }

    // YYYY/MM → YYYY-MM 形式に変換
    const yearMonthKey = targetYearMonth.replace("/", "-");

    let maxCycleTime = 0;
    let hasValue = false;

    for (const bom of bomDataSource) {
      if (bom.cycleTimeMonthly) {
        try {
          const monthlyData = JSON.parse(bom.cycleTimeMonthly);
          const value = monthlyData[yearMonthKey];
          if (value !== undefined && value !== null && value !== "") {
            const cycleTimeValue = parseFloat(value);
            if (!isNaN(cycleTimeValue) && cycleTimeValue > maxCycleTime) {
              maxCycleTime = cycleTimeValue;
              hasValue = true;
            }
          }
        } catch (e) {
          console.warn("Failed to parse cycleTimeMonthly:", e);
        }
      }
    }

    return hasValue ? maxCycleTime : null;
  };

  /**
   * BOMデータから指定した年月の歩留（累積＝全工程の積）を取得する（汎用）
   * @param targetYearMonth 対象年月 (YYYY/MM形式)
   * @param bomDataSource BOMデータ配列
   * @returns 歩留（0-1の範囲）、データがない場合はnull
   */
  const getYieldRateFromBomData = (targetYearMonth: string, bomDataSource: BomData[]): number | null => {
    if (!bomDataSource || bomDataSource.length === 0) {
      return null;
    }

    // YYYY/MM → YYYY-MM 形式に変換
    const yearMonthKey = targetYearMonth.replace("/", "-");

    let yieldProduct = new Decimal(1);
    let hasValue = false;

    for (const bom of bomDataSource) {
      if (bom.yieldMonthly) {
        try {
          const monthlyData = JSON.parse(bom.yieldMonthly);
          const value = monthlyData[yearMonthKey];
          if (value !== undefined && value !== null && value !== "") {
            const yieldValue = parseFloat(value);
            if (!isNaN(yieldValue)) {
              yieldProduct = yieldProduct.mul(new Decimal(yieldValue).div(100));
              hasValue = true;
            }
          }
        } catch (e) {
          console.warn("Failed to parse yieldMonthly:", e);
        }
      }
    }

    return hasValue ? yieldProduct.toNumber() : null;
  };

  /**
   * 【生産能力（ライン全体）】チャートデータ作成（当初計画）
   * 増産投資の場合のみ計算
   */
  useEffect(() => {
    // 増産投資以外はスキップ
    if (projectData?.purpose !== PurposeType.IncreasedProduction.code) {
      return;
    }

    // 必要なデータが揃っているかチェック
    if (
      !originalProfitAndLossByMonth ||
      !workingDayByYear || workingDayByYear.length === 0 ||
      !holidayByYear || holidayByYear.length === 0 ||
      !availabilityRateByMonth || availabilityRateByMonth.length === 0 ||
      !investmentStartYearMonth || investmentStartYearMonth.length === 0 ||
      !productionLine
    ) {
      return;
    }

    // 年月ラベルを生成
    const labels: string[] = [...originalProfitAndLossByMonth.labels];

    // 投資開始年月のインデックスを見つける
    const productionStartIndex = labels.indexOf(investmentStartYearMonth);

    // 増産前生産数量過去ベスト（増産投資の場合のみ）
    let preProductionBest: (number | null)[] = [];
    if (projectData?.purpose === PurposeType.IncreasedProduction.code) {
      preProductionBest = calcPreProductionBest(labels, productionStartIndex);
    }

    // 顧客需要
    const customerDemand: Decimal[] = calcCustomerDemandData(labels, originalProfitAndLossByMonth.quantityByPartNo);

    // 稼働日分 と 休日稼働分 算出
    const numberOfUnitsProduced = calcNumberOfUnitsProduced(
      labels,
      workingDayByYear,
      lineCountByYear,
      holidayByYear,
      availabilityRateByMonth,
      (targetYearMonth: string) => {
        // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
        return getYieldRateFromBomData(targetYearMonth, bomData) ?? 0;
      },
      (targetYearMonth: string) => {
        // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
        return getCycleTimeFromBomData(targetYearMonth, bomData) ?? 0;
      },
      projectData?.projectStartDate!
    );

    // チャートデータを作成
    const chartData = {
      labels,
      datasets: [
        // 増産投資の場合のみ「増産前生産数量過去ベスト」を表示
        ...(projectData?.purpose === PurposeType.IncreasedProduction.code ? [{
          type: 'line' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.preIncreaseProductionPast'),
          data: preProductionBest,
          borderColor: 'rgb(255, 159, 64)',
          backgroundColor: 'rgba(255, 159, 64, 0.5)',
          borderWidth: 2,
          tension: 0.4,
          pointRadius: 0,
          pointStyle: 'rect',
          order: 1,
        }] : []),
        {
          type: 'line' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
          data: customerDemand,
          borderColor: 'rgb(75, 192, 75)',
          backgroundColor: 'rgba(75, 192, 75, 0.5)',
          borderWidth: 5,
          tension: 0.4,
          pointRadius: 0,
          pointStyle: 'rect',
          order: 2,
        },
        {
          type: 'bar' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
          data: numberOfUnitsProduced.holidays,
          backgroundColor: 'rgb(255, 205, 86)',
          stack: 'production',
          pointStyle: 'rect',
          order: 4,
        },
        {
          type: 'bar' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
          data: numberOfUnitsProduced.weekdays,
          backgroundColor: 'rgb(201, 203, 207)',
          stack: 'production',
          pointStyle: 'rect',
          order: 3,
        },
      ],
    };

    // 生産能力（ライン全体）当初計画 チャートデータ設定
    setProductionCapacityChartData(chartData);
    // 生産キャパグラフ（既存ライン含む）用：キャパ＝稼働日分、案件品＝当初の販売数量
    setElqVersionOriginal(toExistingLineCapacityVersion(originalProfitAndLossByMonth.quantityByPartNo, numberOfUnitsProduced.weekdays, labels.length));
  }, [
    originalProfitAndLossByMonth,
    workingDayByYear,
    holidayByYear,
    availabilityRateByMonth,
    investmentStartYearMonth,
    productionLine,
    lineCountByYear,
    projectData,
    bomData,
  ]);

  /**
   * 【生産能力（ライン全体）】チャートデータ作成（ダウンサイド）
   * 増産投資の場合のみ計算
   */
  useEffect(() => {
    // 増産投資以外はスキップ
    if (projectData?.purpose !== PurposeType.IncreasedProduction.code) {
      return;
    }

    // 必要なデータが揃っているかチェック
    if (
      !originalProfitAndLossByMonth ||
      !workingDayByYear || workingDayByYear.length === 0 ||
      !holidayByYear || holidayByYear.length === 0 ||
      !availabilityRateByMonth || availabilityRateByMonth.length === 0 ||
      !investmentStartYearMonth || investmentStartYearMonth.length === 0 ||
      !productionLine ||
      !quantitiesChartDataModified
    ) {
      return;
    }

    // 年月ラベルを生成（ラベルは全期間のまま、データのみ短縮する）
    const labels: string[] = [...originalProfitAndLossByMonth.labels];

    // 数量（ダウンサイド）からPartNo別数量と短縮後の月数を取得（ストレス指数は適用済み）
    const { quantityByPartNo: downsideQuantityByPartNo, length: downsideLength } =
      extractQuantityByPartNoFromChart(quantitiesChartDataModified, labels.length);

    // 増産開始年月のインデックスを見つける
    const productionStartIndex = labels.indexOf(investmentStartYearMonth);

    // 増産前生産数量過去ベスト（増産投資の場合のみ）
    let preProductionBest: (number | null)[] = [];
    if (projectData?.purpose === PurposeType.IncreasedProduction.code) {
      preProductionBest = calcPreProductionBest(labels, productionStartIndex);
    }

    // 顧客需要（ダウンサイドの数量）
    const customerDemand: Decimal[] = calcCustomerDemandData(labels, downsideQuantityByPartNo);

    // 稼働日分 と 休日稼働分 算出（キャパにはストレス指数を掛けない）
    const numberOfUnitsProduced = calcNumberOfUnitsProduced(
      labels,
      workingDayByYear,
      lineCountByYear,
      holidayByYear,
      availabilityRateByMonth,
      (targetYearMonth: string) => {
        // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
        return getYieldRateFromBomData(targetYearMonth, bomData) ?? 0;
      },
      (targetYearMonth: string) => {
        // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
        return getCycleTimeFromBomData(targetYearMonth, bomData) ?? 0;
      },
      projectData?.projectStartDate!
    );

    // チャートデータを作成（全系列を数量（ダウンサイド）と同じ月数で短縮）
    const chartData = {
      labels,
      datasets: [
        // 増産投資の場合のみ「増産前生産数量過去ベスト」を表示
        ...(projectData?.purpose === PurposeType.IncreasedProduction.code ? [{
          type: 'line' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.preIncreaseProductionPast'),
          data: preProductionBest.slice(0, downsideLength),
          borderColor: 'rgb(255, 159, 64)',
          backgroundColor: 'rgba(255, 159, 64, 0.5)',
          borderWidth: 2,
          tension: 0.4,
          pointRadius: 0,
          pointStyle: 'rect',
          order: 1,
        }] : []),
        {
          type: 'line' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
          data: customerDemand.slice(0, downsideLength),
          borderColor: 'rgb(75, 192, 75)',
          backgroundColor: 'rgba(75, 192, 75, 0.5)',
          borderWidth: 5,
          tension: 0.4,
          pointRadius: 0,
          pointStyle: 'rect',
          order: 2,
        },
        {
          type: 'bar' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
          data: numberOfUnitsProduced.holidays.slice(0, downsideLength),
          backgroundColor: 'rgb(255, 205, 86)',
          stack: 'production',
          pointStyle: 'rect',
          order: 4,
        },
        {
          type: 'bar' as const,
          label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
          data: numberOfUnitsProduced.weekdays.slice(0, downsideLength),
          backgroundColor: 'rgb(201, 203, 207)',
          stack: 'production',
          pointStyle: 'rect',
          order: 3,
        },
      ],
    };

    // 生産能力（ライン全体）ダウンサイド チャートデータ設定
    setProductionCapacityChartDataModified(chartData);
    // 生産キャパグラフ（既存ライン含む）用：キャパ＝稼働日分（当初値）、案件品＝数量（ダウンサイド）、期間短縮後の月数
    setElqVersionModified(toExistingLineCapacityVersion(downsideQuantityByPartNo, numberOfUnitsProduced.weekdays, downsideLength));
  }, [
    originalProfitAndLossByMonth,
    workingDayByYear,
    holidayByYear,
    availabilityRateByMonth,
    investmentStartYearMonth,
    productionLine,
    quantitiesChartDataModified,
    lineCountByYear,
    projectData,
    bomData,
  ]);

  /**
   * 【生産能力（プロセス）】チャートデータ作成
   * 設備追加があるプロセスごとにグラフを生成
   * 更新投資または合理化の場合のみ計算
   */
  useEffect(() => {
    // 更新投資・合理化以外はスキップ
    if (projectData?.purpose !== PurposeType.UpdateAndOther.code &&
      projectData?.purpose !== PurposeType.Rationalization.code) {
      return;
    }

    // 必要なデータが揃っているかチェック
    if (
      !originalProfitAndLossByMonth ||
      !workingDayByYear || workingDayByYear.length === 0 ||
      !holidayByYear || holidayByYear.length === 0 ||
      !availabilityRateByMonth || availabilityRateByMonth.length === 0 ||
      !investmentStartYearMonth || investmentStartYearMonth.length === 0 ||
      !productionLine ||
      !equipmentAmounts || equipmentAmounts.length === 0 ||
      !processCodeData || processCodeData.length === 0
    ) {
      return;
    }

    // 設備追加があるプロセスIDを抽出（重複なし）
    const processIdsWithEquipment = new Set(
      equipmentAmounts
        .filter(e => e.processId)
        .map(e => e.processId!)
    );

    // 設備追加があるプロセスのみフィルタリング
    const processesWithEquipment = processCodeData.filter(
      process => processIdsWithEquipment.has(process.uniqueProcessId || "")
    );

    if (processesWithEquipment.length === 0) {
      setProductionCapacityProcessChartDataList([]);
      return;
    }

    // 年月ラベルを生成（ダウンサイドもラベルは全期間のまま、データのみ短縮する）
    const labels: string[] = [...originalProfitAndLossByMonth.labels];

    // 数量（ダウンサイド）からPartNo別数量と短縮後の月数を取得（ストレス指数は適用済み）
    // 数量グラフ未作成時は空データ＋全期間が返り、作成後に依存配列で再計算される
    const { quantityByPartNo: downsideQuantityByPartNo, length: downsideLength } =
      extractQuantityByPartNoFromChart(quantitiesChartDataModified, labels.length);

    // 各プロセスのチャートデータを生成
    const chartDataList = processesWithEquipment.map(process => {
      // 投資目的に応じてpartsCountを取得
      let partsCount = 1;

      if (projectData?.purpose === PurposeType.Rationalization.code) {
        // 合理化投資: rationalizationSummaryDataListから取得
        const rationalizationSummary = rationalizationSummaryDataList.find(
          s => s.processId === process.uniqueProcessId
        );
        partsCount = rationalizationSummary?.partsCount ?? 1;
      } else {
        // 更新投資・増産投資: updateSummaryDataListから取得
        const updateSummary = updateSummaryDataList.find(
          s => s.productionLineId === process.uniqueProcessId
        );
        partsCount = updateSummary?.partsCount ?? 1;
      }

      // 更新投資の場合のみ直近実績値を取得（合理化投資ではBOMを使用し続ける）
      let beforeOperatingRate = 0;
      let beforeYieldRate = 0;
      let beforeCycleTime = 0;

      if (projectData?.purpose !== PurposeType.Rationalization.code) {
        // 更新投資・増産投資の場合のみ直近実績値を取得
        const updateSummary = updateSummaryDataList.find(
          s => s.productionLineId === process.uniqueProcessId
        );

        const selectedPartNo = updateSummary?.selectedPartNo;
        const productionCapacityByPartNo = updateSummary?.productionCapacityByPartNo;

        // 使用するPartNoを決定（selectedPartNoがあればそれを、なければ最初のキーを使用）
        let targetPartNo: string | undefined;
        if (productionCapacityByPartNo) {
          const partNoKeys = Object.keys(productionCapacityByPartNo);
          targetPartNo = selectedPartNo && partNoKeys.includes(selectedPartNo)
            ? selectedPartNo
            : partNoKeys[0];
        }

        // 更新前後サマリーからデータを取得
        const capacityData = targetPartNo && productionCapacityByPartNo
          ? productionCapacityByPartNo[targetPartNo]
          : null;

        // 更新前データ（直近実績 recentActual）- 更新投資量産開始後に使用
        beforeOperatingRate = capacityData?.recentActual?.operatingRate ?? 0;
        beforeYieldRate = capacityData?.recentActual?.yield ?? 0;
        beforeCycleTime = capacityData?.recentActual?.cycleTime ?? 0;
      }

      // ▼ 顧客需要
      let beforeCustomerDemand: Decimal[] = [];
      let afterCustomerDemand: Decimal[] = [];
      // ダウンサイドの顧客需要（詳細モードのみ使用。簡易モードは当初計画と同値）
      let downsideCustomerDemand: Decimal[] = [];

      if (isSimpleMode) {
        // 簡易モードの場合は前後サマリーの売上数量から顧客需要を取得
        if (projectData?.purpose === PurposeType.Rationalization.code) {
          // 合理化投資: rationalizationSummaryDataListから取得
          const rationalizationSummary = rationalizationSummaryDataList.find(
            s => s.processId === process.uniqueProcessId
          );
          // 対象プロセスの売上数量を取得
          const salesQuantity = rationalizationSummary?.indicatorItems?.find(
            i => i.itemType === "salesQuantity"
          );
          // 売上数量が取得できた場合はDecimal型配列に変換
          if (salesQuantity) {
            // 合理化前の売上数量を顧客需要データに変換
            const beforeSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.beforeMonthlyData);
            beforeCustomerDemand = beforeSalesQuantity;
            // 合理化後の売上数量を顧客需要データに変換
            const afterSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.afterMonthlyData);
            afterCustomerDemand = afterSalesQuantity;
          }
        } else if (projectData?.purpose === PurposeType.UpdateAndOther.code) {
          // 更新投資: updateSummaryDataListから取得
          const updateSummary = updateSummaryDataList.find(
            s => s.productionLineId === process.uniqueProcessId
          );
          // 対象プロセスの売上数量を取得
          const salesQuantity = updateSummary?.indicatorItems?.find(
            i => i.itemType === "salesQuantity"
          );
          // 売上数量が取得できた場合はDecimal型配列に変換
          if (salesQuantity) {
            // 更新前の売上数量を顧客需要データに変換
            const beforeSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.beforeMonthlyData);
            beforeCustomerDemand = beforeSalesQuantity;
            // 更新後の売上数量を顧客需要データに変換
            const afterSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.afterMonthlyData);
            afterCustomerDemand = afterSalesQuantity;
          }
        }

      } else {
        // 詳細モードの場合は販売数量から顧客需要を取得（販売数量 × 1製品あたり必要部品数）
        const customerDemand: Decimal[] = calcCustomerDemandDataForProcess(labels, originalProfitAndLossByMonth.quantityByPartNo, partsCount);
        // 更新/合理化前後で共通
        beforeCustomerDemand = customerDemand;
        afterCustomerDemand = customerDemand;
        // ダウンサイドは数量（ダウンサイド）から（更新/合理化前後で共通）
        downsideCustomerDemand = calcCustomerDemandDataForProcess(labels, downsideQuantityByPartNo, partsCount);
      }

      // ▼ 更新前の計算
      // 更新投資量産開始前: availabilityRateByMonth, yieldRate, cycleTime
      // 更新投資量産開始後: recentActual.operatingRate, recentActual.yield, recentActual.cycleTime
      // 合理化投資: 常にBOM使用（beforeXXX = 0）
      const numberOfUnitsProducedBefore = calcNumberOfUnitsProducedForProcessBefore(
        labels,
        workingDayByYear,
        lineCountByYear,
        holidayByYear,
        availabilityRateByMonth,
        beforeOperatingRate / 100,
        (targetYearMonth: string) => getYieldRateFromBom(targetYearMonth) ?? 0,
        beforeYieldRate / 100,
        (targetYearMonth: string) => getCycleTimeFromBom(targetYearMonth) ?? 0,
        beforeCycleTime,
        investmentStartYearMonth,
        projectData?.projectStartDate!
      );

      // ▼ 更新後の計算
      // 全期間: availabilityRateByMonth, yieldRate, cycleTime
      const numberOfUnitsProducedAfter = calcNumberOfUnitsProduced(
        labels,
        workingDayByYear,
        lineCountByYear,
        holidayByYear,
        availabilityRateByMonth,
        (targetYearMonth: string) => {
          // BOMデータから月別歩留を取得、なければ0
          return getYieldRateFromBom(targetYearMonth) ?? 0;
        },
        (targetYearMonth: string) => {
          // BOMデータから月別C/Tを取得、なければ0
          return getCycleTimeFromBom(targetYearMonth) ?? 0;
        },
        projectData?.projectStartDate!
      );

      // ダウンサイドのキャパ（稼働日分・休日稼働分）はストレス指数を掛けず当初値を期間短縮して使う

      // ▼ 増加非稼働時間分の計算（更新投資・合理化の場合のみ、投資量産開始前のみ表示）
      let increasedNonWorkingTimeProduction: Decimal[] = [];
      if ((projectData?.purpose === PurposeType.UpdateAndOther.code ||
        projectData?.purpose === PurposeType.Rationalization.code) && pastAvailabilityRateByMonth.length > 0) {
        increasedNonWorkingTimeProduction = calcIncreasedNonWorkingTimeProduction(
          labels,
          workingDayByYear,
          lineCountByYear,
          holidayByYear,
          availabilityRateByMonth,
          pastAvailabilityRateByMonth,
          (targetYearMonth: string) => {
            // BOMデータから月別歩留を取得、なければ0
            return getYieldRateFromBom(targetYearMonth) ?? 0;
          },
          (targetYearMonth: string) => {
            // BOMデータから月別C/Tを取得、なければ0
            return getCycleTimeFromBom(targetYearMonth) ?? 0;
          },
          investmentStartYearMonth,
        );
      }

      // 更新前チャートデータ
      const beforeChartData = {
        labels,
        datasets: [
          {
            type: 'line' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
            data: beforeCustomerDemand,
            borderColor: 'rgb(75, 192, 75)',
            backgroundColor: 'rgba(75, 192, 75, 0.5)',
            borderWidth: 5,
            tension: 0.4,
            pointRadius: 0,
            pointStyle: 'rect',
            order: 2,
          },
          // 非稼働増加による能力押し下げ（更新投資の場合のみ）
          ...(increasedNonWorkingTimeProduction.length > 0 ? [{
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'),
            data: increasedNonWorkingTimeProduction,
            backgroundColor: 'rgb(153, 102, 255)',
            stack: 'production',
            pointStyle: 'rect',
            order: 5,
          }] : []),
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
            data: numberOfUnitsProducedBefore.holidays,
            backgroundColor: 'rgb(255, 205, 86)',
            stack: 'production',
            pointStyle: 'rect',
            order: 4,
          },
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
            data: numberOfUnitsProducedBefore.weekdays,
            backgroundColor: 'rgb(201, 203, 207)',
            stack: 'production',
            pointStyle: 'rect',
            order: 3,
          },
        ],
      };

      // 更新前（ダウンサイド）チャートデータ（詳細モードのみ使用。顧客需要＝数量（ダウンサイド）、キャパ・押し下げは当初値。全系列を期間短縮）
      const beforeDownsideChartData = {
        labels,
        datasets: [
          {
            type: 'line' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
            data: downsideCustomerDemand.slice(0, downsideLength),
            borderColor: 'rgb(75, 192, 75)',
            backgroundColor: 'rgba(75, 192, 75, 0.5)',
            borderWidth: 5,
            tension: 0.4,
            pointRadius: 0,
            pointStyle: 'rect',
            order: 2,
          },
          // 非稼働増加による能力押し下げ（更新投資の場合のみ）
          ...(increasedNonWorkingTimeProduction.length > 0 ? [{
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'),
            data: increasedNonWorkingTimeProduction.slice(0, downsideLength),
            backgroundColor: 'rgb(153, 102, 255)',
            stack: 'production',
            pointStyle: 'rect',
            order: 5,
          }] : []),
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
            data: numberOfUnitsProducedBefore.holidays.slice(0, downsideLength),
            backgroundColor: 'rgb(255, 205, 86)',
            stack: 'production',
            pointStyle: 'rect',
            order: 4,
          },
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
            data: numberOfUnitsProducedBefore.weekdays.slice(0, downsideLength),
            backgroundColor: 'rgb(201, 203, 207)',
            stack: 'production',
            pointStyle: 'rect',
            order: 3,
          },
        ],
      };

      // 更新後チャートデータ
      const afterChartData = {
        labels,
        datasets: [
          {
            type: 'line' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
            data: afterCustomerDemand,
            borderColor: 'rgb(75, 192, 75)',
            backgroundColor: 'rgba(75, 192, 75, 0.5)',
            borderWidth: 5,
            tension: 0.4,
            pointRadius: 0,
            pointStyle: 'rect',
            order: 2,
          },
          // 非稼働増加による能力押し下げ（更新投資の場合のみ）
          ...(increasedNonWorkingTimeProduction.length > 0 ? [{
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'),
            data: increasedNonWorkingTimeProduction,
            backgroundColor: 'rgb(153, 102, 255)',
            stack: 'production',
            pointStyle: 'rect',
            order: 5,
          }] : []),
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
            data: numberOfUnitsProducedAfter.holidays,
            backgroundColor: 'rgb(255, 205, 86)',
            stack: 'production',
            pointStyle: 'rect',
            order: 4,
          },
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
            data: numberOfUnitsProducedAfter.weekdays,
            backgroundColor: 'rgb(201, 203, 207)',
            stack: 'production',
            pointStyle: 'rect',
            order: 3,
          },
        ],
      };

      // 更新後（ダウンサイド）チャートデータ（更新前（ダウンサイド）と同じ方式）
      const afterDownsideChartData = {
        labels,
        datasets: [
          {
            type: 'line' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
            data: downsideCustomerDemand.slice(0, downsideLength),
            borderColor: 'rgb(75, 192, 75)',
            backgroundColor: 'rgba(75, 192, 75, 0.5)',
            borderWidth: 5,
            tension: 0.4,
            pointRadius: 0,
            pointStyle: 'rect',
            order: 2,
          },
          // 非稼働増加による能力押し下げ（更新投資の場合のみ）
          ...(increasedNonWorkingTimeProduction.length > 0 ? [{
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'),
            data: increasedNonWorkingTimeProduction.slice(0, downsideLength),
            backgroundColor: 'rgb(153, 102, 255)',
            stack: 'production',
            pointStyle: 'rect',
            order: 5,
          }] : []),
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
            data: numberOfUnitsProducedAfter.holidays.slice(0, downsideLength),
            backgroundColor: 'rgb(255, 205, 86)',
            stack: 'production',
            pointStyle: 'rect',
            order: 4,
          },
          {
            type: 'bar' as const,
            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
            data: numberOfUnitsProducedAfter.weekdays.slice(0, downsideLength),
            backgroundColor: 'rgb(201, 203, 207)',
            stack: 'production',
            pointStyle: 'rect',
            order: 3,
          },
        ],
      };

      return {
        processId: process.uniqueProcessId || "",
        processName: process.uniqueProcessName || "",
        beforeData: beforeChartData,
        // 簡易モード時はダウンサイド計算なし（当初計画と同値）
        beforeDownsideData: isSimpleMode ? beforeChartData : beforeDownsideChartData,
        afterData: afterChartData,
        afterDownsideData: isSimpleMode ? afterChartData : afterDownsideChartData,
      };
    });

    setProductionCapacityProcessChartDataList(chartDataList);
  }, [
    originalProfitAndLossByMonth,
    workingDayByYear,
    holidayByYear,
    availabilityRateByMonth,
    pastAvailabilityRateByMonth,
    investmentStartYearMonth,
    productionLine,
    equipmentAmounts,
    processCodeData,
    updateSummaryDataList,
    quantitiesChartDataModified,
    bomData,
    isSimpleMode,
  ]);

  /**
   * 【合理化前後サマリーチャート】実データからチャートデータを生成（processId単位）
   */
  useEffect(() => {
    // 合理化投資、または更新投資（簡易モード）の場合のみチャートを表示
    const isUpdateSimple = isSimpleMode && projectData?.purpose === PurposeType.UpdateAndOther.code;
    if (projectData?.purpose !== PurposeType.Rationalization.code && !isUpdateSimple) {
      setRationalizationSummaryChartDataList([]);
      return;
    }

    // labelsがない場合は処理しない
    if (!originalProfitAndLossByMonth?.labels || originalProfitAndLossByMonth.labels.length === 0) {
      return;
    }

    // サマリーデータがない場合は処理しない
    const activeSummaryList = isUpdateSimple ? updateSummaryDataList : rationalizationSummaryDataList;
    if (!activeSummaryList || activeSummaryList.length === 0) {
      setRationalizationSummaryChartDataList([]);
      return;
    }

    // ローカル通貨名が未設定の場合は処理しない（設定後に再実行される）
    if (!localCurrencyName) {
      return;
    }

    const labels = originalProfitAndLossByMonth.labels;

    // 項目名マッピング
    const itemTypeToName: Record<string, string> = {
      productionQuantity: t('features.InvestmentScreening.SimulationProductivityImprovement.label.productionQuantity'),
      salesQuantity: t('features.InvestmentScreening.SimulationProductivityImprovement.label.revenueQuantity'),
      laborCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.laborCostAndDepreciation'),
      repairCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.repairCost'),
      consumablesCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.consumablesCost'),
      maintenanceCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.maintenanceCost'),
      scrapCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.scrapCost'),
      totalCost: t('features.InvestmentScreening.SimulationProductivityImprovement.label.totalCost'),
      targetEquipmentDepreciation: t('features.InvestmentScreening.SimulationProductivityImprovement.label.targetEquipmentDepreciation'),
      otherDepreciation: t('features.InvestmentScreening.SimulationProductivityImprovement.label.otherDepreciation'),
    };

    // labelsは"YYYY/MM"形式だが、beforeMonthlyData/afterMonthlyDataのキーは"YYYY-MM"形式のため変換
    const labelsAsHyphen = labels.map((label: string) => label.replace("/", "-"));

    // 0年度フラグ（labelsの開始月が4月より前なら0年度あり）
    const firstLabel = labels[0]; // "2024/04" 形式
    const [, firstMonth] = firstLabel.split("/").map(Number);
    const zeroFiscalFlg = firstMonth < 4;
    const maxYears = Math.ceil(labels.length / 12) + 1;

    // processId単位でチャートデータを生成
    const chartDataList: {
      processId: string;
      itemNo: string;
      labels: string[];
      items: RationalizationSummaryChartItem[];
    }[] = [];

    // データソースに応じてリストを正規化
    type NormalizedSummaryForChart = {
      processId: string;
      itemNo: string;
      costCurrencyId?: string;
      indicatorItems?: RationalizationProfitLossItem[];
      costItems?: RationalizationProfitLossItem[];
    };
    const normalizedSummaryList: NormalizedSummaryForChart[] = isUpdateSimple
      ? updateSummaryDataList.map(s => ({
        processId: s.productionLineId || "",
        itemNo: s.productionLineName || s.productionLineId || "",
        costCurrencyId: s.costCurrencyId,
        indicatorItems: s.indicatorItems,
        costItems: s.costItems,
      }))
      : rationalizationSummaryDataList.map(s => ({
        processId: s.processId || "",
        itemNo: s.itemNo || "",
        costCurrencyId: s.costCurrencyId,
        indicatorItems: s.indicatorItems,
        costItems: s.costItems,
      }));

    normalizedSummaryList.forEach(summaryData => {
      const processId = summaryData.processId || "";

      // 合理化前後サマリーデータから費用の通貨を取得
      const costCurrencyId = summaryData.costCurrencyId;
      const costCurrencyName = costCurrencyId
        ? currencyData.find(c => c.currencyId === costCurrencyId)?.currencyName || localCurrencyName || "JPY"
        : localCurrencyName || "JPY";

      // 費用項目の表示通貨はlocalCurrencyNameに統一
      const itemTypeToUnit: Record<string, string> = {
        productionQuantity: "pcs",
        laborCost: localCurrencyName,
        repairCost: localCurrencyName,
        consumablesCost: localCurrencyName,
        maintenanceCost: localCurrencyName,
        scrapCost: localCurrencyName,
        targetEquipmentDepreciation: localCurrencyName,
        otherDepreciation: localCurrencyName,
      };

      // このprocessIdのindicatorItemsとcostItemsを集約
      type ItemWithGroup = RationalizationProfitLossItem & { sourceGroup: "indicator" | "cost" };
      const allItems: ItemWithGroup[] = [];
      if (summaryData.indicatorItems) {
        summaryData.indicatorItems.forEach(item => {
          allItems.push({ ...item, sourceGroup: "indicator" });
        });
      }
      if (summaryData.costItems) {
        summaryData.costItems.forEach(item => {
          allItems.push({ ...item, sourceGroup: "cost" });
        });
      }

      // データがない場合はスキップ
      if (allItems.length === 0) {
        return;
      }

      // 項目ごとにデータを集約（同じ項目ID + グループの組み合わせでデータを合算）
      // 自由入力（custom）は項目名も含めてキーにする
      const itemDataMap = new Map<string, {
        itemType: RationalizationProfitLossItemType;
        customItemName?: string;
        customUnit?: string;
        sourceGroup: "indicator" | "cost";
        beforeData: Record<string, number>;
        afterData: Record<string, number>;
      }>();

      allItems.forEach(item => {
        const key = item.itemType === "custom"
          ? `${item.itemType}_${item.sourceGroup}_${item.customItemName || ""}`
          : `${item.itemType}_${item.sourceGroup}`;

        const existingData = itemDataMap.get(key);
        if (existingData) {
          Object.entries(item.beforeMonthlyData).forEach(([month, value]) => {
            existingData.beforeData[month] = (existingData.beforeData[month] || 0) + value;
          });
          Object.entries(item.afterMonthlyData).forEach(([month, value]) => {
            existingData.afterData[month] = (existingData.afterData[month] || 0) + value;
          });
        } else {
          itemDataMap.set(key, {
            itemType: item.itemType,
            customItemName: item.customItemName,
            customUnit: item.customUnit,
            sourceGroup: item.sourceGroup,
            beforeData: { ...item.beforeMonthlyData },
            afterData: { ...item.afterMonthlyData },
          });
        }
      });

      // 労務費グラフ用の月別減価償却費
      // 簡易モード: 合理化前後サマリーの targetEquipmentDepreciation + otherDepreciation の after - before 差分
      // 通常モード: 設備投資タブの設備情報から定額法で自動計算（変更前の挙動を維持）
      const depreciationByLabel: Record<string, number> = {};
      if (isSimpleMode) {
        if (summaryData.costItems) {
          summaryData.costItems.forEach(item => {
            if (item.itemType !== "targetEquipmentDepreciation" && item.itemType !== "otherDepreciation") return;
            labelsAsHyphen.forEach((monthKey, idx) => {
              const before = new Decimal((item.beforeMonthlyData as any)?.[monthKey] || 0);
              const after = new Decimal((item.afterMonthlyData as any)?.[monthKey] || 0);
              const diff = after.minus(before);
              const converted = costCurrencyName === localCurrencyName
                ? diff
                : convertCurrency(diff, costCurrencyName, localCurrencyName, currencyData);
              const labelKey = labels[idx];
              depreciationByLabel[labelKey] = (depreciationByLabel[labelKey] || 0) + converted.toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toNumber();
            });
          });
        }
      } else {
        if (equipmentAmounts && equipmentAmounts.length > 0 && projectData?.projectStartDate) {
          const filteredEquipments = equipmentAmounts.filter(e => e.processId === processId);
          if (filteredEquipments.length > 0) {
            const depreciationData = calcEquipmentDepreciationByYearMonth(
              maxYears,
              filteredEquipments,
              true,
              projectData.projectStartDate,
              zeroFiscalFlg
            );
            depreciationData.forEach(({ year, month, value }) => {
              const startDateParts = projectData.projectStartDate!.split(/[-\/]/);
              const startYear = Number(startDateParts[0]);
              const startMonth = Number(startDateParts[1]);
              let fiscalStartYear: number;
              if (zeroFiscalFlg) {
                fiscalStartYear = startMonth < 4 ? startYear - 2 + year : startYear - 1 + year;
              } else {
                fiscalStartYear = startMonth < 4 ? startYear - 1 + (year - 1) : startYear + (year - 1);
              }
              const actualYear = month >= 4 ? fiscalStartYear : fiscalStartYear + 1;
              const labelKey = `${actualYear}/${String(month).padStart(2, "0")}`;
              depreciationByLabel[labelKey] = (depreciationByLabel[labelKey] || 0) + Number(value.toFixed(0));
            });
          }
        }
      }

      // チャートデータに変換
      const chartItems: RationalizationSummaryChartItem[] = [];

      itemDataMap.forEach((data, key) => {
        const rawBeforeDataArray = labelsAsHyphen.map(label => data.beforeData[label] || 0);
        const rawAfterDataArray = labelsAsHyphen.map(label => data.afterData[label] || 0);

        const group = data.sourceGroup;
        const itemName = data.customItemName || itemTypeToName[data.itemType] || data.itemType;
        const unit = data.customUnit || itemTypeToUnit[data.itemType] || "";

        // 費用グループの場合、costCurrencyNameからlocalCurrencyNameへ通貨変換
        const needsCurrencyConversion = group === "cost" && costCurrencyName !== localCurrencyName;
        const beforeDataArray = needsCurrencyConversion
          ? rawBeforeDataArray.map(v => convertCurrency(v, costCurrencyName, localCurrencyName, currencyData).toDecimalPlaces(4).toNumber())
          : rawBeforeDataArray;
        const afterDataArray = needsCurrencyConversion
          ? rawAfterDataArray.map(v => convertCurrency(v, costCurrencyName, localCurrencyName, currencyData).toDecimalPlaces(4).toNumber())
          : rawAfterDataArray;

        if (data.itemType === "laborCost") {
          // 費用セクション用: 労務費（前後比較のみ）
          chartItems.push({
            itemId: key + "_laborCost",
            itemName: t('features.InvestmentScreening.SimulationProductivityImprovement.label.laborCost'),
            unit,
            beforeData: beforeDataArray,
            afterData: afterDataArray,
            group: "cost",
            depreciationData: undefined,
          });
          // 改善効果セクション用: 労務費と減価償却費（複合チャート）
          const depreciationDataArray = labels.map(label => depreciationByLabel[label] || 0);
          chartItems.push({
            itemId: key + "_improvementEffect",
            itemName: itemTypeToName["laborCost"],
            unit,
            beforeData: beforeDataArray,
            afterData: afterDataArray,
            group: "improvementEffect",
            depreciationData: depreciationDataArray,
          });
        } else {
          chartItems.push({
            itemId: key,
            itemName,
            unit,
            beforeData: beforeDataArray,
            afterData: afterDataArray,
            group,
            depreciationData: undefined,
          });
        }
      });

      // 指標 → 費用 → 改善効果 の順で並び替え
      const sortedItems = [
        ...chartItems.filter(item => item.group === "indicator"),
        ...chartItems.filter(item => item.group === "cost"),
        ...chartItems.filter(item => item.group === "improvementEffect"),
      ];

      chartDataList.push({
        processId,
        itemNo: summaryData.itemNo,
        labels,
        items: sortedItems,
      });
    });

    setRationalizationSummaryChartDataList(chartDataList);
  }, [projectData?.purpose, originalProfitAndLossByMonth?.labels, rationalizationSummaryDataList, updateSummaryDataList, equipmentAmounts, projectData?.projectStartDate, currencyData, localCurrencyName, isSimpleMode]);

  /**
   * プロセス用顧客需要データ作成（簡易モード）
   * @param labels ラベル情報
   * @param monthlyData 月別売上数量
   * @returns 顧客需要データ（前後サマリーの売上数量から取得）
   */
  const calcCustomerDemandDataForProcessSummary = (
    labels: string[],
    monthlyData: Record<string, number>
  ) => {
    const customerDemand: Decimal[] = Array(labels.length).fill(new Decimal(0));

    for (const [index, [key, value]] of Object.entries(monthlyData).entries()) {
      customerDemand[index] = new Decimal(value);
    }

    return customerDemand;
  };

  /**
   * プロセス用顧客需要データ作成（詳細モード）
   * @param labels ラベル情報
   * @param quantityByPartNo パーツ別数量
   * @param partsCount 1製品あたり必要部品数
   * @returns 顧客需要データ（販売数量 × partsCount）
   */
  const calcCustomerDemandDataForProcess = (
    labels: string[],
    quantityByPartNo: Record<string, string[]>,
    partsCount: number
  ) => {
    const customerDemand: Decimal[] = Array(labels.length).fill(new Decimal(0));

    for (const [_, values] of Object.entries(quantityByPartNo)) {
      const quantities = values.map(value => new Decimal(value));

      quantities.forEach((quantity, idx) => {
        customerDemand[idx] = customerDemand[idx].plus(quantity.mul(partsCount));
      });
    }

    return customerDemand;
  };

  /**
   * 稼働日分と休日稼働分の生産数算出
   * @param labels ラベル情報
   * @param baseWorkingDayData 稼働日数情報
   * @param baseLineCountData ライン数情報
   * @param baseHolidayData 休日稼働日数
   * @param baseAvailabilityData 稼働率情報
   * @param baseYieldRateValueFunc 歩留（取得処理）
   * @param cycleTimeFunc サイクルタイム（取得処理）
   * @param downsideIndexGraph ストレス指数
   * @returns 稼働日分と休日稼働分の生産数
   */
  const calcNumberOfUnitsProduced = (
    labels: string[],
    baseWorkingDayData: { fiscalYear: string, workingDay: number[] }[],
    baseLineCountData: { fiscalYear: string, lineCount: number[] }[],
    baseHolidayData: { fiscalYear: string, holiday: number[] }[],
    baseAvailabilityData: { fiscalYear: string, availabilityRate: number[] }[],
    baseYieldRateValueFunc: (targetYearMonth: string) => number,
    cycleTimeFunc: (targetYearMonth: string) => number,
    projectStartDate: string,
    downsideIndexGraph?: DownsideIndex,
  ) => {
    const weekdays: Decimal[] = Array(labels.length).fill(new Decimal(0));
    const holidays: Decimal[] = Array(labels.length).fill(new Decimal(0));;

    // 1日を秒換算
    const oneDaySeconds = new Decimal(3600 * 24);

    // 年月を取得
    const [year, month] = projectStartDate.split(/\/|-/).map(v => Number(v) || 0);
    const projectStartFiscalYear = month >= 4 ? year : year - 1;

    // 最大サイクルタイムの初期値は過去プロジェクト
    let idx = 0;
    for (const yearMonth of labels) {
      // 年月分割
      const { year: fiscalYear, month } = getFiscalYearMonth(labels, idx);

      /** 稼働日数 */
      const workingDay = getMonthlyDataByYearAndMonth(baseWorkingDayData, fiscalYear, month, "workingDay");

      /** ライン数 */
      const lineCount = getMonthlyDataByYearAndMonth(baseLineCountData, fiscalYear, month, "lineCount");

      /** 休日日数 */
      const workOnHoliday = getMonthlyDataByYearAndMonth(baseHolidayData, fiscalYear, month, "holiday");

      /** 稼働率 */
      const availabilityRateToUse = getMonthlyDataByYearAndMonth(baseAvailabilityData, fiscalYear, month, "availabilityRate");

      // 歩留
      const baseYieldRateValue = baseYieldRateValueFunc(yearMonth);

      // サイクルタイム
      const baseCycleTimeValue = cycleTimeFunc(yearMonth);

      // サイクルタイムが0の場合はスキップ
      if (baseCycleTimeValue <= 0) {
        idx++;
        continue;
      }

      // 平日稼働分 = 3600 × 24h × 平日稼働日数 × 稼働率 × 歩留 × ライン数 ÷ 最大サイクルタイム
      weekdays[idx] = oneDaySeconds.mul(workingDay).mul(availabilityRateToUse).mul(baseYieldRateValue).mul(lineCount).div(baseCycleTimeValue).toDecimalPlaces(0);

      // 休日稼働分 = 3600 × 24h × 休日稼働日数 × 稼働率 × 歩留 × ライン数 ÷ 最大サイクルタイム
      holidays[idx] = oneDaySeconds.mul(workOnHoliday).mul(availabilityRateToUse).mul(baseYieldRateValue).mul(lineCount).div(baseCycleTimeValue).toDecimalPlaces(0);

      if (downsideIndexGraph) {
        const fiscalYearIndex = fiscalYear - projectStartFiscalYear;

        //  数量をストレス指数分減少（月度単利）
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex, downsideIndexGraph));

        // 稼働分(数量) = 稼働分(数量) × ストレス指数
        weekdays[idx] = weekdays[idx].mul(downsindeIndex).toDecimalPlaces(0);
        holidays[idx] = holidays[idx].mul(downsindeIndex).toDecimalPlaces(0);
      }

      idx++;
    }

    return {
      weekdays: weekdays,
      holidays: holidays,
    };
  }

  /**
   * 増加非稼働時間分の生産数を計算する
   * 現在の稼働率と過去プロジェクトの稼働率の差分に基づいて生産数を算出
   *
   * @param labels ラベル配列（年月）
   * @param baseWorkingDayData 稼働日数データ
   * @param baseLineCountData ライン数データ
   * @param baseHolidayData 休日出勤データ
   * @param baseAvailabilityData 現在の稼働率データ
   * @param pastAvailabilityData 過去プロジェクトの稼働率データ
   * @param baseYieldRateValueFunc 歩留を取得する関数
   * @param cycleTimeFunc サイクルタイムを取得する関数
   * @returns 増加非稼働時間分の生産数配列
   */
  const calcIncreasedNonWorkingTimeProduction = (
    labels: string[],
    baseWorkingDayData: { fiscalYear: string, workingDay: number[] }[],
    baseLineCountData: { fiscalYear: string, lineCount: number[] }[],
    baseHolidayData: { fiscalYear: string, holiday: number[] }[],
    baseAvailabilityData: { fiscalYear: string, availabilityRate: number[] }[],
    pastAvailabilityData: { fiscalYear: string, availabilityRate: number[] }[],
    baseYieldRateValueFunc: (targetYearMonth: string) => number,
    cycleTimeFunc: (targetYearMonth: string) => number,
    investmentStartYearMonth?: string,
  ): Decimal[] => {
    const production: Decimal[] = Array(labels.length).fill(new Decimal(0));

    // 1日を秒換算
    const oneDaySeconds = new Decimal(3600 * 24);

    let idx = 0;
    for (const yearMonth of labels) {
      // 更新投資量産開始後は0を返す
      if (investmentStartYearMonth && yearMonth >= investmentStartYearMonth) {
        idx++;
        continue;
      }

      // 年月分割
      const { year: fiscalYear, month } = getFiscalYearMonth(labels, idx);

      /** 稼働日数 */
      const workingDay = getMonthlyDataByYearAndMonth(baseWorkingDayData, fiscalYear, month, "workingDay");

      /** ライン数 */
      const lineCount = getMonthlyDataByYearAndMonth(baseLineCountData, fiscalYear, month, "lineCount");

      /** 休日出勤日数 */
      const workOnHoliday = getMonthlyDataByYearAndMonth(baseHolidayData, fiscalYear, month, "holiday");

      /** 現在稼働率 */
      const currentAvailabilityRate = getMonthlyDataByYearAndMonth(baseAvailabilityData, fiscalYear, month, "availabilityRate");

      /** 過去稼働率 */
      const pastAvailabilityRate = getMonthlyDataByYearAndMonth(pastAvailabilityData, fiscalYear, month, "availabilityRate");

      // 稼働率差分（現在 - 過去）
      const availabilityRateDiff = currentAvailabilityRate - pastAvailabilityRate;

      // 歩留
      const baseYieldRateValue = baseYieldRateValueFunc(yearMonth);

      // サイクルタイム
      const baseCycleTimeValue = cycleTimeFunc(yearMonth);

      // 増加非稼働時間分生産数 = 3600 × 24h × (稼働日数 + 休日出勤日数) × (現在稼働率 - 過去稼働率) × 歩留 × ライン数 ÷ サイクルタイム
      const totalWorkDays = new Decimal(workingDay).plus(workOnHoliday);
      production[idx] = oneDaySeconds
        .mul(totalWorkDays)
        .mul(availabilityRateDiff)
        .mul(baseYieldRateValue)
        .mul(lineCount)
        .div(baseCycleTimeValue)
        .toDecimalPlaces(0);

      idx++;
    }

    return production;
  }

  /**
   * 【プロセス用・更新前】稼働日分と休日稼働分の生産数算出
   * 更新投資量産開始年月によってデータソースを切り替える
   * - 更新投資量産開始前: availabilityRateByMonth(月別), yieldRate(月別/BOM), cycleTime(月別/BOM)
   * - 更新投資量産開始後: recentActual.operatingRate(固定), recentActual.yield(固定), recentActual.cycleTime(固定)
   *
   * @param labels ラベル情報
   * @param baseWorkingDayData 稼働日数情報
   * @param baseLineCountData ライン数情報
   * @param baseHolidayData 休日稼働日数
   * @param baseAvailabilityData 稼働率情報（月別）- 更新投資量産開始前に使用
   * @param recentActualOperatingRate 直近実績の稼働率（0-1の小数）- 更新投資量産開始後に使用
   * @param getBaseYieldRate 歩留を取得する関数（0-1の小数）- 更新投資量産開始前に使用
   * @param recentActualYieldRate 直近実績の歩留（0-1の小数）- 更新投資量産開始後に使用
   * @param getBaseCycleTime サイクルタイムを取得する関数（秒）- 更新投資量産開始前に使用
   * @param recentActualCycleTime 直近実績のサイクルタイム（秒）- 更新投資量産開始後に使用
   * @param investmentStartYearMonth 更新投資量産開始年月
   * @param projectStartDate プロジェクト開始日
   * @param downsideIndexGraph ストレス指数（オプション）
   * @returns 稼働日分と休日稼働分の生産数
   */
  const calcNumberOfUnitsProducedForProcessBefore = (
    labels: string[],
    baseWorkingDayData: { fiscalYear: string, workingDay: number[] }[],
    baseLineCountData: { fiscalYear: string, lineCount: number[] }[],
    baseHolidayData: { fiscalYear: string, holiday: number[] }[],
    baseAvailabilityData: { fiscalYear: string, availabilityRate: number[] }[],
    recentActualOperatingRate: number,
    getBaseYieldRate: (targetYearMonth: string) => number,
    recentActualYieldRate: number,
    getBaseCycleTime: (targetYearMonth: string) => number,
    recentActualCycleTime: number,
    investmentStartYearMonth: string,
    projectStartDate: string,
    downsideIndexGraph?: DownsideIndex,
  ) => {
    const weekdays: Decimal[] = Array(labels.length).fill(new Decimal(0));
    const holidays: Decimal[] = Array(labels.length).fill(new Decimal(0));

    // 1日を秒換算
    const oneDaySeconds = new Decimal(3600 * 24);

    // 年月を取得
    const [year, month] = projectStartDate.split(/\/|-/).map(v => Number(v) || 0);
    const projectStartFiscalYear = month >= 4 ? year : year - 1;

    let idx = 0;
    for (const yearMonth of labels) {
      // 年月分割
      const { year: fiscalYear, month } = getFiscalYearMonth(labels, idx);

      /** 稼働日数 */
      const workingDay = getMonthlyDataByYearAndMonth(baseWorkingDayData, fiscalYear, month, "workingDay");

      /** ライン数 */
      const lineCount = getMonthlyDataByYearAndMonth(baseLineCountData, fiscalYear, month, "lineCount");

      /** 休日日数 */
      const workOnHoliday = getMonthlyDataByYearAndMonth(baseHolidayData, fiscalYear, month, "holiday");

      // 更新投資量産開始年月によってデータソースを切り替え
      let operatingRate: number;
      let yieldRateValue: number;
      let cycleTimeValue: number;

      if (yearMonth < investmentStartYearMonth) {
        // 更新投資量産開始前: 月別データを使用（BOM）
        operatingRate = getMonthlyDataByYearAndMonth(baseAvailabilityData, fiscalYear, month, "availabilityRate");
        yieldRateValue = getBaseYieldRate(yearMonth);
        cycleTimeValue = getBaseCycleTime(yearMonth);
      } else {
        // 更新投資量産開始後: 直近実績の値を使用
        operatingRate = recentActualOperatingRate;
        yieldRateValue = recentActualYieldRate;
        cycleTimeValue = recentActualCycleTime;
      }

      // サイクルタイムが0の場合はスキップ
      if (cycleTimeValue <= 0) {
        idx++;
        continue;
      }

      // 平日稼働分 = 3600 × 24h × 平日稼働日数 × 稼働率 × 歩留 × ライン数 ÷ サイクルタイム
      weekdays[idx] = oneDaySeconds.mul(workingDay).mul(operatingRate).mul(yieldRateValue).mul(lineCount).div(cycleTimeValue).toDecimalPlaces(0);

      // 休日稼働分 = 3600 × 24h × 休日稼働日数 × 稼働率 × 歩留 × ライン数 ÷ サイクルタイム
      holidays[idx] = oneDaySeconds.mul(workOnHoliday).mul(operatingRate).mul(yieldRateValue).mul(lineCount).div(cycleTimeValue).toDecimalPlaces(0);

      if (downsideIndexGraph) {
        const fiscalYearIndex = fiscalYear - projectStartFiscalYear;

        //  数量をストレス指数分減少（月度単利）
        const downsindeIndex = (1 - getDownsideIndexToQuantity(fiscalYearIndex, downsideIndexGraph));

        // 稼働分(数量) = 稼働分(数量) × ストレス指数
        weekdays[idx] = weekdays[idx].mul(downsindeIndex).toDecimalPlaces(0);
        holidays[idx] = holidays[idx].mul(downsindeIndex).toDecimalPlaces(0);
      }

      idx++;
    }

    return {
      weekdays: weekdays,
      holidays: holidays,
    };
  }

  /**
   * 改善後非稼働時間更新時
   */
  useEffect(() => {

    // 算出した稼働率を参照（年度ごとの非稼働時間データ配列）
    const availabilityRates: {
      fiscalYear: string;
      availabilityRate: number[];
    }[] = [];

    // 各年度のデータを処理
    improvedWorkingDaysData.forEach(({ fiscalYear, workingDaysData }) => {
      // 各年度に対応する非稼働時間データを検索（会計年度文字列は表示言語で変わるため年数値で判定する）
      const matchingNonWorkingHoursData = improvedNonWorkingHoursData.find(
        (data) => isSameFiscalYear(data.fiscalYear, fiscalYear)
      );

      // 該当するデータがある場合のみ処理
      if (matchingNonWorkingHoursData) {
        const availabilityRateByMonth = workingDaysData.requiredOverTimes.map((_, index) => {
          // 該当月の availabilityRate を取得（存在しない場合は 0）
          return Number(
            matchingNonWorkingHoursData.nonWorkingHoursByMonth[index]?.availabilityRate ?? 0
          );
        });

        // 結果を配列に格納
        availabilityRates.push({
          fiscalYear,
          availabilityRate: availabilityRateByMonth,
        });
      } else {
        // 該当するデータがない場合は空の配列を追加 (もしくは別の処理)
        availabilityRates.push({
          fiscalYear,
          availabilityRate: Array(12).fill(0), // 仮に月ごとの稼働率が全て 0 の場合
        });
      }
    });

    // 差分確認および更新を行う
    availabilityRates.forEach((_, index) => {
      updateStateIfNeeded(
        availabilityRates,
        improvedAvailabilityRateByMonth,
        index,
        (sourceItem, targetItem) =>
          JSON.stringify(sourceItem) !== JSON.stringify(targetItem),
        setImprovedAvailabilityRateByMonth,
        (sourceItem) => sourceItem
      );
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    improvedNonWorkingHoursData,
    improvedWorkingDaysData,
    // 以下は出力側の状態のため依存配列から除外（無限ループ防止）
    // improvedAvailabilityRateByMonth,
  ]);

  /**
   * 権限情報
   */
  useEffect(() => {
    const pagePermissions =
      getPermissions(
        userPermissions,
        WorkflowId.SimulationProductivityImprovement,
        projectData?.purpose,
        employeeId,
        divisionId,
        projectData?.registrantDivisionId
      );
    setPagePermissions(pagePermissions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermissions, employeeId, divisionId, projectData?.purpose, projectData?.registrantDivisionId]);

  /**
   * 別案件・別の振り返りを表示した際、過去Part No不整合の通知済みフラグをリセットする
   */
  useEffect(() => {
    pastPartNoToastShownRef.current = false;
    setMissingPastPartNoList([]);
  }, [projectId, reviewDate]);

  /**
   * 過去プロジェクトのPart No不整合をトーストで通知する（画面表示時に1回のみ）
   * pagePermissionsが未設定の間は承認完了かどうかを判定できないため待つ（権限判定の競合防止）
   */
  useEffect(() => {
    if (pastPartNoToastShownRef.current) return;
    if (missingPastPartNoList.length === 0) return;
    if ((userPermissions?.length || 0) <= 0) return;
    if (!pagePermissions) return;

    const partNos = missingPastPartNoList.join(", ");

    if (userPermissions[0].flowKb === FlowKb.Confirmation) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastPartNoMismatchForConfirmer', { partNos }),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
    } else if (userPermissions[0].flowKb === FlowKb.Approval) {
      if (pagePermissions?.currentFlowId !== WorkflowId.ApproveComplete) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastPartNoMismatchForApprover', { partNos }),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.warn(`For the approved request, the PartNo[${partNos}] of the Project linked to a past project does not match the PartNo of the current project.`);
      }
    }
    pastPartNoToastShownRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missingPastPartNoList, userPermissions, pagePermissions]);

  /**
   * 初期表示時
   */
  useEffect(() => {
    if (projectId) {
      // ドラフトとテキストエリア（マウント中のみ）の両方を初期化し、表示とドラフトの不一致を防ぐ
      finalInvestmentReasonDraftRef.current = null;
      finalInvestmentReasonRef.current?.setValue(null);
      downsideRiskDraftRef.current = null;
      downsideRiskRef.current?.setValue(null);
      fetchData();
    }
  }, [projectId, toast, t]);

  /**
   * 初期表示時：シナリオデータを取得して保存済み設定一覧を更新
   */
  useEffect(() => {
    const loadScenarioConfigs = async () => {
      if (!projectId) return;

      // DB からシナリオデータを取得
      const scenarioData = await fetchScenarioData();

      // DB から取得したデータを SavedSimulationConfig 形式に変換
      const convertedConfigs = scenarioData.map(convertTScenarioToSavedConfig);

      // 保存済み設定一覧を更新
      setSavedConfigs(convertedConfigs);
    };

    loadScenarioConfigs();
  }, [projectId]);

  /**
   * 保存済み設定の選択状態を復元
   * savedConfigsとprojectDataが揃った後、一度だけ実行
   * 必要なグラフデータが生成されてから実行
   */
  useEffect(() => {
    // 既に復元済みの場合はスキップ
    if (hasRestoredSelection) return;

    // 必要なデータが揃っていない場合はスキップ
    if (!savedConfigs || savedConfigs.length === 0) return;
    if (!projectData || !projectData.selectedSimulationConfigIds) return;

    // 基本グラフデータが生成されるまで待機
    // （保存済み設定グラフ生成に必要なデータ）
    if (!quantitiesChartDataModified || !mergedChartDataModified) return;

    // DBから取得した選択状態を復元
    const savedSelectedIds = projectData.selectedSimulationConfigIds.split(",").filter(Boolean);

    // 存在する設定のみフィルタ
    const validSelectedIds = savedSelectedIds.filter(id =>
      savedConfigs.some(config => config.id === id)
    );

    // 有効な選択IDがある場合、選択状態を復元（グラフは自動的に生成される）
    if (validSelectedIds.length > 0) {
      setSelectedConfigIds(validSelectedIds);
    }

    // 復元完了フラグを立てる
    setHasRestoredSelection(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedConfigs, projectData?.selectedSimulationConfigIds, hasRestoredSelection, quantitiesChartDataModified, mergedChartDataModified]);

  /**
   * 必要情報をチェックし、ない場合は、トースト表示する。
   * @param projectData プロジェクト情報
   * @param capexPartNo パーツNo情報（数量・単価と材料費）
   * @param equipmentAmounts 設備情報
   * @param productionLine 製造ライン情報
   * @param pastProjectData 過去プロジェクト
   * @param additionalInfoCheckResult 更新前後サマリーチェック結果
   */
  const requiredDataNotice = (projectData: ProjectWithRdsData, capexPartNo: PartNo[], equipmentAmounts: EquipmentType[], productionLine: ProductionLineType, pastProjectData: ProjectWithRdsData | null | undefined, additionalInfoCheckResult: boolean) => {
    let displayName = null;
    // 簡易モード時は販売数量・販売単価・費用・損益試算データが未入力でも進めるため、関連チェックをスキップ
    const isSimple = isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType);

    if (!projectData.projectStartDate || !projectData.projectEndDate || !projectData.companyPlantId) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.basicInfo');
    } else if (projectData.pastProjectId && (!pastProjectData?.originalProfitAndLossByMonth || pastProjectData?.originalProfitAndLossByMonth.trim() === '')) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.pastProjectProfitAndLoss');
    } else if (projectData.pastProjectId && !(pastProjectData?.mergedChartDataOriginal || null)) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.pastProjectSimulationNewProduct');
    } else if (!isSimple && (capexPartNo.some((p: PartNo) => !p.quantityAndPrice || !p.quantityAndPrice) || !projectData.currencyId)) {
      displayName = labelQuantityAndPrice;
    } else if (!isSimple && (!projectData.customerNationality || !projectData.pricingAgreement ||
      !(projectData.pricingAgreement ? (JSON.parse(projectData.pricingAgreement) as PricingAgreementFormType)?.competitor : undefined))) {
      // 顧客取り決め事項が未入力、または競合状態（competitor）が未入力の場合
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.pricingAgreement');
    } else if (!isSimple && (
      capexPartNo.some((p: PartNo) => !p.materialCost || !p.materialCostWithInhouseProfit) ||
      !projectData.productionLineId || !productionLine || !productionLine.workingDays || !productionLine.nonWorkingHours)) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.manufacturingProcess');
    } else if (!isSimple && (!equipmentAmounts || equipmentAmounts.length === 0 || (!productionLine.cycleTime && productionLine.cycleTime !== 0) || (!productionLine.yieldRate && Number(productionLine.yieldRate) !== 0))) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.equipment');
    } else if (!isSimple && !projectData.originalProfitAndLossByMonth) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.profitAndLoss');
    } else if (projectData.purpose === PurposeType.UpdateAndOther.code && !additionalInfoCheckResult) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.equipmentUpdateSummary');
    } else if (projectData.purpose === PurposeType.Rationalization.code && !additionalInfoCheckResult) {
      displayName = t('features.InvestmentScreening.SimulationProductivityImprovement.validation.equipmentRationalizationSummary');
    }

    if (displayName) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.validation.registerFrom', { displayName }),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return false;
    }

    return true;
  }


  /**
  * エラー情報をユーザー通知する
  * @param dataName データ論理名
  * @param apiName API名称
  * @param responseErrors レスポンスエラー情報
  */
  const showApiError = (dataName: string, apiName: string, responseErrors: any) => {
    toast({
      title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchError'),
      description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataFetchFailedFor', { dataName }),
      status: 'error',
      duration: 5000,
      isClosable: true,
    });

    console.error(`Failed to call API ${apiName}.errors = ${JSON.stringify(responseErrors)}`);
  }

  // 生産キャパグラフ（既存ライン含む）の元データ（増産のみ）。保存済み設定は選択中のもののみ
  const existingLineCapacitySource = useMemo<TExistingLineCapacitySource | null>(() => {
    if (
      projectData?.purpose !== PurposeType.IncreasedProduction.code ||
      !originalProfitAndLossByMonth ||
      !elqVersionOriginal ||
      !elqVersionModified
    ) {
      return null;
    }
    return {
      labels: [...originalProfitAndLossByMonth.labels],
      original: elqVersionOriginal,
      modified: elqVersionModified,
      savedConfigs: elqVersionsForSavedConfig.filter(item => selectedConfigIds.includes(item.configId)),
    };
  }, [projectData?.purpose, originalProfitAndLossByMonth, elqVersionOriginal, elqVersionModified, elqVersionsForSavedConfig, selectedConfigIds]);

  // 生産キャパグラフ（既存ライン含む）：要否・既存ライン生産数量・入力操作・保存・グラフデータ
  const elq = useExistingLineCapacity({
    projectId,
    reviewDate,
    labels: originalProfitAndLossByMonth?.labels ?? [],
    title: TITLE,
    googleAPI,
    source: existingLineCapacitySource,
    capexPartNo,
  });

  /**
   * 【数量 (当初計画 / ダウンサイド)】チャートデータ作成
   */
  useEffect(() => {
    if (
      originalProfitAndLossByMonth &&                // オリジナル月別(当初損益月別)（「対象プロジェクトの利益試算」で登録）
      originalProfitAndLossByMonth.quantityByPartNo  // オリジナル月別(当初損益月別) パーツNo別の月別/数量
    ) {

      const quantitiesChartDataset = calcQuantitiesChartDataSet(originalProfitAndLossByMonth, downsideIndexGraph, capexPartNo);

      // Chart.js 用に 2種のデータを別々に作る
      // 数量（当初計画）[ラベル/データセット]設定
      setQuantitiesChartDataOriginal(quantitiesChartDataset.quantitiesChartDataOriginal);
      // 数量（ダウンサイド）[ラベル/データセット]設定
      setQuantitiesChartDataModified(quantitiesChartDataset.quantitiesChartDataModified);
    }
  }, [originalProfitAndLossByMonth, selectedCustomerProduct, downsideIndexGraph, originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData]);

  /**
   * 月別材料費単価を算出
   */
  useEffect(() => {
    if (!originalProfitAndLossByMonth?.labels || capexPartNo.length === 0) {
      return;
    }
    // ラベル（YYYY/MM形式）から年月リストを生成
    const yearMonthList = originalProfitAndLossByMonth.labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return { year, month };
    });
    // 月別材料単価を取得（材料費は既に記帳通貨で保存されているため為替変換なし）
    const materialCostByPartNo = getMaterialCostByPartNoByMonth(
      capexPartNo,
      undefined,  // sourceCurrencyName (通貨変換なし)
      undefined,  // targetCurrencyName (通貨変換なし)
      undefined,  // currencyData (通貨変換なし)
      yearMonthList
    );
    // MapオブジェクトにconvertしてStateに設定
    const partNoToMonthlyMaterialCostMap = new Map<string, Record<string, Decimal>>();
    materialCostByPartNo.forEach((item) => {
      if (item.partNo) {
        partNoToMonthlyMaterialCostMap.set(item.partNo, item.materialCostByMonth);
      }
    });
    setPartNoToMonthlyMaterialCost(partNoToMonthlyMaterialCostMap);
  }, [originalProfitAndLossByMonth?.labels, capexPartNo]);

  /**
   * 【JPY版】月別材料単価を算出
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）用
   * 選択通貨が保存時の表示通貨(JPY)と一致する場合のExcel出力に使用（二重変換回避）
   */
  useEffect(() => {
    if (!displayOriginalProfitAndLossByMonth?.labels || !savedDisplayCurrencyName || !localCurrencyName || capexPartNo.length === 0 || !currencyData.length) {
      setDisplayVersionPartNoToMonthlyMaterialCost(null);
      return;
    }
    const yearMonthList = displayOriginalProfitAndLossByMonth.labels.map((label) => {
      const [year, month] = label.split("/").map(Number);
      return { year, month };
    });
    // 月別材料単価を取得（ローカル通貨→JPYに変換）
    const materialCostByPartNo = getMaterialCostByPartNoByMonth(
      capexPartNo,
      localCurrencyName,
      savedDisplayCurrencyName,
      currencyData,
      yearMonthList
    );
    const displayVersionMaterialCostMap = new Map<string, Record<string, Decimal>>();
    materialCostByPartNo.forEach((item) => {
      if (item.partNo) {
        displayVersionMaterialCostMap.set(item.partNo, item.materialCostByMonth);
      }
    });
    setDisplayVersionPartNoToMonthlyMaterialCost(displayVersionMaterialCostMap);
  }, [displayOriginalProfitAndLossByMonth?.labels, savedDisplayCurrencyName, localCurrencyName, capexPartNo, currencyData]);

  /**
   * 【価格と材料単価 (当初計画 / ダウンサイド)】チャートデータ作成
   */
  useEffect(() => {
    if (
      originalProfitAndLossByMonth &&         // オリジナル月別(当初損益月別）（「対象プロジェクトの利益試算」で登録）
      originalProfitAndLossByMonth.labels &&  // オリジナル月別(当初損益月別）年月ラベル配列
      capexPartNo.length > 0 &&               // パーツNo情報（「数量・単価」と「材料費」）
      capexPartNo.every((p: PartNo) => p.quantityAndPrice) &&
      (partNoToMonthlyMaterialCost?.size || 0) > 0
    ) {

      // チャートデータ作成
      // 振り返りモード: 対象PJの損益試算画面と同じく月別レートで販売単価をローカル通貨に変換
      const mergedChartDataSet = calcMergedChartDataSet(
        originalProfitAndLossByMonth, capexPartNo, partNoToMonthlyMaterialCost, downsideIndexGraph, localCurrencyName, currencyData,
        reviewDate ? convertWithRate : undefined,
      );

      // 価格と材料単価（当初計画）データ設定
      setMergedChartDataOriginal(mergedChartDataSet.mergedOriginal);

      // 価格と材料単価（ダウンサイド）データ設定
      setMergedChartDataModified(mergedChartDataSet.mergedModified);
    }
  }, [originalProfitAndLossByMonth, capexPartNo, selectedCustomerProduct, partNoToMonthlyMaterialCost, downsideIndexGraph, originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, reviewDate, convertWithRate]);

  /**
   * 【JPY版】販売単価と材料単価チャートデータ作成
   * displayOriginalProfitAndLossByMonth（対象PJ画面で保存したJPY版）から直接計算
   * 選択通貨が保存時の表示通貨(JPY)と一致する場合のExcel出力に使用（二重変換回避）
   */
  useEffect(() => {
    if (
      displayOriginalProfitAndLossByMonth &&
      displayOriginalProfitAndLossByMonth.labels &&
      savedDisplayCurrencyName &&
      capexPartNo.length > 0 &&
      capexPartNo.every((p: PartNo) => p.quantityAndPrice) &&
      (displayVersionPartNoToMonthlyMaterialCost?.size || 0) > 0
    ) {
      const displayVersionMergedChartDataSet = calcMergedChartDataSet(
        displayOriginalProfitAndLossByMonth, capexPartNo, displayVersionPartNoToMonthlyMaterialCost, downsideIndexGraph, savedDisplayCurrencyName, currencyData
      );

      setDisplayVersionMergedChartDataOriginal(displayVersionMergedChartDataSet.mergedOriginal);
    }
  }, [displayOriginalProfitAndLossByMonth, savedDisplayCurrencyName, capexPartNo, selectedCustomerProduct, displayVersionPartNoToMonthlyMaterialCost, downsideIndexGraph]);

  /**
   * 【数量グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (quantitiesChartDataModified && selectedConfigIds.length > 0 && originalProfitAndLossByMonth) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        if (config) {
          const configApplyDownside = config.applyDownside !== false;
          let chartData;

          if (!configApplyDownside) {
            // ストレスOFF: null で再計算（当初計画と同じ値になる）
            const quantitiesChartDataset = calcQuantitiesChartDataSet(originalProfitAndLossByMonth, null, capexPartNo);
            chartData = quantitiesChartDataset.quantitiesChartDataModified;
          } else {
            // ストレスON: プリ計算済みデータ使用
            chartData = quantitiesChartDataModified;
          }

          setQuantitiesChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: chartData }];
          });
        }
      });
    }
  }, [quantitiesChartDataModified, selectedConfigIds, neutralDownsideIndex, originalProfitAndLossByMonth, savedConfigs, downsideIndexGraph]);

  /**
   * 【価格・材料単価グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (mergedChartDataModified && selectedConfigIds.length > 0 && originalProfitAndLossByMonth) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);
        if (config) {
          const configApplyDownside = config.applyDownside !== false;
          let chartData;

          if (!configApplyDownside) {
            // ストレスOFF: neutralDownsideIndex で再計算し Modified パスのデータを使用
            const mergedChartDataSet = calcMergedChartDataSet(
              originalProfitAndLossByMonth, capexPartNo, partNoToMonthlyMaterialCost, neutralDownsideIndex, localCurrencyName, currencyData,
              reviewDate ? convertWithRate : undefined,
            );
            chartData = mergedChartDataSet.mergedModified;
          } else {
            // ストレスON: プリ計算済みデータ使用
            chartData = mergedChartDataModified;
          }

          setMergedChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, { configId, data: chartData }];
          });
        }
      });
    }
  }, [mergedChartDataModified, selectedConfigIds, neutralDownsideIndex, originalProfitAndLossByMonth, savedConfigs, downsideIndexGraph, capexPartNo, partNoToMonthlyMaterialCost, localCurrencyName, currencyData, reviewDate, convertWithRate]);

  /**
   * 【売上（当初計画）】チャートデータ作成（売上/営業利益/営業利益率）
   */
  useEffect(() => {
    if (!originalImprovedWorkingDaysData || !originalImprovedNonWorkingHoursData) {
      return;
    }

    // originalImprovedWorkingDaysDataとoriginalImprovedNonWorkingHoursDataが空でないことを確認
    if (originalImprovedWorkingDaysData.length === 0 || originalImprovedNonWorkingHoursData.length === 0) {
      return;
    }

    // 各要素にnonWorkingHoursByMonthが存在することを確認
    const hasValidNonWorkingHoursData = originalImprovedNonWorkingHoursData.every(
      item => item.nonWorkingHoursByMonth && item.nonWorkingHoursByMonth.length > 0
    );

    if (!hasValidNonWorkingHoursData) {
      console.warn('originalImprovedNonWorkingHoursData has invalid structure');
      return;
    }

    if (originalProfitAndLossByMonth && originalEquipmentAmounts.length > 0) {

      if (!mergedChartDataOriginal || !quantitiesChartDataOriginal) {
        // console.log(`mergedChartDataOriginal or quantitiesChartDataOriginal not ready`);
        return;
      }

      // 【売上（当初計画）】チャートデータ作成
      // 振り返りモード: selectedCurrency.name を targetCurrencyName に渡し月別レートで変換
      // 通常モード: localCurrencyName を渡し従来パスを通す
      // 振り返り×JPY かつ販売通貨==表示通貨(JPY) かつ displayOriginalProfitAndLossByMonth あり:
      //   overrideSales で申請時JPY値を渡し rawSales（工場通貨経由）→ 月別レート変換による二重変換を回避
      //   販売通貨≠表示通貨 のときは rawSales × 月別レート 経路で正しく月別変動するため override しない
      const originalSalesChartDataSet = calcOriginalSalesChartDataSet(
        originalProfitAndLossByMonth,
        quantitiesChartDataOriginal,
        mergedChartDataOriginal,
        capexPartNo,
        projectData,
        originalEquipmentAmounts,
        originalImprovedWorkingDaysData,
        originalImprovedNonWorkingHoursData,
        downsideIndexGraph,
        reviewDate ? selectedCurrency.name : localCurrencyName,
        currencyData,
        decimalCurrency,
        processCodeData,
        bomData,
        undefined,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? localCurrencyName : undefined,
        (reviewDate
          && selectedCurrency.name === CurrencyNameJPY
          && projectData?.currencyId === selectedCurrency.id
          && displayOriginalProfitAndLossByMonth?.totalSales?.length)
          ? displayOriginalProfitAndLossByMonth.totalSales.map(v => Number(v || 0))
          : undefined,
      );

      // 売上（当初計画）データ設定
      setSalesChartData(originalSalesChartDataSet.charData);
    }
  }, [
    originalProfitAndLossByMonth,
    quantitiesChartDataOriginal,
    mergedChartDataOriginal,
    capexPartNo,
    originalEquipmentAmounts,
    productionLine,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    processCodeData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  // #region 「売上(当初計画)」JPY版チャートデータ（Excel出力のJPYパス用）

  /**
   * JPY版売上チャートデータ（displayOriginalProfitAndLossByMonthから作成）
   * 対象PJ画面が保存したJPY版totalSalesを使用し、Excel出力時のJPY表示で変換粒度差を解消する
   */
  const displayVersionSalesChartData = useMemo(() => {
    if (!displayOriginalProfitAndLossByMonth || !salesChartData) return null;
    const jpyTotalSales = displayOriginalProfitAndLossByMonth.totalSales
      .map(v => Number(v || 0));
    // salesChartDataの構造を流用し、salesデータだけJPY版に差し替え
    const cloned = JSON.parse(JSON.stringify(salesChartData));
    const salesDs = cloned.datasets?.find((d: any) => d.id === "sales");
    if (salesDs) salesDs.data = jpyTotalSales;
    return cloned;
  }, [displayOriginalProfitAndLossByMonth, salesChartData]);

  // #endregion

  // #region 「売上(ダウンサイド)」チャートデータ作成

  /**
   * 「売上(ダウンサイド)」チャートデータ作成
   */
  useEffect(() => {

    if (quantitiesChartDataModified && mergedChartDataModified && capexPartNo && originalProfitAndLossByMonth) {
      // 振り返りモード: selectedCurrency.name を targetCurrencyName に渡し月別レートで変換
      // 通常モード: localCurrencyName を渡し従来パスを通す
      const downsideSalesChartDataSet = calcDownsideSalesChartDataSet(
        quantitiesChartDataModified, mergedChartDataModified, capexPartNo, projectData, originalEquipmentAmounts,
        originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, null, null, downsideIndexGraph,
        salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData,
        originalProfitAndLossByMonth.labels, decimalCurrency,
        processCodeData, bomData,
        undefined,
        true,
        undefined,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? localCurrencyName : undefined,
      );

      // パーツNo毎の月次売上（ダウンサイド）を保持
      setMonthlySalesModifiedByPartNo(downsideSalesChartDataSet.monthlySalesByPartNo);

      // ダウンサイドグラフを更新
      setSalesChartDataModified(downsideSalesChartDataSet.chartData);
    }
  }, [
    quantitiesChartDataModified,
    mergedChartDataModified,
    capexPartNo,
    projectData,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    originalEquipmentAmounts,
    originalProfitAndLossByMonth,
    downsideIndexGraph,
    processCodeData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  // #endregion

  /**
   * 【簡易モード専用】増分キャッシュフローチャートデータ生成
   * 対象PJ損益試算画面で保存した月別営業利益 + 設備投資データから直接組み立て
   */
  useEffect(() => {
    if (!isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType)) {
      return;
    }
    if (
      !originalProfitAndLossByMonth?.labels?.length ||
      !projectData ||
      !originalEquipmentAmounts ||
      !localCurrencyName ||
      !currencyData
    ) {
      return;
    }

    const labels: string[] = originalProfitAndLossByMonth.labels;

    // 月別営業利益（対象PJ損益試算で保存済み）
    const profitByMonth: Decimal[] = ((originalProfitAndLossByMonth.profit ?? []) as string[])
      .map(v => new Decimal(v || 0));

    if (profitByMonth.length === 0) return;

    // 年数（プロジェクト日付から算出）
    const totalFiscalYears = getFiscalYearsByProjectDates(projectData.projectStartDate, projectData.projectEndDate);
    const startDate = projectData.projectStartDate || (labels[0].replace("/", "-") + "-01");

    // 設備投資額をローカル通貨へ変換
    const convertedEquipmentAmounts = convertEquipmentData(originalEquipmentAmounts, localCurrencyName, currencyData) as EquipmentExtType[];
    const selectedEquipments = convertedEquipmentAmounts.filter(e => e.selected !== false);

    // 投資対象設備の減価償却費（月別）
    // 対象PJ損益試算画面と一致させるため、前後サマリーの targetEquipmentDepreciation 月別データを使用
    // 目的に応じてサマリーデータを選択
    const depreciationSummaryList1 = projectData.purpose === PurposeType.Rationalization.code
      ? rationalizationSummaryDataList
      : updateSummaryDataList;
    const equipmentDepreciationByMonth: Decimal[] = labels.map(label => {
      const monthKey = label.replace("/", "-");
      let total = new Decimal(0);
      depreciationSummaryList1.forEach(summary => {
        if (!summary.costItems) return;
        const sourceCurrency = currencyData.find(c => c.currencyId === summary.costCurrencyId);
        const sourceCurrencyName = sourceCurrency?.currencyName || localCurrencyName;
        summary.costItems.forEach(item => {
          if (item.itemType !== "targetEquipmentDepreciation") return;
          const before = new Decimal((item.beforeMonthlyData as any)?.[monthKey] || 0);
          const after = new Decimal((item.afterMonthlyData as any)?.[monthKey] || 0);
          const diff = after.minus(before);
          total = total.plus(
            sourceCurrencyName === localCurrencyName
              ? diff
              : convertCurrency(diff, sourceCurrencyName, localCurrencyName, currencyData)
          );
        });
      });
      return decimalCurrency ? total : total.toDecimalPlaces(0, Decimal.ROUND_HALF_UP);
    });

    // 回収原資 = 営業利益 + 投資対象設備償却費
    // ※工場建物(=0固定)とその他設備は加算後に差し引かれるため相殺、実質的に investEquip のみが寄与
    const recoverySourcesByMonth: Decimal[] = profitByMonth.map((v, i) =>
      v.plus(equipmentDepreciationByMonth[i])
    );

    // 設備投資額（月別・設備ごと）
    const capexAmountByMonthArray: { equipmentId: string; year: number; month: number; capexAmount: Decimal }[][] = [];
    const equipmentAmountsByMonth = convertedEquipmentAmounts
      .filter(e => e.selected !== false)
      .map(equip => {
        const capexAmountByMonth = calcCapexAmountByMonth(equip, totalFiscalYears, startDate, false);
        capexAmountByMonthArray.push(capexAmountByMonth);
        return { equipment: equip, capexAmountByMonth };
      });

    const selectedEquipmentAmountsByMonth = capexAmountByMonthArray
      .map(monthlyData =>
        monthlyData.filter(capex => selectedEquipments.some(eq => eq.equipmentId === capex.equipmentId))
      )
      .filter(monthlyData => monthlyData.length > 0);

    // 設備投資額（月別集約）
    let capexEquipmentByMonth: Decimal[] = calcAggregateCapexByMonth(selectedEquipmentAmountsByMonth).map(e => e.capexAmount);

    // 設備がない場合、空配列になるため0で補完する
    if (capexEquipmentByMonth.length === 0) {
      capexEquipmentByMonth = Array.from({ length: recoverySourcesByMonth.length }, () => new Decimal(0));
    }

    // 設備投資額は事業年度全体の月数分あるため、EOLで切り詰めたlabelsの長さに合わせる
    if (capexEquipmentByMonth.length > labels.length) {
      capexEquipmentByMonth = capexEquipmentByMonth.slice(0, labels.length);
    }

    // 振り返り時: グラフ表示用に月別レートで表示通貨へ変換
    // Excel用 incrementalCFData はローカル通貨のまま（createIncrementalCashFlowSheet 内で変換）
    const toChartCurrency = (v: Decimal, label: string | undefined): Decimal =>
      reviewDate
        ? new Decimal(convertWithRate(v, localCurrencyName, selectedCurrency.name, label?.replace("/", "-")) || 0)
        : v;
    const profitForChart = profitByMonth.map((v, i) => toChartCurrency(v, labels[i]));
    const equipDepForChart = equipmentDepreciationByMonth.map((v, i) => toChartCurrency(v, labels[i]));
    const recoverySourcesForChart = profitForChart.map((v, i) => v.plus(equipDepForChart[i]));
    const capexForChart = capexEquipmentByMonth.map((v, i) => toChartCurrency(v, labels[i]));

    // 未回収額（累積）計算
    const monthlyRecovery: Decimal[] = calcRecoverySimulation(recoverySourcesByMonth, capexEquipmentByMonth, decimalCurrency, false);
    const monthlyRecoveryForChart: Decimal[] = calcRecoverySimulation(recoverySourcesForChart, capexForChart, decimalCurrency, false);

    // 回収月の特定
    const recoveryMonths: number[] = monthlyRecovery
      .map((val, idx) => ((val?.toNumber() >= 0) && ((monthlyRecovery[idx - 1]?.toNumber() ?? -1) < 0) ? idx : null))
      .filter((v): v is number => v !== null)
      .map(idx => idx + 1);
    const recoveryMonthsForChart: number[] = monthlyRecoveryForChart
      .map((val, idx) => ((val?.toNumber() >= 0) && ((monthlyRecoveryForChart[idx - 1]?.toNumber() ?? -1) < 0) ? idx : null))
      .filter((v): v is number => v !== null)
      .map(idx => idx + 1);

    // 投資回収データセット（当初計画 = 簡易モードはダウンサイドなし）
    const recoveryDataset = {
      type: "line",
      label: i18n.t('common.chart.recoveryChartOriginal'),
      data: monthlyRecoveryForChart,
      borderColor: "green",
      backgroundColor: "rgba(0,255,0,0.1)",
      fill: false,
      tension: 0.4,
    };

    // 設備投資額バーデータセット（振り返り時は月別レートで表示通貨へ変換）
    const capexDatasets = equipmentAmountsByMonth.map((eqData, eqIdx) => {
      const data = new Array(labels.length).fill(0);
      eqData.capexAmountByMonth.forEach((amountData, i) => {
        if (i < data.length) {
          const raw = amountData.capexAmount ? Number(amountData.capexAmount) : 0;
          data[i] = reviewDate && raw !== 0
            ? Number(convertWithRate(new Decimal(raw), localCurrencyName, selectedCurrency.name,
              `${amountData.year}-${String(amountData.month).padStart(2, '0')}`) || 0)
            : raw;
        }
      });
      return {
        type: "bar",
        label: eqData.equipment.equipmentName,
        data,
        backgroundColor: [
          "rgba(255,99,132,0.5)",
          "rgba(54,162,235,0.5)",
          "rgba(255,206,86,0.5)",
          "rgba(75,192,192,0.5)",
          "rgba(153,102,255,0.5)",
          "rgba(255,159,64,0.5)",
        ][eqIdx % 6],
        stack: "capex",
      };
    });

    const chartDataObj = { labels, datasets: [recoveryDataset, ...capexDatasets] };

    // 当初計画・ダウンサイド両方に同じ値をセット（チャート表示条件を満たすため）
    setMonthOfRecoveryOriginal(recoveryMonthsForChart);
    setMonthOfRecoveryModified(recoveryMonthsForChart);
    setCombinedChartData(chartDataObj);
    setCombinedChartDataModified({
      ...chartDataObj,
      datasets: [{ ...recoveryDataset, label: i18n.t('common.chart.recoveryChartModified') }, ...capexDatasets],
    });

    // Excel出力用データ保持（ローカル通貨のまま - createIncrementalCashFlowSheet 内で変換）
    const zeroArray: Decimal[] = Array.from({ length: profitByMonth.length }, () => new Decimal(0));
    const incrementalCFData = {
      labels,
      profitByMonth,
      equipmentDepreciationByMonth,
      factoryAndOtherCostByMonth: zeroArray,
      recoverySourcesByMonth,
      capexByMonth: capexEquipmentByMonth,
      recoveryByMonth: monthlyRecovery,
      recoveryMonths,
    };
    // 簡易モードはダウンサイド計算なし（当初計画と同値）
    setIncrementalCashFlowOriginal(incrementalCFData);
    setIncrementalCashFlowDownside(incrementalCFData);
  }, [
    projectData,
    originalProfitAndLossByMonth,
    originalEquipmentAmounts,
    rationalizationSummaryDataList,
    updateSummaryDataList,
    localCurrencyName,
    currencyData,
    decimalCurrency,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【投資分回収グラフ（簡易モード）】保存済み設定用グラフ生成
   * 対象PJ損益試算画面で保存した月別営業利益 + 設備投資データから直接組み立て
   * 設備・人員構成変更で設備投資額が変わるため、各設定の equipmentAmounts を使って個別計算する
   */
  useEffect(() => {
    if (!isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType)) {
      return;
    }
    if (
      !originalProfitAndLossByMonth?.labels?.length ||
      !projectData ||
      !originalEquipmentAmounts ||
      !localCurrencyName ||
      !currencyData ||
      selectedConfigIds.length === 0
    ) {
      return;
    }

    const labels: string[] = originalProfitAndLossByMonth.labels;

    // 月別営業利益（全設定共通 - 対象PJ損益試算で保存済み）
    const profitByMonth: Decimal[] = ((originalProfitAndLossByMonth.profit ?? []) as string[])
      .map(v => new Decimal(v || 0));

    if (profitByMonth.length === 0) return;

    // 年数（プロジェクト日付から算出）
    const totalFiscalYears = getFiscalYearsByProjectDates(projectData.projectStartDate, projectData.projectEndDate);
    const startDate = projectData.projectStartDate || (labels[0].replace("/", "-") + "-01");

    // 投資対象設備の減価償却費（月別・全設定共通）
    // 目的に応じてサマリーデータを選択
    const depreciationSummaryList2 = projectData.purpose === PurposeType.Rationalization.code
      ? rationalizationSummaryDataList
      : updateSummaryDataList;
    const equipmentDepreciationByMonth: Decimal[] = labels.map(label => {
      const monthKey = label.replace("/", "-");
      let total = new Decimal(0);
      depreciationSummaryList2.forEach(summary => {
        if (!summary.costItems) return;
        const sourceCurrency = currencyData.find(c => c.currencyId === summary.costCurrencyId);
        const sourceCurrencyName = sourceCurrency?.currencyName || localCurrencyName;
        summary.costItems.forEach(item => {
          if (item.itemType !== "targetEquipmentDepreciation") return;
          const before = new Decimal((item.beforeMonthlyData as any)?.[monthKey] || 0);
          const after = new Decimal((item.afterMonthlyData as any)?.[monthKey] || 0);
          const diff = after.minus(before);
          total = total.plus(
            sourceCurrencyName === localCurrencyName
              ? diff
              : convertCurrency(diff, sourceCurrencyName, localCurrencyName, currencyData)
          );
        });
      });
      return decimalCurrency ? total : total.toDecimalPlaces(0, Decimal.ROUND_HALF_UP);
    });

    // 回収原資 = 営業利益 + 投資対象設備償却費（全設定共通）
    const recoverySourcesByMonth: Decimal[] = profitByMonth.map((v, i) =>
      v.plus(equipmentDepreciationByMonth[i])
    );

    // 営業利益合計（表示用・全設定共通）
    const totalProfit = profitByMonth.reduce((sum, v) => sum.plus(v), new Decimal(0));

    // 振り返り時: グラフ表示用に月別レートで表示通貨へ変換（全設定共通部分）
    // Excel用 setIncrementalCashFlowForSavedConfig はローカル通貨のまま（createIncrementalCashFlowSheet 内で変換）
    const toChartCurrency2 = (v: Decimal, label: string | undefined): Decimal =>
      reviewDate
        ? new Decimal(convertWithRate(v, localCurrencyName, selectedCurrency.name, label?.replace("/", "-")) || 0)
        : v;
    const recoverySourcesForChart2 = recoverySourcesByMonth.map((v, i) => toChartCurrency2(v, labels[i]));

    selectedConfigIds.forEach(configId => {
      const config = savedConfigs.find(c => c.id === configId);
      if (!config) return;

      // 保存済み設定の設備情報をマージ（非簡易モードと同じ restoreEquipmentAmounts を使用）
      const configEquipmentAmounts = restoreEquipmentAmounts(config.equipmentAmounts ?? [], originalEquipmentAmounts);

      const selectedConfigEquipments = configEquipmentAmounts.filter(e => e.selected !== false);

      // 設備投資額（月別・設備ごと）
      const configCapexAmountByMonthArray: { equipmentId: string; year: number; month: number; capexAmount: Decimal }[][] = [];
      const configEquipmentAmountsByMonth = selectedConfigEquipments.map(equip => {
        const capexAmountByMonth = calcCapexAmountByMonth(equip, totalFiscalYears, startDate, false);
        configCapexAmountByMonthArray.push(capexAmountByMonth);
        return { equipment: equip, capexAmountByMonth };
      });

      // 設備投資額（月別集約）
      let configCapexByMonth: Decimal[] = calcAggregateCapexByMonth(configCapexAmountByMonthArray).map(e => e.capexAmount);

      // 設備がない場合、空配列になるため0で補完する
      if (configCapexByMonth.length === 0) {
        configCapexByMonth = Array.from({ length: recoverySourcesByMonth.length }, () => new Decimal(0));
      }

      // 設備投資額は事業年度全体の月数分あるため、EOLで切り詰めたlabelsの長さに合わせる
      if (configCapexByMonth.length > labels.length) {
        configCapexByMonth = configCapexByMonth.slice(0, labels.length);
      }

      const configCapexForChart: Decimal[] = configCapexByMonth.map((v, i) => toChartCurrency2(v, labels[i]));

      // 未回収額（累積）計算
      const configMonthlyRecovery: Decimal[] = calcRecoverySimulation(recoverySourcesByMonth, configCapexByMonth, decimalCurrency, false);
      const configMonthlyRecoveryForChart: Decimal[] = calcRecoverySimulation(recoverySourcesForChart2, configCapexForChart, decimalCurrency, false);

      // 回収月の特定
      const configRecoveryMonths: number[] = configMonthlyRecovery
        .map((val, idx) => ((val?.toNumber() >= 0) && ((configMonthlyRecovery[idx - 1]?.toNumber() ?? -1) < 0) ? idx : null))
        .filter((v): v is number => v !== null)
        .map(idx => idx + 1);
      const configRecoveryMonthsForChart: number[] = configMonthlyRecoveryForChart
        .map((val, idx) => ((val?.toNumber() >= 0) && ((configMonthlyRecoveryForChart[idx - 1]?.toNumber() ?? -1) < 0) ? idx : null))
        .filter((v): v is number => v !== null)
        .map(idx => idx + 1);

      // 投資回収データセット（グラフ用・振り返り時は月別レート適用済み）
      const configRecoveryDataset = {
        type: "line",
        label: i18n.t('common.chart.recoveryChartOriginal'),
        data: configMonthlyRecoveryForChart,
        borderColor: "green",
        backgroundColor: "rgba(0,255,0,0.1)",
        fill: false,
        tension: 0.4,
      };

      // 設備投資額バーデータセット（振り返り時は月別レートで表示通貨へ変換）
      const configCapexDatasets = configEquipmentAmountsByMonth.map((eqData, eqIdx) => {
        const data = new Array(labels.length).fill(0);
        eqData.capexAmountByMonth.forEach((amountData, i) => {
          if (i < data.length) {
            const raw = amountData.capexAmount ? Number(amountData.capexAmount) : 0;
            data[i] = reviewDate && raw !== 0
              ? Number(convertWithRate(new Decimal(raw), localCurrencyName, selectedCurrency.name,
                `${amountData.year}-${String(amountData.month).padStart(2, '0')}`) || 0)
              : raw;
          }
        });
        return {
          type: "bar",
          label: eqData.equipment.equipmentName,
          data,
          backgroundColor: [
            "rgba(255,99,132,0.5)",
            "rgba(54,162,235,0.5)",
            "rgba(255,206,86,0.5)",
            "rgba(75,192,192,0.5)",
            "rgba(153,102,255,0.5)",
            "rgba(255,159,64,0.5)",
          ][eqIdx % 6],
          stack: "capex",
        };
      });

      const zeroArray: Decimal[] = Array.from({ length: profitByMonth.length }, () => new Decimal(0));

      setCombinedChartDataForSavedConfig(prev => {
        const filtered = prev.filter(item => item.configId !== configId);
        return [...filtered, {
          configId,
          data: {
            labels,
            datasets: [configRecoveryDataset, ...configCapexDatasets],
            totalProfit,
          },
        }];
      });

      setMonthOfRecoveryForSavedConfig(prev => {
        const filtered = prev.filter(item => item.configId !== configId);
        return [...filtered, { configId, data: configRecoveryMonthsForChart }];
      });

      setIncrementalCashFlowForSavedConfig(prev => {
        const filtered = prev.filter(item => item.configId !== configId);
        return [...filtered, {
          configId,
          data: {
            labels,
            profitByMonth,
            equipmentDepreciationByMonth,
            factoryAndOtherCostByMonth: zeroArray,
            recoverySourcesByMonth,
            capexByMonth: configCapexByMonth,
            recoveryByMonth: configMonthlyRecovery,
            recoveryMonths: configRecoveryMonths,
          },
        }];
      });
    });
  }, [
    projectData,
    originalProfitAndLossByMonth,
    originalEquipmentAmounts,
    rationalizationSummaryDataList,
    updateSummaryDataList,
    selectedConfigIds,
    savedConfigs,
    localCurrencyName,
    currencyData,
    decimalCurrency,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【増産投資分回収用（当初計画）】「売上 ⇒ 投資回収」チャートデータ作成
   */
  useEffect(() => {

    if (
      !quantitiesChartDataOriginal ||
      !mergedChartDataOriginal ||
      !capexPartNo ||
      !projectData ||
      !originalImprovedWorkingDaysData ||
      !originalImprovedNonWorkingHoursData ||
      !originalEquipmentAmounts ||
      !originalProfitAndLossByMonth ||
      !downsideIndexGraph ||
      !investmentStartYearMonth ||
      !salesCurrencyName ||
      !localCurrencyName ||
      !currencyData
    ) {
      // データが揃っていない場合、処理しない。
      return;
    }

    // 基本情報で登録したパーツのみ
    const basicInfoRegisteredPartNoDataOriginal: PartNo[] = JSON.parse(JSON.stringify(capexPartNo.filter(p => p.basicInfoRegistered === true)));

    // quantityAndPrice、moldSalesByPartNo、developmentSalesByPartNoをincreasedProductionStartYearMonthを起点として切り出す
    const basicInfoRegisteredPartNoData: PartNo[] = basicInfoRegisteredPartNoDataOriginal.map(partNo =>
      slicePartNoDataByStartYearMonth(partNo, projectData.projectStartDate || "", investmentStartYearMonth)
    );

    // 増産投資量産開始年月のインデックス
    const investmentStartYearMonthPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);

    // ラベル情報（増産投資量産開始年月～）
    const labels = originalProfitAndLossByMonth.labels.slice(investmentStartYearMonthPos);

    // 数量チャートデータ期間調整
    const tempQuantitiesChartData = JSON.parse(JSON.stringify(quantitiesChartDataOriginal));
    tempQuantitiesChartData.labels = tempQuantitiesChartData.labels.slice(investmentStartYearMonthPos);
    tempQuantitiesChartData.datasets = tempQuantitiesChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
    tempQuantitiesChartData.datasets.map((d: any) => {
      d.data = d.data.slice(investmentStartYearMonthPos);
    });

    // 価格と材料単価チャートデータ期間調整
    const tempMergedChartData = JSON.parse(JSON.stringify(mergedChartDataOriginal));
    tempMergedChartData.labels = tempMergedChartData.labels.slice(investmentStartYearMonthPos);
    tempMergedChartData.datasets = tempMergedChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
    tempMergedChartData.datasets.map((d: any) => {
      d.data = d.data.slice(investmentStartYearMonthPos);
    });

    // 基本情報で登録したパーツのみの売上チャートデータ作成（※画面表示しない）
    const salesChartDataSet2 = calcDownsideSalesChartDataSet(
      tempQuantitiesChartData, tempMergedChartData,
      basicInfoRegisteredPartNoData,
      {
        ...projectData, projectStartDate: projectData.pastProjectId
          ? projectData?.purpose === PurposeType.IncreasedProduction.code
            ? projectData.increasedProductionStartDate
            : projectData?.purpose === PurposeType.Rationalization.code
              ? projectData.rationalizationStartDate
              : projectData.updateAndOtherStartDate
          : projectData.projectStartDate
      },
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData,
      null, null, null,
      salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, labels, decimalCurrency,
      processCodeData, bomData, projectData.projectStartDate || undefined,
      undefined, undefined, reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    // 増産投資分回収用 - 売上 保持
    setSalesChartData2(salesChartDataSet2.chartData);

    // 【投資回収（増産投資分回収用（当初計画））】チャートデータ作成
    const originalCombinedChartDataSet = calcDownsideCombinedChartDataSet(
      tempQuantitiesChartData, tempMergedChartData,
      basicInfoRegisteredPartNoData,
      {
        ...projectData, projectStartDate: projectData.pastProjectId
          ? projectData?.purpose === PurposeType.IncreasedProduction.code
            ? projectData.increasedProductionStartDate
            : projectData?.purpose === PurposeType.Rationalization.code
              ? projectData.rationalizationStartDate
              : projectData.updateAndOtherStartDate
          : projectData.projectStartDate
      },
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, null,
      null, salesChartDataForSavedConfig, salesChartDataSet2.chartData,
      salesChartDataSet2.monthlySalesByPartNo,
      null, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, decimalCurrency,
      processCodeData, bomData, projectData.projectStartDate || undefined,
      undefined, undefined, reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    if (!originalCombinedChartDataSet) {
      return;
    }

    originalCombinedChartDataSet.recoveryDataset.label = originalCombinedChartDataSet.recoveryDataset.label.replace("Modified", "Original");

    // 回収額設定
    setMonthOfRecoveryOriginal(originalCombinedChartDataSet.recoveryMonths);
    // 投資回収（当初計画）データ設定
    setCombinedChartData({
      labels: originalCombinedChartDataSet.labels,
      datasets: [originalCombinedChartDataSet.recoveryDataset, ...originalCombinedChartDataSet.capexDatasets],
    });
    // 増分キャッシュフロー Excel出力用データ保持
    setIncrementalCashFlowOriginal({
      labels: originalCombinedChartDataSet.labels,
      ...originalCombinedChartDataSet.incrementalCashFlowData,
      recoveryMonths: originalCombinedChartDataSet.recoveryMonths,
    });
  }, [
    quantitiesChartDataOriginal,
    mergedChartDataOriginal,
    capexPartNo,
    projectData,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    originalEquipmentAmounts,
    originalProfitAndLossByMonth,
    downsideIndexGraph,
    investmentStartYearMonth,
    salesCurrencyName,
    localCurrencyName,
    currencyData,
    processCodeData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【増産投資分回収用（ダウンサイド）】「売上 ⇒ 投資回収」チャートデータ作成
   */
  useEffect(() => {

    if (
      !quantitiesChartDataModified ||
      !mergedChartDataModified ||
      !capexPartNo ||
      !projectData ||
      !originalImprovedWorkingDaysData ||
      !originalImprovedNonWorkingHoursData ||
      !originalEquipmentAmounts ||
      !originalProfitAndLossByMonth ||
      !downsideIndexGraph ||
      !investmentStartYearMonth ||
      !salesCurrencyName ||
      !localCurrencyName ||
      !currencyData
    ) {
      // データが揃っていない場合、処理しない。
      return;
    }

    // 基本情報で登録したパーツのみ
    const basicInfoRegisteredPartNoDataOriginal: PartNo[] = JSON.parse(JSON.stringify(capexPartNo.filter(p => p.basicInfoRegistered === true)));

    // quantityAndPrice、moldSalesByPartNo、developmentSalesByPartNoをincreasedProductionStartYearMonthを起点として切り出す
    const basicInfoRegisteredPartNoData: PartNo[] = basicInfoRegisteredPartNoDataOriginal.map(partNo =>
      slicePartNoDataByStartYearMonth(partNo, projectData.projectStartDate || "", investmentStartYearMonth)
    );

    // 増産投資量産開始年月のインデックス
    const investmentStartYearMonthPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);

    // ラベル情報（増産投資量産開始年月～）
    const labels = originalProfitAndLossByMonth.labels.slice(investmentStartYearMonthPos);

    // 数量チャートデータ期間調整
    const tempQuantitiesChartData = JSON.parse(JSON.stringify(quantitiesChartDataModified));
    tempQuantitiesChartData.labels = tempQuantitiesChartData.labels.slice(investmentStartYearMonthPos);
    tempQuantitiesChartData.datasets = tempQuantitiesChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
    tempQuantitiesChartData.datasets.map((d: any) => {
      d.data = d.data.slice(investmentStartYearMonthPos);
    });

    // 価格と材料単価チャートデータ期間調整
    const tempMergedChartData = JSON.parse(JSON.stringify(mergedChartDataModified));
    tempMergedChartData.labels = tempMergedChartData.labels.slice(investmentStartYearMonthPos);
    tempMergedChartData.datasets = tempMergedChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
    tempMergedChartData.datasets.map((d: any) => {
      d.data = d.data.slice(investmentStartYearMonthPos);
    });

    // 基本情報で登録したパーツのみの売上チャートデータ作成（※画面表示しない）
    const salesChartDataSetModified2 = calcDownsideSalesChartDataSet(
      tempQuantitiesChartData, tempMergedChartData,
      basicInfoRegisteredPartNoData,
      {
        ...projectData, projectStartDate: projectData.pastProjectId
          ? projectData?.purpose === PurposeType.IncreasedProduction.code
            ? projectData.increasedProductionStartDate
            : projectData?.purpose === PurposeType.Rationalization.code
              ? projectData.rationalizationStartDate
              : projectData.updateAndOtherStartDate
          : projectData.projectStartDate
      },
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData,
      null, null, downsideIndexGraph,
      salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, labels, decimalCurrency,
      processCodeData, bomData, projectData.projectStartDate || undefined,
      undefined, undefined, reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    // 増産投資分回収用 - 売上 保持
    setSalesChartDataModified2(salesChartDataSetModified2.chartData);

    // 【投資回収（増産投資分回収用（ダウンサイド））】チャートデータ作成
    const combinedChartDataSetDownside = calcDownsideCombinedChartDataSet(
      tempQuantitiesChartData, tempMergedChartData,
      basicInfoRegisteredPartNoData,
      {
        ...projectData, projectStartDate: projectData.pastProjectId
          ? projectData?.purpose === PurposeType.IncreasedProduction.code
            ? projectData.increasedProductionStartDate
            : projectData?.purpose === PurposeType.Rationalization.code
              ? projectData.rationalizationStartDate
              : projectData.updateAndOtherStartDate
          : projectData.projectStartDate
      },
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData, originalImprovedNonWorkingHoursData, null,
      null, salesChartDataForSavedConfig, salesChartDataSetModified2.chartData,
      salesChartDataSetModified2.monthlySalesByPartNo,
      downsideIndexGraph, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, decimalCurrency,
      processCodeData, bomData, projectData.projectStartDate || undefined,
      undefined, undefined, reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    if (!combinedChartDataSetDownside) {
      return;
    }

    // 回収額設定
    setMonthOfRecoveryModified(combinedChartDataSetDownside.recoveryMonths);
    // 投資回収（当初計画）データ設定
    setCombinedChartDataModified({
      labels: combinedChartDataSetDownside.labels,
      datasets: [combinedChartDataSetDownside.recoveryDataset, ...combinedChartDataSetDownside.capexDatasets],
    });
    // 増分キャッシュフロー Excel出力用データ保持
    setIncrementalCashFlowDownside({
      labels: combinedChartDataSetDownside.labels,
      ...combinedChartDataSetDownside.incrementalCashFlowData,
      recoveryMonths: combinedChartDataSetDownside.recoveryMonths,
    });

  }, [
    quantitiesChartDataModified,
    mergedChartDataModified,
    capexPartNo,
    projectData,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    originalEquipmentAmounts,
    originalProfitAndLossByMonth,
    downsideIndexGraph,
    investmentStartYearMonth,
    salesCurrencyName,
    localCurrencyName,
    currencyData,
    processCodeData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【投資回収（プロジェクト全体投資回収）】チャートデータ作成
   *
   * ■ 概要
   *   過去PJ（当初投資）と現在PJ（増産/更新/合理化投資）を統合した、
   *   プロジェクト全体の投資回収シミュレーション。
   *   「当初投資 + 追加投資の合算」でプロジェクト全体としての投資回収を評価する。
   *
   * ■ 対象データ
   *   - 数量・単価: 現在PJのデータを使用
   *   - 設備投資（CAPEXバー）: 過去PJ設備 + 現在PJ設備を統合（mergeEquipmentAmounts）
   *   - 減価償却費: 費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用
   *
   * ■ 前提条件
   *   pastProjectIdがある場合のみ計算。
   */
  useEffect(() => {
    // 簡易モード時はPartNo別の数量データが未入力のため、プロジェクト全体投資回収計算をスキップ
    if (isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType)) {
      return;
    }
    // 必要なデータの有無チェック
    if (
      (!originalProfitAndLossByMonth) ||
      (!mergedChartDataOriginal) ||
      (!quantitiesChartDataOriginal) ||
      (!capexPartNo || capexPartNo.length === 0) ||
      (!projectData) ||
      (!pastEquipmentAmounts || pastEquipmentAmounts.length === 0) ||
      (!originalImprovedWorkingDaysData || originalImprovedWorkingDaysData.length === 0) ||
      (!originalImprovedNonWorkingHoursData || originalImprovedNonWorkingHoursData.length === 0) ||
      (!originalImprovedNonWorkingHoursData.every(
        // 各要素にnonWorkingHoursByMonthが存在することを確認
        item => item.nonWorkingHoursByMonth && item.nonWorkingHoursByMonth.length > 0
      )) ||
      (!processCodeData || processCodeData.length === 0) ||
      (!bomData || bomData.length === 0)
    ) {
      return;
    }

    const mergeEquipmentAmounts = [...pastEquipmentAmounts, ...originalEquipmentAmounts];

    // 【売上（プロジェクト全体投資回収）】チャートデータ作成
    // ※過去PJ設備の減価償却費は費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用するため、
    //   設備データは当初設備のみ渡し、現在PJのmonthlyExpenseDataを渡して費用画面の値を合算
    const currentMonthlyExpenseData: MonthlyExpenseData[] = projectData.monthlyExpenseData
      ? JSON.parse(projectData.monthlyExpenseData) : [];
    const pastEquipmentCostCurrencyName = currencyData?.find(
      c => c.currencyId === projectData?.pastEquipmentCostCurrencyId
    )?.currencyName;
    const salesChartDataSet = calcOriginalSalesChartDataSet(
      originalProfitAndLossByMonth,
      quantitiesChartDataOriginal,
      mergedChartDataOriginal,
      capexPartNo,
      projectData,
      originalEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      downsideIndexGraph,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      decimalCurrency,
      processCodeData,
      bomData,
      { expenseData: currentMonthlyExpenseData, currencyName: pastEquipmentCostCurrencyName },
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
      (reviewDate
        && selectedCurrency.name === CurrencyNameJPY
        && projectData?.currencyId === selectedCurrency.id
        && displayOriginalProfitAndLossByMonth?.totalSales?.length)
        ? displayOriginalProfitAndLossByMonth.totalSales.map(v => Number(v || 0))
        : undefined,
    );

    setSalesChartDataAll(salesChartDataSet.charData);

    // 【投資回収（プロジェクト全体投資回収）】チャートデータ作成
    const combinedAllChartDataSet = calcOriginalCombinedChartDataSet(
      salesChartDataSet.profitByMonth,
      capexPartNo,
      projectData,
      mergeEquipmentAmounts,
      originalProfitAndLossByMonth.labels,
      decimalCurrency,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      reviewDate ? convertWithRate : undefined
    );

    // 回収額設定（プロジェクト全体投資回収）
    setMonthOfRecoveryAll(combinedAllChartDataSet.monthOfRecoveryOriginal);

    // 投資回収（プロジェクト全体投資回収）データ設定
    setCombinedChartDataAll(combinedAllChartDataSet.chartData);

    // 増分キャッシュフロー Excel出力用データ保持
    // ※equipmentDepreciationInputs.equipmentsに過去PJ設備を含めることで、
    //   calcMonthlyProfitInDisplayCurrencyが設備金額一括変換→償却計算のパスで処理し、
    //   月額個別変換による丸め誤差を防止する
    const salesCostBreakdown = salesChartDataSet?.charData?.costBreakdown;
    const salesEquipDepInputs = salesChartDataSet?.charData?.equipmentDepreciationInputs;
    setIncrementalCashFlowAll({
      labels: combinedAllChartDataSet?.chartData?.labels,
      ...combinedAllChartDataSet?.incrementalCashFlowData,
      recoveryMonths: combinedAllChartDataSet?.monthOfRecoveryOriginal,
      costBreakdown: salesCostBreakdown ? {
        ...salesCostBreakdown,
        pastEquipmentCostSeparate: !!reviewDate,
      } : salesCostBreakdown,
      equipmentDepreciationInputs: salesEquipDepInputs ? {
        ...salesEquipDepInputs,
        equipments: [...pastEquipmentAmounts, ...(salesEquipDepInputs.equipments || [])],
        originalEquipments: salesEquipDepInputs.originalEquipments
          ? [...pastEquipmentAmounts, ...salesEquipDepInputs.originalEquipments]
          : undefined,
      } : salesEquipDepInputs,
      scrapCostInputs: salesChartDataSet?.charData?.scrapCostInputs,
    });

  }, [
    originalProfitAndLossByMonth,
    quantitiesChartDataOriginal,
    mergedChartDataOriginal,
    capexPartNo,
    projectData,
    pastEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    downsideIndexGraph,
    localCurrencyName,
    currencyData,
    decimalCurrency,
    processCodeData,
    bomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【投資回収（当初投資・回収）】チャートデータ作成
   *
   * ■ 概要
   *   過去PJ（当初投資）単体での投資回収シミュレーション。
   *   当初の投資申請時の計画が、実績を踏まえてどのように回収されるかを評価する。
   *   「プロジェクト全体投資回収」と対比して、当初投資分だけの回収状況を確認できる。
   *
   * ■ 対象データ
   *   - 数量・単価: 過去PJのデータを使用（投資開始年月より前は現在PJの実績で上書き）
   *   - 設備投資（CAPEXバー）: 過去PJ設備のみ（pastEquipmentAmounts）
   *   - 減価償却費: 費用画面の値（monthlyExpenseData.pastEquipmentCost）を使用
   *   - 金型費・開発費: 過去PJのデータ（投資開始年月より前は現在PJの実績で上書き）
   *
   * ■ 前提条件
   *   pastProjectIdがある場合のみ計算。
   */
  useEffect(() => {
    // 必要なデータの有無チェック
    if (
      !originalProfitAndLossByMonth ||
      !projectData ||
      !pastProjectData ||
      !pastCapexPartNo || pastCapexPartNo.length === 0 ||
      !capexPartNo || capexPartNo.length === 0 ||
      !pastCurrencyData ||
      !pastEquipmentAmounts || pastEquipmentAmounts.length === 0 ||
      !currencyData || currencyData.length === 0 ||
      !originalImprovedWorkingDaysData || originalImprovedWorkingDaysData.length === 0 ||
      !originalImprovedNonWorkingHoursData || originalImprovedNonWorkingHoursData.length === 0 ||
      (projectData?.pastProjectId && pastBomData.length === 0) ||
      (projectData?.pastProjectId && pastProcessCodeData.length === 0)
    ) {
      return;
    }

    // 簡易モード時はPartNo別の数量データが未入力のため、当初投資・回収計算をスキップ
    if (isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType)) {
      return;
    }

    // 増産開始年月のインデックスを見つける
    const productionStartIndex = originalProfitAndLossByMonth.labels.indexOf(investmentStartYearMonth);

    // 過去プロジェクトのオリジナル(当初損益)
    if (!pastProjectData?.originalProfitAndLossByMonth || pastProjectData.originalProfitAndLossByMonth.trim() === '') {
      return;
    }
    const pastOriginalProfitAndLossByMonth: OriginalProfitAndLossByMonthTable = JSON.parse(pastProjectData.originalProfitAndLossByMonth);

    // EOL予定日までの月数でフィルタリング（現在プロジェクトと同様の処理）
    const pastVisibleMonths = calcMonthsBetweenDates(
      pastProjectData.projectStartDate,
      pastProjectData.projectEndDate
    );

    if (pastVisibleMonths > 0 && pastOriginalProfitAndLossByMonth.labels &&
      pastVisibleMonths < pastOriginalProfitAndLossByMonth.labels.length) {
      // labels をフィルタリング
      pastOriginalProfitAndLossByMonth.labels = pastOriginalProfitAndLossByMonth.labels.slice(0, pastVisibleMonths);
      // totalSales をフィルタリング
      if (pastOriginalProfitAndLossByMonth.totalSales) {
        pastOriginalProfitAndLossByMonth.totalSales = pastOriginalProfitAndLossByMonth.totalSales.slice(0, pastVisibleMonths);
      }
      // profit をフィルタリング
      if (pastOriginalProfitAndLossByMonth.profit) {
        pastOriginalProfitAndLossByMonth.profit = pastOriginalProfitAndLossByMonth.profit.slice(0, pastVisibleMonths);
      }
      // quantityByPartNo を各PartNo毎にフィルタリング
      if (pastOriginalProfitAndLossByMonth.quantityByPartNo) {
        Object.keys(pastOriginalProfitAndLossByMonth.quantityByPartNo).forEach(partNo => {
          pastOriginalProfitAndLossByMonth.quantityByPartNo[partNo] =
            pastOriginalProfitAndLossByMonth.quantityByPartNo[partNo].slice(0, pastVisibleMonths);
        });
      }
    }

    // 過去プロジェクトの終了インデックス
    const pastEndIndex = pastOriginalProfitAndLossByMonth.labels.length - 1;

    const localQuantityByPartNo: Record<string, string[]> = {};
    for (let [partNo, pastQuantities] of Object.entries(pastOriginalProfitAndLossByMonth.quantityByPartNo)) {
      let quantities = originalProfitAndLossByMonth.quantityByPartNo[partNo];

      if (!quantities) {
        // PartNo数の不整合の場合は例外発生しないようにする
        continue;
      }

      if (pastEndIndex < productionStartIndex) {
        // 過去プロジェクトの期間の方が、増産開始年月より短い場合、過去プロジェクトの期間で切り出し
        localQuantityByPartNo[partNo] = quantities.slice(0, pastEndIndex);
      } else {
        // 実績：先頭から増産開始年月より前まで切り出し
        quantities = quantities.slice(0, productionStartIndex);

        // 過去プロジェクトの数量：増産開始年月以降を切り出し
        pastQuantities = pastQuantities.slice(productionStartIndex);

        // 実績＋過去プロジェクトの数量
        localQuantityByPartNo[partNo] = [...quantities, ...pastQuantities];
      }
    }

    // 差し替え：実績＋過去プロジェクトの数量
    pastOriginalProfitAndLossByMonth.quantityByPartNo = localQuantityByPartNo;

    // 実績＋過去プロジェクト(数量)
    let [startYear, startMonth] = (pastProjectData.projectStartDate || "/").split(/-|\//).map(v => Number(v));
    if (startMonth < 4) {
      // 年度変換
      startYear = startYear - 1;
    }

    let [increasedProductionStartYear, increasedProductionStartMonth] = investmentStartYearMonth.split(/-|\//).map(v => Number(v));
    if (increasedProductionStartMonth < 4) {
      // 年度変換
      increasedProductionStartYear = increasedProductionStartYear - 1;
    }

    // 増産開始年
    const periodYears = increasedProductionStartYear - startYear + 1;
    // 増産開始月
    const periodMonths = increasedProductionStartMonth;

    // プロジェクト単位（金型費、開発費、設備費）
    if (pastProjectData.moldSalesByProject) {
      pastProjectData.moldSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, increasedProductionStartMonth, projectData.moldSalesByProject, pastProjectData.moldSalesByProject);
    }

    if (pastProjectData.developmentSalesByProject) {
      pastProjectData.developmentSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, increasedProductionStartMonth, projectData.developmentSalesByProject, pastProjectData.developmentSalesByProject);
    }

    if (pastProjectData.equipmentSalesByProject) {
      pastProjectData.equipmentSalesByProject = replaceMoldOrDevelopmentSales(periodYears, periodMonths, increasedProductionStartMonth, projectData.equipmentSalesByProject, pastProjectData.equipmentSalesByProject);
    }

    // パーツNoループ
    for (let pastPartNoItem of pastCapexPartNo) {
      const capexPartNoItem = capexPartNo.find(p => p.partNo === pastPartNoItem.partNo);

      if (!capexPartNoItem) {
        continue;
      }

      // 数量パース
      const quantityAndPrice: QuantityAndPriceMonthTable = JSON.parse(capexPartNoItem.quantityAndPrice!);
      const pastQuantityAndPrice: QuantityAndPriceMonthTable = JSON.parse(pastPartNoItem.quantityAndPrice!);

      for (let years of pastQuantityAndPrice.years) {
        // 数量・単価
        if (years < periodYears) {
          // 実績コピー(年単位)
          pastQuantityAndPrice.data[years] = quantityAndPrice?.data[years] || 0;
        } else if (years === periodYears && increasedProductionStartMonth !== 4) {
          for (const [months, data] of Object.entries(pastQuantityAndPrice.data[years].months)) {
            if (data.month >= periodMonths) {
              break;
            }
            // 実績コピー(月単位)
            pastQuantityAndPrice.data[years].months[Number(months)] =
              quantityAndPrice.data[years].months[Number(months)];
          }
        }
      }

      // 金型費の置き換え
      if (pastPartNoItem.moldSalesByPartNo) {
        pastPartNoItem.moldSalesByPartNo = replaceMoldOrDevelopmentSales(periodYears, periodMonths, increasedProductionStartMonth, capexPartNoItem.moldSalesByPartNo, pastPartNoItem.moldSalesByPartNo);
      }

      // 開発費の置き換え
      if (pastPartNoItem.developmentSalesByPartNo) {
        pastPartNoItem.developmentSalesByPartNo = replaceMoldOrDevelopmentSales(periodYears, periodMonths, increasedProductionStartMonth, capexPartNoItem.developmentSalesByPartNo, pastPartNoItem.developmentSalesByPartNo);
      }

      // 数量：実績コピーしたものを戻す
      pastPartNoItem.quantityAndPrice = JSON.stringify(pastQuantityAndPrice);
    }

    // 数量チャートデータ生成
    const pastQuantitiesChartDataSets = calcQuantitiesChartDataSet(
      pastOriginalProfitAndLossByMonth,
      null,
      pastCapexPartNo
    );

    // 販売通貨（過去プロジェクト）
    const pastSalesCurrencyName = pastCurrencyData.find(c => c.currencyId === pastProjectData?.currencyId)?.currencyName;

    if (!(pastProjectData?.mergedChartDataOriginal || null)) {
      return;
    }

    // 価格と材料単価チャートデータ（過去プロジェクト）
    // ※DB保存済みJSONのlabelには実キーが焼き込まれている可能性があるため、displayPartNoに補正する
    const pastMergedChartDataOriginal = resolveChartDatasetLabels(
      JSON.parse(pastProjectData?.mergedChartDataOriginal!) as { labels?: string[]; datasets: any[] },
      pastCapexPartNo
    );

    // 過去PJのローカル通貨名を取得
    const pastLocalCurrencyName = pastCurrencyData.find(
      c => c.currencyId === getLocalCurrencyId(pastProjectData?.companyPlantSnapshot)
    )?.currencyName || "";

    // 過去PJのローカル通貨 → 現在PJのローカル通貨に変換（通貨が異なる場合のみ）
    const convertedPastMergedData = (pastLocalCurrencyName && pastLocalCurrencyName !== localCurrencyName)
      ? convertChartDatasets(pastMergedChartDataOriginal, pastLocalCurrencyName, localCurrencyName, currencyData)
      : pastMergedChartDataOriginal;

    // 【売上（当初投資・回収）】チャートデータ作成
    // ※過去PJ設備の減価償却費は費用画面の値（現在PJのmonthlyExpenseData.pastEquipmentCost）を使用するため、
    //   設備データは空配列を渡し、現在PJのmonthlyExpenseDataを渡して費用画面の値を合算
    const currentMonthlyExpenseDataForPast: MonthlyExpenseData[] = projectData?.monthlyExpenseData
      ? JSON.parse(projectData.monthlyExpenseData) : [];
    const pastEquipmentCostOverrideForPast = {
      expenseData: currentMonthlyExpenseDataForPast,
      currencyName: currencyData?.find(c => c.currencyId === projectData?.pastEquipmentCostCurrencyId)?.currencyName,
    };
    const salesChartDataSetPast = calcDownsideSalesChartDataSet(
      pastQuantitiesChartDataSets.quantitiesChartDataOriginal,
      convertedPastMergedData,
      pastCapexPartNo,
      pastProjectData,
      [],
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      null,
      pastSalesCurrencyName || "",
      reviewDate ? selectedCurrency.name : localCurrencyName,
      pastCurrencyData,
      pastOriginalProfitAndLossByMonth.labels,
      decimalCurrency,
      pastProcessCodeData,
      pastBomData,
      undefined,
      true,
      pastEquipmentCostOverrideForPast,
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    // 売上
    setSalesChartDataPast(salesChartDataSetPast.chartData);

    // 【投資回収（当初投資・回収）】チャートデータ作成
    // ※pastEquipmentAmountsはCAPEXバー表示用に引き続き渡すが、
    //   減価償却費計算は費用画面の値を使用
    const combinedPastChartDataSet = calcDownsideCombinedChartDataSet(
      pastQuantitiesChartDataSets.quantitiesChartDataOriginal,
      convertedPastMergedData,
      pastCapexPartNo,
      pastProjectData,
      pastEquipmentAmounts,
      originalImprovedWorkingDaysData,
      originalImprovedNonWorkingHoursData,
      null,
      null,
      [],
      salesChartDataSetPast.chartData,
      salesChartDataSetPast.monthlySalesByPartNo,
      null,
      reviewDate ? selectedCurrency.name : localCurrencyName,
      pastCurrencyData,
      decimalCurrency,
      pastProcessCodeData,
      pastBomData,
      undefined,
      true,
      pastEquipmentCostOverrideForPast,
      reviewDate ? convertWithRate : undefined,
      reviewDate ? localCurrencyName : undefined,
    );

    if (!combinedPastChartDataSet) {
      return;
    }


    combinedPastChartDataSet.recoveryDataset.label = combinedPastChartDataSet.recoveryDataset.label.replace("(Modified)", "");

    // 回収額設定（当初投資・回収）
    setMonthOfRecoveryPast(combinedPastChartDataSet?.recoveryMonths!);

    // 投資回収（当初投資・回収）データ設定
    setCombinedChartDataPast({
      labels: combinedPastChartDataSet.labels,
      datasets: [combinedPastChartDataSet.recoveryDataset, ...combinedPastChartDataSet.capexDatasets],
    });

    // 増分キャッシュフロー Excel出力用データ保持
    setIncrementalCashFlowPast({
      labels: combinedPastChartDataSet?.labels,
      ...combinedPastChartDataSet?.incrementalCashFlowData,
      recoveryMonths: combinedPastChartDataSet?.recoveryMonths,
    });

  }, [
    originalProfitAndLossByMonth,
    pastProjectData,
    pastCapexPartNo,
    capexPartNo,
    quantitiesChartDataOriginal,
    pastEquipmentAmounts,
    originalImprovedWorkingDaysData,
    originalImprovedNonWorkingHoursData,
    pastCurrencyData,
    decimalCurrency,
    pastProcessCodeData,
    pastBomData,
    reviewDate,
    selectedCurrency.name,
    convertWithRate,
  ]);

  /**
   * 【売上グラフ】保存済み設定用グラフ生成
   */
  useEffect(() => {
    if (selectedConfigIds.length > 0 && quantitiesChartDataForSavedConfig.length > 0 && mergedChartDataForSavedConfig.length > 0 && projectData && originalProfitAndLossByMonth) {
      selectedConfigIds.forEach(configId => {
        const config = savedConfigs.find(c => c.id === configId);

        const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
        const savedMergedData = mergedChartDataForSavedConfig.find(q => q.configId === configId);

        if (config && savedQuantitiesData && savedMergedData) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

          const savedConfigSalesChartDataSet = calcDownsideSalesChartDataSet(
            savedQuantitiesData.data, savedMergedData.data, capexPartNo,
            applyScenarioLaborCostToProjectData(
              projectData!,
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              originalProfitAndLossByMonth.labels
            ), originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config, configId, configDownsideIndex,
            salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, originalProfitAndLossByMonth.labels, decimalCurrency,
            processCodeData, bomData,
            undefined,
            configApplyDownside,
            undefined,
            reviewDate ? convertWithRate : undefined,
            reviewDate ? localCurrencyName : undefined,
          );

          // No.411追加対応: 申請書画面（ReportAndDraft.tsx）が投資回収用データ構造
          // （combinedChartDataForSavedConfig）に間借りせず自己完結で参照できるよう、
          // realProfitRateForConfigsMemo（画面表示用）と同じ入力データでrealProfitRate/realProfitRateByMonthを算出し、
          // salesChartDataForSavedConfigのchartData自体に付帯させる。
          const salesDataset = savedConfigSalesChartDataSet.chartData.datasets?.find((d: any) => d.id === "sales");
          const sales = salesDataset ? salesDataset.data.map((v: string | number) => new Decimal(v)) : [];
          const savedConfigLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
          const savedConfigCapexPartNo = config.quantityAndPrice.length > 0
            ? capexPartNo.map(partNo => {
              const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
              return matched
                ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                : partNo;
            })
            : capexPartNo;
          // 顧客指定部品の有無判断
          const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
          const { realProfitRate, realProfitRateByMonth } = a // 判定条件の sales.length > 0  を a にしてみた
            ? calcRealProfitRateCommon({
              salesData: sales,
              mergedData: savedMergedData.data,
              quantitiesData: savedQuantitiesData.data,
              labels: savedConfigLabels,
              capexPartNo: savedConfigCapexPartNo,
              equipments: originalEquipmentAmounts,
              projectData: applyScenarioLaborCostToProjectData(
                projectData!,
                config.scenarioLaborCostByMonth,
                config.scenarioOverseasFactoryExpensesByMonth,
                savedConfigLabels
              ),
              isDownside: configApplyDownside,
              localCurrencyName,
              currencyData,
              targetCurrencyName: reviewDate ? selectedCurrency.name : localCurrencyName,
              downsideIndexGraph: configDownsideIndex,
              decimalCurrency,
              processCodeData,
              bomData,
              moldSales: projectData?.moldSalesByProject,
              developmentSales: projectData?.developmentSalesByProject,
              equipmentSales: projectData?.equipmentSalesByProject,
              convertFn: reviewDate ? convertWithRate : undefined,
            })
            : { realProfitRate: "", realProfitRateByMonth: [] as number[] };

          setSalesChartDataForSavedConfig(prev => {
            const filtered = prev.filter(item => item.configId !== configId);
            return [...filtered, {
              configId, data: {
                ...savedConfigSalesChartDataSet.chartData,
                realProfitRate,
                realProfitRateByMonth,
              }
            }];
          });
        }
      });
    }
  }, [selectedConfigIds, savedConfigs, quantitiesChartDataForSavedConfig, mergedChartDataForSavedConfig, capexPartNo, projectData, downsideIndexGraph, salesCurrencyName, localCurrencyName, currencyData, originalProfitAndLossByMonth, decimalCurrency, processCodeData, bomData, neutralDownsideIndex, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 【投資分回収グラフ（詳細モード）】保存済み設定用グラフ生成
   * 増産・合理化（詳細）・更新（詳細）投資が対象。簡易モードは専用useEffectで処理。
   */
  useEffect(() => {
    // 簡易モードは専用useEffectで計算するためスキップ
    if (isSimpleApplicationForm(projectData?.purpose, projectData?.applicationFormType)) {
      return;
    }
    if (selectedConfigIds.length > 0 && salesChartDataForSavedConfig.length > 0 && quantitiesChartDataForSavedConfig.length > 0 && mergedChartDataForSavedConfig.length > 0 && projectData && originalProfitAndLossByMonth) {
      selectedConfigIds.forEach(configId => {
        // 選択中の 「保存されたシミュレーション設定」 取得
        const config = savedConfigs.find(c => c.id === configId);

        // 選択中の 「保存済み設定」 取得
        const savedSalesDataFull = salesChartDataForSavedConfig.find(item => item.configId === configId);
        const savedQuantitiesData = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
        const savedMergedData = mergedChartDataForSavedConfig.find(q => q.configId === configId);

        // 基本情報で登録したパーツのみ
        let basicInfoRegisteredPartNoData: PartNo[] = capexPartNo.filter(p => p.basicInfoRegistered === true);

        // quantityAndPrice、moldSalesByPartNo、developmentSalesByPartNoをincreasedProductionStartYearMonthを起点として切り出す
        basicInfoRegisteredPartNoData = basicInfoRegisteredPartNoData.map(partNo =>
          slicePartNoDataByStartYearMonth(partNo, projectData.projectStartDate || "", investmentStartYearMonth)
        );

        // 増産投資量産開始年月のインデックス
        const investmentStartYearMonthPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);

        // ラベル情報（増産投資量産開始年月～）
        const labels = originalProfitAndLossByMonth.labels.slice(investmentStartYearMonthPos);

        // 「保存されたシミュレーション設定」「保存済み設定」を取得できた場合のみ処理する
        if (config && savedQuantitiesData && savedMergedData) {
          const configApplyDownside = config.applyDownside !== false;
          const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

          // 数量チャートデータ期間調整
          const tempQuantitiesChartData = JSON.parse(JSON.stringify(savedQuantitiesData.data));
          tempQuantitiesChartData.labels = tempQuantitiesChartData.labels.slice(investmentStartYearMonthPos);
          tempQuantitiesChartData.datasets = tempQuantitiesChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
          tempQuantitiesChartData.datasets.map((d: any) => {
            d.data = d.data.slice(investmentStartYearMonthPos);
          });

          // 価格と材料単価チャートデータ期間調整
          const tempMergedChartData = JSON.parse(JSON.stringify(savedMergedData.data));
          tempMergedChartData.labels = tempMergedChartData.labels.slice(investmentStartYearMonthPos);
          tempMergedChartData.datasets = tempMergedChartData.datasets.filter((d: any) => basicInfoRegisteredPartNoData.some((p: any) => d.partNoKey === p.partNo));
          tempMergedChartData.datasets.map((d: any) => {
            d.data = d.data.slice(investmentStartYearMonthPos);
          });
          // 売上チャートデータ作成
          const savedConfigSalesChartDataSet = calcDownsideSalesChartDataSet(
            tempQuantitiesChartData, tempMergedChartData,
            basicInfoRegisteredPartNoData,
            applyScenarioLaborCostToProjectData(
              {
                ...projectData, projectStartDate: projectData.pastProjectId
                  ? projectData?.purpose === PurposeType.IncreasedProduction.code
                    ? projectData.increasedProductionStartDate
                    : projectData?.purpose === PurposeType.Rationalization.code
                      ? projectData.rationalizationStartDate
                      : projectData.updateAndOtherStartDate
                  : projectData.projectStartDate
              },
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              // 労務費配列はoriginalProfitAndLossByMonth.labels（全期間）基準のため、
              // 期間短縮された labels ではなく全期間ラベルでインデックスを合わせる
              originalProfitAndLossByMonth.labels
            ),
            originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config, configId, configDownsideIndex,
            salesCurrencyName, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, labels, decimalCurrency,
            processCodeData, bomData, projectData.projectStartDate || undefined,
            configApplyDownside,
            undefined,
            reviewDate ? convertWithRate : undefined,
            reviewDate ? localCurrencyName : undefined,
          );

          // calcDownsideCombinedChartDataSetのI/Fを合わせるため、疑似データ作成
          const salesChartDataForSavedConfig = [{
            configId: configId,
            data: savedConfigSalesChartDataSet.chartData
          }];

          // 投資回収チャートデータ（ダウンサイド）作成
          const savedCombinedDataSet = calcDownsideCombinedChartDataSet(
            tempQuantitiesChartData, tempMergedChartData,
            basicInfoRegisteredPartNoData,
            applyScenarioLaborCostToProjectData(
              {
                ...projectData, projectStartDate: projectData.pastProjectId
                  ? projectData?.purpose === PurposeType.IncreasedProduction.code
                    ? projectData.increasedProductionStartDate
                    : projectData?.purpose === PurposeType.Rationalization.code
                      ? projectData.rationalizationStartDate
                      : projectData.updateAndOtherStartDate
                  : projectData.projectStartDate
              },
              config.scenarioLaborCostByMonth,
              config.scenarioOverseasFactoryExpensesByMonth,
              originalProfitAndLossByMonth.labels
            ),
            originalEquipmentAmounts,
            config.improvedWorkingDaysData, config.improvedNonWorkingHoursData, config,
            configId, salesChartDataForSavedConfig, savedConfigSalesChartDataSet.chartData, savedConfigSalesChartDataSet.monthlySalesByPartNo,
            configDownsideIndex, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, decimalCurrency,
            processCodeData, bomData, projectData.projectStartDate || undefined,
            configApplyDownside,
            undefined,
            reviewDate ? convertWithRate : undefined,
            reviewDate ? localCurrencyName : undefined,
          );

          if (savedCombinedDataSet) {
            //  「回収時期ｎヶ月目」設定
            setMonthOfRecoveryForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, { configId, data: savedCombinedDataSet.recoveryMonths }];
            });

            // 営業利益額と営業利益率を計算（ローカル通貨のまま）
            const { totalProfit: configTotalProfit, profitRate: configProfitRate } = calcTotalProfitAndRate(savedConfigSalesChartDataSet.chartData);
            // 営業利益合計を当初計画/ダウンサイドと同じ方式（costBreakdown経由）で計算（表示通貨）
            const configDisplayTotalProfit = calcDisplayTotalProfit(savedConfigSalesChartDataSet.chartData);

            // customerSpecifiedPartsCost は全期間データで算出（PJ全期間と投資開始以降の両方で使用）
            // 保存済み設定のストレスON/OFF設定に応じたデータを使用する
            // No.411追加対応: 画面表示用（realProfitRateForConfigsMemo）と同じ入力データ
            // （savedConfigCapexPartNo・applyScenarioLaborCostToProjectData適用済みprojectData）で統一し、
            // シナリオ労務費・海外工場費・数量価格を設定した保存済み設定でのズレを解消する。
            const savedConfigCapexPartNoFull = config.quantityAndPrice.length > 0
              ? capexPartNo.map(partNo => {
                const matched = config.quantityAndPrice.find(q => q.partNo === partNo.partNo);
                return matched
                  ? { ...partNo, quantityAndPrice: JSON.stringify(matched) }
                  : partNo;
              })
              : capexPartNo;
            let fullMonthlyData: any = null;
            if (savedSalesDataFull?.data?.datasets) {
              const salesDatasetFull = savedSalesDataFull.data.datasets.find((d: any) => d.id === "sales");
              const savedQuantitiesDataFull = quantitiesChartDataForSavedConfig.find(q => q.configId === configId);
              const savedMergedDataFull = mergedChartDataForSavedConfig.find(m => m.configId === configId);
              if (salesDatasetFull && savedQuantitiesDataFull && savedMergedDataFull) {
                const salesFull = salesDatasetFull.data.map((v: string | number) => new Decimal(v));
                const fullLabels = originalProfitAndLossByMonth.labels.slice(0, salesFull.length);
                const fullMaterialCosts = calcMaterialCost(
                  savedMergedDataFull.data,
                  savedQuantitiesDataFull.data,
                  savedConfigCapexPartNoFull,
                  fullLabels,
                  projectData?.projectId!,
                  localCurrencyName,
                  currencyData
                );
                fullMonthlyData = calcMonthlyProfitAndLossDetails(
                  salesFull,
                  fullMaterialCosts || [],
                  fullLabels,
                  configApplyDownside,
                  originalEquipmentAmounts,
                  applyScenarioLaborCostToProjectData(
                    projectData!,
                    config.scenarioLaborCostByMonth,
                    config.scenarioOverseasFactoryExpensesByMonth,
                    fullLabels
                  ),
                  savedConfigCapexPartNoFull,
                  // 振り返りモード: salesFullは表示通貨(selectedCurrency)で月別レート変換済みのため、
                  // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
                  // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
                  reviewDate ? selectedCurrency.name : localCurrencyName,
                  currencyData,
                  configDownsideIndex,
                  decimalCurrency,
                  processCodeData,
                  bomData,
                  projectData?.moldSalesByProject,
                  projectData?.developmentSalesByProject,
                  projectData?.equipmentSalesByProject,
                  undefined,
                  reviewDate ? convertWithRate : undefined,
                );
              }
            }

            // PJ全期間の実質的営業利益率を計算（保存済み設定用 - 売上セクション向け）
            let configRealProfitRate = "";
            let configRealProfitRateByMonth: number[] = [];
            // 顧客指定部品の有無判断
            const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
            if (savedSalesDataFull?.data?.datasets && fullMonthlyData) {
              const configSalesDatasetFull = savedSalesDataFull.data.datasets.find((d: any) => d.id === "sales");
              const configProfitDatasetFull = savedSalesDataFull.data.datasets.find((d: any) => d.id === "profit");
              if (configSalesDatasetFull && configProfitDatasetFull) {
                const totalSalesValFull = configSalesDatasetFull.data.reduce(
                  (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
                );
                // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
                const totalProfitValFull = configProfitDatasetFull.data.reduce(
                  (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
                ).plus(fullMonthlyData.residualDepreciationTotal ?? new Decimal(0));
                const totalCustomerCostFull = fullMonthlyData.customerSpecifiedPartsCost.reduce(
                  (sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0)
                );
                if (a) {
                  configRealProfitRate = calcRealProfitRate(totalSalesValFull, totalProfitValFull, totalCustomerCostFull);
                  configRealProfitRateByMonth = calcRealProfitRateByMonth(
                    configSalesDatasetFull.data.map((v: string | number) => Number(v)),
                    configProfitDatasetFull.data.map((v: string | number) => Number(v)),
                    fullMonthlyData.customerSpecifiedPartsCost
                  );
                }
              }
            }

            // 投資開始以降の実質的営業利益率を計算（保存済み設定用 - 投資分回収セクション向け）
            // No.411追加対応: 「営業利益率」側（calcTotalProfitAndRate(savedConfigSalesChartDataSet.chartData)）と
            // 同じ基準（投資開始以降のlabelsで算出したresidualDepreciationTotal）で揃える。
            // fullMonthlyData.residualDepreciationTotalはPJ全期間labels基準のため、基準がずれて過大計上になるため使わない。
            let configRealProfitRateCashflow = "";
            let configRealProfitRateByMonthCashflow: number[] = [];
            const configSalesDataset = savedConfigSalesChartDataSet.chartData?.datasets?.find((d: any) => d.id === "sales");
            const configProfitDataset = savedConfigSalesChartDataSet.chartData?.datasets?.find((d: any) => d.id === "profit");
            if (configSalesDataset && configProfitDataset && fullMonthlyData) {
              const totalSalesVal = configSalesDataset.data.reduce(
                (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
              );
              const savedConfigResidualDepreciationTotal = (savedConfigSalesChartDataSet.chartData as any)?.residualDepreciationTotal;
              const totalProfitVal = configProfitDataset.data.reduce(
                (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
              ).plus(
                savedConfigResidualDepreciationTotal
                  ? new Decimal(savedConfigResidualDepreciationTotal)
                  : new Decimal(0)
              );
              const customerCostSliced = fullMonthlyData.customerSpecifiedPartsCost.slice(investmentStartYearMonthPos);
              const totalCustomerCost = customerCostSliced.reduce(
                (sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0)
              );
              if (a) {
                configRealProfitRateCashflow = calcRealProfitRate(totalSalesVal, totalProfitVal, totalCustomerCost);
                configRealProfitRateByMonthCashflow = calcRealProfitRateByMonth(
                  configSalesDataset.data.map((v: string | number) => Number(v)),
                  configProfitDataset.data.map((v: string | number) => Number(v)),
                  customerCostSliced
                );
              }
            }

            // 「投資回収チャートデータ」設定
            setCombinedChartDataForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId, data: {
                  labels: savedCombinedDataSet.labels,
                  datasets: [savedCombinedDataSet.recoveryDataset, ...savedCombinedDataSet.capexDatasets],
                  totalProfit: configTotalProfit,
                  displayTotalProfit: configDisplayTotalProfit?.toString(),
                  profitRate: configProfitRate,
                  realProfitRate: configRealProfitRate,
                  realProfitRateByMonth: configRealProfitRateByMonth,
                  realProfitRateCashflow: configRealProfitRateCashflow,
                  realProfitRateByMonthCashflow: configRealProfitRateByMonthCashflow,
                }
              }];
            });
            // 増分キャッシュフロー Excel出力用データ保持
            setIncrementalCashFlowForSavedConfig(prev => {
              const filtered = prev.filter(item => item.configId !== configId);
              return [...filtered, {
                configId,
                data: {
                  labels: savedCombinedDataSet.labels,
                  ...savedCombinedDataSet.incrementalCashFlowData,
                  recoveryMonths: savedCombinedDataSet.recoveryMonths,
                },
              }];
            });
          }
        }
      });
    }
  }, [selectedConfigIds, savedConfigs, salesChartDataForSavedConfig, quantitiesChartDataForSavedConfig, mergedChartDataForSavedConfig, capexPartNo, projectData, monthlySalesModifiedByPartNo, downsideIndexGraph, localCurrencyName, currencyData, decimalCurrency, selectedCustomerProduct, processCodeData, bomData, neutralDownsideIndex, reviewDate, selectedCurrency.name, convertWithRate]);
  /**
   * 【生産能力（ライン全体）グラフ】保存済み設定用グラフ生成
   * 増産投資の場合のみ計算
   */
  useEffect(() => {
    // 増産投資以外はスキップ
    if (projectData?.purpose !== PurposeType.IncreasedProduction.code) {
      return;
    }

    if (
      (selectedConfigIds?.length || 0) === 0 ||
      !originalProfitAndLossByMonth ||
      !investmentStartYearMonth
    ) {
      return;
    }

    selectedConfigIds.forEach(configId => {
      const config = savedConfigs.find(c => c.id === configId);
      // 数量グラフの保存済み設定版（ストレスON＝ダウンサイド／OFF＝当初）。未作成なら作成後の再実行を待つ
      const quantitiesItem = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
      if (config && quantitiesItem) {
        // 年月ラベルを生成（ラベルは全期間のまま、データのみ短縮する）
        const labels: string[] = [...originalProfitAndLossByMonth.labels];

        // 数量からPartNo別数量と月数を取得（ストレスONなら係数・期間短縮が適用済み）
        const { quantityByPartNo: configQuantityByPartNo, length: configLength } =
          extractQuantityByPartNoFromChart(quantitiesItem.data, labels.length);

        // 増産開始年月のインデックスを見つける
        const productionStartIndex = labels.indexOf(investmentStartYearMonth);

        // 増産前生産数量過去ベスト（増産投資の場合のみ）
        let preProductionBest: (number | null)[] = [];
        if (projectData?.purpose === PurposeType.IncreasedProduction.code) {
          preProductionBest = calcPreProductionBest(labels, productionStartIndex);
        }

        // 顧客需要
        const customerDemand: Decimal[] = calcCustomerDemandData(labels, configQuantityByPartNo);

        // 稼働日分 と 休日稼働分 算出（キャパにはストレス指数を掛けない）
        const numberOfUnitsProduced = calcNumberOfUnitsProduced(
          labels,
          config.improvedWorkingDayByYear,
          config.improvedLineCountByYear,
          config.improvedHolidayByYear,
          config.improvedAvailabilityRateByMonth,
          (targetYearMonth) => {
            // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
            return getApplicableYieldRate(targetYearMonth, config.improvedYieldRateList, (ym) => getYieldRateFromBomData(ym, bomData));
          },
          (targetYearMonth: string) => {
            // 過去分は実績データを入力しているため、常に現在プロジェクトのBOMを参照
            return getApplicableCycleTime(targetYearMonth, config.improvedCycleTimeList, (ym) => getCycleTimeFromBomData(ym, bomData));
          },
          projectData?.projectStartDate!
        );

        // チャートデータを作成（ストレスONなら全系列を数量と同じ月数で短縮）
        const chartData = {
          labels,
          datasets: [
            // 増産投資の場合のみ「増産前生産数量過去ベスト」を表示
            ...(projectData?.purpose === PurposeType.IncreasedProduction.code ? [{
              type: 'line' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.preIncreaseProductionPast'),
              data: preProductionBest.slice(0, configLength),
              borderColor: 'rgb(255, 159, 64)',
              backgroundColor: 'rgba(255, 159, 64, 0.5)',
              borderWidth: 2,
              tension: 0.4,
              pointRadius: 0,
              pointStyle: 'rect',
              order: 1,
            }] : []),
            {
              type: 'line' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
              data: customerDemand.slice(0, configLength),
              borderColor: 'rgb(75, 192, 75)',
              backgroundColor: 'rgba(75, 192, 75, 0.5)',
              borderWidth: 5,
              tension: 0.4,
              pointRadius: 0,
              pointStyle: 'rect',
              order: 2,
            },
            {
              type: 'bar' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
              data: numberOfUnitsProduced.holidays.slice(0, configLength),
              backgroundColor: 'rgb(255, 205, 86)',
              stack: 'production',
              pointStyle: 'rect',
              order: 4,
            },
            {
              type: 'bar' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
              data: numberOfUnitsProduced.weekdays.slice(0, configLength),
              backgroundColor: 'rgb(201, 203, 207)',
              stack: 'production',
              pointStyle: 'rect',
              order: 3,
            },
          ],
        };

        // 生産能力チャートデータを保存
        setProductionCapacityChartDataForSavedConfig(prev => {
          const filtered = prev.filter(item => item.configId !== configId);
          return [...filtered, { configId, data: chartData }];
        });
        // 生産キャパグラフ（既存ライン含む）用：キャパ＝改善後の稼働日分、案件品＝数量（保存済み設定）
        setElqVersionsForSavedConfig(prev => [
          ...prev.filter(item => item.configId !== configId),
          { configId, ...toExistingLineCapacityVersion(configQuantityByPartNo, numberOfUnitsProduced.weekdays, configLength) },
        ]);
      }
    });
  }, [
    selectedConfigIds,
    savedConfigs,
    originalProfitAndLossByMonth,
    investmentStartYearMonth,
    projectData,
    quantitiesChartDataForSavedConfig,
    bomData,
  ]);

  /**
   * 【生産能力（プロセス）グラフ】保存済み設定用グラフ生成
   * 更新後のグラフベースでシミュレーション設定のデータを使用
   * 更新投資または合理化の場合のみ計算
   */
  useEffect(() => {
    // 更新投資・合理化以外はスキップ
    if (projectData?.purpose !== PurposeType.UpdateAndOther.code &&
      projectData?.purpose !== PurposeType.Rationalization.code) {
      return;
    }

    // 必要なデータが揃っているかチェック
    if (
      (selectedConfigIds?.length || 0) === 0 ||
      !originalProfitAndLossByMonth ||
      !equipmentAmounts || equipmentAmounts.length === 0 ||
      !processCodeData || processCodeData.length === 0
    ) {
      return;
    }

    // 設備追加があるプロセスIDを抽出（重複なし）
    const processIdsWithEquipment = new Set(
      equipmentAmounts
        .filter(e => e.processId)
        .map(e => e.processId!)
    );

    // 設備追加があるプロセスのみフィルタリング
    const processesWithEquipment = processCodeData.filter(
      process => processIdsWithEquipment.has(process.uniqueProcessId || "")
    );

    if (processesWithEquipment.length === 0) {
      setProductionCapacityProcessChartDataForSavedConfig([]);
      return;
    }

    // 年月ラベルを生成
    const labels: string[] = [...originalProfitAndLossByMonth.labels];

    // 選択された各設定に対してプロセスごとのグラフデータを生成
    const savedConfigProcessData = selectedConfigIds.map(configId => {
      const config = savedConfigs.find(c => c.id === configId);
      if (!config) return null;

      // 詳細モード: 数量グラフの保存済み設定版（ストレスON＝ダウンサイド／OFF＝当初）から需要・月数を取得。未作成なら作成後の再実行を待つ
      // 簡易モード: ストレス指数を適用しない（当初計画と同様の挙動）ため、当初数量・全期間のまま
      let configQuantityByPartNo: Record<string, string[]> = originalProfitAndLossByMonth.quantityByPartNo;
      let configLength = labels.length;
      if (!isSimpleMode) {
        const quantitiesItem = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
        if (!quantitiesItem) return null;
        ({ quantityByPartNo: configQuantityByPartNo, length: configLength } =
          extractQuantityByPartNoFromChart(quantitiesItem.data, labels.length));
      }

      // 各プロセスのチャートデータを生成
      const processData = processesWithEquipment.map(process => {
        // 投資目的に応じてpartsCountを取得
        let partsCount = 1;
        if (projectData?.purpose === PurposeType.Rationalization.code) {
          // 合理化投資: rationalizationSummaryDataListから取得
          const rationalizationSummary = rationalizationSummaryDataList.find(
            s => s.processId === process.uniqueProcessId
          );
          partsCount = rationalizationSummary?.partsCount ?? 1;
        } else {
          // 更新投資: updateSummaryDataListから取得
          const updateSummary = updateSummaryDataList.find(
            summary => summary.productionLineId === process.uniqueProcessId
          );
          partsCount = updateSummary?.partsCount ?? 1;
        }

        // ▼ 顧客需要
        let afterCustomerDemand: Decimal[] = [];

        if (isSimpleMode) {
          // 簡易モードの場合は前後サマリーの売上数量から顧客需要を取得
          if (projectData?.purpose === PurposeType.Rationalization.code) {
            // 合理化投資: rationalizationSummaryDataListから取得
            const rationalizationSummary = rationalizationSummaryDataList.find(
              s => s.processId === process.uniqueProcessId
            );
            // 対象プロセスの売上数量を取得
            const salesQuantity = rationalizationSummary?.indicatorItems?.find(
              i => i.itemType === "salesQuantity"
            );
            // 売上数量が取得できた場合はDecimal型配列に変換
            if (salesQuantity) {
              // 合理化後の売上数量を顧客需要データに変換
              const afterSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.afterMonthlyData);
              afterCustomerDemand = afterSalesQuantity;
            }
          } else if (projectData?.purpose === PurposeType.UpdateAndOther.code) {
            // 更新投資: updateSummaryDataListから取得
            const updateSummary = updateSummaryDataList.find(
              s => s.productionLineId === process.uniqueProcessId
            );
            // 対象プロセスの売上数量を取得
            const salesQuantity = updateSummary?.indicatorItems?.find(
              i => i.itemType === "salesQuantity"
            );
            // 売上数量が取得できた場合はDecimal型配列に変換
            if (salesQuantity) {
              // 更新後の売上数量を顧客需要データに変換
              const afterSalesQuantity: Decimal[] = calcCustomerDemandDataForProcessSummary(labels, salesQuantity.afterMonthlyData);
              afterCustomerDemand = afterSalesQuantity;
            }
          }

        } else {
          // 詳細モードの場合は販売数量から顧客需要を取得（販売数量 × 1製品あたり必要部品数。ストレスONなら係数・期間短縮が適用済み）
          const customerDemand: Decimal[] = calcCustomerDemandDataForProcess(labels, configQuantityByPartNo, partsCount);
          // 更新/合理化後のみ使用
          afterCustomerDemand = customerDemand;
        }

        // 更新後の計算（シミュレーション設定のデータを使用。キャパにはストレス指数を掛けない）
        // 全期間: config.improvedAvailabilityRateByMonth, config.improvedYieldRateList, config.improvedCycleTimeList
        const numberOfUnitsProducedAfter = calcNumberOfUnitsProduced(
          labels,
          config.improvedWorkingDayByYear,
          config.improvedLineCountByYear,
          config.improvedHolidayByYear,
          config.improvedAvailabilityRateByMonth,
          (targetYearMonth: string) => getApplicableYieldRate(targetYearMonth, config.improvedYieldRateList, getYieldRateFromBom),
          (targetYearMonth: string) => getApplicableCycleTime(targetYearMonth, config.improvedCycleTimeList, getCycleTimeFromBom),
          projectData?.projectStartDate!
        );

        // 増加非稼働時間分の計算（更新投資・合理化の場合のみ、投資量産開始前のみ）
        let increasedNonWorkingTimeProduction: Decimal[] = [];
        if ((projectData?.purpose === PurposeType.UpdateAndOther.code ||
          projectData?.purpose === PurposeType.Rationalization.code) && pastAvailabilityRateByMonth.length > 0) {
          increasedNonWorkingTimeProduction = calcIncreasedNonWorkingTimeProduction(
            labels,
            config.improvedWorkingDayByYear,
            config.improvedLineCountByYear,
            config.improvedHolidayByYear,
            config.improvedAvailabilityRateByMonth,
            pastAvailabilityRateByMonth,
            (targetYearMonth: string) => getApplicableYieldRate(targetYearMonth, config.improvedYieldRateList, getYieldRateFromBom),
            (targetYearMonth: string) => getApplicableCycleTime(targetYearMonth, config.improvedCycleTimeList, getCycleTimeFromBom),
            investmentStartYearMonth,
          );
        }

        // 更新後チャートデータ（シミュレーション設定。ストレスONなら全系列を数量と同じ月数で短縮）
        const afterChartData = {
          labels,
          datasets: [
            {
              type: 'line' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'),
              data: afterCustomerDemand.slice(0, configLength),
              borderColor: 'rgb(75, 192, 75)',
              backgroundColor: 'rgba(75, 192, 75, 0.5)',
              borderWidth: 5,
              tension: 0.4,
              pointRadius: 0,
              pointStyle: 'rect',
              order: 2,
            },
            // 非稼働増加による能力押し下げ（更新投資の場合のみ）
            ...(increasedNonWorkingTimeProduction.length > 0 ? [{
              type: 'bar' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'),
              data: increasedNonWorkingTimeProduction.slice(0, configLength),
              backgroundColor: 'rgb(153, 102, 255)',
              stack: 'production',
              pointStyle: 'rect',
              order: 5,
            }] : []),
            {
              type: 'bar' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'),
              data: numberOfUnitsProducedAfter.holidays.slice(0, configLength),
              backgroundColor: 'rgb(255, 205, 86)',
              stack: 'production',
              pointStyle: 'rect',
              order: 4,
            },
            {
              type: 'bar' as const,
              label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'),
              data: numberOfUnitsProducedAfter.weekdays.slice(0, configLength),
              backgroundColor: 'rgb(201, 203, 207)',
              stack: 'production',
              pointStyle: 'rect',
              order: 3,
            },
          ],
        };

        return {
          processId: process.uniqueProcessId || "",
          processName: process.uniqueProcessName || "",
          afterData: afterChartData,
        };
      });

      return {
        configId,
        processData,
      };
    }).filter((item): item is NonNullable<typeof item> => item !== null);

    setProductionCapacityProcessChartDataForSavedConfig(savedConfigProcessData);
  }, [
    selectedConfigIds,
    savedConfigs,
    originalProfitAndLossByMonth,
    equipmentAmounts,
    processCodeData,
    updateSummaryDataList,
    rationalizationSummaryDataList,
    pastAvailabilityRateByMonth,
    projectData,
    investmentStartYearMonth,
    bomData,
    quantitiesChartDataForSavedConfig,
    isSimpleMode,
  ]);

  /**
   * 年月度別配列から年月を引数に値を取得する
   * @param dataByYear 
   * @param year 
   * @param month 
   * @param targetKey 
   * @returns 
   */
  const getMonthlyDataByYearAndMonth = (
    dataByYear: {
      fiscalYear: string,
      workingDay?: number[],
      holiday?: number[],
      availabilityRate?: number[],
      lineCount?: number[],
    }[],
    year: number,
    month: number,
    targetKey: "workingDay" | "holiday" | "availabilityRate" | "lineCount" // 限定されたキー
  ): number => {
    // 対象の年度（year+1 = 3月期の年）
    // 例: 2025年4月 → 2026年3月期（2025年4月〜2026年3月）
    const targetFiscalYear = `${year + 1}年3月期`;

    // 該当する fiscalYear を検索（会計年度文字列は表示言語で変わるため年数値で判定する）
    const data = dataByYear.find((item) => isSameFiscalYear(item.fiscalYear, targetFiscalYear));

    if (!data) {
      // 該当する fiscalYear が存在しない場合
      // console.error(`Fiscal Year ${targetFiscalYear} が見つかりません`);
      return 0;
    }

    // 対象データが存在しない場合
    const targetData = data[targetKey];
    if (!targetData) {
      // console.error(`キー "${targetKey}" に対応するデータが存在しません`);
      return 0;
    }

    // 月のインデックスを計算（1月は 0 インデックス）
    const monthIndex = month - 1;

    if (monthIndex < 0 || monthIndex >= 12) {
      // 無効な月のチェック
      // console.error(`月 "${month}" は無効な月です（1～12 の範囲で指定してください）`);
      return 0;
    }

    // 該当する targetKey のデータを返す
    const monthlyData = targetData[monthIndex];

    if (monthlyData === undefined) {
      // console.error(`月 "${month}" のデータが見つかりません`);
      return 0;
    }

    return monthlyData;
  };

  /**
 * 金型費または開発費の実績マージ
 * @param periodYears 終了年
 * @param periodMonths 終了月
 * @param increasedProductionStartMonth 増産開始月
 * @param moldOrOrDevelopmentSalesJson 金型費または開発費JSON
 * @param pastMoldOrOrDevelopmentSalesJson 金型費または開発費JSON（過去）
 * @returns 
 */
  const replaceMoldOrDevelopmentSales = (periodYears: number, periodMonths: number, increasedProductionStartMonth: number, moldOrOrDevelopmentSalesJson: string | null | undefined, pastMoldOrOrDevelopmentSalesJson: string | null | undefined) => {
    const moldOrDevelopmentSalesByProjectList: any[] = moldOrOrDevelopmentSalesJson ? JSON.parse(moldOrOrDevelopmentSalesJson) : undefined;
    const pastMoldOrDevelopmentSalesByProjectList: any[] = pastMoldOrOrDevelopmentSalesJson ? JSON.parse(pastMoldOrOrDevelopmentSalesJson) : undefined;

    if (pastMoldOrDevelopmentSalesByProjectList) {
      for (let i = 0; i < pastMoldOrDevelopmentSalesByProjectList.length; i++) {
        const moldOrDevelopmentSalesByPartNo = moldOrDevelopmentSalesByProjectList ? moldOrDevelopmentSalesByProjectList[i] : undefined;
        const pastMoldOrDevelopmentSalesByPartNo = pastMoldOrDevelopmentSalesByProjectList[i];

        if (!moldOrDevelopmentSalesByPartNo) {
          // 実績なし
          continue;
        }

        for (let years of pastMoldOrDevelopmentSalesByPartNo.years) {
          if (years < periodYears) {
            // 実績コピー(年単位)
            pastMoldOrDevelopmentSalesByPartNo.data[years] = moldOrDevelopmentSalesByPartNo.data[years];
          } else if (years === periodYears && increasedProductionStartMonth !== 4) {
            for (const [months, data] of Object.entries(pastMoldOrDevelopmentSalesByPartNo.data[years].months)) {
              if (Object(data).month > periodMonths) {
                break;
              }
              // 実績コピー(月単位)
              pastMoldOrDevelopmentSalesByPartNo.data[years].months[Number(months)] =
                moldOrDevelopmentSalesByPartNo.data[years].months[Number(months)];
            }
          }
        }
      }

      return JSON.stringify(pastMoldOrDevelopmentSalesByProjectList);
    }

    return null;
  }

  /**
   * ストレス指数（グラフ用）を更新
   * 注：downsideIndexまたはdownsideIndexEnableが更新されたとき（onChange/onBlur時を含む）に実行
   */
  useEffect(() => {
    // 初期化が完了していない場合は処理を抜ける
    if (!downsideIndex ||
      (Array.isArray(downsideIndex.quantityChangeOverTime) &&
        downsideIndex.quantityChangeOverTime.length === 0 &&
        Array.isArray(downsideIndex.quantityFluctuation) &&
        downsideIndex.quantityFluctuation.length === 0)) {
      return;
    }

    // ストレス指数（グラフ用）を更新
    setDownsideIndexGraph({
      // 数量経時変化
      quantityChangeOverTime: downsideIndexEnable.isEnabledQuantityChangeOverTime ? [...downsideIndex.quantityChangeOverTime] : [],
      // 数量上下変動
      quantityFluctuation: downsideIndexEnable.isEnabledFluctuationInQuantity ? [...downsideIndex.quantityFluctuation] : [],
      // 単価経時変化
      priceChangeOverTime: downsideIndexEnable.isEnabledPriceChangeOverTime ? [...downsideIndex.priceChangeOverTime] : [],
      // 顧客製品寿命（正の値は無視し、負の値のみ有効）
      customerProductLifecycle: downsideIndexEnable.isEnabledCustomerProductLifecycle && downsideIndex.customerProductLifecycle < 0
        ? downsideIndex.customerProductLifecycle
        : 0,
      // 為替変動（単価）
      exchangeRateFluctuationToPrice: downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? [...downsideIndex.exchangeRateFluctuationToPrice] : [],
      // 為替変動（原価）
      exchangeRateFluctuationToCost: downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? [...downsideIndex.exchangeRateFluctuationToCost] : [],
      // 材料高騰
      materialCostIncrease: downsideIndexEnable.isEnabledRisingMaterialCosts ? [...downsideIndex.materialCostIncrease] : [],
      // 労務費高騰
      laborCostIncrease: downsideIndexEnable.isEnabledRisingLaborCosts ? [...downsideIndex.laborCostIncrease] : [],
      // 競合状態（数量）
      competitorStatusToQuantity: downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? [...downsideIndex.competitorStatusToQuantity] : [],
      // 競合状態（単価）
      competitorStatusToPrice: downsideIndexEnable.isEnabledCompetitorConditionToPrice ? [...downsideIndex.competitorStatusToPrice] : [],
    });
  }, [downsideIndex, downsideIndexEnable]);

  // ❸ (任意) レンダリング部に「combinedChartDataModified」があればグラフを表示
  combinedChartDataModified && (
    <Box mt={4}>
      <Heading size="md" mb={2}>
        回収チャート (Modified)
      </Heading>
      <Chart
        type="bar"
        data={combinedChartDataModified}
        options={{
          plugins: {
            tooltip: { enabled: true },
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        }}
      />
    </Box>
  )

  /**
   * スケール算出
   * @param data1 当初計画データ
   * @param data2 ダウンサイドデータ
   * @param isMinZero true：最小値を0とする。false：data1とdata2の最小値
   * @returns
   */
  const computeCommonScale = (data1: any, data2: any, isMinZero: boolean) => {
    const allData = [
      ...data1.datasets.flatMap((ds: any) => ds.data.filter((v: any) => v !== null)),
      ...data2.datasets.flatMap((ds: any) => ds.data.filter((v: any) => v !== null))
    ];
    const commonLabels = data1.labels.length >= data2.labels.length ? data1.labels : data2.labels;
    const { yMin, yMax } = calcYAxisRange(allData, isMinZero);
    return { yMin, yMax, commonLabels };
  };

  /**
   * タイプがlineのものを表示する。
   * @param chart チャート
   * @returns ラベル
   */
  const generateLabels = (chart: any): LegendItem[] => {
    return chart.data.datasets.filter((dataset: any) => dataset.type === "line").map((dataset: any, index: number) => {
      return {
        text: dataset.label,
        fillStyle: dataset.backgroundColor,
        strokeStyle: dataset.borderColor,
        hidden: !chart.isDatasetVisible(index),
        datasetIndex: index,
      }
    });
  }

  /**
   * ストレス指数の初期化（新規）
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexDisplayNew = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): string => {

      // 関数宣言
      function formatStressIndex(index: number): string {
        return index > 0 ? `+${index}` : `${index}`;
      }

      // 変数宣言
      let downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.none');

      // itemIdが無効の場合は処理を抜ける
      if (!itemId) return downsideIndexString;

      // ストレス指数を取得
      const stressIndex = mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0)[0];               // ストレス指数を返却

      // ストレス指数（画面表示用）を取得
      if (
        itemId === DownsideItems.quantityChangeOverTime.downsideId ||
        itemId === DownsideItems.customerProductLifecycle.downsideId
      ) {
        // 数量経時変化
        // 顧客製品寿命
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex(stressIndex) });
      } else if (
        itemId === DownsideItems.priceChangeOverTime.downsideId ||
        itemId === DownsideItems.materialCostIncrease.downsideId ||
        itemId === DownsideItems.laborCostIncrease.downsideId
      ) {
        // 単価経時変化
        // 材料高騰
        // 労務費高騰
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex(stressIndex) });
      } else if (
        itemId === DownsideItems.competitorStatus1stToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatus1stToPrice.downsideId ||
        itemId === DownsideItems.competitorStatus2ndToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatus2ndToQuantity.downsideId
      ) {
        // 競合状態（数量）（1番手）
        // 競合状態（単価）（1番手）
        // 競合状態（数量）（2番手）
        // 競合状態（単価）（2番手）
        downsideIndexString = `${competitor?.competitiorCondition === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name : competitiorCondition.LowerRank.name}${formatStressIndex(stressIndex)}%`;
      } else if (
        itemId === DownsideItems.competitorStatusNoToQuantity.downsideId ||
        itemId === DownsideItems.competitorStatusNoToToPrice.downsideId
      ) {
        // 競合状態（数量）（競合なし）
        // 競合状態（単価）（競合なし）
        downsideIndexString = `${competitorType.NoCompetitor.name}${formatStressIndex(stressIndex)}%`;
      } else {
        // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
        // 為替変動（単価） TODO 保留
        // 為替変動（原価） TODO 保留
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.none');
      }

      // ストレス指数を返却
      return downsideIndexString;

    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTimeString", id: DownsideItems.quantityChangeOverTime.downsideId },                         // 数量経時変化
      { key: "fluctuationInQuantityString", id: DownsideItems.quantityFluctuation.downsideId },                             // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTimeString", id: DownsideItems.priceChangeOverTime.downsideId },                               // 単価経時変化
      { key: "customerProductLifecycleString", id: DownsideItems.customerProductLifecycle.downsideId },                     // 顧客製品寿命
      { key: "currencyFluctuationString", id: DownsideItems.exchangeRateFluctuationToPrice.downsideId },                    // 為替変動（単価） TODO 保留
      { key: "", id: DownsideItems.exchangeRateFluctuationToCost.downsideId },                                              // 為替変動（原価） TODO 保留
      { key: "risingMaterialCostsString", id: DownsideItems.materialCostIncrease.downsideId },                              // 材料高騰
      { key: "risingLaborCostsString", id: DownsideItems.laborCostIncrease.downsideId },                                    // 労務費高騰
      { key: "competitorConditionString", id: competitorStatusToQuantityDownsideId || competitorType.NoCompetitor.value },  // 競合状態（数量）
      { key: "", id: competitorStatusToPriceDownsideId || competitorType.NoCompetitor.value },                              // 競合状態（単価）
    ];

    // ストレス指数（画面表示用）の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndexDisplay(key, processedData);
    });

  }

  /**
   * ストレス指数の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex T_CEAS_PROJECT ダウンサイド指数(downsideIndex)データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexDisplay = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): string => {

      // 関数宣言
      function formatStressIndex(index: number): string {
        return index > 0 ? `+${index}` : `${index}`;
      }

      // 変数宣言
      let downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.none');

      // itemIdが無効の場合は処理を抜ける
      if (!itemId) return downsideIndexString;

      // ストレス指数を取得
      const stressIndex = mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0)[0];               // ストレス指数を返却

      // ストレス指数（画面表示用）を取得
      if (
        itemId === DownsideItems.quantityChangeOverTime.id ||
        itemId === DownsideItems.customerProductLifecycle.id
      ) {
        // 数量経時変化
        // 顧客製品寿命
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex(stressIndex) });
      } else if (
        itemId === DownsideItems.priceChangeOverTime.id ||
        itemId === DownsideItems.materialCostIncrease.id ||
        itemId === DownsideItems.laborCostIncrease.id
      ) {
        // 単価経時変化
        // 材料高騰
        // 労務費高騰
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex(stressIndex) });
      } else if (
        itemId === competitorStatusToQuantityId ||
        itemId === competitorStatusToPriceId
      ) {
        // 競合状態（数量）
        // 競合状態（単価）
        if (competitor?.competitorType === competitorType.Competitor.value) {
          // 競合ありの場合
          downsideIndexString = `${competitor?.competitiorCondition}${formatStressIndex(stressIndex)}%`;
        } else {
          // 競合なしの場合
          downsideIndexString = `${competitorType.NoCompetitor.value}${formatStressIndex(stressIndex)}%`;
        }
      } else {
        // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
        // 為替変動（単価） TODO 保留
        // 為替変動（原価） TODO 保留
        downsideIndexString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.none');
      }

      // ストレス指数を返却
      return downsideIndexString;

    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTimeString", id: DownsideItems.quantityChangeOverTime.id },                         // 数量経時変化
      { key: "fluctuationInQuantityString", id: DownsideItems.quantityFluctuation.id },                             // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTimeString", id: DownsideItems.priceChangeOverTime.id },                               // 単価経時変化
      { key: "customerProductLifecycleString", id: DownsideItems.customerProductLifecycle.id },                     // 顧客製品寿命
      { key: "currencyFluctuationString", id: DownsideItems.exchangeRateFluctuationToPrice.id },                    // 為替変動（単価） TODO 保留
      { key: "", id: DownsideItems.exchangeRateFluctuationToCost.id },                                              // 為替変動（原価） TODO 保留
      { key: "risingMaterialCostsString", id: DownsideItems.materialCostIncrease.id },                              // 材料高騰
      { key: "risingLaborCostsString", id: DownsideItems.laborCostIncrease.id },                                    // 労務費高騰
      { key: "competitorConditionString", id: competitorStatusToQuantityId || competitorType.NoCompetitor.value },  // 競合状態（数量）
      { key: "", id: competitorStatusToPriceId || competitorType.NoCompetitor.value },                              // 競合状態（単価）
    ];

    // ストレス指数（画面表示用）の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndexDisplay(key, processedData);
    });

  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数（画面表示用）
   * @returns {void} なし
   */
  const updateDownsideIndexDisplay = (
    itemName: string,
    downsideIndex: string,
  ): void => {

    // ストレス指数（画面表示用）を更新
    setDownsideIndexDisplay((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /**
   * ストレス指数(表)の初期化（新規）
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @param {string[]} labels グラフ用ラベル
   * @returns {void} なし
   */
  const setInitialDownsideIndexTableDisplayNew = (
    mDownsideIndex: DownsideIndexType[],
    agreement: PricingAgreementFormType,
    labels: string[]
  ): void => {

    // ストレス指数データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    const competitor = agreement?.competitor;
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    const yearList =
      Array.from(new Set(labels.map((s) => s.split("/")[0])))
        .sort((a, b) => Number(a) - Number(b));

    // mDownsideIndexを年ごとにグルーピング
    type DownsideIndexList = {
      [key: string]: Record<string, DownsideIndexType>
    };
    let downsideIndexList: DownsideIndexList = {};
    for (let i = 0; i < mDownsideIndex.length; i++) {
      const yearIndex = mDownsideIndex[i].yearIndex;
      if (yearIndex === undefined || yearIndex === 0 || yearIndex > yearList.length) continue;
      const year = yearList[yearIndex - 1];
      if (!downsideIndexList.hasOwnProperty(year)) {
        downsideIndexList[year] = {};
      }
      const itemId = mDownsideIndex[i].itemId;
      if (itemId === undefined) continue;
      downsideIndexList[year][itemId] = mDownsideIndex[i];
    }

    function formatStressIndex(index: number): string {
      return index > 0 ? `+${index}` : `${index}`;
    }

    // ストレス指数(表)のデータを作成
    let rows: DownsideIndexTableRowDisplay[] = [];
    yearList.forEach((year, index) => {
      let row: DownsideIndexTableRowDisplay = {
        /** 年 */
        yearString: year,
        yearIndex: index,

        /** 数量経時変化 */
        quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        quantityChangeOverTimeId: DownsideItems.quantityChangeOverTime.id,
        quantityChangeOverTime: 0,

        /** 数量上下変動 */
        fluctuationInQuantityString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        fluctuationInQuantityId: DownsideItems.quantityFluctuation.id,
        fluctuationInQuantity: 0,

        /** 単価経時変化 */
        priceChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        priceChangeOverTimeId: DownsideItems.priceChangeOverTime.id,
        priceChangeOverTime: 0,

        /** 顧客製品寿命 */
        customerProductLifecycleString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        customerProductLifecycleId: DownsideItems.customerProductLifecycle.id,
        customerProductLifecycle: 0,

        /** 為替変動（単価） */
        currencyFluctuationToPriceString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        currencyFluctuationToPriceId: DownsideItems.exchangeRateFluctuationToPrice.id,
        currencyFluctuationToPrice: 0,

        /** 為替変動（原価） */
        currencyFluctuationToCostString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        currencyFluctuationToCostId: DownsideItems.exchangeRateFluctuationToCost.id,
        currencyFluctuationToCost: 0,

        /** 材料高騰 */
        risingMaterialCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        risingMaterialCostsId: DownsideItems.materialCostIncrease.id,
        risingMaterialCosts: 0,

        /** 労務費高騰 */
        risingLaborCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        risingLaborCostsId: DownsideItems.laborCostIncrease.id,
        risingLaborCosts: 0,

        /** 競合状態（数量） */
        competitorConditionToQuantityString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor'),
        competitorConditionToQuantityStringPre: (!competitor || competitor?.competitiorCondition === null) ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor') : competitor?.competitiorCondition,
        competitorConditionToQuantityId: DownsideItems.competitorStatusNoToQuantity.id,
        competitorConditionToQuantity: 0,

        /** 競合状態（単価） */
        competitorConditionToPriceString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor'),
        competitorConditionToPriceStringPre: (!competitor || competitor?.competitiorCondition === null) ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor') : competitor?.competitiorCondition,
        competitorConditionToPriceId: DownsideItems.competitorStatusNoToToPrice.id,
        competitorConditionToPrice: 0,
      };

      let downsideIndex: DownsideIndexType = downsideIndexList[year];
      if (downsideIndex === undefined) downsideIndex = {};
      Object.keys(downsideIndex).forEach((key) => {
        const value = downsideIndex[key as keyof DownsideIndexType];
        if (value === undefined) return;
        if (!(typeof value === "object" && "stressIndex" in value)) return;
        switch (key) {
          // 数量経時変化
          case DownsideItems.quantityChangeOverTime.downsideId:
            row.quantityChangeOverTimeString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.quantityChangeOverTimeId = DownsideItems.quantityChangeOverTime.id;
            row.quantityChangeOverTime = (value as any).stressIndex;
            break;

          // 数量上下変動
          case DownsideItems.quantityFluctuation.downsideId:
            row.fluctuationInQuantityString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.fluctuationInQuantityId = DownsideItems.quantityFluctuation.id;
            row.fluctuationInQuantity = (value as any).stressIndex;
            break;

          // 単価経時変化
          case DownsideItems.priceChangeOverTime.downsideId:
            row.priceChangeOverTimeString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.priceChangeOverTimeId = DownsideItems.priceChangeOverTime.id;
            row.priceChangeOverTime = (value as any).stressIndex;
            break;

          // 顧客製品寿命
          case DownsideItems.customerProductLifecycle.downsideId:
            row.customerProductLifecycleString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.customerProductLifecycleId = DownsideItems.customerProductLifecycle.id;
            row.customerProductLifecycle = (value as any).stressIndex;
            break;

          // 為替変動（単価）
          case DownsideItems.exchangeRateFluctuationToPrice.downsideId:
            row.currencyFluctuationToPriceString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.currencyFluctuationToPriceId = DownsideItems.exchangeRateFluctuationToPrice.id;
            row.currencyFluctuationToPrice = (value as any).stressIndex;
            break;

          // 為替変動（原価）
          case DownsideItems.exchangeRateFluctuationToCost.downsideId:
            row.currencyFluctuationToCostString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.currencyFluctuationToCostId = DownsideItems.exchangeRateFluctuationToCost.id;
            row.currencyFluctuationToCost = (value as any).stressIndex;
            break;

          // 材料高騰
          case DownsideItems.materialCostIncrease.downsideId:
            row.risingMaterialCostsString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.risingMaterialCostsId = DownsideItems.materialCostIncrease.id;
            row.risingMaterialCosts = (value as any).stressIndex;
            break;

          // 労務費高騰
          case DownsideItems.laborCostIncrease.downsideId:
            row.risingLaborCostsString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.risingLaborCostsId = DownsideItems.laborCostIncrease.id;
            row.risingLaborCosts = (value as any).stressIndex;
            break;

          // 競合状態（数量）
          case competitorStatusToQuantityDownsideId:
            row.competitorConditionToQuantityString = `${competitor?.competitiorCondition}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToQuantityStringPre = `${competitor?.competitiorCondition}`;
            // IDはdownsideIdでなく項目IDを設定
            row.competitorConditionToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
            row.competitorConditionToQuantity = (value as any).stressIndex;

            if (competitor?.competitorType !== competitorType.Competitor.value) {
              // 競合なしの場合（未入力を含む）
              row.competitorConditionToQuantityString = `${competitorType.NoCompetitor.value}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToQuantityStringPre = `${competitorType.NoCompetitor.value}`;
            }
            break;

          // 競合状態（単価）
          case competitorStatusToPriceDownsideId:
            row.competitorConditionToPriceString = `${competitor?.competitiorCondition}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToPriceStringPre = `${competitor?.competitiorCondition}`;
            // IDはdownsideIdでなく項目IDを設定
            row.competitorConditionToPriceId = DownsideItems.competitorStatus1stToPrice.id;
            row.competitorConditionToPrice = (value as any).stressIndex;

            if (competitor?.competitorType !== competitorType.Competitor.value) {
              // 競合なしの場合（未入力を含む）
              row.competitorConditionToPriceString = `${competitorType.NoCompetitor.value}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToPriceStringPre = `${competitorType.NoCompetitor.value}`;
            }
            break;
        }
      });
      rows.push(row);
    });

    updateDownsideIndexTableDisplay(rows);

    // リセット用にコピーを保持
    setDownsideIndexTableDisplayForReset(JSON.parse(JSON.stringify(rows)) as DownsideIndexTableRowDisplay[]);
  }

  /**
   * ストレス指数(表)の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex T_CEAS_PROJECT ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @param {string[]} labels グラフ用ラベル
   * @returns {void} なし
   */
  const setInitialDownsideIndexTableDisplay = (
    mDownsideIndex: DownsideIndexType[],
    agreement: PricingAgreementFormType,
    labels: string[]
  ): void => {

    // ストレス指数データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    const yearList =
      Array.from(new Set(labels.map((s) => s.split("/")[0])))
        .sort((a, b) => Number(a) - Number(b));

    // mDownsideIndexを年ごとにグルーピング
    type DownsideIndexList = {
      [key: string]: Record<string, DownsideIndexType>
    };
    let downsideIndexList: DownsideIndexList = {};
    for (let i = 0; i < mDownsideIndex.length; i++) {
      const yearIndex = mDownsideIndex[i].yearIndex;
      if (yearIndex === undefined || yearIndex === 0 || yearIndex > yearList.length) continue;
      const year = yearList[yearIndex - 1];
      if (!downsideIndexList.hasOwnProperty(year)) {
        downsideIndexList[year] = {};
      }
      const itemId = mDownsideIndex[i].itemId;
      if (itemId === undefined) continue;
      downsideIndexList[year][itemId] = mDownsideIndex[i];
    }

    function formatStressIndex(index: number): string {
      return index > 0 ? `+${index}` : `${index}`;
    }

    // ストレス指数(表)のデータを作成
    let rows: DownsideIndexTableRowDisplay[] = [];
    yearList.forEach((year, index) => {
      let row: DownsideIndexTableRowDisplay = {
        /** 年 */
        yearString: year,
        yearIndex: index,

        /** 数量経時変化 */
        quantityChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        quantityChangeOverTimeId: DownsideItems.quantityChangeOverTime.id,
        quantityChangeOverTime: 0,

        /** 数量上下変動 */
        fluctuationInQuantityString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        fluctuationInQuantityId: DownsideItems.quantityFluctuation.id,
        fluctuationInQuantity: 0,

        /** 単価経時変化 */
        priceChangeOverTimeString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        priceChangeOverTimeId: DownsideItems.priceChangeOverTime.id,
        priceChangeOverTime: 0,

        /** 顧客製品寿命 */
        customerProductLifecycleString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        customerProductLifecycleId: DownsideItems.customerProductLifecycle.id,
        customerProductLifecycle: 0,

        /** 為替変動（単価） */
        currencyFluctuationToPriceString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        currencyFluctuationToPriceId: DownsideItems.exchangeRateFluctuationToPrice.id,
        currencyFluctuationToPrice: 0,

        /** 為替変動（原価） */
        currencyFluctuationToCostString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        currencyFluctuationToCostId: DownsideItems.exchangeRateFluctuationToCost.id,
        currencyFluctuationToCost: 0,

        /** 材料高騰 */
        risingMaterialCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        risingMaterialCostsId: DownsideItems.materialCostIncrease.id,
        risingMaterialCosts: 0,

        /** 労務費高騰 */
        risingLaborCostsString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.none'),
        risingLaborCostsId: DownsideItems.laborCostIncrease.id,
        risingLaborCosts: 0,

        /** 競合状態（数量） */
        competitorConditionToQuantityString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor'),
        competitorConditionToQuantityStringPre: (!competitor || competitor?.competitiorCondition === null) ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor') : competitor?.competitiorCondition,
        competitorConditionToQuantityId: DownsideItems.competitorStatusNoToQuantity.id,
        competitorConditionToQuantity: 0,

        /** 競合状態（単価） */
        competitorConditionToPriceString: t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor'),
        competitorConditionToPriceStringPre: (!competitor || competitor?.competitiorCondition === null) ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.noCompetitor') : competitor?.competitiorCondition,
        competitorConditionToPriceId: DownsideItems.competitorStatusNoToToPrice.id,
        competitorConditionToPrice: 0,
      };

      let downsideIndex: DownsideIndexType = downsideIndexList[year];
      if (downsideIndex === undefined) downsideIndex = {};
      Object.keys(downsideIndex).forEach((key) => {
        const value = downsideIndex[key as keyof DownsideIndexType];
        if (value === undefined) return;
        if (!(typeof value === "object" && "stressIndex" in value)) return;
        switch (key) {
          // 数量経時変化
          case DownsideItems.quantityChangeOverTime.id:
            row.quantityChangeOverTimeString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.quantityChangeOverTimeId = (value as any).itemId;
            row.quantityChangeOverTime = (value as any).stressIndex;
            break;

          // 数量上下変動
          case DownsideItems.quantityFluctuation.id:
            row.fluctuationInQuantityString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.fluctuationInQuantityId = (value as any).itemId;
            row.fluctuationInQuantity = (value as any).stressIndex;
            break;

          // 単価経時変化
          case DownsideItems.priceChangeOverTime.id:
            row.priceChangeOverTimeString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.priceChangeOverTimeId = (value as any).itemId;
            row.priceChangeOverTime = (value as any).stressIndex;
            break;

          // 顧客製品寿命
          case DownsideItems.customerProductLifecycle.id:
            row.customerProductLifecycleString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.customerProductLifecycleId = (value as any).itemId;
            row.customerProductLifecycle = (value as any).stressIndex;
            break;

          // 為替変動（単価）
          case DownsideItems.exchangeRateFluctuationToPrice.id:
            row.currencyFluctuationToPriceString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.currencyFluctuationToPriceId = (value as any).itemId;
            row.currencyFluctuationToPrice = (value as any).stressIndex;
            break;

          // 為替変動（原価）
          case DownsideItems.exchangeRateFluctuationToCost.id:
            row.currencyFluctuationToCostString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.originalPlanComparison', { value: formatStressIndex((value as any).stressIndex) });
            row.currencyFluctuationToCostId = (value as any).itemId;
            row.currencyFluctuationToCost = (value as any).stressIndex;
            break;

          // 材料高騰
          case DownsideItems.materialCostIncrease.id:
            row.risingMaterialCostsString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.risingMaterialCostsId = (value as any).itemId;
            row.risingMaterialCosts = (value as any).stressIndex;
            break;

          // 労務費高騰
          case DownsideItems.laborCostIncrease.id:
            row.risingLaborCostsString = t('features.InvestmentScreening.SimulationProductivityImprovement.label.annualRate', { value: formatStressIndex((value as any).stressIndex) });
            row.risingLaborCostsId = (value as any).itemId;
            row.risingLaborCosts = (value as any).stressIndex;
            break;

          // 競合状態（数量）
          case competitorStatusToQuantityId:
            row.competitorConditionToQuantityString = `${competitor?.competitiorCondition}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToQuantityStringPre = `${competitor?.competitiorCondition}`;
            row.competitorConditionToQuantityId = (value as any).itemId;
            row.competitorConditionToQuantity = (value as any).stressIndex;

            if (competitor?.competitorType !== competitorType.Competitor.value) {
              // 競合なしの場合（未入力を含む）
              row.competitorConditionToQuantityString = `${competitorType.NoCompetitor.value}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToQuantityStringPre = `${competitorType.NoCompetitor.value}`;
            }
            break;

          // 競合状態（単価）
          case competitorStatusToPriceId:
            row.competitorConditionToPriceString = `${competitor?.competitiorCondition}${formatStressIndex((value as any).stressIndex)}%`;
            row.competitorConditionToPriceStringPre = `${competitor?.competitiorCondition}`;
            row.competitorConditionToPriceId = (value as any).itemId;
            row.competitorConditionToPrice = (value as any).stressIndex;

            if (competitor?.competitorType !== competitorType.Competitor.value) {
              // 競合なしの場合（未入力を含む）
              row.competitorConditionToPriceString = `${competitorType.NoCompetitor.value}${formatStressIndex((value as any).stressIndex)}%`;
              row.competitorConditionToPriceStringPre = `${competitorType.NoCompetitor.value}`;
            }
            break;
        }
      });
      rows.push(row);
    });

    updateDownsideIndexTableDisplay(rows);

    // リセット用にコピーを保持
    setDownsideIndexTableDisplayForReset(JSON.parse(JSON.stringify(rows)) as DownsideIndexTableRowDisplay[]);

  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {DownsideIndexTableRowDisplay[]} rows ストレス指数（表）
   * @returns {void} なし
   */
  const updateDownsideIndexTableDisplay = (
    rows: DownsideIndexTableRowDisplay[]
  ): void => {

    // ストレス指数(表)（画面表示用）を更新
    setDownsideIndexTableDisplay(rows);
  }

  /**
   * ストレス指数（画面表示用）の更新
   * 
   * @param {string} year 年
   * @param {string} name プロパティ名
   * @param {number} value ストレス指数
   * @returns {void} なし
   */
  const updateDownsideIndexTableValue = <K extends keyof DownsideIndexTableRowDisplay>(
    year: string,
    name: K,
    value: DownsideIndexTableRowDisplay[K],
    // true(既定): 親state(downsideIndex)へも反映しグラフ再計算のカスケードを起こす。
    // false: 表示用テーブルのみ更新（入力中の1文字ごとの重い再計算を避けるため、onChangeではfalseを渡す）。
    commit: boolean = true
  ): void => {

    // 年を取得
    const index = downsideIndexTableDisplay.findIndex(row => row.yearString === year);
    if (index < 0) return;

    // 該当する年のストレス指数を取得
    const row = { ...downsideIndexTableDisplay[index] };
    // 項目の値を更新
    row[name] = value;
    setDownsideIndexTableDisplay(prevState => prevState.map((item, i) => i === index ? row : item));

    if (!commit) return;

    const keyMap = {

      /** 数量経時変化 */
      quantityChangeOverTime: "quantityChangeOverTime",

      /** 数量上下変動 */
      fluctuationInQuantity: "quantityFluctuation",

      /** 単価経時変化 */
      priceChangeOverTime: "priceChangeOverTime",

      /** 顧客製品寿命 */
      customerProductLifecycle: "customerProductLifecycle",

      /** 為替変動（単価） */
      currencyFluctuationToPrice: "exchangeRateFluctuationToPrice",

      /** 為替変動（原価） */
      currencyFluctuationToCost: "exchangeRateFluctuationToCost",

      /** 材料高騰 */
      risingMaterialCosts: "materialCostIncrease",

      /** 労務費高騰 */
      risingLaborCosts: "laborCostIncrease",

      /** 競合状態（数量） */
      competitorConditionToQuantity: "competitorStatusToQuantity",

      /** 競合状態（単価） */
      competitorConditionToPrice: "competitorStatusToPrice"
    };
    const itemName = keyMap[name as keyof typeof keyMap];

    // 顧客製品寿命
    if (name === "customerProductLifecycle") {
      // 大きいマイナス値を手入力された際のエラー回避用処理
      if (Number(value) < DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN) return;

      // 値が変わっていなければ親stateへのコミット（重い再計算カスケード）をスキップ
      if (Number(downsideIndex.customerProductLifecycle) === Number(value)) return;

      updateDownsideIndex(itemName, Number(value));
      return;
    }

    // 顧客製品寿命以外
    let processedData: number[] = [];
    for (let i = 0; i < downsideIndexTableDisplay.length; i++) {
      const item = downsideIndexTableDisplay[i];
      processedData.push(i === index ? Number(value) : Number(item[name]));
    }

    // 値が変わっていなければ親stateへのコミット（重い再計算カスケード）をスキップ
    const currentArray = (downsideIndex as any)[itemName] as number[] | undefined;
    const isUnchanged = !!currentArray
      && currentArray.length === processedData.length
      && currentArray.every((v, i) => Number(v) === processedData[i]);
    if (isUnchanged) return;

    updateDownsideIndex(itemName, processedData);
  }

  /**
   * ストレス指数の初期化
   * M_CEAS_DOWNSIDE_INDEXのitemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndexNew = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityDownsideId = "";
    let competitorStatusToPriceDownsideId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus1stToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus1stToPrice.downsideId;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityDownsideId = DownsideItems.competitorStatus2ndToQuantity.downsideId;
          competitorStatusToPriceDownsideId = DownsideItems.competitorStatus2ndToPrice.downsideId;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityDownsideId = DownsideItems.competitorStatusNoToQuantity.downsideId;
      competitorStatusToPriceDownsideId = DownsideItems.competitorStatusNoToToPrice.downsideId;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): number[] => {
      if (!itemId) return []; // itemIdが無効の場合は処理を抜ける
      return mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0);                  // ストレス指数を返却
    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTime", id: DownsideItems.quantityChangeOverTime.downsideId },                 // 数量経時変化
      { key: "quantityFluctuation", id: DownsideItems.quantityFluctuation.downsideId },                       // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTime", id: DownsideItems.priceChangeOverTime.downsideId },                       // 単価経時変化
      { key: "customerProductLifecycle", id: DownsideItems.customerProductLifecycle.downsideId },             // 顧客製品寿命
      { key: "exchangeRateFluctuationToPrice", id: DownsideItems.exchangeRateFluctuationToPrice.downsideId }, // 為替変動（単価） TODO 保留
      { key: "exchangeRateFluctuationToCost", id: DownsideItems.exchangeRateFluctuationToCost.downsideId },   // 為替変動（原価） TODO 保留
      { key: "materialCostIncrease", id: DownsideItems.materialCostIncrease.downsideId },                     // 材料高騰
      { key: "laborCostIncrease", id: DownsideItems.laborCostIncrease.downsideId },                           // 労務費高騰
      { key: "competitorStatusToQuantity", id: competitorStatusToQuantityDownsideId || "" },                  // 競合状態（数量）
      { key: "competitorStatusToPrice", id: competitorStatusToPriceDownsideId || "" },                        // 競合状態（単価）
    ];

    // ストレス指数の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndex(key, processedData);

      // リセット用にコピーを保持
      updateDownsideIndexForReset(key, JSON.parse(JSON.stringify(processedData)));

    });

  }

  /**
   * ストレス指数の初期化（更新）
   * T_CEAS_PROJECTから取得したダウンサイド指数(downsideIndex)の
   * itemIdに紐づくストレス指数値(stressIndex)を設定する
   * 
   * @param {DownsideIndexType[]} mDownsideIndex M_CEAS_DOWNSIDE_INDEX ストレス指数データ
   * @param {PricingAgreementFormType} agreement T_CEAS_PROJECT 顧客取り決め事項
   * @returns {void} なし
   */
  const setInitialDownsideIndex = (mDownsideIndex: DownsideIndexType[], agreement: PricingAgreementFormType): void => {

    // M_CEAS_DOWNSIDE_INDEX データが空の場合は処理を抜ける
    if (!mDownsideIndex || mDownsideIndex.length === 0) {
      return;
    }

    // 競合状態の判定
    let competitorStatusToQuantityId = "";
    let competitorStatusToPriceId = "";
    const competitor = agreement?.competitor;
    if (competitor?.competitorType === competitorType.Competitor.value) {
      // 競合ありの場合
      switch (competitor?.competitiorCondition) {
        case competitiorCondition.TopRank.value:
          // 競合1番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus1stToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus1stToPrice.id;
          break;
        case competitiorCondition.LowerRank.value:
          // 競合2番手の場合
          competitorStatusToQuantityId = DownsideItems.competitorStatus2ndToQuantity.id;
          competitorStatusToPriceId = DownsideItems.competitorStatus2ndToPrice.id;
          break;
      }
    } else {
      // 競合なしの場合
      competitorStatusToQuantityId = DownsideItems.competitorStatusNoToQuantity.id;
      competitorStatusToPriceId = DownsideItems.competitorStatusNoToToPrice.id;
    }

    // 関数宣言
    const processDownsideIndex = (
      mDownsideIndex: DownsideIndexType[],
      itemId: string
    ): number[] => {
      if (!itemId) return []; // itemIdが無効の場合は処理を抜ける
      return mDownsideIndex
        .filter(record => record.itemId === itemId)               // 項目IDが一致
        .sort((a, b) => (a.yearIndex || 0) - (b.yearIndex || 0))  // 年数昇順で並び替え
        .map(record => record.stressIndex ?? 0);                  // ストレス指数を返却
    };

    // 変数宣言
    const itemsToProcess = [
      { key: "quantityChangeOverTime", id: DownsideItems.quantityChangeOverTime.id },                 // 数量経時変化
      { key: "quantityFluctuation", id: DownsideItems.quantityFluctuation.id },                       // 数量上下変動 TODO 2025/8/4の週に菅原様から情報提供あり
      { key: "priceChangeOverTime", id: DownsideItems.priceChangeOverTime.id },                       // 単価経時変化
      { key: "customerProductLifecycle", id: DownsideItems.customerProductLifecycle.id },             // 顧客製品寿命
      { key: "exchangeRateFluctuationToPrice", id: DownsideItems.exchangeRateFluctuationToPrice.id }, // 為替変動（単価） TODO 保留
      { key: "exchangeRateFluctuationToCost", id: DownsideItems.exchangeRateFluctuationToCost.id },   // 為替変動（原価） TODO 保留
      { key: "materialCostIncrease", id: DownsideItems.materialCostIncrease.id },                     // 材料高騰
      { key: "laborCostIncrease", id: DownsideItems.laborCostIncrease.id },                           // 労務費高騰
      { key: "competitorStatusToQuantity", id: competitorStatusToQuantityId || "" },                  // 競合状態（数量）
      { key: "competitorStatusToPrice", id: competitorStatusToPriceId || "" },                        // 競合状態（単価）
    ];

    // ストレス指数の初期化
    itemsToProcess.forEach(({ key, id }) => {
      const processedData = processDownsideIndex(mDownsideIndex, id);
      updateDownsideIndex(key, processedData);

      // リセット用にコピーを保持
      updateDownsideIndexForReset(key, JSON.parse(JSON.stringify(processedData)));

    });

  }

  /**
   * ストレス指数（有効・無効）更新
   * 
   * @param {enableDownsideIndexType[]} enDwnidx ストレス指数（有効・無効）情報
   * @returns {void} なし
   */
  const updateEnabledDownsideIndex = (dwnIdxEn: DownsideIndexEnableType[]): void => {

    // ストレス指数（有効・無効）情報が空の場合は処理を抜ける
    if (!dwnIdxEn || dwnIdxEn.length === 0) {
      return;
    }

    // ストレス指数(表)のヘッダー(有効・無効)を設定
    // 数量経時変化
    downsideIndexEnable.isEnabledQuantityChangeOverTime
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.quantityChangeOverTime.id)?.enable ?? true);
    // 数量上下変動
    downsideIndexEnable.isEnabledFluctuationInQuantity
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.quantityFluctuation.id)?.enable ?? true);
    // 単価経時変化
    downsideIndexEnable.isEnabledPriceChangeOverTime
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.priceChangeOverTime.id)?.enable ?? true);
    // 顧客製品寿命
    downsideIndexEnable.isEnabledCustomerProductLifecycle
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.customerProductLifecycle.id)?.enable ?? true);
    // 為替変動（単価）
    downsideIndexEnable.isEnabledCurrencyFluctuationToPrice
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.exchangeRateFluctuationToPrice.id)?.enable ?? true);
    // 為替変動（原価）
    downsideIndexEnable.isEnabledCurrencyFluctuationToCost
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.exchangeRateFluctuationToCost.id)?.enable ?? true);
    // 材料高騰
    downsideIndexEnable.isEnabledRisingMaterialCosts
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.materialCostIncrease.id)?.enable ?? true);
    // 労務費高騰
    downsideIndexEnable.isEnabledRisingLaborCosts
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.laborCostIncrease.id)?.enable ?? true);
    // 競合状態（数量）
    downsideIndexEnable.isEnabledCompetitorConditionToQuantity
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.competitorStatusToQuantity.id)?.enable ?? true);
    //  競合状態（単価）
    downsideIndexEnable.isEnabledCompetitorConditionToPrice
      = (dwnIdxEn.find(item => item.id === DownsideItemsTitle.competitorStatusToPrice.id)?.enable ?? true);

  }

  /**
   * ストレス指数の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateDownsideIndex = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndex((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /** AI要因(FactorDef.labelKey) → ストレス指数(表)の項目名 のマッピング */
  const FACTOR_KEY_TO_TABLE_FIELD: Partial<Record<string, keyof DownsideIndexTableRowDisplay>> = {
    quantityChangeOverTime: "quantityChangeOverTime",
    quantityFluctuation: "fluctuationInQuantity",
    priceChangeOverTime: "priceChangeOverTime",
    customerProductLifecycle: "customerProductLifecycle",
    exchangeRateFluctuationToPrice: "currencyFluctuationToPrice",
    exchangeRateFluctuationToCost: "currencyFluctuationToCost",
    materialCostIncrease: "risingMaterialCosts",
    laborCostIncrease: "risingLaborCosts",
    competitorStatusToQuantity: "competitorConditionToQuantity",
    competitorStatusToPrice: "competitorConditionToPrice",
  };

  /**
   * 営業データ連携のAI試算結果（要因別ストレス）をストレス指数（ダウンサイド指数）へ反映する
   * ・表示用テーブル（downsideIndexTableDisplay）と計算用state（downsideIndex）を
   *   1回のsetStateでまとめて更新する（ループ内でのstate参照による反映漏れを避けるため）。
   * ・保存（DB反映）は行わない。ユーザーが内容を確認し、既存の保存操作で確定する。
   * ・customerProductLifecycleのみスカラー値、他の項目は全年度に同じ値を設定する。
   *
   * @param {FactorDef[]} factors AI試算結果（要因別ストレス）
   * @returns {void} なし
   */
  const handleReflectSalesDataLinkageToDownsideIndex = (factors: FactorDef[]): void => {

    if (!factors || factors.length === 0) return;

    // ストレス指数（表）（画面表示用）：全年度の該当項目に同じ値を反映
    setDownsideIndexTableDisplay((prevState) => prevState.map((row) => {
      const nextRow = { ...row };
      factors.forEach(({ labelKey, v }) => {
        const fieldName = FACTOR_KEY_TO_TABLE_FIELD[labelKey];
        if (fieldName) {
          (nextRow[fieldName] as number) = v;
        }
      });
      return nextRow;
    }));

    // ストレス指数（計算用state）：customerProductLifecycleはスカラー、他は年度分の配列に同じ値を設定
    setDownsideIndex((prevState) => {
      const nextState = { ...prevState };
      factors.forEach(({ labelKey, v }) => {
        if (!(labelKey in nextState)) return;
        if (labelKey === "customerProductLifecycle") {
          (nextState as any)[labelKey] = v;
        } else {
          const length = (nextState as any)[labelKey]?.length ?? downsideIndexTableDisplay.length;
          (nextState as any)[labelKey] = Array.from({ length }, () => v);
        }
      });
      return nextState;
    });
  }

  /**
   * ストレス指数（リセット用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateDownsideIndexForReset = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndexForReset((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  /**
   * ストレス指数（有効・無効）（リセット用）の更新
   * 
   * @param {string} itemName 項目名
   * @param {number} downsideIndex ストレス指数
   * @returns {void} なし
   */
  const updateEnabledDownsideIndexForReset = (
    itemName: string,
    downsideIndex: number | number[],
  ): void => {

    // ストレス指数を更新
    setDownsideIndexForReset((prevState) => ({
      ...prevState,
      [itemName]: downsideIndex,
    }));

  }

  // バリデーションを行う
  // 必須入力チェック追加
  // isError true：入力エラー、false：入力正常
  const validate = () => {

    // 先頭と末尾の空白を除去し、未定義の場合は空文字として扱う。
    const required = (value: string | undefined) => value?.trim() ?? "" !== "";

    // エラー情報初期化
    setErrors(clearErrors);

    let isError = false;

    if (!required(finalInvestmentReasonDraftRef.current ?? "")) {
      changeErrors("finalInvestmentReason", true, t('features.InvestmentScreening.SimulationProductivityImprovement.validation.finalInvestmentReasonRequired'));
      isError = true;
    }
    return !isError;
  }

  /**
   * ストレス指数画面「保存」ボタン押下処理
   */
  const handleSaveDownsideIndex = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // フォーカスを外す
    e.currentTarget.blur();

    if (isSaving) return;
    setIsSaving(true);

    // ダウンサイド指数保存
    const result = await saveDownsideIndex();

    setIsSaving(false);

  }

  /**
   * ダウンサイド指数(ストレス指数)データを保存する。
   * @returns true：処理成功、false：処理失敗
   */
  const saveDownsideIndex = async () => {
    const query = `
    mutation updateDownsideIndex($input: DownsideIndexInput!) {
      updateDownsideIndex(input: $input) {status}
    }
  `;

    // APIリクエスト実行
    const result = await WebAPI.request({
      query: query,
      variables: {
        input: {
          projectId: projectId,
          downsideIndex: convertDownsideIndexToDynamoFormat(),
          downsideIndexEnable: convertDownsideIndexEnableToDynamoFormat(),
          updateDate: projectData?.updateDate,
          ...(reviewDate && { reviewDate }),
        }
      }
    });

    // console.log(`response = `, result);

    if (result?.data?.updateDownsideIndex?.status === "success") {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.downsideIndexSaveSuccess'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.savedInputContent'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // データ再取得（未保存のテキスト入力は上書きしない）
      await fetchData({ preserveTextDraft: true });

      return true;
    } else if (result?.data?.updateDownsideIndex.status === 'expired') {
      toast({
        title: TITLE,
        description: Messages.expiredMessage,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      console.warn(`Conflict error. updateDownsideIndex.`);
      onCloseConfirmModal();
    } else {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.downsideIndexSaveFailed'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.error(`Failed to call API updateDownsideIndex.errors = `, result?.errors);
      return false;
    }
  }

  /**
   * シナリオデータを保存する。
   * @param {boolean} deleted 削除フラグ
   * @param {string} updateDate 更新日時
   * @returns {Promise<boolean>} TRUE: 処理成功, FALSE: 処理失敗
   */
  const saveScenarioData = async (deleted: boolean, updateDate?: string, scenarioId?: string): Promise<boolean> => {
    const functionName = "saveScenarioData";

    // GraphQLクエリ
    const query = `
    mutation putScenario($input: ScenarioInput!) {
      putScenario(input: $input) {
        status
      }
    }
  `;

    // improvedWorkingDaysDataから他の2つの配列を同期生成
    // WorkingDaysコンポーネントはimprovedWorkingDaysDataのみを更新するため、
    // 保存時にworkingDay/holidayも同期させる必要がある
    const syncedWorkingDayByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      workingDay: item.workingDaysData.workingDays,
    }));

    const syncedHolidayByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      holiday: item.workingDaysData.workOnWeekendAndHolidays,
    }));

    const syncedLineCountByYear = improvedWorkingDaysData.map((item) => ({
      fiscalYear: item.fiscalYear,
      lineCount: item.workingDaysData.lineCount || Array(12).fill(1),
    }));

    const workingDaysScenario = {
      workingDay: syncedWorkingDayByYear,           // 同期済みデータを使用
      holiday: syncedHolidayByYear,                 // 同期済みデータを使用
      lineCount: syncedLineCountByYear,             // 同期済みデータを使用
      workingDaysData: improvedWorkingDaysData,
    };

    // improvedNonWorkingHoursDataから他の2つの配列を同期生成
    const syncedOverTimeByYear = improvedNonWorkingHoursData.map((item) => ({
      fiscalYear: item.fiscalYear,
      overTime: item.nonWorkingHoursByMonth.map((monthData) => monthData.overTime !== "00:00"),
    }));

    const syncedAvailabilityRateByMonth = improvedNonWorkingHoursData.map((item) => ({
      fiscalYear: item.fiscalYear,
      availabilityRate: item.nonWorkingHoursByMonth.map((monthData) => Number(monthData?.availabilityRate ?? 0)),
    }));

    const nonWorkingHoursScenario = {
      overTime: syncedOverTimeByYear,                     // 同期済みデータを使用
      availabilityRate: syncedAvailabilityRateByMonth,    // 同期済みデータを使用
      nonWorkingHoursData: improvedNonWorkingHoursData,
    };

    const yieldRateScenario = {
      yieldRateData: JSON.stringify(improvedYieldRateList)
    };

    const cycleTimeScenario = {
      cycleTimeData: JSON.stringify(improvedCycleTimeList)
    };

    const equipmentScenario = {
      equipmentsData: JSON.stringify(
        equipmentAmounts.filter(e => e.selected).map(e => ({
          equipmentId: e.equipmentId!,
          changeInQuantity: e.changeInQuantity,
          changedAcceptanceMonth: e.changedAcceptanceMonth,
          changedDepreciationStartMonth: e.changedDepreciationStartMonth
        }))
      )
    };

    const laborCostScenario: LaborCostScenario = {
      productionLaborCostByMonth: scenarioLaborCostByMonth,
      overseasFactoryExpensesByMonth: scenarioOverseasFactoryExpensesByMonth,
      // 単価・ベースアップ率（シミュレーション設定値）もシナリオに保存
      productionFactoryLaborUnitPrice: scenarioProductionFactoryLaborUnitPrice,
      productionFactoryExpenseUnitPrice: scenarioProductionFactoryExpenseUnitPrice,
      baseLaborCostIncreaseRate: scenarioBaseLaborCostIncreaseRate,
    };

    try {
      // APIリクエストの実行
      const result = await WebAPI.request({
        query: query,
        variables: {
          input: {
            projectId: projectId,
            scenarioId: scenarioId || `scenario-${v4()}`,
            scenarioName: configNameInput,
            workingDays: JSON.stringify(workingDaysScenario),
            nonWorkingHours: JSON.stringify(nonWorkingHoursScenario),
            yieldRate: JSON.stringify(yieldRateScenario),
            cycleTime: JSON.stringify(cycleTimeScenario),
            equipment: JSON.stringify(equipmentScenario),
            quantityAndPrice: null,
            laborCost: JSON.stringify(laborCostScenario),
            applyDownside: applyDownsideInput,
            deleted: deleted,
            updateDate: updateDate,
            ...(reviewDate && { reviewDate }),
          },
        },
      });

      // console.log(`${functionName} result: `, JSON.stringify(result));

      // APIレスポンスのステータスチェック
      const status = result?.data?.putScenario?.status;

      if (status === "success") {
        toast({
          title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveSuccess'),
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.savedInputContent'),
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        console.log(`${functionName}: 保存成功`);
        return true;
      }

      if (status === "expired") {
        toast({
          title: TITLE,
          description: Messages.expiredMessage,
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        console.warn(`${functionName}: Conflict error. データが期限切れです。`);
        return false;
      }

      // APIレスポンスが失敗である場合
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveFailedShort'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveFailed'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName}: Failed to call API. Errors: `, result?.errors);
      return false;

    } catch (error) {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.systemError'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dbSaveError'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName}: ERROR occurred while saving scenario data`, error);
      return false;
    }
  };

  /**
   * シナリオデータを取得する。
   * @returns {Promise<TScenario[]>} 取得したシナリオデータのリスト
   */
  const fetchScenarioData = async (): Promise<TScenario[]> => {
    const functionName = "fetchScenarioData";

    // GraphQLクエリ
    const query = {
      query: `
      query getScenarioByProjectId($projectId: String, $hasDeleted: Boolean, $reviewDate: String) {
        getScenarioByProjectId(projectId: $projectId, hasDeleted: $hasDeleted, reviewDate: $reviewDate) {
          projectId
          scenarioId
          scenarioName
          workingDays
          nonWorkingHours
          yieldRate
          cycleTime
          equipment
          quantityAndPrice
          laborCost
          applyDownside
          updateDate
        }
      }
    `,
      variables: {
        projectId,
        hasDeleted: false,
        ...(reviewDate && { reviewDate }),
      },
    };

    try {
      // APIリクエストの実行
      const response = await WebAPI.request(query);
      // console.log(`${functionName} response: `, JSON.stringify(response));

      // データ取得失敗時の処理
      if (!response?.data?.getScenarioByProjectId) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.scenarioFetchFailed'),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        console.error(`${functionName} ERROR: Failed to fetch scenario data`, response?.errors);
        return [];
      }

      // データ取得成功時の処理
      // console.log(`${functionName} SUCCESS: Data fetched successfully`);
      return response.data.getScenarioByProjectId;

    } catch (error) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.fetchError'),
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
      return [];
    }
  };

  // #region Excel出力関連

  /**
   * Excelシート名のサニタイズ（禁止文字を置換し、31文字以内に制限）
   */
  const sanitizeSheetName = (baseName: string, suffix: string = ''): string => {
    const sanitized = (baseName + suffix).replace(/[\\\/\?\*\[\]:]/g, '_');
    if (sanitized.length <= 31) return sanitized;
    // サフィックスを保持して基本名を切り詰め
    const sanitizedSuffix = suffix.replace(/[\\\/\?\*\[\]:]/g, '_');
    const maxBase = 31 - sanitizedSuffix.length;
    return baseName.replace(/[\\\/\?\*\[\]:]/g, '_').substring(0, maxBase) + sanitizedSuffix;
  };

  /**
   * 列幅自動計算
   */
  const getAutoColWidths = (data: (string | number | null)[][]): XLSX.ColInfo[] => {
    const maxLengths: number[] = [];
    data.forEach(row => {
      row.forEach((cell, idx) => {
        const len = String(cell ?? "").length * 1.2;
        maxLengths[idx] = Math.max(maxLengths[idx] || 0, len);
      });
    });
    return maxLengths.map(wch => ({ wch: Math.min(Math.max(wch, 10), 50) }));
  };

  /**
   * 月別損益シートデータを作成（増産プロジェクト用）
   */
  const createMonthlyProfitLossSheet = (
    data: MonthlyProfitAndLossData,
    sheetTitle: string,
    skipConversion: boolean = false,  // 既に選択通貨で計算済みの場合はtrue
  ): (string | number)[][] => {
    const currencyName = selectedCurrency.name || '';

    // 月次データ処理用ヘルパー関数（通貨変換 → 丸め）
    // skipConversion=trueの場合は変換をスキップ（calcMonthlyProfitAndLossDetails内で既に変換済み）
    // 合計列はローカル通貨で精密合算→1回変換（対象PJ画面と同一方式）
    const processMonthlyData = (values: Decimal[]): { values: number[], total: number } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const nums = values.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        const rawTotal = values.reduce((sum, val) => sum.plus(val || new Decimal(0)), new Decimal(0));
        const total = rawTotal.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber();
        return { values: nums, total };
      }
      // 各月: 個別に変換→丸め
      const converted = values.map(v => new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData)));
      const nums = converted.map(v => v.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
      // 合計: ローカル通貨で精密合算→1回変換（対象PJ画面と同一方式）
      const rawTotal = values.reduce((sum, val) => sum.plus(val || new Decimal(0)), new Decimal(0));
      const total = new Decimal(convertCurrency(rawTotal, localCurrencyName, currencyName, currencyData))
        .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber();
      return { values: nums, total };
    };

    // 各データの取得と変換
    const totalSales = processMonthlyData(data.totalSales);
    const productSales = processMonthlyData(data.productSales);
    const moldSales = processMonthlyData(data.moldSales);
    const devSales = processMonthlyData(data.devSales);
    const equipmentSales = processMonthlyData(data.equipmentSales);
    const salesCost = processMonthlyData(data.salesCost);
    const materialCost = processMonthlyData(data.materialCost);
    const outsideCost = processMonthlyData(data.outsideCost);
    const laborCost = processMonthlyData(data.laborCost);
    const domesticLaborCost = processMonthlyData(data.domesticLaborCost);
    const factoryExpenses = processMonthlyData(data.factoryExpenses);
    const overHeadCost = processMonthlyData(data.overHeadCost);
    const depreciation = processMonthlyData(data.depreciation);
    const equipmentDepreciation = processMonthlyData(data.equipmentDepreciation);
    const pastEquipmentCostData = processMonthlyData(data.pastEquipmentCost || []);
    const factoryCost = processMonthlyData(data.factoryCost);
    const otherEquipmentCost = processMonthlyData(data.otherEquipmentCost);
    const domesticFactoryExpenses = processMonthlyData(data.domesticFactoryExpenses);
    const domesticOverHeadCost = processMonthlyData(data.domesticOverHeadCost || []);
    const domesticDepreciation = processMonthlyData(data.domesticDepreciation || []);
    const domesticInvestmentDepreciation = processMonthlyData(data.domesticInvestmentDepreciation || []);
    const domesticFactoryBuildingDepreciation = processMonthlyData(data.domesticFactoryBuildingDepreciation || []);
    const domesticOtherDepreciation = processMonthlyData(data.domesticOtherDepreciation || []);
    const scrapCost = processMonthlyData(data.scrapCost);
    const sGAExpenses = processMonthlyData(data.sGAExpenses);
    const appliedLaborCost = processMonthlyData(data.appliedLaborCost);
    const domesticSgaCost = processMonthlyData(data.domesticSgaCost);
    const salesManagementCost = processMonthlyData(data.salesManagementCost);
    const devCost = processMonthlyData(data.devCost);
    const royalty = processMonthlyData(data.royalty);
    const otherCost = processMonthlyData(data.otherCost);
    const profit = processMonthlyData(data.profit);

    // 営業利益率（月別）
    const profitRateValues = data.labels.map((_, index) => {
      const sales = data.totalSales[index] || new Decimal(0);
      const profitVal = data.profit[index] || new Decimal(0);
      return sales.isZero() ? 0 : profitVal.div(sales).times(100).toNumber();
    });
    const totalProfitRate = totalSales.total === 0 ? 0 : (profit.total / totalSales.total) * 100;

    // 客先指定部品材料費
    const customerSpecifiedPartsCost = processMonthlyData(data.customerSpecifiedPartsCost || []);

    // 実質的営業利益率（月別）= 営業利益 / (売上合計 - 客先指定部品材料費) × 100
    const realProfitRateValues = data.labels.map((_, index) => {
      const sales = data.totalSales[index] || new Decimal(0);
      const custPartsCost = data.customerSpecifiedPartsCost?.[index] || new Decimal(0);
      const realSales = sales.minus(custPartsCost);
      const profitVal = data.profit[index] || new Decimal(0);
      return realSales.isZero() ? 0 : profitVal.div(realSales).times(100).toNumber();
    });
    const totalRealSales = totalSales.total - customerSpecifiedPartsCost.total;
    const totalRealProfitRate = totalRealSales === 0 ? 0 : (profit.total / totalRealSales) * 100;

    const monthsRow = [sheetTitle, ...data.labels, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.tableHeaderTotal')];

    const rows = [
      [ProfitAndLossItems.totalSales.name, ...totalSales.values, totalSales.total],
      [ProfitAndLossItems.productSales.name, ...productSales.values, productSales.total],
      [ProfitAndLossItems.moldRecovery.name, ...moldSales.values, moldSales.total],
      [ProfitAndLossItems.devRecovery.name, ...devSales.values, devSales.total],
      [ProfitAndLossItems.equipmentRecovery.name, ...equipmentSales.values, equipmentSales.total],
      [ProfitAndLossItems.salesCost.name, ...salesCost.values, salesCost.total],
      [ProfitAndLossItems.materialCost.name, ...materialCost.values, materialCost.total],
      [ProfitAndLossItems.outsideCost.name, ...outsideCost.values, outsideCost.total],
      [ProfitAndLossItems.laborCost.name, ...laborCost.values, laborCost.total],
      [ProfitAndLossItems.domesticLaborCost.name, ...domesticLaborCost.values, domesticLaborCost.total],
      [ProfitAndLossItems.factoryExpenses.name, ...factoryExpenses.values, factoryExpenses.total],
      [ProfitAndLossItems.overHeadCost.name, ...overHeadCost.values, overHeadCost.total],
      [ProfitAndLossItems.depreciation.name, ...depreciation.values, depreciation.total],
      [ProfitAndLossItems.equipmentDepreciation.name, ...equipmentDepreciation.values, equipmentDepreciation.total],
      [ProfitAndLossItems.factoryCost.name, ...factoryCost.values, factoryCost.total],
      [ProfitAndLossItems.pastEquipmentCost.name, ...pastEquipmentCostData.values, pastEquipmentCostData.total],
      [ProfitAndLossItems.otherEquipmentCost.name, ...otherEquipmentCost.values, otherEquipmentCost.total],
      [ProfitAndLossItems.domesticFactoryExpenses.name, ...domesticFactoryExpenses.values, domesticFactoryExpenses.total],
      [ProfitAndLossItems.domesticOverHeadCost.name, ...domesticOverHeadCost.values, domesticOverHeadCost.total],
      [ProfitAndLossItems.domesticDepreciation.name, ...domesticDepreciation.values, domesticDepreciation.total],
      [ProfitAndLossItems.domesticInvestmentDepreciation.name, ...domesticInvestmentDepreciation.values, domesticInvestmentDepreciation.total],
      [ProfitAndLossItems.domesticFactoryBuildingDepreciation.name, ...domesticFactoryBuildingDepreciation.values, domesticFactoryBuildingDepreciation.total],
      [ProfitAndLossItems.domesticOtherDepreciation.name, ...domesticOtherDepreciation.values, domesticOtherDepreciation.total],
      [ProfitAndLossItems.scrapCost.name, ...scrapCost.values, scrapCost.total],
      [ProfitAndLossItems.sgaExpenses.name, ...sGAExpenses.values, sGAExpenses.total],
      [ProfitAndLossItems.appliedLaborCost.name, ...appliedLaborCost.values, appliedLaborCost.total],
      [ProfitAndLossItems.domesticSgaCost.name, ...domesticSgaCost.values, domesticSgaCost.total],
      [ProfitAndLossItems.salesManagementCost.name, ...salesManagementCost.values, salesManagementCost.total],
      [ProfitAndLossItems.devCost.name, ...devCost.values, devCost.total],
      [ProfitAndLossItems.royalty.name, ...royalty.values, royalty.total],
      [ProfitAndLossItems.otherCost.name, ...otherCost.values, otherCost.total],
      [ProfitAndLossItems.operatingProfit.name, ...profit.values, profit.total],
      [`${ProfitAndLossItems.operatingProfitRate.name}(%)`, ...profitRateValues, totalProfitRate],
      [`${ProfitAndLossItems.realOperatingProfitRate.name}(%)`, ...realProfitRateValues, totalRealProfitRate],
    ];

    return [
      [`unit: ${currencyName}`],
      [],
      monthsRow,
      ...rows,
    ];
  };

  /**
   * 増分キャッシュフロー月次Excel出力用シートデータを作成
   * 対象PJ画面の createExportDataForRecoverySimulation（年次版）と同じ行構成
   */
  const createIncrementalCashFlowSheet = (
    data: any,
    sheetTitle: string,
    skipConversion: boolean = false,
    extendedLabels?: string[],
  ): (string | number)[][] => {
    const currencyName = selectedCurrency.name || '';

    // 月次データ処理用ヘルパー関数（通貨変換 → 丸め → 合計は各月の単純合算）
    const processMonthlyData = (values: Decimal[]): { values: number[], total: number } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const nums = values.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        const total = nums.reduce((sum, val) => sum + val, 0);
        return { values: nums, total };
      }
      const converted = values.map(v => new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData)));
      const nums = converted.map(v => v.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
      const total = nums.reduce((sum, val) => sum + val, 0);
      return { values: nums, total };
    };

    // 回収額（累積値）の処理 - 合計列は「-」
    const processRecoveryData = (values: Decimal[]): { values: number[] } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const nums = values.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        return { values: nums };
      }
      const nums = values.map(v =>
        new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData))
          .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber()
      );
      return { values: nums };
    };

    // No.411対応（8章）: ダウンサイド・通常モード時のみ、当初計画側と同じ長さまで年月列を延長する
    const isExtended = !reviewDate && !!extendedLabels && extendedLabels.length > (data.labels || []).length;
    const outputLabels = isExtended ? extendedLabels! : (data.labels || []);

    // データ配列をラベル数に合わせる（長い場合は切り詰め、短い場合は0でパディング）
    const labelCount = outputLabels.length;
    const fitToLabels = (arr: Decimal[]) => {
      const trimmed = arr.slice(0, labelCount);
      while (trimmed.length < labelCount) {
        trimmed.push(new Decimal(0));
      }
      return trimmed;
    };

    // 振り返りモード: capexByMonthは既にtargetCurrencyName（=表示通貨）で計算済みのため変換不要
    // 通常モード: ローカル通貨→表示通貨に変換
    const capex = reviewDate
      ? (() => {
        const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
        const nums = fitToLabels(data.capexByMonth || []).map((v: Decimal) =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        return { values: nums, total: nums.reduce((s: number, v: number) => s + v, 0) };
      })()
      : processMonthlyData(fitToLabels(data.capexByMonth || []));

    const hasCostBreakdown = !!data.costBreakdown;
    let profit: { values: number[], total: number };
    let equipmentDepreciation: { values: number[], total: number };
    let recoverySources: { values: number[], total: number };
    let uncollected: { values: number[] };

    if (hasCostBreakdown) {
      const recalc = calcMonthlyProfitInDisplayCurrency(
        data.costBreakdown,
        localCurrencyName,
        currencyName,
        currencyData,
        data.equipmentDepreciationInputs,
        data.scrapCostInputs,
        reviewDate ? convertWithRate : undefined,
        reviewDate ? data.labels : undefined,
        isExtended ? labelCount : undefined,
      );
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      const toNumbers = (arr: any[]) => {
        const nums = arr.slice(0, labelCount).map(v =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber()
        );
        return { values: nums, total: nums.reduce((s, v) => s + v, 0) };
      };
      profit = toNumbers(recalc.profitByMonth);
      equipmentDepreciation = toNumbers(recalc.equipmentDepreciationByMonth);
      // 回収原資 = 営業利益 + 投資対象設備の減価償却費（表示通貨で再計算）
      const recoverySourceNums = profit.values.map((p, i) => p + equipmentDepreciation.values[i]);
      recoverySources = { values: recoverySourceNums, total: recoverySourceNums.reduce((s, v) => s + v, 0) };
      // 未回収額: data.recoveryByMonth（calcRecoverySimulationの結果、検収月CAPEX計上済み）を使用
      // 振り返りモード: 既に表示通貨に変換済み → 丸めのみ
      // 通常モード: ローカル通貨 → processRecoveryData で表示通貨に変換
      if (reviewDate) {
        const recoveryNums = fitToLabels(data.recoveryByMonth || []).map((v: Decimal) =>
          (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        uncollected = { values: recoveryNums };
      } else if (isExtended) {
        // No.411対応（8章）: ダウンサイドの生産期間短縮時、延長期間まで未回収額を再計算する。
        // 回収原資（表示通貨で再計算済み）と設備投資額（延長部分は0埋め）を
        // calcRecoverySimulationに渡し、延長後の期間で検算可能な未回収額を得る。
        const recoverySourceDecimals = recoverySources.values.map(v => new Decimal(v));
        const capexDecimals = fitToLabels(data.capexByMonth || []).map((v: Decimal) =>
          new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData))
            .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP));
        const extendedRecovery = calcRecoverySimulation(recoverySourceDecimals, capexDecimals, hasDecimal(currencyName), false);
        uncollected = { values: extendedRecovery.map(v => v.toNumber()) };
      } else {
        uncollected = processRecoveryData(fitToLabels(data.recoveryByMonth || []));
      }
    } else {
      profit = processMonthlyData(fitToLabels(data.profitByMonth || []));
      equipmentDepreciation = processMonthlyData(fitToLabels(data.equipmentDepreciationByMonth || []));
      recoverySources = processMonthlyData(fitToLabels(data.recoverySourcesByMonth || []));
      uncollected = processRecoveryData(fitToLabels(data.recoveryByMonth || []));
    }

    // 回収時点の表示（チャートのアノテーションと同じ formatRecoveryMonths を使用）
    const recoveryMonthStr = data.recoveryMonths?.length > 0
      ? data.recoveryMonths.map((m: number) => `${formatRecoveryMonths(m)}目`).join(", ")
      : "-";
    const recoveryPeriod = outputLabels.map(() => "");

    const monthsRow = [sheetTitle, ...outputLabels, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.tableHeaderTotal')];

    const rows = [
      [RecoverySimulationItems.capexAmount.name, ...capex.values, capex.total],
      [RecoverySimulationItems.recoveredResources.name, ...recoverySources.values, recoverySources.total],
      [RecoverySimulationItems.operatingProfit.name, ...profit.values, profit.total],
      [RecoverySimulationItems.equipmentDepreciation.name, ...equipmentDepreciation.values, equipmentDepreciation.total],
      [RecoverySimulationItems.uncollectedAmount.name, ...uncollected.values, "-"],
      [RecoverySimulationItems.collectionPeriod.name, ...recoveryPeriod, recoveryMonthStr],
    ];

    return [
      [`unit: ${currencyName}`],
      [],
      monthsRow,
      ...rows,
    ];
  };

  /**
   * 生産能力チャートのExcel出力用シートデータを作成
   * チャートのデータセットから最終値を取得し、入力パラメータ（中間値）も出力する
   */
  const createProductionCapacitySheet = (
    sheetTitle: string,
    chartData: any,
    quantityByPartNo: Record<string, (string | null)[]> | undefined,
    workingDayData: { fiscalYear: string, workingDay: number[] }[],
    holidayData: { fiscalYear: string, holiday: number[] }[],
    availabilityRateData: { fiscalYear: string, availabilityRate: number[] }[],
    lineCountData: { fiscalYear: string, lineCount: number[] }[],
    getYieldRate: (ym: string) => number | null,
    getCycleTime: (ym: string) => number | null,
    showPreProductionBest: boolean,
  ): (string | number | null)[][] => {
    const allLabels: string[] = chartData?.labels || [];

    // datasets からチャート最終値を取得
    const datasets = chartData?.datasets || [];
    const findDataset = (label: string) => datasets.find((ds: any) => ds.label === label)?.data || [];

    const customerDemandRaw = findDataset(t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'));
    const weekdaysRaw = findDataset(t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'));
    const holidaysRaw = findDataset(t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'));
    const preProductionBestRaw = findDataset(t('features.InvestmentScreening.SimulationProductivityImprovement.chart.preIncreaseProductionPast'));

    // ダウンサイドは全系列が期間短縮済みのため、出力する月数をデータ長に揃える
    const labels: string[] = allLabels.slice(0, weekdaysRaw.length || allLabels.length);

    const toNum = (v: any) => v?.toNumber ? v.toNumber() : (v ?? 0);
    const toNumOrEmpty = (v: any) => v != null ? (v?.toNumber ? v.toNumber() : v) : "";

    // 各月の入力パラメータ（中間値）を計算
    const intermediates = labels.map((label, i) => {
      const { year: fy, month: m } = getFiscalYearMonth(labels, i);
      return {
        workingDay: getMonthlyDataByYearAndMonth(workingDayData, fy, m, "workingDay"),
        holiday: getMonthlyDataByYearAndMonth(holidayData, fy, m, "holiday"),
        availabilityRate: getMonthlyDataByYearAndMonth(availabilityRateData, fy, m, "availabilityRate"),
        lineCount: getMonthlyDataByYearAndMonth(lineCountData, fy, m, "lineCount"),
        yieldRate: getYieldRate(label),
        cycleTime: getCycleTime(label),
      };
    });

    const monthsRow: (string | number)[] = [sheetTitle, ...labels];

    const dataRows: (string | number | null)[][] = [
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.workingDays'), ...intermediates.map(r => r.workingDay)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.holidayWorkDays'), ...intermediates.map(r => r.holiday)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.availabilityRate'), ...intermediates.map(r => r.availabilityRate)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.lineCount'), ...intermediates.map(r => r.lineCount)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.yieldRate'), ...intermediates.map(r => r.yieldRate)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.cycleTimeSeconds'), ...intermediates.map(r => r.cycleTime)],
    ];

    if (showPreProductionBest) {
      dataRows.push([t('features.InvestmentScreening.SimulationProductivityImprovement.excel.preIncreaseProductionPastBest'), ...preProductionBestRaw.map(toNumOrEmpty)]);
    }

    // 販売数量（引数のPartNo別数量の全PartNo合計。ダウンサイドはストレス指数適用後の数量）
    const salesQuantity = labels.map((_, i) => {
      let total = new Decimal(0);
      if (quantityByPartNo) {
        for (const [, values] of Object.entries(quantityByPartNo)) {
          total = total.plus(new Decimal(values[i] || 0));
        }
      }
      return total.toNumber();
    });

    dataRows.push(
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.salesQuantity'), ...salesQuantity],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.customerDemand'), ...customerDemandRaw.map(toNum)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.holidayProduction'), ...holidaysRaw.map(toNum)],
      [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.workingDayProduction'), ...weekdaysRaw.map(toNum)],
    );

    return [
      ["unit: pcs"],
      [],
      monthsRow,
      ...dataRows,
    ];
  };

  /**
   * 生産能力（プロセス）のExcel出力用シートデータを作成
   * 複数プロセスを1シートに縦に並べる
   * @param processList 各プロセスの { processName, chartData, recentActual } の配列
   * @param isBefore trueなら「前」計算（投資開始月でデータソース切替）、falseなら「後」計算（常にBOM）
   * @param quantityByPartNo 販売数量行に使うPartNo別数量（ダウンサイド・保存済み設定は各数量グラフの値）
   */
  const createProcessProductionCapacitySheet = (
    processList: {
      processName: string;
      chartData: any;
      recentActual: { operatingRate: number, yieldRate: number, cycleTime: number };
      partsCount: number;
    }[],
    isBefore: boolean,
    quantityByPartNo: Record<string, string[]> | undefined,
    workingDayData: { fiscalYear: string, workingDay: number[] }[],
    holidayData: { fiscalYear: string, holiday: number[] }[],
    availabilityRateData: { fiscalYear: string, availabilityRate: number[] }[],
    lineCountData: { fiscalYear: string, lineCount: number[] }[],
    getYieldRate: (ym: string) => number | null,
    getCycleTime: (ym: string) => number | null,
    pastAvailabilityRateData?: { fiscalYear: string, availabilityRate: number[] }[],
  ): (string | number | null)[][] => {
    const toNum = (v: any) => v?.toNumber ? v.toNumber() : (v ?? 0);
    const findDataset = (chartData: any, label: string) =>
      (chartData?.datasets || []).find((ds: any) => ds.label === label)?.data || [];

    const result: (string | number | null)[][] = [
      ["unit: pcs"],
      [],
    ];

    for (const proc of processList) {
      const customerDemandRaw = findDataset(proc.chartData, t('features.InvestmentScreening.SimulationProductivityImprovement.chart.customerDemand'));
      const weekdaysRaw = findDataset(proc.chartData, t('features.InvestmentScreening.SimulationProductivityImprovement.chart.workingDayProduction'));
      // 出力月数は棒のデータ長に揃える（ダウンサイドは期間短縮済み。ラベルは全期間のため切る）
      const allLabels: string[] = proc.chartData?.labels || [];
      const labels: string[] = allLabels.slice(0, weekdaysRaw.length || allLabels.length);
      const holidaysRaw = findDataset(proc.chartData, t('features.InvestmentScreening.SimulationProductivityImprovement.chart.holidayProduction'));
      const nonWorkingRaw = findDataset(proc.chartData, t('features.InvestmentScreening.SimulationProductivityImprovement.chart.nonWorkingCapacityReduction'));

      // 中間値を計算
      const intermediates = labels.map((label, i) => {
        const { year: fy, month: m } = getFiscalYearMonth(labels, i);
        if (isBefore) {
          // 「前」: 投資開始月でデータソース切替
          const useBom = label < investmentStartYearMonth;
          return {
            workingDay: getMonthlyDataByYearAndMonth(workingDayData, fy, m, "workingDay"),
            holiday: getMonthlyDataByYearAndMonth(holidayData, fy, m, "holiday"),
            availabilityRate: useBom
              ? getMonthlyDataByYearAndMonth(availabilityRateData, fy, m, "availabilityRate")
              : proc.recentActual.operatingRate,
            pastAvailabilityRate: pastAvailabilityRateData
              ? getMonthlyDataByYearAndMonth(pastAvailabilityRateData, fy, m, "availabilityRate")
              : null,
            lineCount: getMonthlyDataByYearAndMonth(lineCountData, fy, m, "lineCount"),
            yieldRate: useBom ? (getYieldRate(label) ?? 0) : proc.recentActual.yieldRate,
            cycleTime: useBom ? (getCycleTime(label) ?? 0) : proc.recentActual.cycleTime,
          };
        } else {
          // 「後」: 常にBOMデータ
          return {
            workingDay: getMonthlyDataByYearAndMonth(workingDayData, fy, m, "workingDay"),
            holiday: getMonthlyDataByYearAndMonth(holidayData, fy, m, "holiday"),
            availabilityRate: getMonthlyDataByYearAndMonth(availabilityRateData, fy, m, "availabilityRate"),
            pastAvailabilityRate: null,
            lineCount: getMonthlyDataByYearAndMonth(lineCountData, fy, m, "lineCount"),
            yieldRate: getYieldRate(label) ?? 0,
            cycleTime: getCycleTime(label) ?? 0,
          };
        }
      });

      // プロセスのセクション
      result.push(
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.equipmentNameLabel', { processName: proc.processName }), ...labels],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.workingDays'), ...intermediates.map(r => r.workingDay)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.holidayWorkDays'), ...intermediates.map(r => r.holiday)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.availabilityRate'), ...intermediates.map(r => r.availabilityRate)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.lineCount'), ...intermediates.map(r => r.lineCount)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.yieldRate'), ...intermediates.map(r => r.yieldRate)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.cycleTimeSeconds'), ...intermediates.map(r => r.cycleTime)],
      );

      // 販売数量（quantityByPartNoの全PartNo合計）
      const salesQuantity = labels.map((_, i) => {
        let total = new Decimal(0);
        if (quantityByPartNo) {
          for (const [, values] of Object.entries(quantityByPartNo)) {
            total = total.plus(new Decimal(values[i] || 0));
          }
        }
        return total.toNumber();
      });

      result.push(
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.salesQuantity'), ...salesQuantity],
        ["partsCount", ...labels.map(() => proc.partsCount)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.customerDemand'), ...customerDemandRaw.map(toNum)],
      );

      if (nonWorkingRaw.length > 0) {
        if (intermediates[0]?.pastAvailabilityRate !== null) {
          result.push([t('features.InvestmentScreening.SimulationProductivityImprovement.excel.pastAvailabilityRate'), ...intermediates.map(r => r.pastAvailabilityRate)]);
        }
        result.push([t('features.InvestmentScreening.SimulationProductivityImprovement.excel.nonWorkingCapacityReduction'), ...nonWorkingRaw.map(toNum)]);
      }

      result.push(
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.holidayProduction'), ...holidaysRaw.map(toNum)],
        [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.workingDayProduction'), ...weekdaysRaw.map(toNum)],
        [], // プロセス間の空行
      );
    }

    return result;
  };

  /**
   * 更新前/更新後（合理化前/合理化後）比較形式の月次損益データを作成
   * @param beforeData 更新前/合理化前データ
   * @param afterData 更新後/合理化後データ
   * @param sheetTitle シートタイトル
   * @param beforeLabel 更新前/合理化前ラベル（デフォルト: "更新前"）
   * @param afterLabel 更新後/合理化後ラベル（デフォルト: "更新後"）
   */
  const createUpdateComparisonMonthlySheet = (
    beforeData: MonthlyProfitAndLossData,
    afterData: MonthlyProfitAndLossData,
    sheetTitle: string,
    beforeLabel: string = t('features.InvestmentScreening.SimulationProductivityImprovement.excel.updateBefore'),
    afterLabel: string = t('features.InvestmentScreening.SimulationProductivityImprovement.excel.updateAfter'),
    skipConversion: boolean = false,  // 既に選択通貨で計算済みの場合はtrue
  ): (string | number)[][] => {
    const currencyName = selectedCurrency.name || '';

    // 月次データ処理用ヘルパー関数（通貨変換 → 丸め）
    // skipConversion=trueの場合は変換をスキップ（calcMonthlyProfitAndLossDetails内で既に変換済み）
    // 合計列はローカル通貨で精密合算→1回変換（対象PJ画面と同一方式）
    const processMonthlyData = (data: Decimal[]): { values: number[], total: number } => {
      const decimalPlaces = hasDecimal(currencyName) ? 2 : 0;
      if (skipConversion) {
        const values = data.map(v => (v || new Decimal(0)).toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
        const rawTotal = data.reduce((sum, val) => sum.plus(val || new Decimal(0)), new Decimal(0));
        const total = rawTotal.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber();
        return { values, total };
      }
      // 各月: 個別に変換→丸め
      const converted = data.map(v => new Decimal(convertCurrency(v || new Decimal(0), localCurrencyName, currencyName, currencyData)));
      const values = converted.map(v => v.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber());
      // 合計: ローカル通貨で精密合算→1回変換（対象PJ画面と同一方式）
      const rawTotal = data.reduce((sum, val) => sum.plus(val || new Decimal(0)), new Decimal(0));
      const total = new Decimal(convertCurrency(rawTotal, localCurrencyName, currencyName, currencyData))
        .toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_UP).toNumber();
      return { values, total };
    };

    // 営業利益率計算用ヘルパー関数
    const calcProfitRateValues = (salesData: Decimal[], profitData: Decimal[]): number[] => {
      return salesData.map((sales, index) => {
        const profitVal = profitData[index] || new Decimal(0);
        return sales.isZero() ? 0 : profitVal.div(sales).times(100).toNumber();
      });
    };

    // 更新前データ
    const beforeTotalSales = processMonthlyData(beforeData.totalSales);
    const beforeProductSales = processMonthlyData(beforeData.productSales);
    const beforeMoldSales = processMonthlyData(beforeData.moldSales);
    const beforeDevSales = processMonthlyData(beforeData.devSales);
    const beforeEquipmentSales = processMonthlyData(beforeData.equipmentSales);
    const beforeSalesCost = processMonthlyData(beforeData.salesCost);
    const beforeMaterialCost = processMonthlyData(beforeData.materialCost);
    const beforeOutsideCost = processMonthlyData(beforeData.outsideCost);
    const beforeLaborCost = processMonthlyData(beforeData.laborCost);
    const beforeDomesticLaborCost = processMonthlyData(beforeData.domesticLaborCost);
    const beforeFactoryExpenses = processMonthlyData(beforeData.factoryExpenses);
    const beforeOverHeadCost = processMonthlyData(beforeData.overHeadCost);
    const beforeDepreciation = processMonthlyData(beforeData.depreciation);
    const beforeEquipmentDepreciation = processMonthlyData(beforeData.equipmentDepreciation);
    const beforePastEquipmentCost = processMonthlyData(beforeData.pastEquipmentCost || []);
    const beforeFactoryCost = processMonthlyData(beforeData.factoryCost);
    const beforeOtherEquipmentCost = processMonthlyData(beforeData.otherEquipmentCost);
    const beforeDomesticFactoryExpenses = processMonthlyData(beforeData.domesticFactoryExpenses);
    const beforeDomesticOverHeadCost = processMonthlyData(beforeData.domesticOverHeadCost || []);
    const beforeDomesticDepreciation = processMonthlyData(beforeData.domesticDepreciation || []);
    const beforeDomesticInvestmentDepreciation = processMonthlyData(beforeData.domesticInvestmentDepreciation || []);
    const beforeDomesticFactoryBuildingDepreciation = processMonthlyData(beforeData.domesticFactoryBuildingDepreciation || []);
    const beforeDomesticOtherDepreciation = processMonthlyData(beforeData.domesticOtherDepreciation || []);
    const beforeScrapCost = processMonthlyData(beforeData.scrapCost);
    const beforeSGAExpenses = processMonthlyData(beforeData.sGAExpenses);
    const beforeAppliedLaborCost = processMonthlyData(beforeData.appliedLaborCost);
    const beforeDomesticSgaCost = processMonthlyData(beforeData.domesticSgaCost);
    const beforeSalesManagementCost = processMonthlyData(beforeData.salesManagementCost);
    const beforeDevCost = processMonthlyData(beforeData.devCost);
    const beforeRoyalty = processMonthlyData(beforeData.royalty);
    const beforeOtherCost = processMonthlyData(beforeData.otherCost);
    const beforeProfit = processMonthlyData(beforeData.profit);

    const beforeProfitRateValues = calcProfitRateValues(beforeData.totalSales, beforeData.profit);
    const beforeTotalProfitRate = beforeTotalSales.total === 0 ? 0 : (beforeProfit.total / beforeTotalSales.total) * 100;

    // 更新後データ
    const afterTotalSales = processMonthlyData(afterData.totalSales);
    const afterProductSales = processMonthlyData(afterData.productSales);
    const afterMoldSales = processMonthlyData(afterData.moldSales);
    const afterDevSales = processMonthlyData(afterData.devSales);
    const afterEquipmentSales = processMonthlyData(afterData.equipmentSales);
    const afterSalesCost = processMonthlyData(afterData.salesCost);
    const afterMaterialCost = processMonthlyData(afterData.materialCost);
    const afterOutsideCost = processMonthlyData(afterData.outsideCost);
    const afterLaborCost = processMonthlyData(afterData.laborCost);
    const afterDomesticLaborCost = processMonthlyData(afterData.domesticLaborCost);
    const afterFactoryExpenses = processMonthlyData(afterData.factoryExpenses);
    const afterOverHeadCost = processMonthlyData(afterData.overHeadCost);
    const afterDepreciation = processMonthlyData(afterData.depreciation);
    const afterEquipmentDepreciation = processMonthlyData(afterData.equipmentDepreciation);
    const afterPastEquipmentCost = processMonthlyData(afterData.pastEquipmentCost || []);
    const afterFactoryCost = processMonthlyData(afterData.factoryCost);
    const afterOtherEquipmentCost = processMonthlyData(afterData.otherEquipmentCost);
    const afterDomesticFactoryExpenses = processMonthlyData(afterData.domesticFactoryExpenses);
    const afterDomesticOverHeadCost = processMonthlyData(afterData.domesticOverHeadCost || []);
    const afterDomesticDepreciation = processMonthlyData(afterData.domesticDepreciation || []);
    const afterDomesticInvestmentDepreciation = processMonthlyData(afterData.domesticInvestmentDepreciation || []);
    const afterDomesticFactoryBuildingDepreciation = processMonthlyData(afterData.domesticFactoryBuildingDepreciation || []);
    const afterDomesticOtherDepreciation = processMonthlyData(afterData.domesticOtherDepreciation || []);
    const afterScrapCost = processMonthlyData(afterData.scrapCost);
    const afterSGAExpenses = processMonthlyData(afterData.sGAExpenses);
    const afterAppliedLaborCost = processMonthlyData(afterData.appliedLaborCost);
    const afterDomesticSgaCost = processMonthlyData(afterData.domesticSgaCost);
    const afterSalesManagementCost = processMonthlyData(afterData.salesManagementCost);
    const afterDevCost = processMonthlyData(afterData.devCost);
    const afterRoyalty = processMonthlyData(afterData.royalty);
    const afterOtherCost = processMonthlyData(afterData.otherCost);
    const afterProfit = processMonthlyData(afterData.profit);

    const afterProfitRateValues = calcProfitRateValues(afterData.totalSales, afterData.profit);
    const afterTotalProfitRate = afterTotalSales.total === 0 ? 0 : (afterProfit.total / afterTotalSales.total) * 100;

    // ヘッダー行
    const headerRow = [t('features.InvestmentScreening.SimulationProductivityImprovement.excel.tableHeaderItem'),
    t('features.InvestmentScreening.SimulationProductivityImprovement.excel.tableHeaderClassification'),
    ...afterData.labels,
    t('features.InvestmentScreening.SimulationProductivityImprovement.excel.tableHeaderTotal')];

    // 各項目について更新前/更新後（合理化前/合理化後）の2行を生成するヘルパー関数
    const createComparisonRows = (
      name: string,
      before: { values: number[], total: number },
      after: { values: number[], total: number }
    ): (string | number)[][] => [
        [name, beforeLabel, ...before.values, before.total],
        ["", afterLabel, ...after.values, after.total],
      ];

    // 営業利益率用（%値）
    const createRateComparisonRows = (
      name: string,
      beforeValues: number[],
      beforeTotal: number,
      afterValues: number[],
      afterTotal: number
    ): (string | number)[][] => [
        [name, beforeLabel, ...beforeValues, beforeTotal],
        ["", afterLabel, ...afterValues, afterTotal],
      ];

    const rows: (string | number)[][] = [
      ...createComparisonRows(ProfitAndLossItems.totalSales.name, beforeTotalSales, afterTotalSales),
      ...createComparisonRows(ProfitAndLossItems.productSales.name, beforeProductSales, afterProductSales),
      ...createComparisonRows(ProfitAndLossItems.moldRecovery.name, beforeMoldSales, afterMoldSales),
      ...createComparisonRows(ProfitAndLossItems.devRecovery.name, beforeDevSales, afterDevSales),
      ...createComparisonRows(ProfitAndLossItems.equipmentRecovery.name, beforeEquipmentSales, afterEquipmentSales),
      ...createComparisonRows(ProfitAndLossItems.salesCost.name, beforeSalesCost, afterSalesCost),
      ...createComparisonRows(ProfitAndLossItems.materialCost.name, beforeMaterialCost, afterMaterialCost),
      ...createComparisonRows(ProfitAndLossItems.outsideCost.name, beforeOutsideCost, afterOutsideCost),
      ...createComparisonRows(ProfitAndLossItems.laborCost.name, beforeLaborCost, afterLaborCost),
      ...createComparisonRows(ProfitAndLossItems.domesticLaborCost.name, beforeDomesticLaborCost, afterDomesticLaborCost),
      ...createComparisonRows(ProfitAndLossItems.factoryExpenses.name, beforeFactoryExpenses, afterFactoryExpenses),
      ...createComparisonRows(ProfitAndLossItems.overHeadCost.name, beforeOverHeadCost, afterOverHeadCost),
      ...createComparisonRows(ProfitAndLossItems.depreciation.name, beforeDepreciation, afterDepreciation),
      ...createComparisonRows(ProfitAndLossItems.equipmentDepreciation.name, beforeEquipmentDepreciation, afterEquipmentDepreciation),
      ...createComparisonRows(ProfitAndLossItems.factoryCost.name, beforeFactoryCost, afterFactoryCost),
      ...createComparisonRows(ProfitAndLossItems.pastEquipmentCost.name, beforePastEquipmentCost, afterPastEquipmentCost),
      ...createComparisonRows(ProfitAndLossItems.otherEquipmentCost.name, beforeOtherEquipmentCost, afterOtherEquipmentCost),
      ...createComparisonRows(ProfitAndLossItems.domesticFactoryExpenses.name, beforeDomesticFactoryExpenses, afterDomesticFactoryExpenses),
      ...createComparisonRows(ProfitAndLossItems.domesticOverHeadCost.name, beforeDomesticOverHeadCost, afterDomesticOverHeadCost),
      ...createComparisonRows(ProfitAndLossItems.domesticDepreciation.name, beforeDomesticDepreciation, afterDomesticDepreciation),
      ...createComparisonRows(ProfitAndLossItems.domesticInvestmentDepreciation.name, beforeDomesticInvestmentDepreciation, afterDomesticInvestmentDepreciation),
      ...createComparisonRows(ProfitAndLossItems.domesticFactoryBuildingDepreciation.name, beforeDomesticFactoryBuildingDepreciation, afterDomesticFactoryBuildingDepreciation),
      ...createComparisonRows(ProfitAndLossItems.domesticOtherDepreciation.name, beforeDomesticOtherDepreciation, afterDomesticOtherDepreciation),
      ...createComparisonRows(ProfitAndLossItems.scrapCost.name, beforeScrapCost, afterScrapCost),
      ...createComparisonRows(ProfitAndLossItems.sgaExpenses.name, beforeSGAExpenses, afterSGAExpenses),
      ...createComparisonRows(ProfitAndLossItems.appliedLaborCost.name, beforeAppliedLaborCost, afterAppliedLaborCost),
      ...createComparisonRows(ProfitAndLossItems.domesticSgaCost.name, beforeDomesticSgaCost, afterDomesticSgaCost),
      ...createComparisonRows(ProfitAndLossItems.salesManagementCost.name, beforeSalesManagementCost, afterSalesManagementCost),
      ...createComparisonRows(ProfitAndLossItems.devCost.name, beforeDevCost, afterDevCost),
      ...createComparisonRows(ProfitAndLossItems.royalty.name, beforeRoyalty, afterRoyalty),
      ...createComparisonRows(ProfitAndLossItems.otherCost.name, beforeOtherCost, afterOtherCost),
      ...createComparisonRows(ProfitAndLossItems.operatingProfit.name, beforeProfit, afterProfit),
      ...createRateComparisonRows(`${ProfitAndLossItems.operatingProfitRate.name}(%)`, beforeProfitRateValues, beforeTotalProfitRate, afterProfitRateValues, afterTotalProfitRate),
    ];

    // 実質的営業利益率（客先指定部品がある場合のみ）
    if (beforeData.customerSpecifiedPartsCost && afterData.customerSpecifiedPartsCost) {
      const beforeCustomerCostSum = beforeData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v || new Decimal(0)), new Decimal(0));
      const afterCustomerCostSum = afterData.customerSpecifiedPartsCost.reduce((sum, v) => sum.plus(v || new Decimal(0)), new Decimal(0));

      // 客先指定部品材料費がある場合のみ出力
      if (!beforeCustomerCostSum.isZero() || !afterCustomerCostSum.isZero()) {
        // 通貨変換済み客先指定部品材料費（合計計算用）
        const beforeCustomerCostConverted = processMonthlyData(beforeData.customerSpecifiedPartsCost);
        const afterCustomerCostConverted = processMonthlyData(afterData.customerSpecifiedPartsCost);

        // 更新前の実質的営業利益率
        const beforeRealProfitRateValues = beforeData.labels.map((_, index) => {
          const sales = beforeData.totalSales[index] || new Decimal(0);
          const customerCost = beforeData.customerSpecifiedPartsCost[index] || new Decimal(0);
          const realSales = sales.minus(customerCost);
          const profitVal = beforeData.profit[index] || new Decimal(0);
          return realSales.isZero() ? 0 : profitVal.div(realSales).times(100).toNumber();
        });
        const beforeTotalRealSales = beforeTotalSales.total - beforeCustomerCostConverted.total;
        const beforeTotalRealProfitRate = beforeTotalRealSales === 0 ? 0 : (beforeProfit.total / beforeTotalRealSales) * 100;

        // 更新後の実質的営業利益率
        const afterRealProfitRateValues = afterData.labels.map((_, index) => {
          const sales = afterData.totalSales[index] || new Decimal(0);
          const customerCost = afterData.customerSpecifiedPartsCost[index] || new Decimal(0);
          const realSales = sales.minus(customerCost);
          const profitVal = afterData.profit[index] || new Decimal(0);
          return realSales.isZero() ? 0 : profitVal.div(realSales).times(100).toNumber();
        });
        const afterTotalRealSales = afterTotalSales.total - afterCustomerCostConverted.total;
        const afterTotalRealProfitRate = afterTotalRealSales === 0 ? 0 : (afterProfit.total / afterTotalRealSales) * 100;

        rows.push(
          ...createRateComparisonRows(
            `${ProfitAndLossItems.realOperatingProfitRate.name}(%)`,
            beforeRealProfitRateValues,
            beforeTotalRealProfitRate,
            afterRealProfitRateValues,
            afterTotalRealProfitRate
          )
        );
      }
    }

    return [
      [`unit: ${currencyName}`],
      [sheetTitle],
      [],
      headerRow,
      ...rows,
    ];
  };

  /**
   * 月次損益Excel出力
   */
  const exportMonthlyProfitLossToExcel = async () => {
    const functionName = "exportMonthlyProfitLossToExcel";
    console.log(`${functionName} START`);

    try {
      if (!projectData || !originalProfitAndLossByMonth || !capexPartNo || capexPartNo.length === 0) {
        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.dataInsufficient'),
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const workbook = XLSX.utils.book_new();

      // 日付シート追加
      const today = new Date();
      const downloadTimeData = [[`${today.getUTCFullYear()}-${String(today.getUTCMonth() + 1).padStart(2, '0')}-${String(today.getUTCDate()).padStart(2, '0')} ${String(today.getUTCHours()).padStart(2, '0')}:${String(today.getUTCMinutes()).padStart(2, '0')}:${String(today.getUTCSeconds()).padStart(2, '0')}`]];
      const downloadTimeSheet = XLSX.utils.aoa_to_sheet(downloadTimeData);
      XLSX.utils.book_append_sheet(workbook, downloadTimeSheet, "downloadTime");

      // Excel出力：通貨変換はcalcMonthlyProfitAndLossDetails内で行われるため、
      // 適切なソースデータと通貨名を選択する
      // ※通常モードで表示通貨=JPY かつ displayデータが存在する場合: JPY版データを使用（変換粒度差の解消）
      // ※振り返りモードで表示通貨=JPY かつ販売通貨==表示通貨: JPY版データを使用（rawSales 経由の二重変換回避）
      //   振り返りで販売通貨≠表示通貨 のときは salesChartData (= rawSales × 月別レート) を使用して正しく月別変動を反映
      const useDisplayVersionForExport = displayVersionSalesChartData
        && displayVersionMergedChartDataOriginal
        && selectedCurrency?.name === CurrencyNameJPY
        && (!reviewDate || projectData?.currencyId === selectedCurrency?.id);

      // 増産プロジェクトの場合はSimulationNewProduct.tsxと同じフォーマットで出力
      if (projectData.purpose === PurposeType.IncreasedProduction.code) {
        // 当初計画シートを作成
        // 適切なソースデータと通貨名を選択する
        // ※表示通貨=JPY かつ display版データが存在する場合は、対象PJ画面が保存したJPY版データを使用（変換粒度差の解消）
        // 表示通貨=JPY かつ display版データが存在する場合は申請時保存のJPY版を使用
        // 振り返り×JPY: displayVersionSalesChartDataを使うことで rawSales(工場通貨) → JPY の二重変換を回避
        const salesChartDataForOriginal = useDisplayVersionForExport ? displayVersionSalesChartData : salesChartData;
        const exportCurrencyNameForOriginal = reviewDate ? selectedCurrency.name : (useDisplayVersionForExport ? savedDisplayCurrencyName : localCurrencyName);
        if (salesChartDataForOriginal?.datasets) {
          const salesDataset = salesChartDataForOriginal.datasets.find((d: any) => d.id === "sales");
          if (salesDataset) {
            const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
            const rawMaterialCosts = calcMaterialCost(
              mergedChartDataOriginal,
              quantitiesChartDataOriginal,
              capexPartNo,
              originalProfitAndLossByMonth.labels,
              projectData.projectId!,
              localCurrencyName,
              currencyData
            );
            // 振り返りモード: calcMonthlyProfitAndLossDetails内でconvertFn（月別レート）により変換されるため事前変換不要
            // 通常JPYモード: calcMonthlyProfitAndLossDetailsにはconvertFn=undefinedで渡すため、事前にJPY変換が必要
            const materialCosts = (!reviewDate && useDisplayVersionForExport && rawMaterialCosts)
              ? rawMaterialCosts.map(v => convertCurrency(v || new Decimal(0), localCurrencyName, savedDisplayCurrencyName, currencyData))
              : rawMaterialCosts;

            const originalData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              originalProfitAndLossByMonth.labels,
              false,
              originalEquipmentAmounts,
              projectData,
              capexPartNo,
              exportCurrencyNameForOriginal,
              currencyData,
              downsideIndexGraph,
              hasDecimal(exportCurrencyNameForOriginal),
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined
            );

            if (originalData) {
              // 営業利益をローカル通貨から直接変換して上書き（対象PJ画面の営業利益との一致）
              // calcMonthlyProfitAndLossDetailsは各費用項目を個別に表示通貨変換した後に差引で営業利益を求めるため、
              // 対象PJの「ローカル通貨で営業利益を算出→1回だけ表示通貨変換」方式と丸め差が出る
              // 振り返りモード: originalData.profitは既にJPYで正しく計算済みのため上書き不要（上書きするとJPY→JPY変換で20倍になる）
              if (!reviewDate && useDisplayVersionForExport) {
                const localProfitDataset = salesChartData?.datasets?.find((d: any) => d.id === "profit");
                if (localProfitDataset) {
                  originalData.profit = localProfitDataset.data
                    .slice(0, originalData.labels.length)
                    .map((v: number) =>
                      convertCurrency(new Decimal(v || 0), localCurrencyName, savedDisplayCurrencyName, currencyData)
                    );
                }
              }
              // 振り返りモード or JPY版: calcMonthlyProfitAndLossDetails内で既に選択通貨に変換済み
              const sheetData = createMonthlyProfitLossSheet(originalData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossOriginal'), !!reviewDate || useDisplayVersionForExport);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.originalMonthlyProfitLossSheetName'));
            }
          }
        }

        // ダウンサイドシートを作成
        if (salesChartDataModified?.datasets) {
          const salesDataset = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
          if (salesDataset) {
            const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
            // ダウンサイドチャートデータは既に期間短縮されているため、labelsもそれに合わせる
            const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
            const rawMaterialCostsDownside = calcMaterialCost(
              mergedChartDataModified,
              quantitiesChartDataModified,
              capexPartNo,
              downsideLabels,
              projectData.projectId!,
              localCurrencyName,
              currencyData
            );
            // 振り返りモード: calcMonthlyProfitAndLossDetails内でconvertFn（月別レート）により変換されるため事前変換不要
            const materialCosts = rawMaterialCostsDownside;

            const downsideData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              downsideLabels,
              true,
              originalEquipmentAmounts,
              projectData,
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              downsideIndexGraph,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined,
              // No.411対応（9章）: 当初計画側と同じラベルまで年月列を延長する
              !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
            );

            if (downsideData) {
              // 振り返りモード: calcMonthlyProfitAndLossDetails内で既にselectedCurrencyで変換済み
              const sheetData = createMonthlyProfitLossSheet(downsideData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossDownside'), !!reviewDate);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.downsideMonthlyProfitLossSheetName'));
            }
          }
        }

        // 保存済み設定シートを作成
        for (const chartDataItem of salesChartDataForSavedConfig) {
          const config = savedConfigs.find(c => c.id === chartDataItem.configId);
          if (!config) continue;

          const salesDataset = chartDataItem.data?.datasets?.find((d: any) => d.id === "sales");
          if (salesDataset) {
            const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
            // 保存済み設定のチャートデータは既に期間短縮されているため、labelsもそれに合わせる
            const savedConfigLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);

            // 保存済み設定の数量データを取得
            const savedQuantitiesChartData = quantitiesChartDataForSavedConfig.find(
              q => q.configId === chartDataItem.configId
            );
            const savedMergedChartData = mergedChartDataForSavedConfig.find(
              m => m.configId === chartDataItem.configId
            );

            if (savedQuantitiesChartData && savedMergedChartData) {
              const rawMaterialCostsSavedConfig = calcMaterialCost(
                savedMergedChartData.data,
                savedQuantitiesChartData.data,
                capexPartNo,
                savedConfigLabels,
                projectData.projectId!,
                localCurrencyName,
                currencyData
              );
              // 振り返りモード: calcMonthlyProfitAndLossDetails内でconvertFn（月別レート）により変換されるため事前変換不要
              const materialCosts = rawMaterialCostsSavedConfig;

              // 保存済み設定の設備情報を取得
              const savedEquipmentConfig = config.equipmentAmounts || [];
              const configEquipments = originalEquipmentAmounts
                .map(eq => {
                  const savedEq = savedEquipmentConfig.find(se => se.equipmentId === eq.equipmentId);
                  return savedEq ? { ...eq, selected: true } : null;
                })
                .filter((eq): eq is EquipmentExtType => eq !== null);

              const configApplyDownside = config.applyDownside !== false;
              const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;
              const savedConfigData = calcMonthlyProfitAndLossDetails(
                sales,
                materialCosts || [],
                savedConfigLabels,
                configApplyDownside,
                configEquipments,
                applyScenarioLaborCostToProjectData(
                  projectData,
                  config.scenarioLaborCostByMonth,
                  config.scenarioOverseasFactoryExpensesByMonth,
                  savedConfigLabels
                ),
                capexPartNo,
                reviewDate ? selectedCurrency.name : localCurrencyName,
                currencyData,
                configDownsideIndex,
                decimalCurrency,
                processCodeData,
                bomData,
                projectData.moldSalesByProject,
                projectData.developmentSalesByProject,
                projectData.equipmentSalesByProject,
                undefined,
                reviewDate ? convertWithRate : undefined,
                // No.411対応（9章）: 保存済み設定もダウンサイド（ストレス指数）の一種のため同様に延長
                !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
              );

              if (savedConfigData) {
                const savedConfigName = config.name || `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigNamePrefix')}${config.id}`;
                const sheetName = sanitizeSheetName(savedConfigName, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossSavedConfigSuffix'));
                // 振り返りモード: calcMonthlyProfitAndLossDetails内で既にselectedCurrencyで変換済み
                const sheetData = createMonthlyProfitLossSheet(savedConfigData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossSavedConfigSheetName', { name: config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName') }), !!reviewDate);
                const sheet = XLSX.utils.aoa_to_sheet(sheetData);
                sheet["!cols"] = getAutoColWidths(sheetData);
                XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
              }
            }
          }
        }

        // PJ全体シートを作成（過去PJ設備 + 現PJ設備のmerge）
        if (salesChartData?.datasets) {
          const salesDataset = salesChartData.datasets.find((d: any) => d.id === "sales");
          if (salesDataset) {
            const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
            const rawMaterialCostsAll = calcMaterialCost(
              mergedChartDataOriginal,
              quantitiesChartDataOriginal,
              capexPartNo,
              originalProfitAndLossByMonth.labels,
              projectData.projectId!,
              localCurrencyName,
              currencyData
            );
            // 振り返りモード: calcMonthlyProfitAndLossDetails内でconvertFn（月別レート）により変換されるため事前変換不要
            const materialCosts = rawMaterialCostsAll;

            // mergeEquipmentAmounts: 過去PJ設備 + 現PJ設備
            const mergeEquipmentAmounts = [...pastEquipmentAmounts, ...originalEquipmentAmounts];

            const allData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              originalProfitAndLossByMonth.labels,
              false,
              mergeEquipmentAmounts,
              projectData,
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              downsideIndexGraph,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined
            );

            if (allData) {
              // PJ全体では過去PJ設備がmergeEquipmentAmounts経由でequipmentDepreciationに含まれるため、
              // 投資対象設備から過去PJ分を差し引いて現PJ分のみにする（内訳合計の整合性を維持）
              // EOL後はpastEquipmentCostが0でもmerge設備の償却が残る場合があるため、
              // EOL予定日以降の月のequipmentDepreciationを0にする
              // 現PJ設備のみで投資対象設備の減価償却費を再計算（過去PJ分を含まない正確な値）
              const currentEquipDepRaw = calcEquipmentDepreciationByYearMonth(
                getTotalFiscalYearsByPartNo(capexPartNo),
                convertEquipmentData(originalEquipmentAmounts, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, reviewDate ? convertWithRate : undefined),
                decimalCurrency,
                projectData.projectStartDate || "",
                false
              );
              allData.equipmentDepreciation = currentEquipDepRaw
                .slice(0, allData.labels.length)
                .map(e => e.value);
              // 減価償却費・工場経費・売上原価・営業利益を再計算（equipmentDepreciation変更に伴い）
              const pastEquipCost = allData.pastEquipmentCost || [];
              allData.depreciation = allData.equipmentDepreciation.map((val, i) =>
                val.plus(pastEquipCost[i] || new Decimal(0))
                  .plus(allData.factoryCost[i] || new Decimal(0))
                  .plus(allData.otherEquipmentCost[i] || new Decimal(0))
              );
              allData.factoryExpenses = allData.depreciation.map((val, i) =>
                val.plus(allData.overHeadCost[i] || new Decimal(0))
              );
              allData.salesCost = allData.materialCost.map((val, i) =>
                val.plus(allData.outsideCost[i] || new Decimal(0))
                  .plus(allData.laborCost[i] || new Decimal(0))
                  .plus(allData.domesticLaborCost[i] || new Decimal(0))
                  .plus(allData.factoryExpenses[i] || new Decimal(0))
                  .plus(allData.domesticFactoryExpenses[i] || new Decimal(0))
                  .plus(allData.scrapCost[i] || new Decimal(0))
              );
              allData.profit = allData.totalSales.map((val, i) =>
                val.minus(allData.salesCost[i] || new Decimal(0))
                  .minus(allData.sGAExpenses[i] || new Decimal(0))
                  .minus(allData.otherCost[i] || new Decimal(0))
              );
              // 振り返りモード: calcMonthlyProfitAndLossDetails内で既にselectedCurrencyで変換済み
              const sheetData = createMonthlyProfitLossSheet(allData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossWholeProject'), !!reviewDate);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.wholeProjectMonthlyProfitLossSheetName'));
            }
          }
        }

        // 増分キャッシュフロー（PJ全体）シート追加
        if (incrementalCashFlowAll) {
          const cfSheetData = createIncrementalCashFlowSheet(
            incrementalCashFlowAll,
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowWholeProject')
          );
          const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
          cfSheet["!cols"] = getAutoColWidths(cfSheetData);
          XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowWholeProject'));
        }

        // 増分キャッシュフロー（当初投資）シート追加
        if (incrementalCashFlowPast) {
          const cfSheetData = createIncrementalCashFlowSheet(
            incrementalCashFlowPast,
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowPastInvestment')
          );
          const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
          cfSheet["!cols"] = getAutoColWidths(cfSheetData);
          XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowPastInvestment'));
        }

        // 増分キャッシュフロー（当初計画）シート追加
        // 注意: 増分CFデータは常にローカル通貨なので skipConversion は常に false
        if (incrementalCashFlowOriginal) {
          const cfSheetData = createIncrementalCashFlowSheet(
            incrementalCashFlowOriginal,
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowOriginal')
          );
          const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
          cfSheet["!cols"] = getAutoColWidths(cfSheetData);
          XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowOriginal'));
        }

        // 増分キャッシュフロー（ダウンサイド）シート追加
        if (incrementalCashFlowDownside) {
          // No.411対応（8章）: 当初計画側と同じラベルまで年月列を延長する
          const cfSheetData = createIncrementalCashFlowSheet(
            incrementalCashFlowDownside,
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowDownside'),
            false,
            incrementalCashFlowOriginal?.labels
          );
          const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
          cfSheet["!cols"] = getAutoColWidths(cfSheetData);
          XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowDownside'));
        }

        // 増分キャッシュフロー（保存済み設定）シート追加
        for (const chartDataItem of salesChartDataForSavedConfig) {
          const config = savedConfigs.find(c => c.id === chartDataItem.configId);
          if (!config) continue;
          const savedCfData = incrementalCashFlowForSavedConfig.find(
            item => item.configId === chartDataItem.configId
          );
          if (savedCfData) {
            const cfSheetName = sanitizeSheetName(
              `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
              + `（${config.name || `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigNamePrefix')}${config.id}`}）`
            );

            // No.411対応（8章）: 保存済み設定もダウンサイド（ストレス指数）の一種のため同様に延長
            const cfSheetData = createIncrementalCashFlowSheet(
              savedCfData.data,
              `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
              + `（${config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName')}）`,
              false,
              incrementalCashFlowOriginal?.labels
            );
            const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
            cfSheet["!cols"] = getAutoColWidths(cfSheetData);
            XLSX.utils.book_append_sheet(workbook, cfSheet, cfSheetName);
          }
        }

        // 生産キャパグラフ（既存ライン含む）のセクションを「生産能力（ライン全体）」シートの末尾に追加する
        // 生産キャパグラフOFF（不要）のときは出力しない（申請書と同じ扱い）
        const elqSource = elq.show ? existingLineCapacitySource : null;
        const appendExistingLineCapacitySection = (
          sheetData: (string | number | null)[][],
          version: TExistingLineCapacityVersion | undefined,
          sheetTitle: string,
        ): (string | number | null)[][] => {
          if (!elqSource || !version) return sheetData;
          return [...sheetData, [], ...createExistingLineCapacitySectionRows(t, elq.data, version, elqSource.labels, sheetTitle, capexPartNo)];
        };

        // 生産能力（ライン全体）当初計画シート追加
        if (productionCapacityChartData) {
          const pcSheetData = appendExistingLineCapacitySection(createProductionCapacitySheet(
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.gapDetailsOriginal'),
            productionCapacityChartData,
            originalProfitAndLossByMonth?.quantityByPartNo,
            workingDayByYear,
            holidayByYear,
            availabilityRateByMonth,
            lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
            true,
          ), elqSource?.original, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.gapDetailsOriginal'));
          const pcSheet = XLSX.utils.aoa_to_sheet(pcSheetData);
          pcSheet["!cols"] = getAutoColWidths(pcSheetData);
          XLSX.utils.book_append_sheet(workbook, pcSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.originalGapSheetName'));
        }

        // 生産能力（ライン全体）ダウンサイドシート追加
        if (productionCapacityChartDataModified) {
          const pcSheetData = appendExistingLineCapacitySection(createProductionCapacitySheet(
            t('features.InvestmentScreening.SimulationProductivityImprovement.excel.gapDetailsDownside'),
            productionCapacityChartDataModified,
            extractQuantityByPartNoFromChart(quantitiesChartDataModified, 0).quantityByPartNo,
            workingDayByYear,
            holidayByYear,
            availabilityRateByMonth,
            lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
            true,
          ), elqSource?.modified, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.gapDetailsDownside'));
          const pcSheet = XLSX.utils.aoa_to_sheet(pcSheetData);
          pcSheet["!cols"] = getAutoColWidths(pcSheetData);
          XLSX.utils.book_append_sheet(workbook, pcSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.downsideGapSheetName'));
        }

        // 生産能力（ライン全体）保存済み設定シート追加
        for (const pcItem of productionCapacityChartDataForSavedConfig) {
          const config = savedConfigs.find(c => c.id === pcItem.configId);
          if (!config) continue;
          const pcSheetData = appendExistingLineCapacitySection(createProductionCapacitySheet(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}`
            + `（${config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName')}）`,
            pcItem.data,
            extractQuantityByPartNoFromChart(
              quantitiesChartDataForSavedConfig.find(item => item.configId === pcItem.configId)?.data, 0
            ).quantityByPartNo,
            config.improvedWorkingDayByYear,
            config.improvedHolidayByYear,
            config.improvedAvailabilityRateByMonth,
            config.improvedLineCountByYear,
            (ym) => getApplicableYieldRate(ym, config.improvedYieldRateList, (y) => getYieldRateFromBomData(y, bomData)),
            (ym) => getApplicableCycleTime(ym, config.improvedCycleTimeList, (y) => getCycleTimeFromBomData(y, bomData)),
            true,
          ),
            elqSource?.savedConfigs.find(item => item.configId === pcItem.configId),
            config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName'),
          );
          const pcSheet = XLSX.utils.aoa_to_sheet(pcSheetData);
          pcSheet["!cols"] = getAutoColWidths(pcSheetData);
          const pcSheetName = sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}`
            + `（${config.name || `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigNamePrefix')}${config.id}`}）`
          );
          XLSX.utils.book_append_sheet(workbook, pcSheet, pcSheetName);
        }

        // ファイル出力
        const formatted = today.toISOString().split("T")[0].replace(/-/g, "");
        const fileNamePrefix = t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossFileNamePrefix');
        XLSX.writeFile(workbook, `${fileNamePrefix}_${projectId}_${formatted}.xlsx`);

        toast({
          title: TITLE,
          description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.excelExportSuccess'),
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        console.log(`${functionName} SUCCESS`);
        return;
      }

      // 更新・合理化プロジェクトの場合は更新前/更新後（合理化前/合理化後）形式で出力
      // 更新前データの3ヶ月平均変換用の共通設定
      const startDate = projectData.projectStartDate || "";
      // 投資目的に応じて使用する開始日を選択
      // - 合理化投資の場合: rationalizationStartDate
      // - 更新・その他の場合: updateAndOtherStartDate
      const productionStartDate = projectData.purpose === PurposeType.Rationalization.code
        ? (projectData.rationalizationStartDate ? dayjs(projectData.rationalizationStartDate) : null)
        : (projectData.updateAndOtherStartDate ? dayjs(projectData.updateAndOtherStartDate) : null);
      const projectStartDateObj = dayjs(startDate);
      const projectEndDateObj = projectData.projectEndDate ? dayjs(projectData.projectEndDate) : null;

      // 量産開始日のインデックスを計算（プロジェクト開始日からの月数）
      const updateStartMonthIndex = productionStartDate
        ? productionStartDate.startOf('month').diff(projectStartDateObj.startOf('month'), 'month')
        : 0;

      // EOL予定日のインデックスを計算（プロジェクト開始日からの月数）
      const eolMonthIndex = projectEndDateObj
        ? projectEndDateObj.diff(projectStartDateObj, 'month') + 1
        : Infinity;

      // 投資目的に応じた区分ラベルを設定
      const isRationalization = projectData.purpose === PurposeType.Rationalization.code;
      const beforeLabel = isRationalization ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationBefore') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateBefore');
      const afterLabel = isRationalization ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationAfter') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateAfter');

      // 量産開始直前3ヶ月のインデックスを計算
      const avgStartIndex = Math.max(0, updateStartMonthIndex - 3);
      const avgEndIndex = updateStartMonthIndex;

      // 3ヶ月平均を計算するヘルパー関数
      const calcThreeMonthAverage = (monthlyData: Decimal[]): Decimal => {
        let sum = new Decimal(0);
        let count = 0;
        for (let i = avgStartIndex; i < avgEndIndex && i < monthlyData.length; i++) {
          const val = monthlyData[i];
          if (val) {
            sum = sum.plus(val);
            count++;
          }
        }
        return count > 0 ? sum.div(count) : new Decimal(0);
      };

      // 更新前データを3ヶ月平均に変換する関数
      const applyBeforeUpdateLogic = (data: MonthlyProfitAndLossData): MonthlyProfitAndLossData => {
        // 各項目の3ヶ月平均を計算
        const avgProductSales = calcThreeMonthAverage(data.productSales);
        const avgMaterialCost = calcThreeMonthAverage(data.materialCost);
        const avgOutsideCost = calcThreeMonthAverage(data.outsideCost);
        const avgLaborCost = calcThreeMonthAverage(data.laborCost);
        const avgDomesticLaborCost = calcThreeMonthAverage(data.domesticLaborCost);
        const avgOverHeadCost = calcThreeMonthAverage(data.overHeadCost);
        const avgEquipmentDepreciation = calcThreeMonthAverage(data.equipmentDepreciation);
        const avgFactoryCost = calcThreeMonthAverage(data.factoryCost);
        const avgOtherEquipmentCost = calcThreeMonthAverage(data.otherEquipmentCost);
        const avgPastEquipmentCost = data.pastEquipmentCost
          ? calcThreeMonthAverage(data.pastEquipmentCost)
          : new Decimal(0);
        const avgDomesticFactoryExpenses = calcThreeMonthAverage(data.domesticFactoryExpenses);
        const avgDomesticOverHeadCost = data.domesticOverHeadCost
          ? calcThreeMonthAverage(data.domesticOverHeadCost)
          : new Decimal(0);
        const avgDomesticDepreciation = data.domesticDepreciation
          ? calcThreeMonthAverage(data.domesticDepreciation)
          : new Decimal(0);
        const avgDomesticInvestmentDepreciation = data.domesticInvestmentDepreciation
          ? calcThreeMonthAverage(data.domesticInvestmentDepreciation)
          : new Decimal(0);
        const avgDomesticFactoryBuildingDepreciation = data.domesticFactoryBuildingDepreciation
          ? calcThreeMonthAverage(data.domesticFactoryBuildingDepreciation)
          : new Decimal(0);
        const avgDomesticOtherDepreciation = data.domesticOtherDepreciation
          ? calcThreeMonthAverage(data.domesticOtherDepreciation)
          : new Decimal(0);
        const avgScrapCost = calcThreeMonthAverage(data.scrapCost);
        const avgAppliedLaborCost = calcThreeMonthAverage(data.appliedLaborCost);
        const avgDomesticSgaCost = calcThreeMonthAverage(data.domesticSgaCost);
        const avgSalesManagementCost = calcThreeMonthAverage(data.salesManagementCost);
        const avgDevCost = calcThreeMonthAverage(data.devCost);
        const avgRoyalty = calcThreeMonthAverage(data.royalty);
        const avgOtherCost = calcThreeMonthAverage(data.otherCost);
        const avgCustomerSpecifiedPartsCost = data.customerSpecifiedPartsCost
          ? calcThreeMonthAverage(data.customerSpecifiedPartsCost)
          : new Decimal(0);

        // 量産開始前は入力値、量産開始後～EOLは3ヶ月平均、EOL以降は0
        const applyLogic = (monthlyData: Decimal[], avgValue: Decimal): Decimal[] => {
          return monthlyData.map((val, index) => {
            if (index >= eolMonthIndex) {
              return new Decimal(0);
            } else if (index < updateStartMonthIndex) {
              return val;
            } else {
              return avgValue;
            }
          });
        };

        // 更新前の各項目を変換
        const beforeProductSales = applyLogic(data.productSales, avgProductSales);
        // PJ回収の3ヶ月平均を計算（売上合計の算出用）
        const avgMoldSales = calcThreeMonthAverage(data.moldSales);
        const avgDevSales = calcThreeMonthAverage(data.devSales);
        const avgEquipmentSales = calcThreeMonthAverage(data.equipmentSales);
        const beforeMoldSalesForCalc = applyLogic(data.moldSales, avgMoldSales);
        const beforeDevSalesForCalc = applyLogic(data.devSales, avgDevSales);
        const beforeEquipmentSalesForCalc = applyLogic(data.equipmentSales, avgEquipmentSales);

        // PJ回収の表示値は生値のまま（現行動作を維持）
        const beforeMoldSales = data.moldSales;
        const beforeDevSales = data.devSales;
        const beforeEquipmentSales = data.equipmentSales;

        const beforeMaterialCost = applyLogic(data.materialCost, avgMaterialCost);
        const beforeOutsideCost = applyLogic(data.outsideCost, avgOutsideCost);
        const beforeLaborCost = applyLogic(data.laborCost, avgLaborCost);
        const beforeDomesticLaborCost = applyLogic(data.domesticLaborCost, avgDomesticLaborCost);
        const beforeOverHeadCost = applyLogic(data.overHeadCost, avgOverHeadCost);
        const beforeEquipmentDepreciation = applyLogic(data.equipmentDepreciation, avgEquipmentDepreciation);
        const beforeFactoryCost = applyLogic(data.factoryCost, avgFactoryCost);
        const beforeOtherEquipmentCost = applyLogic(data.otherEquipmentCost, avgOtherEquipmentCost);
        const beforePastEquipmentCost = data.pastEquipmentCost
          ? applyLogic(data.pastEquipmentCost, avgPastEquipmentCost)
          : [];
        const beforeDomesticFactoryExpenses = applyLogic(data.domesticFactoryExpenses, avgDomesticFactoryExpenses);
        const beforeDomesticOverHeadCost = data.domesticOverHeadCost
          ? applyLogic(data.domesticOverHeadCost, avgDomesticOverHeadCost)
          : [];
        const beforeDomesticDepreciation = data.domesticDepreciation
          ? applyLogic(data.domesticDepreciation, avgDomesticDepreciation)
          : [];
        const beforeDomesticInvestmentDepreciation = data.domesticInvestmentDepreciation
          ? applyLogic(data.domesticInvestmentDepreciation, avgDomesticInvestmentDepreciation)
          : [];
        const beforeDomesticFactoryBuildingDepreciation = data.domesticFactoryBuildingDepreciation
          ? applyLogic(data.domesticFactoryBuildingDepreciation, avgDomesticFactoryBuildingDepreciation)
          : [];
        const beforeDomesticOtherDepreciation = data.domesticOtherDepreciation
          ? applyLogic(data.domesticOtherDepreciation, avgDomesticOtherDepreciation)
          : [];
        const beforeScrapCost = applyLogic(data.scrapCost, avgScrapCost);
        const beforeAppliedLaborCost = applyLogic(data.appliedLaborCost, avgAppliedLaborCost);
        const beforeDomesticSgaCost = applyLogic(data.domesticSgaCost, avgDomesticSgaCost);
        const beforeSalesManagementCost = applyLogic(data.salesManagementCost, avgSalesManagementCost);
        const beforeDevCost = applyLogic(data.devCost, avgDevCost);
        const beforeRoyalty = applyLogic(data.royalty, avgRoyalty);
        const beforeOtherCost = applyLogic(data.otherCost, avgOtherCost);
        const beforeCustomerSpecifiedPartsCost = data.customerSpecifiedPartsCost
          ? applyLogic(data.customerSpecifiedPartsCost, avgCustomerSpecifiedPartsCost)
          : [];

        // 売上合計は平均値ベースで再計算（対象PJ画面の一括平均と一致させる）
        const beforeTotalSales = beforeProductSales.map((val, i) => {
          return val.plus(beforeMoldSalesForCalc[i] || new Decimal(0))
            .plus(beforeDevSalesForCalc[i] || new Decimal(0))
            .plus(beforeEquipmentSalesForCalc[i] || new Decimal(0));
        });

        // 減価償却費を再計算（投資対象設備 + 工場建物 + その他の設備）
        // ※過去PJの投資対象設備は設備マスタ経由でequipmentDepreciationに含まれるため別途加算しない
        const beforeDepreciation = beforeEquipmentDepreciation.map((val, i) => {
          return val.plus(beforeFactoryCost[i] || new Decimal(0))
            .plus(beforeOtherEquipmentCost[i] || new Decimal(0));
        });

        // 工場経費を再計算（償却費以外の工場経費 + 減価償却費）
        const beforeFactoryExpenses = beforeOverHeadCost.map((val, i) => {
          return val.plus(beforeDepreciation[i] || new Decimal(0));
        });

        // 売上原価を再計算
        const beforeSalesCost = beforeMaterialCost.map((val, i) => {
          return val
            .plus(beforeOutsideCost[i] || new Decimal(0))
            .plus(beforeLaborCost[i] || new Decimal(0))
            .plus(beforeDomesticLaborCost[i] || new Decimal(0))
            .plus(beforeFactoryExpenses[i] || new Decimal(0))
            .plus(beforeDomesticFactoryExpenses[i] || new Decimal(0))
            .plus(beforeScrapCost[i] || new Decimal(0));
        });

        // 販売費及び一般管理費を再計算
        const beforeSGAExpenses = beforeAppliedLaborCost.map((val, i) => {
          return val
            .plus(beforeDomesticSgaCost[i] || new Decimal(0))
            .plus(beforeSalesManagementCost[i] || new Decimal(0))
            .plus(beforeDevCost[i] || new Decimal(0))
            .plus(beforeRoyalty[i] || new Decimal(0));
        });

        // 営業利益を再計算
        const beforeProfit = beforeTotalSales.map((val, i) => {
          return val
            .minus(beforeSalesCost[i] || new Decimal(0))
            .minus(beforeSGAExpenses[i] || new Decimal(0))
            .minus(beforeOtherCost[i] || new Decimal(0));
        });

        return {
          labels: data.labels,
          totalSales: beforeTotalSales,
          productSales: beforeProductSales,
          moldSales: beforeMoldSales,
          devSales: beforeDevSales,
          equipmentSales: beforeEquipmentSales,
          salesCost: beforeSalesCost,
          materialCost: beforeMaterialCost,
          outsideCost: beforeOutsideCost,
          laborCost: beforeLaborCost,
          domesticLaborCost: beforeDomesticLaborCost,
          factoryExpenses: beforeFactoryExpenses,
          overHeadCost: beforeOverHeadCost,
          depreciation: beforeDepreciation,
          equipmentDepreciation: beforeEquipmentDepreciation,
          pastEquipmentCost: beforePastEquipmentCost,
          factoryCost: beforeFactoryCost,
          otherEquipmentCost: beforeOtherEquipmentCost,
          domesticFactoryExpenses: beforeDomesticFactoryExpenses,
          domesticOverHeadCost: beforeDomesticOverHeadCost,
          domesticDepreciation: beforeDomesticDepreciation,
          domesticInvestmentDepreciation: beforeDomesticInvestmentDepreciation,
          domesticFactoryBuildingDepreciation: beforeDomesticFactoryBuildingDepreciation,
          domesticOtherDepreciation: beforeDomesticOtherDepreciation,
          scrapCost: beforeScrapCost,
          sGAExpenses: beforeSGAExpenses,
          appliedLaborCost: beforeAppliedLaborCost,
          domesticSgaCost: beforeDomesticSgaCost,
          salesManagementCost: beforeSalesManagementCost,
          devCost: beforeDevCost,
          royalty: beforeRoyalty,
          otherCost: beforeOtherCost,
          profit: beforeProfit,
          customerSpecifiedPartsCost: beforeCustomerSpecifiedPartsCost,
        };
      };

      // 当初計画（更新前/更新後）シートを作成
      // 表示通貨=JPY かつ display版データが存在する場合は申請時保存のJPY版を使用
      // 振り返り×JPY: displayVersionSalesChartDataを使うことで rawSales(工場通貨) → JPY の二重変換を回避
      const salesChartDataForUpdate = useDisplayVersionForExport ? displayVersionSalesChartData : salesChartData;
      const exportCurrencyNameForUpdate = reviewDate ? selectedCurrency.name : (useDisplayVersionForExport ? savedDisplayCurrencyName : localCurrencyName);
      if (!isSimpleMode && salesChartDataForUpdate?.datasets) {
        const salesDataset = salesChartDataForUpdate.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
          const rawMaterialCosts = calcMaterialCost(
            mergedChartDataOriginal,
            quantitiesChartDataOriginal,
            capexPartNo,
            originalProfitAndLossByMonth.labels,
            projectData.projectId!,
            localCurrencyName,
            currencyData
          );
          const materialCosts = (!reviewDate && useDisplayVersionForExport && rawMaterialCosts)
            ? rawMaterialCosts.map(v => convertCurrency(v || new Decimal(0), localCurrencyName, savedDisplayCurrencyName, currencyData))
            : rawMaterialCosts;

          // 更新後データ
          const afterData = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            originalProfitAndLossByMonth.labels,
            false,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            exportCurrencyNameForUpdate,
            currencyData,
            null,
            hasDecimal(exportCurrencyNameForUpdate),
            processCodeData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined
          );

          // 更新前データ
          const beforeDataRaw = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            originalProfitAndLossByMonth.labels,
            false,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            exportCurrencyNameForUpdate,
            currencyData,
            null,
            hasDecimal(exportCurrencyNameForUpdate),
            processCodeData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined
          );
          const beforeData = beforeDataRaw ? applyBeforeUpdateLogic(beforeDataRaw) : null;

          // 修正6: 営業利益をローカル通貨から直接変換して上書き（DB営業利益との一致）
          // 振り返りモード時はスキップ（afterDataが既に月別レートで変換済みのため、単一レートで上書きすると2重変換になる）
          if (!reviewDate && useDisplayVersionForExport && afterData) {
            const localProfitDataset = salesChartData?.datasets?.find((d: any) => d.id === "profit");
            if (localProfitDataset) {
              afterData.profit = localProfitDataset.data
                .slice(0, afterData.labels.length)
                .map((v: number) =>
                  convertCurrency(new Decimal(v || 0), localCurrencyName, savedDisplayCurrencyName, currencyData)
                    .toDecimalPlaces(4)
                );
            }
          }

          if (afterData && beforeData) {
            const sheetData = createUpdateComparisonMonthlySheet(beforeData, afterData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossOriginal'), beforeLabel, afterLabel, !!reviewDate || useDisplayVersionForExport);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.originalMonthlyProfitLossSheetName'));
          }
        }
      }

      // ダウンサイド（更新前/更新後 または 合理化前/合理化後）シートを作成
      if (!isSimpleMode && salesChartDataModified?.datasets) {
        const salesDataset = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
          // ダウンサイドチャートデータは既に期間短縮されているため、labelsもそれに合わせる
          const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
          const materialCosts = calcMaterialCost(
            mergedChartDataModified,
            quantitiesChartDataModified,
            capexPartNo,
            downsideLabels,
            projectData.projectId!,
            localCurrencyName,
            currencyData
          );

          // 更新後データ（ストレス指数適用）
          const afterData = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            downsideLabels,
            true,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            reviewDate ? selectedCurrency.name : localCurrencyName,
            currencyData,
            downsideIndexGraph,
            decimalCurrency,
            processCodeData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined,
            // No.411対応（追加調査）: 当初計画側と同じラベルまで年月列を延長する
            !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
          );

          // 更新前データ（ストレス指数適用後に3ヶ月平均ロジック適用）
          const beforeDataRaw = calcMonthlyProfitAndLossDetails(
            sales,
            materialCosts || [],
            downsideLabels,
            true,
            originalEquipmentAmounts,
            projectData,
            capexPartNo,
            reviewDate ? selectedCurrency.name : localCurrencyName,
            currencyData,
            downsideIndexGraph,
            decimalCurrency,
            processCodeData,
            bomData,
            projectData.moldSalesByProject,
            projectData.developmentSalesByProject,
            projectData.equipmentSalesByProject,
            undefined,
            reviewDate ? convertWithRate : undefined,
            // No.411対応（追加調査）: 当初計画側と同じラベルまで年月列を延長する（beforeDataも揃えないと行内で列数がずれる）
            !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
          );
          const beforeData = beforeDataRaw ? applyBeforeUpdateLogic(beforeDataRaw) : null;

          if (afterData && beforeData) {
            const sheetData = createUpdateComparisonMonthlySheet(beforeData, afterData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossDownside'), beforeLabel, afterLabel, !!reviewDate);
            const sheet = XLSX.utils.aoa_to_sheet(sheetData);
            sheet["!cols"] = getAutoColWidths(sheetData);
            XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.downsideMonthlyProfitLossSheetName'));
          }
        }
      }

      // 保存済み設定シートを作成（簡易モードは月別損益が画面で非表示のためスキップ）
      if (!isSimpleMode) for (const chartDataItem of salesChartDataForSavedConfig) {
        const config = savedConfigs.find(c => c.id === chartDataItem.configId);
        if (!config) continue;

        const salesDataset = chartDataItem.data?.datasets?.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
          // 保存済み設定のチャートデータは既に期間短縮されているため、labelsもそれに合わせる
          const savedConfigLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);

          // 保存済み設定の数量データを取得
          const savedQuantitiesChartData = quantitiesChartDataForSavedConfig.find(
            q => q.configId === chartDataItem.configId
          );
          const savedMergedChartData = mergedChartDataForSavedConfig.find(
            m => m.configId === chartDataItem.configId
          );

          if (savedQuantitiesChartData && savedMergedChartData) {
            const materialCosts = calcMaterialCost(
              savedMergedChartData.data,
              savedQuantitiesChartData.data,
              capexPartNo,
              savedConfigLabels,
              projectData.projectId!,
              localCurrencyName,
              currencyData
            );

            // 保存済み設定の設備情報を取得
            // SavedEquipmentConfigに含まれている設備 = 選択されている設備
            const savedEquipmentConfig = config.equipmentAmounts || [];
            const configEquipments = originalEquipmentAmounts
              .map(eq => {
                const savedEq = savedEquipmentConfig.find(se => se.equipmentId === eq.equipmentId);
                return savedEq ? { ...eq, selected: true } : null;
              })
              .filter((eq): eq is EquipmentExtType => eq !== null);

            const configApplyDownside = config.applyDownside !== false;
            const configDownsideIndex = configApplyDownside ? downsideIndexGraph : neutralDownsideIndex;

            // 更新後データ（ストレス指数適用）
            const afterData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              savedConfigLabels,
              configApplyDownside,
              configEquipments,
              applyScenarioLaborCostToProjectData(
                projectData,
                config.scenarioLaborCostByMonth,
                config.scenarioOverseasFactoryExpensesByMonth,
                savedConfigLabels
              ),
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              configDownsideIndex,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined,
              // No.411対応（追加調査）: 当初計画側と同じラベルまで年月列を延長する
              !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
            );

            // 更新前データ（ストレス指数適用後に3ヶ月平均ロジック適用）
            const beforeDataRaw = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              savedConfigLabels,
              configApplyDownside,
              configEquipments,
              applyScenarioLaborCostToProjectData(
                projectData,
                config.scenarioLaborCostByMonth,
                config.scenarioOverseasFactoryExpensesByMonth,
                savedConfigLabels
              ),
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              configDownsideIndex,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined,
              // No.411対応（追加調査）: 当初計画側と同じラベルまで年月列を延長する（beforeDataも揃えないと行内で列数がずれる）
              !reviewDate ? incrementalCashFlowOriginal?.labels : undefined,
            );
            const beforeData = beforeDataRaw ? applyBeforeUpdateLogic(beforeDataRaw) : null;

            if (afterData && beforeData) {
              const sheetName = sanitizeSheetName(config.name || `保存済み${config.id}`, '（月別損益）');
              const sheetData = createUpdateComparisonMonthlySheet(beforeData, afterData, `月別損益（${config.name || '保存済み設定'}）`, beforeLabel, afterLabel, !!reviewDate);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
            }
          }
        }
      }

      // PJ全体シートを作成（更新・合理化プロジェクト用）
      if (!isSimpleMode && salesChartData?.datasets) {
        const salesDataset = salesChartData.datasets.find((d: any) => d.id === "sales");
        if (salesDataset) {
          const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
          const materialCosts = calcMaterialCost(
            mergedChartDataOriginal,
            quantitiesChartDataOriginal,
            capexPartNo,
            originalProfitAndLossByMonth.labels,
            projectData.projectId!,
            localCurrencyName,
            currencyData
          );

          // mergeEquipmentAmounts: 過去PJ設備 + 現PJ設備
          const mergeEquipmentAmounts = [...pastEquipmentAmounts, ...originalEquipmentAmounts];

          {
            // 更新・合理化プロジェクト共通: 更新前/後（または合理化前/後）形式
            const afterData = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              originalProfitAndLossByMonth.labels,
              false,
              mergeEquipmentAmounts,
              projectData,
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              null,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined
            );
            const beforeDataRaw = calcMonthlyProfitAndLossDetails(
              sales,
              materialCosts || [],
              originalProfitAndLossByMonth.labels,
              false,
              mergeEquipmentAmounts,
              projectData,
              capexPartNo,
              reviewDate ? selectedCurrency.name : localCurrencyName,
              currencyData,
              null,
              decimalCurrency,
              processCodeData,
              bomData,
              projectData.moldSalesByProject,
              projectData.developmentSalesByProject,
              projectData.equipmentSalesByProject,
              undefined,
              reviewDate ? convertWithRate : undefined
            );
            const beforeData = beforeDataRaw ? applyBeforeUpdateLogic(beforeDataRaw) : null;

            if (afterData && beforeData) {
              // PJ全体では過去PJ設備がmergeEquipmentAmounts経由でequipmentDepreciationに含まれるため、
              // 投資対象設備から過去PJ分を差し引いて現PJ分のみにする（内訳合計の整合性を維持）
              // EOL後はpastEquipmentCostが0でもmerge設備の償却が残る場合があるため、
              // EOL予定日以降の月のequipmentDepreciationを0にする
              // 現PJ設備のみで投資対象設備の減価償却費を再計算（過去PJ分を含まない正確な値）
              const currentEquipDepRaw = calcEquipmentDepreciationByYearMonth(
                getTotalFiscalYearsByPartNo(capexPartNo),
                convertEquipmentData(originalEquipmentAmounts, reviewDate ? selectedCurrency.name : localCurrencyName, currencyData, reviewDate ? convertWithRate : undefined),
                decimalCurrency,
                projectData.projectStartDate || "",
                false
              );
              const currentEquipDep = currentEquipDepRaw
                .slice(0, afterData.labels.length)
                .map(e => e.value);
              afterData.equipmentDepreciation = currentEquipDep;
              // beforeDataにも同じ現PJ設備のみの値を適用（applyBeforeUpdateLogicで平均化済み）
              beforeData.equipmentDepreciation = beforeData.equipmentDepreciation.map((val, i) => {
                const pastVal = (beforeData.pastEquipmentCost || [])[i] || new Decimal(0);
                return val.minus(pastVal);
              });
              // afterData/beforeDataの集計値を再計算
              [afterData, beforeData].forEach(data => {
                const pe = data.pastEquipmentCost || [];
                data.depreciation = data.equipmentDepreciation.map((val, i) =>
                  val.plus(pe[i] || new Decimal(0)).plus(data.factoryCost[i] || new Decimal(0)).plus(data.otherEquipmentCost[i] || new Decimal(0))
                );
                data.factoryExpenses = data.depreciation.map((val, i) => val.plus(data.overHeadCost[i] || new Decimal(0)));
                data.salesCost = data.materialCost.map((val, i) =>
                  val.plus(data.outsideCost[i] || new Decimal(0)).plus(data.laborCost[i] || new Decimal(0))
                    .plus(data.domesticLaborCost[i] || new Decimal(0)).plus(data.factoryExpenses[i] || new Decimal(0))
                    .plus(data.domesticFactoryExpenses[i] || new Decimal(0)).plus(data.scrapCost[i] || new Decimal(0))
                );
                data.profit = data.totalSales.map((val, i) =>
                  val.minus(data.salesCost[i] || new Decimal(0)).minus(data.sGAExpenses[i] || new Decimal(0)).minus(data.otherCost[i] || new Decimal(0))
                );
              });
              const sheetData = createUpdateComparisonMonthlySheet(beforeData, afterData, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossWholeProject'), beforeLabel, afterLabel, !!reviewDate);
              const sheet = XLSX.utils.aoa_to_sheet(sheetData);
              sheet["!cols"] = getAutoColWidths(sheetData);
              XLSX.utils.book_append_sheet(workbook, sheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.wholeProjectMonthlyProfitLossSheetName'));
            }
          }
        }
      }

      // 増分キャッシュフロー（PJ全体）シート追加
      if (incrementalCashFlowAll) {
        const cfSheetData = createIncrementalCashFlowSheet(
          incrementalCashFlowAll,
          t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowWholeProject')
        );
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowWholeProject'));
      }

      // 増分キャッシュフロー（当初投資）シート追加
      if (incrementalCashFlowPast) {
        const cfSheetData = createIncrementalCashFlowSheet(
          incrementalCashFlowPast,
          t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowPastInvestment')
        );
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowPastInvestment'));
      }

      // 増分キャッシュフロー（当初計画）シート追加
      // 注意: 増分CFデータは常にローカル通貨なので skipConversion は常に false
      if (incrementalCashFlowOriginal) {
        const cfSheetData = createIncrementalCashFlowSheet(
          incrementalCashFlowOriginal,
          t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowOriginal')
        );
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowOriginal'));
      }

      // 増分キャッシュフロー（ダウンサイド）シート追加
      if (incrementalCashFlowDownside) {
        // No.411対応（8章）: 当初計画側と同じラベルまで年月列を延長する
        const cfSheetData = createIncrementalCashFlowSheet(
          incrementalCashFlowDownside,
          t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowDownside'),
          false,
          incrementalCashFlowOriginal?.labels
        );
        const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
        cfSheet["!cols"] = getAutoColWidths(cfSheetData);
        XLSX.utils.book_append_sheet(workbook, cfSheet, t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlowDownside'));
      }

      // 増分キャッシュフロー（保存済み設定）シート追加
      // No.411対応（8章）: 保存済み設定もダウンサイド（ストレス指数）の一種のため同様に延長
      if (isSimpleMode) {
        // 簡易モード: salesChartDataForSavedConfig が空のため incrementalCashFlowForSavedConfig を直接使用
        for (const cfItem of incrementalCashFlowForSavedConfig) {
          const config = savedConfigs.find(c => c.id === cfItem.configId);
          if (!config) continue;
          const cfSheetName = sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
            + `（${config.name || `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigNamePrefix')}${config.id}`}）`
          );
          const cfSheetData = createIncrementalCashFlowSheet(
            cfItem.data,
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
            + `（${config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName')}）`,
            false,
            incrementalCashFlowOriginal?.labels
          );
          const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
          cfSheet["!cols"] = getAutoColWidths(cfSheetData);
          XLSX.utils.book_append_sheet(workbook, cfSheet, cfSheetName);
        }
      } else {
        for (const chartDataItem of salesChartDataForSavedConfig) {
          const config = savedConfigs.find(c => c.id === chartDataItem.configId);
          if (!config) continue;
          const savedCfData = incrementalCashFlowForSavedConfig.find(
            item => item.configId === chartDataItem.configId
          );
          if (savedCfData) {
            const cfSheetName = sanitizeSheetName(
              `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
              + `（${config.name || `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigNamePrefix')}${config.id}`}）`
            );
            const cfSheetData = createIncrementalCashFlowSheet(
              savedCfData.data,
              `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.incrementalCashFlow')}`
              + `（${config.name || t('features.InvestmentScreening.SimulationProductivityImprovement.excel.savedConfigDefaultName')}）`,
              false,
              incrementalCashFlowOriginal?.labels
            );
            const cfSheet = XLSX.utils.aoa_to_sheet(cfSheetData);
            cfSheet["!cols"] = getAutoColWidths(cfSheetData);
            XLSX.utils.book_append_sheet(workbook, cfSheet, cfSheetName);
          }
        }
      }

      // 生産能力（プロセス）シート追加
      const pcBeforeLabel = projectData.purpose === PurposeType.Rationalization.code ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationBefore') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateBefore');
      const pcAfterLabel = projectData.purpose === PurposeType.Rationalization.code ? t('features.InvestmentScreening.SimulationProductivityImprovement.label.rationalizationAfter') : t('features.InvestmentScreening.SimulationProductivityImprovement.label.updateAfter');

      // 各プロセスの recentActual を事前計算
      const getRecentActual = (processId: string) => {
        if (projectData.purpose === PurposeType.Rationalization.code) {
          return { operatingRate: 0, yieldRate: 0, cycleTime: 0 };
        }
        const updateSummary = updateSummaryDataList.find(s => s.productionLineId === processId);
        const capacityByPartNo = updateSummary?.productionCapacityByPartNo;
        let targetPartNo: string | undefined;
        if (capacityByPartNo) {
          const keys = Object.keys(capacityByPartNo);
          targetPartNo = (updateSummary?.selectedPartNo && keys.includes(updateSummary.selectedPartNo))
            ? updateSummary.selectedPartNo : keys[0];
        }
        const cap = targetPartNo && capacityByPartNo ? capacityByPartNo[targetPartNo] : null;
        return {
          operatingRate: (cap?.recentActual?.operatingRate ?? 0) / 100,
          yieldRate: (cap?.recentActual?.yield ?? 0) / 100,
          cycleTime: cap?.recentActual?.cycleTime ?? 0,
        };
      };

      // 各プロセスの partsCount を取得
      const getPartsCount = (processId: string) => {
        if (projectData.purpose === PurposeType.Rationalization.code) {
          const summary = rationalizationSummaryDataList.find(s => s.processId === processId);
          return summary?.partsCount ?? 1;
        }
        const summary = updateSummaryDataList.find(s => s.productionLineId === processId);
        return summary?.partsCount ?? 1;
      };

      // 前（当初計画）: 全プロセスを1シートにまとめる
      {
        const processList = productionCapacityProcessChartDataList
          .filter(p => p.beforeData)
          .map(p => ({
            processName: p.processName || p.processId,
            chartData: p.beforeData,
            recentActual: getRecentActual(p.processId),
            partsCount: getPartsCount(p.processId),
          }));
        if (processList.length > 0) {
          const sheetData = createProcessProductionCapacitySheet(
            processList, true, originalProfitAndLossByMonth?.quantityByPartNo,
            workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
            pastAvailabilityRateByMonth,
          );
          const sheet = XLSX.utils.aoa_to_sheet(sheetData);
          sheet["!cols"] = getAutoColWidths(sheetData);
          XLSX.utils.book_append_sheet(workbook, sheet, sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}（${pcBeforeLabel}）`)
          );
        }
      }

      // 後（当初計画）: 全プロセスを1シートにまとめる
      {
        const processList = productionCapacityProcessChartDataList
          .filter(p => p.afterData)
          .map(p => ({
            processName: p.processName || p.processId,
            chartData: p.afterData,
            recentActual: getRecentActual(p.processId),
            partsCount: getPartsCount(p.processId),
          }));
        if (processList.length > 0) {
          const sheetData = createProcessProductionCapacitySheet(
            processList, false, originalProfitAndLossByMonth?.quantityByPartNo,
            workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
          );
          const sheet = XLSX.utils.aoa_to_sheet(sheetData);
          sheet["!cols"] = getAutoColWidths(sheetData);
          XLSX.utils.book_append_sheet(workbook, sheet, sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}（${pcAfterLabel}）`)
          );
        }
      }

      // ダウンサイドの販売数量（簡易モードのダウンサイドは当初計画と同値のため当初数量）
      const pcDownsideQuantityByPartNo = isSimpleMode
        ? originalProfitAndLossByMonth?.quantityByPartNo
        : extractQuantityByPartNoFromChart(quantitiesChartDataModified, 0).quantityByPartNo;

      // 前（ダウンサイド）: 全プロセスを1シートにまとめる
      {
        const processList = productionCapacityProcessChartDataList
          .filter(p => p.beforeDownsideData)
          .map(p => ({
            processName: p.processName || p.processId,
            chartData: p.beforeDownsideData,
            recentActual: getRecentActual(p.processId),
            partsCount: getPartsCount(p.processId),
          }));
        if (processList.length > 0) {
          const sheetData = createProcessProductionCapacitySheet(
            processList, true, pcDownsideQuantityByPartNo,
            workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
            pastAvailabilityRateByMonth,
          );
          const sheet = XLSX.utils.aoa_to_sheet(sheetData);
          sheet["!cols"] = getAutoColWidths(sheetData);
          XLSX.utils.book_append_sheet(workbook, sheet, sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}（${pcBeforeLabel}_DS）`)
          );
        }
      }

      // 後（ダウンサイド）: 全プロセスを1シートにまとめる
      {
        const processList = productionCapacityProcessChartDataList
          .filter(p => p.afterDownsideData)
          .map(p => ({
            processName: p.processName || p.processId,
            chartData: p.afterDownsideData,
            recentActual: getRecentActual(p.processId),
            partsCount: getPartsCount(p.processId),
          }));
        if (processList.length > 0) {
          const sheetData = createProcessProductionCapacitySheet(
            processList, false, pcDownsideQuantityByPartNo,
            workingDayByYear, holidayByYear, availabilityRateByMonth, lineCountByYear,
            (ym) => getYieldRateFromBomData(ym, bomData),
            (ym) => getCycleTimeFromBomData(ym, bomData),
          );
          const sheet = XLSX.utils.aoa_to_sheet(sheetData);
          sheet["!cols"] = getAutoColWidths(sheetData);
          XLSX.utils.book_append_sheet(workbook, sheet, sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}（${pcAfterLabel}_DS）`)
          );
        }
      }

      // 生産能力（プロセス）保存済み設定シート追加（後のみ、全プロセスを1シート）
      for (const savedPcItem of productionCapacityProcessChartDataForSavedConfig) {
        const config = savedConfigs.find(c => c.id === savedPcItem.configId);
        if (!config) continue;
        const processList = savedPcItem.processData
          .filter(p => p.afterData)
          .map(p => ({
            processName: p.processName || p.processId,
            chartData: p.afterData,
            recentActual: { operatingRate: 0, yieldRate: 0, cycleTime: 0 },
            partsCount: getPartsCount(p.processId),
          }));
        if (processList.length > 0) {
          // 簡易モードは当初数量、詳細モードは数量グラフの保存済み設定版（ストレスON＝ダウンサイド／OFF＝当初）
          const configQuantityByPartNo = isSimpleMode
            ? originalProfitAndLossByMonth?.quantityByPartNo
            : extractQuantityByPartNoFromChart(
              quantitiesChartDataForSavedConfig.find(item => item.configId === savedPcItem.configId)?.data, 0).quantityByPartNo;
          const sheetData = createProcessProductionCapacitySheet(
            processList, false, configQuantityByPartNo,
            config.improvedWorkingDayByYear,
            config.improvedHolidayByYear,
            config.improvedAvailabilityRateByMonth,
            config.improvedLineCountByYear,
            (ym) => getApplicableYieldRate(ym, config.improvedYieldRateList, (y) => getYieldRateFromBomData(y, bomData)),
            (ym) => getApplicableCycleTime(ym, config.improvedCycleTimeList, (y) => getCycleTimeFromBomData(y, bomData)),
          );
          const sheet = XLSX.utils.aoa_to_sheet(sheetData);
          sheet["!cols"] = getAutoColWidths(sheetData);
          XLSX.utils.book_append_sheet(workbook, sheet, sanitizeSheetName(
            `${t('features.InvestmentScreening.SimulationProductivityImprovement.excel.productionCapacity')}（${config.name || config.id}）`)
          );
        }
      }

      // ファイル出力
      const formatted = today.toISOString().split("T")[0].replace(/-/g, "");
      const monthlyProfitLossFileNamePrefix = t('features.InvestmentScreening.SimulationProductivityImprovement.excel.monthlyProfitLossFileNamePrefix');
      XLSX.writeFile(workbook, `${monthlyProfitLossFileNamePrefix}_${projectId}_${formatted}.xlsx`);

      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.excelExportSuccess'),
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      // console.log(`${functionName} SUCCESS`);
    } catch (error) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.excelExportFailed'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      console.error(`${functionName} ERROR:`, error);
    }
  };

  // #endregion Excel出力関連

  /**
   * 「確認」ボタン押下処理
   */
  const handleModalOpen: React.MouseEventHandler<HTMLButtonElement> = (event) => {

    // フォーカスを外す
    event.currentTarget.blur();

    // どの部署からの確認かを保持
    const { name } = event.target as HTMLButtonElement;
    setConfirmSource(name);

    if (!projectData) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.registerFromBasicInfo'),
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    // 更新前後サマリー/合理化前後サマリーのチェック結果を計算
    let additionalInfoCheckResult = true;
    if (projectData.purpose === PurposeType.Rationalization.code) {
      // 合理化投資の場合は合理化前後サマリーをチェック
      if (rationalizationSummaryDataList?.length && equipmentAmounts?.length) {
        // 全件登録必須チェック（設備の全processIdが合理化前後サマリーに一致していないと通過できない仕様）は
        // 「1件以上必須チェック」のみ残す方針のためコメントアウト
        // const processIds = [...new Set(equipmentAmounts.map((eq: any) => eq.processId).filter((id: any) => id))];
        // const rationalizationProcessIds = rationalizationSummaryDataList.map((data: RationalizationSummaryInputData) => data.processId);
        // additionalInfoCheckResult =
        //   processIds.length === rationalizationProcessIds.length &&
        //   processIds.every((id: any) => rationalizationProcessIds.includes(id));
        // 上記の全件一致チェックは撤廃し、1件以上登録されていればtrueとする
        additionalInfoCheckResult = true;
      } else if (!rationalizationSummaryDataList?.length) {
        // 簡易様式の場合は合理化前後サマリー未入力を許容（詳細様式では必須）
        additionalInfoCheckResult = isSimpleMode;
      }
    } else if (projectData.purpose === PurposeType.UpdateAndOther.code) {
      // 更新・その他の場合は更新前後サマリーをチェック
      if (updateSummaryDataList?.length && equipmentAmounts?.length) {
        // 全件登録必須チェック（設備の全processIdが更新前後サマリーに一致していないと通過できない仕様）は
        // 「1件以上必須チェック」のみ残す方針のためコメントアウト
        // const processIds = [...new Set(equipmentAmounts.map((eq: any) => eq.processId).filter((id: any) => id))];
        // const updateSummaryProcessIds = updateSummaryDataList.map((data: UpdateSummaryInputData) => data.productionLineId);
        // additionalInfoCheckResult =
        //   processIds.length === updateSummaryProcessIds.length &&
        //   processIds.every((id: any) => updateSummaryProcessIds.includes(id));
        // 上記の全件一致チェックは撤廃し、1件以上登録されていればtrueとする
        additionalInfoCheckResult = true;
      } else if (!updateSummaryDataList?.length) {
        // 簡易様式の場合は更新前後サマリー未入力を許容（詳細様式では必須）
        additionalInfoCheckResult = isSimpleMode;
      }
    }

    // 損益非表示モード時は表・グラフを表示しないため、画面間の入力チェックはスキップ
    if (!isProfitLossHiddenMode
      && !requiredDataNotice(projectData, capexPartNo, equipmentAmounts, productionLine, pastProjectData, additionalInfoCheckResult)) {
      return;
    }

    // 過去プロジェクトとのPart No整合性チェック（不整合時はトースト表示の上、確認モーダルを開かせない）
    if (projectData?.pastProjectId && (userPermissions?.length || 0) > 0) {
      const missingPartNo = findMissingPastPartNos(capexPartNo, pastCapexPartNo);
      if (missingPartNo.length > 0) {
        const partNos = missingPartNo.join(", ");
        if (userPermissions[0].flowKb === FlowKb.Confirmation) {
          toast({
            title: TITLE,
            description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastPartNoMismatchForConfirmer', { partNos }),
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
        } else if (userPermissions[0].flowKb === FlowKb.Approval) {
          if (pagePermissions?.currentFlowId !== WorkflowId.ApproveComplete) {
            toast({
              title: TITLE,
              description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.pastPartNoMismatchForApprover', { partNos }),
              status: 'warning',
              duration: 5000,
              isClosable: true,
            });
          } else {
            console.warn(`For the approved request, the PartNo[${partNos}] of the Project linked to a past project does not match the PartNo of the current project.`);
          }
        }
        return;
      }
    }

    if (validate() === false) {
      toast({
        title: TITLE,
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.inputError'),
        status: 'warning',
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    setSelectedCustomerProduct(conditionTable?.customerIndustryName || "");

    // 確認モーダル表示
    onOpenConfirmModal();
  }

  /**
   * 確認モーダルで「保存」ボタン押下
   */
  const handleConfirm = async (e: React.MouseEvent<HTMLButtonElement>) => {
    // フォーカスを外す
    e.currentTarget.blur();

    if (isSaving) return;
    setIsSaving(true);

    // 損益非表示モードでは表・グラフを生成しないため、チャートデータの保存自体を行わず確認APIのみ呼び出す
    // （保存すると未生成のチャートデータで既存の保存済みデータを上書きしてしまうため）
    // 既存ライン生産数量（生産キャパグラフ、増産のみ）も同じ理由でスキップする（OFF扱いの null で上書きしないため）
    // 増産では既存ライン生産数量 → チャートデータの順に保存し、既存ライン生産数量の保存に失敗した場合はチャート保存・確認登録を行わない
    const isIncreasedProduction = projectData?.purpose === PurposeType.IncreasedProduction.code;
    const result = isProfitLossHiddenMode
      ? true
      : (!isIncreasedProduction || await elq.save()) && await saveChartData();

    if (result) {
      try {
        // ワークフローテーブルを更新
        await updateConfirm(
          WebAPI,
          projectId,
          WorkflowId.SimulationProductivityImprovement,
          employeeId,
          confirmSource,
          "true",
          reviewDate,
        );
        // 確認担当者JSONを取得
        const confirmor = await getConfirmor(
          WebAPI,
          projectId,
          reviewDate,
        );
        setConfirmor(confirmor);

        // 確認モーダルを閉じる
        onCloseConfirmModal();
      } catch (error) {
        // TODO 処理失敗時は暫定でスルーする
      }
    }

    setIsSaving(false);
  }

  /**
   * チャートデータを保存する。
   * @returns true：処理成功、false：処理失敗
   */
  const saveChartData = async () => {
    const query = `
    mutation updateChartData($input: ChartDataInput!) {
      updateChartData(input: $input) {status}
    }
  `;

    // 生産キャパグラフ：増産かつON（使用する）のときのみ保存。合理化・更新・OFFは null（申請書に表示しない）
    const includeExistingLineCapacityChart = projectData?.purpose === PurposeType.IncreasedProduction.code && elq.show;

    // APIリクエスト実行
    const result = await WebAPI.request({
      query: query,
      variables: {
        input: {
          projectId: projectId,
          applyDownside: (selectedCustomerProduct === CustomerIndustry.InVehicle.name),
          quantitiesChartDataOriginal: JSON.stringify(quantitiesChartDataOriginal),
          quantitiesChartDataModified: JSON.stringify(quantitiesChartDataModified),
          quantitiesChartDataForSavedConfig: JSON.stringify(quantitiesChartDataForSavedConfig),
          mergedChartDataOriginal: JSON.stringify(mergedChartDataOriginal),
          mergedChartDataModified: JSON.stringify(mergedChartDataModified),
          mergedChartDataForSavedConfig: JSON.stringify(mergedChartDataForSavedConfig),
          salesChartData: JSON.stringify(MovingAverageRate),
          salesChartDataModified: JSON.stringify(MovingAverageRateModified),
          salesChartDataAll: JSON.stringify(salesChartDataAll),                                     // 売上チャートデータ　プロジェクト全体投資回収用
          salesChartDataPast: JSON.stringify(salesChartDataPast),                                   // 売上チャートデータ　当初投資・回収用
          salesChartDataForSavedConfig: JSON.stringify(salesChartDataForSavedConfig),
          // ※チャートデータ未生成（null）のときは営業利益等のみのdatasetsを持たない不正なオブジェクトを
          //   保存してしまわないよう、nullをそのまま保存する
          combinedChartData: JSON.stringify(combinedChartData ? {
            ...combinedChartData,
            // ※生産性向上シミュレーション都合で営業利益額と営業利益率を保存
            totalProfit: totalProfitOriginal?.toString(),
            displayTotalProfit: calcDisplayTotalProfit(salesChartData2)?.toString(),
            profitRate: profitRateOriginal,
            realProfitRate: realProfitRateOriginal,
            realProfitRateByMonth: realProfitRateByMonthOriginal,
            realProfitRateCashflow: realProfitRateCashflowOriginal,
            realProfitRateByMonthCashflow: realProfitRateByMonthCashflowOriginal,
          } : null),
          combinedChartDataModified: JSON.stringify(combinedChartDataModified ? {
            ...combinedChartDataModified,
            // ※生産性向上シミュレーション都合で営業利益額と営業利益率を保存
            totalProfit: totalProfitModified?.toString(),
            displayTotalProfit: calcDisplayTotalProfit(salesChartDataModified2)?.toString(),
            profitRate: profitRateModified,
            realProfitRate: realProfitRateModifiedState,
            realProfitRateByMonth: realProfitRateByMonthModifiedState,
            realProfitRateCashflow: realProfitRateCashflowModifiedState,
            realProfitRateByMonthCashflow: realProfitRateByMonthCashflowModifiedState,
          } : null),
          combinedChartDataAll: JSON.stringify(combinedChartDataAll),                                             // プロジェクト全体投資回収チャートデータ
          combinedChartDataPast: JSON.stringify(combinedChartDataPast),                                           // 当初投資・回収チャートデータ
          combinedChartDataForSavedConfig: JSON.stringify(combinedChartDataForSavedConfig),
          monthOfRecoveryOriginal: monthOfRecoveryOriginal.join(","),
          monthOfRecoveryModified: monthOfRecoveryModified.join(","),
          monthOfRecoveryAll: monthOfRecoveryAll.join(","),                                                       // 回収時期ｎヶ月目　プロジェクト全体投資回収用
          monthOfRecoveryPast: monthOfRecoveryPast.join(","),                                                     // 回収時期ｎヶ月目　当初投資・回収用
          monthOfRecoveryForSavedConfig: JSON.stringify(monthOfRecoveryForSavedConfig),
          gapChartDataOriginal: null,                                                                             // 新製品シミュレーションでのみ保存
          gapChartDataModified: null,                                                                             // 新製品シミュレーションでのみ保存
          gapChartDataForSavedConfig: null,                                                                       // 新製品シミュレーションでのみ保存
          productionQuantityChartDataOriginal: null,                                                              // 新製品シミュレーションでのみ保存
          productionQuantityChartDataModified: null,                                                              // 新製品シミュレーションでのみ保存
          productionQuantityChartDataForSavedConfig: null,                                                        // 新製品シミュレーションでのみ保存
          existingLineCapacityChartDataOriginal: includeExistingLineCapacityChart ? JSON.stringify(elq.chartDataOriginal) : null,
          existingLineCapacityChartDataModified: includeExistingLineCapacityChart ? JSON.stringify(elq.chartDataModified) : null,
          existingLineCapacityChartDataForSavedConfig: includeExistingLineCapacityChart ? JSON.stringify(elq.chartDataForSavedConfig) : null,
          productionCapacityChartData: JSON.stringify(productionCapacityChartData),                               // 生産能力（ライン全体）当初計画
          productionCapacityChartDataModified: JSON.stringify(productionCapacityChartDataModified),               // 生産能力（ライン全体）ダウンサイド
          productionCapacityChartDataForSavedConfig: JSON.stringify(productionCapacityChartDataForSavedConfig),   // 生産能力（ライン全体）設定
          productionCapacityProcessChartDataList: JSON.stringify(productionCapacityProcessChartDataList),         // 生産能力（プロセス）更新前/後
          productionCapacityProcessChartDataForSavedConfig: JSON.stringify(productionCapacityProcessChartDataForSavedConfig), // 生産能力（プロセス）設定
          rationalizationSummaryChartData: JSON.stringify(rationalizationSummaryChartDataList),                    // 合理化前後サマリーチャートデータ（processId単位）
          selectedSimulationConfigIds: selectedConfigIds.join(","),
          downsideRisk: (downsideRiskDraftRef.current ?? "").trim(),
          downsideIndex: convertDownsideIndexToDynamoFormat(),
          updateDate: projectData?.updateDate,
          finalInvestmentReason: (finalInvestmentReasonDraftRef.current ?? "").trim(),
          ...(reviewDate && { reviewDate }),
        }
      }
    });

    // console.log(`response = `, result);

    if (result?.data?.updateChartData?.status === "success") {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveSuccess'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.savedInputContent'),
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // データ再取得
      await fetchData();

      return true;
    } else if (result?.data?.updateChartData.status === 'expired') {
      toast({
        title: TITLE,
        description: Messages.expiredMessage,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      console.warn(`Conflict error. updateChartData.`);
      onCloseConfirmModal();
    } else {
      toast({
        title: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveFailedShort'),
        description: t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.error(`Failed to call API updateChartData.errors = `, result?.errors);
      return false;
    }
  }

  /**
   * downsideIndexEnable(有効・無効情報)をDB保存用に変換する。
   * @returns DB保存用json文字列
   */
  const convertDownsideIndexEnableToDynamoFormat = (): string => {
    let data = [];

    // 数量経時変化
    data.push({
      id: DownsideItemsTitle.quantityChangeOverTime.id,
      enable: downsideIndexEnable.isEnabledQuantityChangeOverTime
    });

    // 数量上下変動
    data.push({
      id: DownsideItemsTitle.quantityFluctuation.id,
      enable: downsideIndexEnable.isEnabledFluctuationInQuantity
    });

    // 単価経時変化
    data.push({
      id: DownsideItemsTitle.priceChangeOverTime.id,
      enable: downsideIndexEnable.isEnabledPriceChangeOverTime
    });

    // 顧客製品寿命
    data.push({
      id: DownsideItemsTitle.customerProductLifecycle.id,
      enable: downsideIndexEnable.isEnabledCustomerProductLifecycle
    });

    // 為替変動（単価）
    data.push({
      id: DownsideItemsTitle.exchangeRateFluctuationToPrice.id,
      enable: downsideIndexEnable.isEnabledCurrencyFluctuationToPrice
    });

    // 為替変動（原価）
    data.push({
      id: DownsideItemsTitle.exchangeRateFluctuationToCost.id,
      enable: downsideIndexEnable.isEnabledCurrencyFluctuationToCost
    });

    // 材料高騰
    data.push({
      id: DownsideItemsTitle.materialCostIncrease.id,
      enable: downsideIndexEnable.isEnabledRisingMaterialCosts
    });

    // 労務費高騰
    data.push({
      id: DownsideItemsTitle.laborCostIncrease.id,
      enable: downsideIndexEnable.isEnabledRisingLaborCosts
    });

    // 競合状態（数量）
    data.push({
      id: DownsideItemsTitle.competitorStatusToQuantity.id,
      enable: downsideIndexEnable.isEnabledCompetitorConditionToQuantity
    });

    // 競合状態（単価）
    data.push({
      id: DownsideItemsTitle.competitorStatusToPrice.id,
      enable: downsideIndexEnable.isEnabledCompetitorConditionToPrice
    });

    return JSON.stringify(data);
  }

  /**
   * downsideIndexTableDisplayをDB保存用に変換する。
   * @returns DB保存用json文字列
   */
  const convertDownsideIndexToDynamoFormat = (): string => {
    let data = [];
    for (let i = 0; i < downsideIndexTableDisplay.length; i++) {
      let row: DownsideIndexTableRowDisplay = downsideIndexTableDisplay[i];
      // if (row.yearIndex === 0) continue;
      let stIdxValue: number = 0;

      // 数量経時変化
      stIdxValue = row.quantityChangeOverTime;
      if (!downsideIndexEnable.isEnabledQuantityChangeOverTime) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.quantityChangeOverTimeId,
        stressIndex: stIdxValue
      });

      // 数量上下変動
      stIdxValue = row.fluctuationInQuantity;
      if (!downsideIndexEnable.isEnabledFluctuationInQuantity) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.fluctuationInQuantityId,
        stressIndex: stIdxValue
      });

      // 単価経時変化
      stIdxValue = row.priceChangeOverTime;
      if (!downsideIndexEnable.isEnabledPriceChangeOverTime) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.priceChangeOverTimeId,
        stressIndex: stIdxValue
      });

      // 顧客製品寿命
      if (row.yearIndex === 0) {
        stIdxValue = row.customerProductLifecycle;
        if (!downsideIndexEnable.isEnabledCustomerProductLifecycle) {
          // 無効の場合、値をクリア
          stIdxValue = 0;
        }
        data.push({
          yearIndex: row.yearIndex + 1,
          itemId: row.customerProductLifecycleId,
          stressIndex: stIdxValue
        });
      }

      // 為替変動（単価）
      stIdxValue = row.currencyFluctuationToPrice;
      if (!downsideIndexEnable.isEnabledCurrencyFluctuationToPrice) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.currencyFluctuationToPriceId,
        stressIndex: stIdxValue
      });

      // 為替変動（原価）
      stIdxValue = row.currencyFluctuationToCost;
      if (!downsideIndexEnable.isEnabledCurrencyFluctuationToCost) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.currencyFluctuationToCostId,
        stressIndex: stIdxValue
      });

      // 材料高騰
      stIdxValue = row.risingMaterialCosts;
      if (!downsideIndexEnable.isEnabledRisingMaterialCosts) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.risingMaterialCostsId,
        stressIndex: stIdxValue
      });

      // 労務費高騰
      stIdxValue = row.risingLaborCosts;
      if (!downsideIndexEnable.isEnabledRisingLaborCosts) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.risingLaborCostsId,
        stressIndex: stIdxValue
      });

      // 競合状態（数量）
      stIdxValue = DownsideItems.competitorStatus1stToQuantity.id === row.competitorConditionToQuantityId ? row.competitorConditionToQuantity : 0;
      if (!downsideIndexEnable.isEnabledCompetitorConditionToQuantity) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.competitorConditionToQuantityId,
        stressIndex: stIdxValue
      });

      // 競合状態（単価）
      stIdxValue = DownsideItems.competitorStatus1stToPrice.id === row.competitorConditionToPriceId ? row.competitorConditionToPrice : 0;
      if (!downsideIndexEnable.isEnabledCompetitorConditionToPrice) {
        // 無効の場合、値をクリア
        stIdxValue = 0;
      }
      data.push({
        yearIndex: row.yearIndex + 1,
        itemId: row.competitorConditionToPriceId,
        stressIndex: stIdxValue
      });
    }

    return JSON.stringify(data);
  }

  useEffect(() => {
    const widths: Record<string, number> = Object.keys(refs).reduce((acc, key) => {
      acc[key] = refs[key]?.current?.offsetWidth || 0;
      return acc;
    }, {} as Record<string, number>);
    setButtonWidths(widths);
  }, []);

  useEffect(() => {
    const fetchConfirmor = async () => {
      try {
        // 確認担当者JSONを取得
        const confirmorData = await getConfirmor(
          WebAPI,
          projectId,
          reviewDate,
        );
        setConfirmor(confirmorData);
      } catch (error) {
        // TODO 処理失敗時は暫定でスルーする
      }
    };
    if (projectId) {
      fetchConfirmor();
    }
  }, [projectId, reviewDate]);

  useEffect(() => {
    if (confirmor?.simulationProductivityImprovement) {
      const updatedNames = Object.keys(names).reduce((acc, division) => {
        const divisionData = confirmor.simulationProductivityImprovement?.[division as keyof Confirmor['simulationProductivityImprovement']];
        if (Array.isArray(divisionData)) {
          acc[division] = divisionData;
        } else {
          acc[division] = [];
        }
        return acc;
      }, {} as Record<string, ConfirmorInfo[]>);
      setNames(updatedNames);
    }
  }, [confirmor]);

  /**
   * 指定した値でストレス指数の有効/無効を変更する。
   * @param name 変更先プロパティ名
   * @param value 入力項目
   */
  const changeDownsideIndexEnable = (name: string, value: any) => {
    setDownsideIndexEnable((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /**
   * 設備情報変更
   * @param equipmentId 設備ID
   * @param propertyName プロパティ名
   * @param value 値
   */
  const changeEquipmentAmounts = useCallback((equipmentId: string, propertyName: keyof EquipmentExtType, value: EquipmentExtType[typeof propertyName]) => {
    setEquipmentAmounts((prevState) =>
      prevState.map(
        (e) => e.equipmentId === equipmentId ?
          { ...e, [propertyName]: value } : e
      )
    );
  }, []);

  /**
   * 設備数量変更（金額も再計算）
   * @param equipmentId 設備ID
   * @param newQuantity 新しい数量
   */
  const changeEquipmentQuantity = useCallback((equipmentId: string, newQuantity: number) => {
    setEquipmentAmounts((prevState) =>
      prevState.map((e) => {
        if (e.equipmentId === equipmentId) {
          // 金額 = 単価 × 数量
          const newAmount = new Decimal(e.unitPrice || 0).mul(newQuantity).toString();
          return {
            ...e,
            changeInQuantity: newQuantity,
            amount: newAmount
          };
        }
        return e;
      })
    );
  }, []);

  // ▼ 営業利益率に移動平均反映
  /**移動平均反映後のsalesChartData（当初計画） */
  const [MovingAverageRate, setMovingAverageRate] = useState<any>(null);
  /**移動平均反映後のsalesChartData（ダウンサイド） */
  const [MovingAverageRateModified, setMovingAverageRateModified] = useState<any>(null);

  /** 移動平均反映後の売上チャート（当初計画）表示用 */
  // 振り返りモード時は MovingAverageRate 元データ（calcDownsideSalesChartDataSet戻り値）が
  // 既に表示通貨で返るため、displayFromCurrency を指定して convertChartDatasets を NOP にする。
  // 通常モード時は localCurrencyName → selectedCurrency の通常変換。
  const displayMovingAverageRate = useMemo(() => {
    if (!MovingAverageRate) return null;
    return convertChartDatasets(MovingAverageRate, displayFromCurrency, selectedCurrency.name, currencyData, undefined, ["profitRate"]);
  }, [MovingAverageRate, displayFromCurrency, selectedCurrency.name, currencyData]);

  /** 移動平均反映後の売上チャート（ダウンサイド）表示用 */
  const displayMovingAverageRateModified = useMemo(() => {
    if (!MovingAverageRateModified) return null;
    return convertChartDatasets(MovingAverageRateModified, displayFromCurrency, selectedCurrency.name, currencyData, undefined, ["profitRate"]);
  }, [MovingAverageRateModified, displayFromCurrency, selectedCurrency.name, currencyData]);

  // MovingAverageに移動平均反映後のデータをセット
  useEffect(() => {
    if (!salesChartData && !salesChartDataModified) return;
    if (salesChartData) {
      const updated = processData(salesChartData);
      setMovingAverageRate(updated);
    }

    if (salesChartDataModified) {
      const updatedModified = processData(salesChartDataModified);
      setMovingAverageRateModified(updatedModified);
    }
  }, [salesChartData, salesChartDataModified]);

  /**
   * 営業利益合計と営業利益率を計算して保存（当初計画）
   */
  useEffect(() => {
    if (!salesChartData2) return;

    const { totalProfit, profitRate } = calcTotalProfitAndRate(salesChartData2);
    setTotalProfitOriginal(totalProfit);
    setProfitRateOriginal(profitRate);
  }, [salesChartData2]);

  /**
   * 営業利益合計と営業利益率を計算して保存（ダウンサイド）
   */
  useEffect(() => {
    if (!salesChartDataModified2) return;

    const { totalProfit, profitRate } = calcTotalProfitAndRate(salesChartDataModified2);
    setTotalProfitModified(totalProfit);
    setProfitRateModified(profitRate);
  }, [salesChartDataModified2]);

  /**
   * 実質的営業利益率を計算（当初計画）- DB保存用
   */
  useEffect(() => {
    if (!salesChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const salesDataset = salesChartData.datasets.find((d: any) => d.id === "sales");
    if (!salesDataset) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      mergedChartDataOriginal,
      quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      originalProfitAndLossByMonth.labels,
      false,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
      return;
    }
    const totalSalesVal = monthlyData.totalSales.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0));
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
    const totalProfitVal = monthlyData.profit.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0))
      .plus(monthlyData.residualDepreciationTotal ?? new Decimal(0));
    const totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0));
    const rate = calcRealProfitRate(totalSalesVal, totalProfitVal, totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(
      monthlyData.totalSales.map((v: Decimal) => v.toNumber()),
      monthlyData.profit.map((v: Decimal) => v.toNumber()),
      monthlyData.customerSpecifiedPartsCost
    );
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateOriginal(rate);
      setRealProfitRateByMonthOriginal(byMonth);
    } else {
      setRealProfitRateOriginal(null);
      setRealProfitRateByMonthOriginal([]);
    }
  }, [salesChartData, mergedChartDataOriginal, quantitiesChartDataOriginal, originalProfitAndLossByMonth, capexPartNo, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, processCodeData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 実質的営業利益率を計算（当初計画・投資開始以降）- DB保存用
   * No.411追加対応: 投資回収セクション向け（投資開始以降にスライスした値）も、
   * 「営業利益率」側（calcTotalProfitAndRate(salesChartData2)）と同様にresidualDepreciationTotalを加算して揃える。
   */
  useEffect(() => {
    if (!salesChartData2?.datasets || !salesChartData?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0 || !investmentStartYearMonth) {
      setRealProfitRateCashflowOriginal(null);
      setRealProfitRateByMonthCashflowOriginal([]);
      return;
    }
    // salesChartData2 から totalSales / totalProfit を取得（投資開始以降のデータ）
    const salesDataset2 = salesChartData2.datasets.find((d: any) => d.id === "sales");
    const profitDataset2 = salesChartData2.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset2 || !profitDataset2) {
      setRealProfitRateCashflowOriginal(null);
      setRealProfitRateByMonthCashflowOriginal([]);
      return;
    }
    const totalSalesVal = salesDataset2.data.reduce(
      (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
    );
    const totalProfitValBase = profitDataset2.data.reduce(
      (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
    );

    // customerSpecifiedPartsCost は全期間データで算出し、投資開始以降をスライス
    const salesDatasetFull = salesChartData.datasets.find((d: any) => d.id === "sales");
    if (!salesDatasetFull) {
      setRealProfitRateCashflowOriginal(null);
      setRealProfitRateByMonthCashflowOriginal([]);
      return;
    }
    const salesFull = salesDatasetFull.data.map((v: string | number) => new Decimal(v));
    const materialCosts = calcMaterialCost(
      mergedChartDataOriginal,
      quantitiesChartDataOriginal,
      capexPartNo,
      originalProfitAndLossByMonth.labels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      salesFull,
      materialCosts || [],
      originalProfitAndLossByMonth.labels,
      false,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateCashflowOriginal(null);
      setRealProfitRateByMonthCashflowOriginal([]);
      return;
    }
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、「営業利益率」側と算出方式を統一する。
    // 「営業利益率」側（calcTotalProfitAndRate(salesChartData2)）はsalesChartData2自身が持つresidualDepreciationTotal
    // （投資開始以降のlabelsを基準に算出）を使うため、monthlyData（PJ全期間labels基準）の値ではなく
    // salesChartData2.residualDepreciationTotalを使って基準を揃える。
    const totalProfitVal = totalProfitValBase.plus(
      salesChartData2.residualDepreciationTotal ? new Decimal(salesChartData2.residualDepreciationTotal) : new Decimal(0)
    );

    const investmentStartPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);
    const customerCostSliced = monthlyData.customerSpecifiedPartsCost.slice(investmentStartPos);
    const totalCustomerCost = customerCostSliced.reduce((sum, v) => sum.plus(v || new Decimal(0)), new Decimal(0));

    const rate = calcRealProfitRate(totalSalesVal, totalProfitVal, totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(
      salesDataset2.data.map((v: string | number) => Number(v)),
      profitDataset2.data.map((v: string | number) => Number(v)),
      customerCostSliced
    );
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateCashflowOriginal(rate);
      setRealProfitRateByMonthCashflowOriginal(byMonth);
    } else {
      setRealProfitRateCashflowOriginal(null);
      setRealProfitRateByMonthCashflowOriginal([]);
    }
  }, [salesChartData2, salesChartData, mergedChartDataOriginal, quantitiesChartDataOriginal, originalProfitAndLossByMonth, capexPartNo, investmentStartYearMonth, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, processCodeData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 実質的営業利益率を計算（ダウンサイド）- DB保存用
   */
  useEffect(() => {
    if (!salesChartDataModified?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0) {
      setRealProfitRateModifiedState(null);
      setRealProfitRateByMonthModifiedState([]);
      return;
    }
    const salesDataset = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
    if (!salesDataset) {
      setRealProfitRateModifiedState(null);
      setRealProfitRateByMonthModifiedState([]);
      return;
    }
    const sales = salesDataset.data.map((v: string | number) => new Decimal(v));
    const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, sales.length);
    const materialCosts = calcMaterialCost(
      mergedChartDataModified,
      quantitiesChartDataModified,
      capexPartNo,
      downsideLabels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      sales,
      materialCosts || [],
      downsideLabels,
      true,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataModifiedは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateModifiedState(null);
      setRealProfitRateByMonthModifiedState([]);
      return;
    }
    const totalSalesVal = monthlyData.totalSales.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0));
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、系統A（画面表示用）と算出方式を統一する
    const totalProfitVal = monthlyData.profit.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0))
      .plus(monthlyData.residualDepreciationTotal ?? new Decimal(0));
    const totalCustomerCost = monthlyData.customerSpecifiedPartsCost.reduce((sum: Decimal, v: Decimal) => sum.plus(v || new Decimal(0)), new Decimal(0));
    const rate = calcRealProfitRate(totalSalesVal, totalProfitVal, totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(
      monthlyData.totalSales.map((v: Decimal) => v.toNumber()),
      monthlyData.profit.map((v: Decimal) => v.toNumber()),
      monthlyData.customerSpecifiedPartsCost
    );
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateModifiedState(rate);
      setRealProfitRateByMonthModifiedState(byMonth);
    } else {
      setRealProfitRateModifiedState(null);
      setRealProfitRateByMonthModifiedState([]);
    }
  }, [salesChartDataModified, mergedChartDataModified, quantitiesChartDataModified, originalProfitAndLossByMonth, capexPartNo, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, processCodeData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  /**
   * 実質的営業利益率を計算（ダウンサイド・投資開始以降）- DB保存用
   * No.411追加対応: 投資回収セクション向けも、「営業利益率」側
   * （calcTotalProfitAndRate(salesChartDataModified2)）と同様にresidualDepreciationTotalを加算して揃える。
   */
  useEffect(() => {
    if (!salesChartDataModified2?.datasets || !salesChartDataModified?.datasets || !originalProfitAndLossByMonth?.labels || !capexPartNo || capexPartNo.length === 0 || !investmentStartYearMonth) {
      setRealProfitRateCashflowModifiedState(null);
      setRealProfitRateByMonthCashflowModifiedState([]);
      return;
    }
    // salesChartDataModified2 から totalSales / totalProfit を取得（投資開始以降のデータ）
    const salesDataset2 = salesChartDataModified2.datasets.find((d: any) => d.id === "sales");
    const profitDataset2 = salesChartDataModified2.datasets.find((d: any) => d.id === "profit");
    if (!salesDataset2 || !profitDataset2) {
      setRealProfitRateCashflowModifiedState(null);
      setRealProfitRateByMonthCashflowModifiedState([]);
      return;
    }
    const totalSalesVal = salesDataset2.data.reduce(
      (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
    );
    const totalProfitValBase = profitDataset2.data.reduce(
      (sum: Decimal, v: string | number) => sum.plus(v != null ? new Decimal(v) : new Decimal(0)), new Decimal(0)
    );

    // customerSpecifiedPartsCost は全期間データで算出し、投資開始以降をスライス
    const salesDatasetFull = salesChartDataModified.datasets.find((d: any) => d.id === "sales");
    if (!salesDatasetFull) {
      setRealProfitRateCashflowModifiedState(null);
      setRealProfitRateByMonthCashflowModifiedState([]);
      return;
    }
    const salesFull = salesDatasetFull.data.map((v: string | number) => new Decimal(v));
    const downsideLabels = originalProfitAndLossByMonth.labels.slice(0, salesFull.length);
    const materialCosts = calcMaterialCost(
      mergedChartDataModified,
      quantitiesChartDataModified,
      capexPartNo,
      downsideLabels,
      projectData?.projectId!,
      localCurrencyName,
      currencyData
    );
    const monthlyData = calcMonthlyProfitAndLossDetails(
      salesFull,
      materialCosts || [],
      downsideLabels,
      true,
      originalEquipmentAmounts,
      projectData!,
      capexPartNo,
      // 振り返りモード: salesChartDataModifiedは表示通貨(selectedCurrency)で月別レート変換済みのため、
      // 費用側も表示通貨+convertFnで揃えて通貨不一致を回避する。
      // 通常モード: 従来どおりローカル通貨で統一（比率なので通貨に依存しない）。
      reviewDate ? selectedCurrency.name : localCurrencyName,
      currencyData,
      downsideIndexGraph,
      decimalCurrency,
      processCodeData,
      bomData,
      projectData?.moldSalesByProject,
      projectData?.developmentSalesByProject,
      projectData?.equipmentSalesByProject,
      undefined,
      reviewDate ? convertWithRate : undefined,
    );
    if (!monthlyData) {
      setRealProfitRateCashflowModifiedState(null);
      setRealProfitRateByMonthCashflowModifiedState([]);
      return;
    }
    // No.411追加対応: 表示期間外（生産終了後）に残る減価償却費を分子に加算し、「営業利益率」側と算出方式を統一する。
    // 「営業利益率」側（calcTotalProfitAndRate(salesChartDataModified2)）はsalesChartDataModified2自身が持つ
    // residualDepreciationTotal（投資開始以降のlabelsを基準に算出）を使うため、monthlyData（PJ全期間labels基準）
    // の値ではなくsalesChartDataModified2.residualDepreciationTotalを使って基準を揃える。
    const totalProfitVal = totalProfitValBase.plus(
      salesChartDataModified2.residualDepreciationTotal ? new Decimal(salesChartDataModified2.residualDepreciationTotal) : new Decimal(0)
    );

    const investmentStartPos = originalProfitAndLossByMonth.labels.findIndex(yearMonth => yearMonth === investmentStartYearMonth);
    const customerCostSliced = monthlyData.customerSpecifiedPartsCost.slice(investmentStartPos);
    const totalCustomerCost = customerCostSliced.reduce((sum, v) => sum.plus(v || new Decimal(0)), new Decimal(0));

    const rate = calcRealProfitRate(totalSalesVal, totalProfitVal, totalCustomerCost);
    const byMonth = calcRealProfitRateByMonth(
      salesDataset2.data.map((v: string | number) => Number(v)),
      profitDataset2.data.map((v: string | number) => Number(v)),
      customerCostSliced
    );
    // 顧客指定部品の有無判断
    const a = bomData.some((c) => c.isCustomerSpecifiedParts === "true");
    if (a) {
      setRealProfitRateCashflowModifiedState(rate);
      setRealProfitRateByMonthCashflowModifiedState(byMonth);
    } else {
      setRealProfitRateCashflowModifiedState(null);
      setRealProfitRateByMonthCashflowModifiedState([]);
    }
  }, [salesChartDataModified2, salesChartDataModified, mergedChartDataModified, quantitiesChartDataModified, originalProfitAndLossByMonth, capexPartNo, investmentStartYearMonth, projectData, localCurrencyName, currencyData, originalEquipmentAmounts, downsideIndexGraph, decimalCurrency, processCodeData, bomData, reviewDate, selectedCurrency.name, convertWithRate]);

  // salesChartDataをコピー
  const processData = (data: any): any => {
    const copied = structuredClone(data);
    return copied;
  };

  /**
   * ストレス指数　"-", backspaceを押したときの処理
   * @param row 操作対象の行データ
   * @param fieldName 更新対象となる行データのプロパティ名
   */
  const handleKeyDown = (
    row: DownsideIndexTableRowDisplay,
    fieldName: keyof DownsideIndexTableRowDisplay
  ) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    const currentVal = Number(row?.[fieldName] || 0);
    const input = e.currentTarget;
    const cursorPos = input.selectionStart ?? -1;

    // 1. 0の状態で "-" が押されたら "-0" を設定
    if (currentVal === 0 && e.key === "-") {
      updateDownsideIndexTableValue(row.yearString, fieldName, "-0");
      return;
    }

    // 2. Backspace の場合の特殊制御
    if (e.key === "Backspace") {
      // 1桁の負の数（-1 〜 -9）の末尾で Backspace を押した場合
      if (currentVal < 0 && currentVal >= -9 && cursorPos === 2) {
        e.preventDefault();
        updateDownsideIndexTableValue(row.yearString, fieldName, "-0");
      }
      // 表示が "-0" の状態（または Object.is で -0 判定）で Backspace を押した場合
      else if (input.value === "-0" || Object.is(currentVal, -0)) {
        e.preventDefault();
        updateDownsideIndexTableValue(row.yearString, fieldName, 0);
      }
    }
  };

  /**
   * レイアウト
   */
  return (
    <Box>
      <Box
        position="fixed"
        top="10vh"
        ml="2vw"
        mr="2vw"
        left="250px"
        width="calc(96vw - 250px)"
        height="85vh"
        p={6}
        paddingTop={0}
        overflowY="auto"
        bg="white"
      >
        {/* 表示切替ボタン（損益非表示モード時は表示対象が無いため非表示） */}
        {!isProfitLossHiddenMode && (
          <HStack spacing={4} p={4} bg="gray.100" justify="flex-start" position="sticky" top="0" zIndex={101}>
            <Button
              colorScheme="blue"
              onClick={() => requestModeChange("view")}
              isDisabled={mode === "view"}
            >
              {t('features.InvestmentScreening.SimulationProductivityImprovement.button.simulationView')}
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => requestModeChange("settings")}
              isDisabled={mode === "settings"}
            >
              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.simulationSettings')}
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => requestModeChange("selection")}
              isDisabled={mode === "selection"}
            >
              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.displayTargetSelection')}
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => requestModeChange("salesDataLinkage")}
              isDisabled={mode === "salesDataLinkage"}
            >
              {t('features.InvestmentScreening.SimulationProductivityImprovement.button.salesDataLinkage')}
            </Button>
          </HStack>
        )}

        {/* タブ切替時の未保存入力破棄確認ダイアログ */}
        <ConfirmDialog
          isOpen={isTabSwitchConfirmOpen}
          title={t('features.InvestmentScreening.SimulationProductivityImprovement.label.confirmDialogTitle')}
          message={t('features.InvestmentScreening.SimulationProductivityImprovement.message.confirmDialogMessage')}
          confirmLabel={t('features.InvestmentScreening.SimulationProductivityImprovement.label.confirmLabel')}
          cancelLabel={t('features.InvestmentScreening.SimulationProductivityImprovement.label.cancelLabel')}
          confirmColorScheme="red"
          onConfirm={() => {
            if (pendingModeRef.current) setMode(pendingModeRef.current);
          }}
          onClose={() => {
            pendingModeRef.current = null;
            onCloseTabSwitchConfirm();
          }}
        />

        {/* 条件分岐による表示 */}
        {mode === "salesDataLinkage" && (
          <Box mt={4}>
            <SalesDataLinkage
              isEditable={!!pagePermissions?.isEditable}
              namespace="SimulationProductivityImprovement"
              projectId={projectId}
              onReflect={handleReflectSalesDataLinkageToDownsideIndex}
              onDirtyChange={setIsSalesDataLinkageDirty}
            />
          </Box>
        )}

        {mode === "view" && (
          <Box mt={4}>
            <Heading textColor="blue" fontSize="28px" size="md">
              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.productivitySimulation')}
            </Heading>

            {/* 損益非表示モードの案内 */}
            {isProfitLossHiddenMode && (
              <Box
                mx="auto"
                mt={4}
                borderWidth="1px"
                borderRadius="md"
                boxShadow="md"
                p={6}
                mb={6}
                bg="gray.50"
              >
                <Text color="gray.600" fontSize="md" textAlign="center">
                  {t('common.message.profitLossHiddenNote')}
                </Text>
              </Box>
            )}

            {/* 表示通貨選択（損益非表示モード時は非表示） */}
            {!isProfitLossHiddenMode && (
              <Box mt={4}>
                <Flex align="center" mb={2}>
                  <Text alignItems="center" mr={4}>{t('features.InvestmentScreening.SimulationProductivityImprovement.label.displayCurrency')}</Text>
                  <Select
                    value={selectedCurrency.id}
                    onChange={(e) => {
                      const selectedOption = currencyData.find(c => c.currencyId === e.target.value);
                      if (selectedOption?.currencyId && selectedOption?.currencyName) {
                        setSelectedCurrency({ id: selectedOption.currencyId, name: selectedOption.currencyName });
                      }
                    }}
                    width="200px"
                  >
                    {currencyData
                      .filter(c => c.currencyId === localCurrencyId || c.currencyName === CurrencyNameJPY)
                      .map((c) => (
                        <option key={c.currencyId} value={c.currencyId}>
                          {c.currencyName}
                        </option>
                      ))}
                  </Select>
                </Flex>
              </Box>
            )}

            <fieldset disabled={!pagePermissions?.isEditable}>
              {/* 表・グラフ一式（損益非表示モード時は非表示。投資判断の理由のみ残す） */}
              {!isProfitLossHiddenMode && (<>
                <Box mt={4}>
                  <Heading size="md" mb={2} mt={2}>
                    {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.conditionTable')}
                  </Heading>
                  <Table
                    variant="simple"
                    width="80%"
                    minWidth="1000px"
                    sx={{
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                      "& th, & td": {
                        border: "1px solid",
                        borderColor: "gray.200",
                        whiteSpace: "normal",
                        minHeight: "2em",
                        overflowWrap: "break-word",
                        padding: "0.5em",
                      },
                    }}
                  >
                    <Thead>
                      <Tr>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.customerIndustry')}</Th>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.customerNationality')}</Th>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.customerName')}</Th>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.endUserName')}</Th>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.factoryExchangeToSales')}</Th>
                        <Th style={thStyle}>{t('features.InvestmentScreening.SimulationProductivityImprovement.tableHeader.factoryLocationCountry')}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      <Tr>
                        <Td style={tdStyle}>{conditionTable?.customerIndustryName}</Td>
                        <Td style={tdStyle}>{conditionTable?.customerNationality}</Td>
                        <Td style={tdStyle}>{conditionTable?.customerName}</Td>
                        <Td style={{ ...tdStyle, whiteSpace: "pre-line" }}>{splitEscapedList(conditionTable?.endUserName).join('\n')}</Td>
                        <Td style={tdStyle}>{`${conditionTable?.factoryExchange?.currencyName || t('features.InvestmentScreening.SimulationProductivityImprovement.label.notRegistered')} -${conditionTable?.salesExchange?.currencyName || t('features.InvestmentScreening.SimulationProductivityImprovement.label.notRegistered')} `}</Td>
                        <Td style={tdStyle}>{conditionTable?.factoryLocationCountry?.map(f => (<Text>{f}</Text>))}</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </Box>

              </>)}

              {/* ダウンサイドリスク対応（損益非表示モード時は入力不要のため非表示） */}
              {!isProfitLossHiddenMode && (
                <DownsideRiskTextarea
                  ref={downsideRiskRef}
                  initialValue={downsideRiskDraftRef.current}
                  onValueChange={(v) => { downsideRiskDraftRef.current = v; }}
                />
              )}
            </fieldset>

            {/* ダウンサイド指数（損益非表示モード時は非表示） */}
            {!isProfitLossHiddenMode && (
              <Box mt="5vh">
                <Text color="red" fontWeight="bold" mb="1vh" whiteSpace="pre-line">
                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.recommendationMessage')}
                </Text>
                <HStack>

                  <Button
                    isDisabled={isSimpleMode}
                    onClick={(event) => {
                      // フォーカスを外す
                      event.currentTarget.blur();

                      // 画面中央の座標を計算
                      const centerX = (window.innerWidth / 2) - (DOWNSIDE_INDEX_POPUP_WIDTH / 2);
                      const height = 1 + 16 + 27 + 8 + 33 + 57 * downsideIndexTableDisplay.length + 8 + 40 + 16 + 1;
                      const centerY = (window.innerHeight / 2) - (height / 2);
                      setPosition({ x: centerX, y: centerY });
                      setIsOpenDownsideIndex(true);
                    }}
                  >{t('features.InvestmentScreening.SimulationProductivityImprovement.button.downsideIndex')}</Button>
                  {isSimpleMode && (
                    <Text fontSize="sm" color="gray.500">
                      {t('features.InvestmentScreening.SimulationProductivityImprovement.label.downsideIndexNotAvailableInSimpleMode')}
                    </Text>
                  )}

                </HStack>
              </Box>
            )}

            {/* minWidth: 0 … fieldset 既定の min-width: min-content で、横長の生産キャパ入力欄にページごと引き伸ばされるのを防ぐ */}
            <fieldset disabled={!pagePermissions?.isEditable} style={{ minWidth: 0 }}>
              {/* グラフ一式（損益非表示モード時は非表示。投資判断の理由のみ残す） */}
              {!isProfitLossHiddenMode && (<>
                {/* 販売数量（Quantities Chart） - 簡易モード時は非表示 */}
                {!isSimpleMode && quantitiesChartDataOriginal && quantitiesChartDataModified && (() => {
                  // 選択された設定がある場合は、それらも含めてスケールを計算
                  const allDataSets = [quantitiesChartDataOriginal, quantitiesChartDataModified];
                  selectedConfigIds.forEach(configId => {
                    const chartData = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
                    if (chartData?.data) {
                      allDataSets.push(chartData.data);
                    }
                  });

                  // すべてのデータセットを考慮してスケールを計算
                  const allData = allDataSets.flatMap(ds =>
                    ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                  );
                  const commonLabels = quantitiesChartDataOriginal.labels.length >= quantitiesChartDataModified.labels.length
                    ? quantitiesChartDataOriginal.labels
                    : quantitiesChartDataModified.labels;
                  const { yMin, yMax } = calcYAxisRange(allData);
                  return (
                    <Box mt="8vh">
                      <Heading size="md" mb={2}>
                        {labelQuantity}
                      </Heading>
                      <Text>
                        unit: pcs
                      </Text>
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialPlan')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...quantitiesChartDataOriginal, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                spanGaps: false,
                                elements: { point: { radius: 2 } },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                },
                                plugins: {
                                  datalabels: {
                                    display: false
                                  },
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                    }
                                  }
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downside')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Line
                              data={{ ...quantitiesChartDataModified, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                spanGaps: false,
                                elements: { point: { radius: 2 } },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                },
                                plugins: {
                                  datalabels: {
                                    display: false
                                  },
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                    }
                                  }
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        {selectedConfigIds.map((configId) => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const chartData = quantitiesChartDataForSavedConfig.find(item => item.configId === configId);
                          if (!config || !chartData?.data) return null;
                          return (
                            <Box key={config.id} textAlign="center">
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Line
                                  data={{ ...chartData.data, labels: commonLabels }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    spanGaps: false,
                                    elements: { point: { radius: 2 } },
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      y: {
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard"
                                          }
                                        }
                                      },
                                    },
                                    plugins: {
                                      datalabels: {
                                        display: false
                                      },
                                      annotation: {
                                        annotations: {
                                          ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                        }
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    </Box>
                  );
                })()}

                {/* 販売単価と材料単価（Price & Material Chart） - 簡易モード時は非表示 */}
                {!isSimpleMode && (<>
                  {mergedChartDataOriginal && mergedChartDataModified && (() => {
                    // 選択された設定がある場合は、それらも含めてスケールを計算
                    const allDataSets = [displayMergedChartDataOriginal, displayMergedChartDataModified];
                    selectedConfigIds.forEach(configId => {
                      const chartData = displayMergedChartDataForSavedConfig.find(item => item.configId === configId);
                      if (chartData?.data) {
                        allDataSets.push(chartData.data);
                      }
                    });

                    // すべてのデータセットを考慮してスケールを計算
                    const allData = allDataSets.flatMap(ds =>
                      ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                    );
                    const commonLabels = displayMergedChartDataOriginal.labels.length >= displayMergedChartDataModified.labels.length
                      ? displayMergedChartDataOriginal.labels
                      : displayMergedChartDataModified.labels;
                    const { yMin, yMax } = calcYAxisRange(allData);

                    return (
                      <Box mt={4}>
                        <Heading size="md" mb={2}>
                          {isGeneralPurpose
                            ? t('features.InvestmentScreening.SimulationProductivityImprovement.heading.estimatedPriceAndMaterialUnitPrice')
                            : t('features.InvestmentScreening.SimulationProductivityImprovement.heading.salesPriceAndMaterialUnitPrice')}
                        </Heading>
                        <Text>
                          unit: {selectedCurrency.name}
                        </Text>
                        <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                          <Box textAlign="center">
                            <Heading size="sm" mb={1}>
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialPlan')}
                            </Heading>
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Line
                                data={{ ...displayMergedChartDataOriginal, labels: commonLabels }}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  spanGaps: false,
                                  elements: { point: { radius: 2 } },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard",
                                          minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                          maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        }
                                      }
                                    },
                                  },
                                  plugins: {
                                    tooltip: {
                                      enabled: true,
                                      callbacks: {
                                        label: (context: any) => {
                                          let label = context.dataset.label || '';
                                          if (label) label += ': ';
                                          if (context.parsed.y !== null) {
                                            const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                            label += context.parsed.y.toLocaleString(undefined, {
                                              minimumFractionDigits: dp,
                                              maximumFractionDigits: dp,
                                            }) + ' ' + selectedCurrency.name;
                                          }
                                          return label;
                                        }
                                      }
                                    },
                                    datalabels: {
                                      display: false
                                    },
                                    annotation: {
                                      annotations: {
                                        ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                      }
                                    }
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                          <Box textAlign="center">
                            <Heading size="sm" mb={1}>
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downside')}
                            </Heading>
                            <Box width="30vw" height="calc(30vw * 0.5625)">
                              <Line
                                data={{ ...displayMergedChartDataModified, labels: commonLabels }}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: false,
                                  spanGaps: false,
                                  elements: { point: { radius: 2 } },
                                  scales: {
                                    x: {
                                      offset: true,
                                      ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                    },
                                    y: {
                                      min: yMin,
                                      max: yMax,
                                      ticks: {
                                        format: {
                                          notation: "standard",
                                          minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                          maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        }
                                      }
                                    },
                                  },
                                  plugins: {
                                    tooltip: {
                                      enabled: true,
                                      callbacks: {
                                        label: (context: any) => {
                                          let label = context.dataset.label || '';
                                          if (label) label += ': ';
                                          if (context.parsed.y !== null) {
                                            const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                            label += context.parsed.y.toLocaleString(undefined, {
                                              minimumFractionDigits: dp,
                                              maximumFractionDigits: dp,
                                            }) + ' ' + selectedCurrency.name;
                                          }
                                          return label;
                                        }
                                      }
                                    },
                                    datalabels: {
                                      display: false
                                    },
                                    annotation: {
                                      annotations: {
                                        ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                      }
                                    }
                                  },
                                }}
                              />
                            </Box>
                          </Box>
                          {selectedConfigIds.map((configId) => {
                            const config = savedConfigs.find(c => c.id === configId);
                            const chartData = displayMergedChartDataForSavedConfig.find(item => item.configId === configId);
                            if (!config || !chartData?.data) return null;
                            return (
                              <Box key={config.id} textAlign="center">
                                <Heading size="sm" mb={1}>
                                  {config.name}
                                </Heading>
                                <Box width="30vw" height="calc(30vw * 0.5625)">
                                  <Line
                                    data={{ ...chartData.data, labels: commonLabels }}
                                    options={{
                                      responsive: true,
                                      maintainAspectRatio: false,
                                      spanGaps: false,
                                      elements: { point: { radius: 2 } },
                                      scales: {
                                        x: {
                                          offset: true,
                                          ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                        },
                                        y: {
                                          min: yMin,
                                          max: yMax,
                                          ticks: {
                                            format: {
                                              notation: "standard",
                                              minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                              maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                            }
                                          }
                                        },
                                      },
                                      plugins: {
                                        tooltip: {
                                          enabled: true,
                                          callbacks: {
                                            label: (context: any) => {
                                              let label = context.dataset.label || '';
                                              if (label) label += ': ';
                                              if (context.parsed.y !== null) {
                                                const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                                label += context.parsed.y.toLocaleString(undefined, {
                                                  minimumFractionDigits: dp,
                                                  maximumFractionDigits: dp,
                                                }) + ' ' + selectedCurrency.name;
                                              }
                                              return label;
                                            }
                                          }
                                        },
                                        datalabels: {
                                          display: false
                                        },
                                        annotation: {
                                          annotations: {
                                            ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                          }
                                        },
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                            );
                          })}
                        </Flex>
                      </Box>
                    );
                  })()}

                </>)}

                {/* 売上/営業利益/営業利益率 - 簡易モード時は非表示 */}
                {!isSimpleMode && (<>
                  {MovingAverageRate && (
                    <Box mt={4}>
                      <Heading size="md" mb={1}>
                        {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.salesProfitChart')}
                      </Heading>
                      <Text>
                        unit: {selectedCurrency.name}
                      </Text>
                      {(() => {

                        // 変数宣言（表示通貨変換済みデータ）
                        const dataLeft = displayMovingAverageRate;
                        const dataRight = displayMovingAverageRateModified || displayMovingAverageRate;

                        // 売上合計（当初計画）の合計金額を算出
                        const { totalProfit, profitRate } = calcTotalProfitAndRate(salesChartData);

                        // 売上合計（ダウンサイド）の合計金額を算出
                        const { totalProfit: totalProfitModified, profitRate: profitRateModified } = calcTotalProfitAndRate(salesChartDataModified);

                        // 実質的営業利益率を計算（当初計画）
                        const { realProfitRate, realProfitRateByMonth } = realProfitRateOriginalMemo;

                        // 実質的営業利益率を計算（ダウンサイド）
                        const { realProfitRate: realProfitRateModified, realProfitRateByMonth: realProfitRateByMonthModified } = realProfitRateDownsideMemo;

                        // 当初計画（売上/営業利益額）データをフィルタリング
                        const leftSalesData = {
                          datasets: dataLeft.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "sales"),
                          labels: dataLeft.labels
                        };

                        // 当初計画（営業利益率）データをフィルタリング
                        const leftProfitData = {
                          datasets: dataLeft.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "profitRate"),
                          labels: dataLeft.labels
                        };

                        // ダウンサイド（売上/営業利益額）データをフィルタリング
                        const rightSalesData = {
                          datasets: dataRight.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "sales"),
                          labels: dataRight.labels
                        };

                        // ダウンサイド（営業利益率）データをフィルタリング
                        const rightProfitData = {
                          datasets: dataRight.datasets.filter((ds: { yAxisID: string; }) => ds.yAxisID === "profitRate"),
                          labels: dataRight.labels
                        };

                        // 売上/営業利益額のスケールを算出
                        const { yMin: yMinLeft, yMax: yMaxLeft, commonLabels: commonLabelsLeft } = computeCommonScaleSalesChart(
                          leftSalesData,
                          rightSalesData,
                          false
                        );

                        // 営業利益率のスケールを算出
                        const { yMin: yMinRight, yMax: yMaxRight, commonLabels: commonLabelsRight } = computeCommonScaleSalesChart(
                          leftProfitData,
                          rightProfitData,
                          false
                        );

                        // 年月ラベルを取得
                        const commonLabels = commonLabelsLeft || commonLabelsRight;

                        // 選択されたシミュレーション設定のグラフデータを準備
                        const selectedConfigsData = selectedConfigIds.map(configId => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const salesData = displaySalesChartDataForSavedConfig.find(item => item.configId === configId);
                          if (!config || !salesData?.data) return null;
                          return {
                            config,
                            movingAverageData: processData(salesData.data)
                          };
                        }).filter((item): item is { config: SavedSimulationConfig; movingAverageData: any } => item !== null);

                        // 実質的営業利益率データセットを追加（当初計画）
                        const dataLeftWithRealProfitRate = realProfitRateByMonth.length > 0
                          ? {
                            ...dataLeft,
                            datasets: [
                              ...dataLeft.datasets,
                              {
                                label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.realOperatingProfitRate'),
                                id: "realProfitRate",
                                yAxisID: "profitRate",
                                data: realProfitRateByMonth,
                                borderColor: "orange",
                                backgroundColor: "orange",
                                fill: false,
                                tension: 0.4,
                                type: "line" as const,
                              }
                            ]
                          }
                          : dataLeft;

                        // 実質的営業利益率データセットを追加（ダウンサイド）
                        const dataRightWithRealProfitRate = realProfitRateByMonthModified.length > 0
                          ? {
                            ...dataRight,
                            datasets: [
                              ...dataRight.datasets,
                              {
                                label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.realOperatingProfitRate'),
                                id: "realProfitRate",
                                yAxisID: "profitRate",
                                data: realProfitRateByMonthModified,
                                borderColor: "orange",
                                backgroundColor: "orange",
                                fill: false,
                                tension: 0.4,
                                type: "line" as const,
                              }
                            ]
                          }
                          : dataRight;

                        return (
                          <Flex direction="row" justify="center" align="center" wrap="wrap">
                            <Box textAlign="center" mr="4">
                              <Heading size="sm" mb={1}>
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialPlan')}
                              </Heading>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                  calcDisplayTotalProfit(salesChartData),
                                  selectedCurrency.name
                                )} {selectedCurrency.name}
                              </Text>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRate} %
                              </Text>
                              {realProfitRate && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {realProfitRate} %
                                </Text>
                              )}
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Line
                                  data={{ ...dataLeftWithRealProfitRate, labels: commonLabels }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      sales: {
                                        position: "left",
                                        min: yMinLeft,
                                        max: yMaxLeft,
                                        ticks: {
                                          callback: (value) =>
                                            new Intl.NumberFormat("en-US", {
                                              notation: "standard",
                                              minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                              maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                            }).format(Number(value)),
                                        },
                                      },
                                      profitRate: {
                                        position: "right",
                                        min: ProfitRateChartYAxisMin,
                                        max: ProfitRateChartYAxisMax,
                                        ticks: {
                                          callback: (value) => `${value}%`,
                                        },
                                        grid: {
                                          drawOnChartArea: false,
                                        },
                                      },
                                    },
                                    spanGaps: true,
                                    elements: { point: { radius: 2 } },
                                    plugins: {
                                      tooltip: {
                                        enabled: true,
                                        callbacks: {
                                          label: (context: any) => {
                                            let label = context.dataset.label || '';
                                            if (label) label += ': ';
                                            if (context.parsed.y !== null) {
                                              if (context.dataset.yAxisID === 'profitRate') {
                                                label += context.parsed.y.toFixed(1) + ' %';
                                              } else {
                                                const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                                label += context.parsed.y.toLocaleString(undefined, {
                                                  minimumFractionDigits: dp,
                                                  maximumFractionDigits: dp,
                                                }) + ' ' + selectedCurrency.name;
                                              }
                                            }
                                            return label;
                                          }
                                        }
                                      },
                                      datalabels: {
                                        display: false
                                      },
                                      annotation: {
                                        annotations: {
                                          ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                        }
                                      }
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box textAlign="center" mr="4">
                              <Heading size="sm" mb={1}>
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downside')}
                              </Heading>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                  calcDisplayTotalProfit(salesChartDataModified),
                                  selectedCurrency.name
                                )} {selectedCurrency.name}
                              </Text>
                              <Text fontSize={"sm"} align="right">
                                {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRateModified} %
                              </Text>
                              {realProfitRateModified && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {realProfitRateModified} %
                                </Text>
                              )}
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Line
                                  data={{ ...dataRightWithRealProfitRate, labels: commonLabels }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      sales: {
                                        position: "left",
                                        min: yMinLeft,
                                        max: yMaxLeft,
                                        ticks: {
                                          callback: (value) =>
                                            new Intl.NumberFormat("en-US", {
                                              notation: "standard",
                                              minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                              maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                            }).format(Number(value)),
                                        },
                                      },
                                      profitRate: {
                                        position: "right",
                                        min: ProfitRateChartYAxisMin,
                                        max: ProfitRateChartYAxisMax,
                                        ticks: {
                                          callback: (value) => `${value}%`,
                                        },
                                        grid: {
                                          drawOnChartArea: false,
                                        },
                                      },
                                    },
                                    spanGaps: true,
                                    elements: { point: { radius: 2 } },
                                    plugins: {
                                      tooltip: {
                                        enabled: true,
                                        callbacks: {
                                          label: (context: any) => {
                                            let label = context.dataset.label || '';
                                            if (label) label += ': ';
                                            if (context.parsed.y !== null) {
                                              if (context.dataset.yAxisID === 'profitRate') {
                                                label += context.parsed.y.toFixed(1) + ' %';
                                              } else {
                                                const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                                label += context.parsed.y.toLocaleString(undefined, {
                                                  minimumFractionDigits: dp,
                                                  maximumFractionDigits: dp,
                                                }) + ' ' + selectedCurrency.name;
                                              }
                                            }
                                            return label;
                                          }
                                        }
                                      },
                                      datalabels: {
                                        display: false
                                      },
                                      annotation: {
                                        annotations: {
                                          ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                        }
                                      }
                                    },
                                  }}
                                />
                              </Box>
                            </Box>

                            {/* 選択されたシミュレーション設定のグラフを追加 */}
                            {selectedConfigsData.map(({ config, movingAverageData }, index) => {
                              const dataForGraph = movingAverageData;

                              if (!dataForGraph || !dataForGraph.datasets || !dataForGraph.labels) {
                                return null;
                              }

                              // 売上合計の合計金額を算出
                              const totalSalesConfig: Decimal = dataForGraph.datasets
                                .filter((ds: { id: string }) => ds.id === "sales")
                                .flatMap((ds: { data: any }) => ds.data)
                                .reduce((sum: Decimal, value: number) => sum.plus(value != null ? new Decimal(value) : new Decimal(0)), new Decimal(0));

                              // 営業利益額の合計金額を算出（移動平均前の生データから変換→丸め→合算、申請書画面と同一方式）
                              const rawSalesDataForConfig = salesChartDataForSavedConfig.find(s => s.configId === config.id);
                              const totalProfitConfig = calcDisplayTotalProfit(rawSalesDataForConfig?.data);

                              // 営業利益率を算出
                              const profitRateConfig = (calcProfitRate(totalSalesConfig, totalProfitConfig))?.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                              const commonLabelsConfig = dataForGraph.labels;

                              // 実質的営業利益率を計算（保存済み設定用）
                              const configResult = realProfitRateForConfigsMemo.find(r => r.configId === config.id) ?? { realProfitRate: "", realProfitRateByMonth: [] as number[] };
                              const { realProfitRate: realProfitRateConfig, realProfitRateByMonth: realProfitRateByMonthConfig } = configResult;

                              // 実質的営業利益率データセットを追加
                              const dataForGraphWithRealProfitRate = realProfitRateByMonthConfig.length > 0
                                ? {
                                  ...dataForGraph,
                                  datasets: [
                                    ...dataForGraph.datasets,
                                    {
                                      label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.realOperatingProfitRate'),
                                      id: "realProfitRate",
                                      yAxisID: "profitRate",
                                      data: realProfitRateByMonthConfig,
                                      borderColor: "orange",
                                      backgroundColor: "orange",
                                      fill: false,
                                      tension: 0.4,
                                      type: "line" as const,
                                    }
                                  ]
                                }
                                : dataForGraph;

                              return (
                                <Box key={config.id} textAlign="center" mr={index < selectedConfigsData.length - 1 ? "4" : "0"} mb={4}>
                                  <Heading size="sm" mb={1}>
                                    {config.name}
                                  </Heading>
                                  <Text fontSize={"sm"} align="right">
                                    {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                      totalProfitConfig,
                                      selectedCurrency.name
                                    )} {selectedCurrency.name}
                                  </Text>
                                  <Text fontSize={"sm"} align="right">
                                    {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRateConfig} %
                                  </Text>
                                  {realProfitRateConfig && (
                                    <Text fontSize={"sm"} align="right">
                                      {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {realProfitRateConfig} %
                                    </Text>
                                  )}
                                  <Box width="30vw" height="calc(30vw * 0.5625)">
                                    <Line
                                      data={{ ...dataForGraphWithRealProfitRate, labels: commonLabelsConfig }}
                                      options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        scales: {
                                          x: {
                                            offset: true,
                                            ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabelsConfig[index]) },
                                          },
                                          sales: {
                                            position: "left",
                                            min: yMinLeft,
                                            max: yMaxLeft,
                                            ticks: {
                                              callback: (value) =>
                                                new Intl.NumberFormat("en-US", {
                                                  notation: "standard",
                                                  minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                                  maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                                }).format(Number(value)),
                                            },
                                          },
                                          profitRate: {
                                            position: "right",
                                            min: ProfitRateChartYAxisMin,
                                            max: ProfitRateChartYAxisMax,
                                            ticks: {
                                              callback: (value) => `${value}%`,
                                            },
                                            grid: {
                                              drawOnChartArea: false,
                                            },
                                          },
                                        },
                                        spanGaps: true,
                                        elements: { point: { radius: 2 } },
                                        plugins: {
                                          tooltip: {
                                            enabled: true,
                                            callbacks: {
                                              label: (context: any) => {
                                                let label = context.dataset.label || '';
                                                if (label) label += ': ';
                                                if (context.parsed.y !== null) {
                                                  if (context.dataset.yAxisID === 'profitRate') {
                                                    label += context.parsed.y.toFixed(1) + ' %';
                                                  } else {
                                                    const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                                    label += context.parsed.y.toLocaleString(undefined, {
                                                      minimumFractionDigits: dp,
                                                      maximumFractionDigits: dp,
                                                    }) + ' ' + selectedCurrency.name;
                                                  }
                                                }
                                                return label;
                                              }
                                            }
                                          },
                                          datalabels: {
                                            display: false
                                          },
                                          annotation: {
                                            annotations: {
                                              ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                            }
                                          },
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>
                              );
                            })}
                          </Flex>
                        );
                      })()}
                    </Box>
                  )}

                </>)}

                {/* 投資回収（Combined Chart）見出し */}
                {combinedChartData && combinedChartDataModified && ((
                  <Box mt={4}>
                    <Heading size="md" mb={2}>
                      {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.incrementalCashFlow')}
                    </Heading>
                    <Text>
                      unit: {selectedCurrency.name}
                    </Text>
                  </Box>
                ))}

                {/* プロジェクト全体投資回収　当初投資・回収 */}
                {combinedChartDataAll && combinedChartDataPast && (() => {
                  // 選択された設定がある場合は、それらも含めてスケールを計算
                  const allDataSets = [displayCombinedChartDataAll, displayCombinedChartDataPast];

                  // すべてのデータセットを考慮してスケールを計算
                  const allData = allDataSets.flatMap(ds =>
                    ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                  );
                  const { yMin, yMax } = calcYAxisRange(allData, false);

                  // 営業利益合計と営業利益率を計算（プロジェクト全体投資回収）
                  const { totalProfit: totalProfitAll, profitRate: profitRateAll } = calcTotalProfitAndRate(salesChartDataAll);

                  // 営業利益合計と営業利益率を計算（当初投資・回収）
                  const { totalProfit: totalProfitPast, profitRate: profitRatePast } = calcTotalProfitAndRate(salesChartDataPast);

                  // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成
                  const annotationsAll = generateRecoveryPointAnnotationOptions(monthOfRecoveryAll, displayCombinedChartDataAll.labels);

                  // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成
                  const annotationsPast = generateRecoveryPointAnnotationOptions(monthOfRecoveryPast, displayCombinedChartDataPast.labels);

                  return (
                    <Box mt={4}>
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.projectTotalRecovery')}
                          </Heading>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                              calcDisplayTotalProfit(salesChartDataAll),
                              selectedCurrency.name
                            )} {selectedCurrency.name}
                          </Text>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRateAll} %
                          </Text>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={displayCombinedChartDataAll}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: (context: any) => {
                                        let label = context.dataset.label || '';
                                        if (label) label += ': ';
                                        if (context.parsed.y !== null) {
                                          const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                          label += context.parsed.y.toLocaleString(undefined, {
                                            minimumFractionDigits: dp,
                                            maximumFractionDigits: dp,
                                          }) + ' ' + selectedCurrency.name;
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    labels: {
                                      // 凡例のカスタマイズ
                                      generateLabels: generateLabels,
                                    }
                                  },
                                  annotation: {
                                    annotations: {
                                      zeroLine: {
                                        type: "line",
                                        yMin: 0,
                                        yMax: 0,
                                        borderColor: "red",
                                        borderDash: [4, 4],
                                        borderWidth: 2,
                                      },
                                      ...annotationsAll,
                                      ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose, Object.entries(annotationsAll).length),
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(displayCombinedChartDataAll.labels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard",
                                        minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialInvestmentRecovery')}
                          </Heading>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                              calcDisplayTotalProfit(salesChartDataPast),
                              selectedCurrency.name
                            )} {selectedCurrency.name}
                          </Text>
                          <Text fontSize={"sm"} align="right">
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRatePast} %
                          </Text>
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={displayCombinedChartDataPast}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: (context: any) => {
                                        let label = context.dataset.label || '';
                                        if (label) label += ': ';
                                        if (context.parsed.y !== null) {
                                          const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                          label += context.parsed.y.toLocaleString(undefined, {
                                            minimumFractionDigits: dp,
                                            maximumFractionDigits: dp,
                                          }) + ' ' + selectedCurrency.name;
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    labels: {
                                      // 凡例のカスタマイズ
                                      generateLabels: generateLabels,
                                    }
                                  },
                                  annotation: {
                                    annotations: {
                                      zeroLine: {
                                        type: "line",
                                        yMin: 0,
                                        yMax: 0,
                                        borderColor: "red",
                                        borderDash: [4, 4],
                                        borderWidth: 2,
                                      },
                                      ...annotationsPast,
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(displayCombinedChartDataPast.labels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard",
                                        minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Flex>
                    </Box>
                  );
                })()}

                {/* 増産、更新、合理化投資回収（当初計画 / ダウンサイド） */}
                {combinedChartData && combinedChartDataModified && (() => {
                  // 選択された設定がある場合は、それらも含めてスケールを計算
                  const allDataSets = [displayCombinedChartData, displayCombinedChartDataModified];
                  selectedConfigIds.forEach(configId => {
                    const chartData = displayCombinedChartDataForSavedConfig.find(item => item.configId === configId);
                    if (chartData?.data) {
                      allDataSets.push(chartData.data);
                    }
                  });

                  // すべてのデータセットを考慮してスケールを計算
                  const allData = allDataSets.flatMap(ds =>
                    ds?.datasets?.flatMap((dataset: any) => dataset?.data?.filter((v: any) => v !== null)) || []
                  );
                  const { yMin, yMax } = calcYAxisRange(allData, false);
                  const commonLabels = displayCombinedChartData!.labels.length >= displayCombinedChartDataModified!.labels.length
                    ? displayCombinedChartData!.labels
                    : displayCombinedChartDataModified!.labels;

                  // 営業利益合計と営業利益率を計算（増産投資分回収：当初計画）
                  const { totalProfit: totalProfitOriginal, profitRate: profitRateOriginal } = calcTotalProfitAndRate(salesChartData2);

                  // 営業利益合計と営業利益率を計算（増産投資分回収：ダウンサイド）
                  const { totalProfit: totalProfitModified, profitRate: profitRateModified } = calcTotalProfitAndRate(salesChartDataModified2);

                  // 実質的営業利益率を計算（増産投資分回収：当初計画）— 増産・合理化開始以降の期間で算出
                  const realProfitRateCashflowOriginalDisplay = realProfitRateCashflowOriginalMemo;

                  // 実質的営業利益率を計算（増産投資分回収：ダウンサイド）— 増産・合理化開始以降の期間で算出
                  const realProfitRateCashflowModifiedDisplay = realProfitRateCashflowModifiedMemo;

                  //  営業利益合計と営業利益率をチャートデータにも含める
                  combinedChartData.totalProfit = totalProfitOriginal;
                  combinedChartData.profitRate = profitRateOriginal;
                  combinedChartDataModified.totalProfit = totalProfitModified;
                  combinedChartDataModified.profitRate = profitRateModified;

                  // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成
                  const annotations = generateRecoveryPointAnnotationOptions(monthOfRecoveryOriginal, commonLabels);

                  // 動的に「回収○ヶ月目」ラベル表示のアノテーションを生成（ダウンサイド）
                  const annotationsModified = generateRecoveryPointAnnotationOptions(monthOfRecoveryModified, commonLabels);

                  return (
                    <Box mt={4}>
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4} mt={10}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {getInvestmentRecoveryLabel(projectData?.purpose, t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialPlan'))}
                          </Heading>
                          {!isSimpleMode && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                calcDisplayTotalProfit(salesChartData2),
                                selectedCurrency.name
                              )} {selectedCurrency.name}
                            </Text>
                          )}
                          {!isSimpleMode && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRateOriginal} %
                            </Text>
                          )}
                          {realProfitRateCashflowOriginalDisplay && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {realProfitRateCashflowOriginalDisplay} %
                            </Text>
                          )}
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={{ ...displayCombinedChartData, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: (context: any) => {
                                        let label = context.dataset.label || '';
                                        if (label) label += ': ';
                                        if (context.parsed.y !== null) {
                                          const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                          label += context.parsed.y.toLocaleString(undefined, {
                                            minimumFractionDigits: dp,
                                            maximumFractionDigits: dp,
                                          }) + ' ' + selectedCurrency.name;
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    labels: {
                                      // 凡例のカスタマイズ
                                      generateLabels: generateLabels,
                                    }
                                  },
                                  annotation: {
                                    annotations: {
                                      zeroLine: {
                                        type: "line",
                                        yMin: 0,
                                        yMax: 0,
                                        borderColor: "red",
                                        borderDash: [4, 4],
                                        borderWidth: 2,
                                      },
                                      ...annotations, // 動的に生成したアノテーションをここで展開
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard",
                                        minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {getInvestmentRecoveryLabel(projectData?.purpose, t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downside'))}
                          </Heading>
                          {!isSimpleMode && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                calcDisplayTotalProfit(salesChartDataModified2),
                                selectedCurrency.name
                              )} {selectedCurrency.name}
                            </Text>
                          )}
                          {!isSimpleMode && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {profitRateModified} %
                            </Text>
                          )}
                          {realProfitRateCashflowModifiedDisplay && (
                            <Text fontSize={"sm"} align="right">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {realProfitRateCashflowModifiedDisplay} %
                            </Text>
                          )}
                          <Box width="30vw" height="calc(30vw * 0.5625)">
                            <Chart
                              type="bar"
                              data={{ ...displayCombinedChartDataModified, labels: commonLabels }}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: (context: any) => {
                                        let label = context.dataset.label || '';
                                        if (label) label += ': ';
                                        if (context.parsed.y !== null) {
                                          const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                          label += context.parsed.y.toLocaleString(undefined, {
                                            minimumFractionDigits: dp,
                                            maximumFractionDigits: dp,
                                          }) + ' ' + selectedCurrency.name;
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    labels: {
                                      // 凡例のカスタマイズ
                                      generateLabels: generateLabels,
                                    }
                                  },
                                  annotation: {
                                    annotations: {
                                      zeroLine: {
                                        type: "line",
                                        yMin: 0,
                                        yMax: 0,
                                        borderColor: "red",
                                        borderDash: [4, 4],
                                        borderWidth: 2,
                                      },
                                      ...annotationsModified, // 動的に生成したアノテーションをここで展開
                                    }
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard",
                                        minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                        maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        {selectedConfigIds.map((configId) => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const combinedData = displayCombinedChartDataForSavedConfig.find(item => item.configId === configId);
                          const monthOfRecoveryData = monthOfRecoveryForSavedConfig.find(item => item.configId === configId);

                          if (!config || !combinedData?.data) return null;

                          const configAnnotations = generateRecoveryPointAnnotationOptions(monthOfRecoveryData?.data, commonLabels);
                          // 顧客指定部品の有無判断
                          const hasCustomerSpecifiedParts = bomData.some((c) => c.isCustomerSpecifiedParts === "true");

                          return (
                            <Box key={config.id} textAlign="center">
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              {!isSimpleMode && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitTotal')}{operatingProfitTotalHelpIcon}: {formatNumber(
                                    combinedData.data.displayTotalProfit != null
                                      ? new Decimal(combinedData.data.displayTotalProfit)
                                      : convertCurrency(combinedData.data.totalProfit, localCurrencyName, selectedCurrency.name, currencyData),
                                    selectedCurrency.name
                                  )} {selectedCurrency.name}
                                </Text>
                              )}
                              {!isSimpleMode && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.operatingProfitRate')}: {combinedData.data.profitRate} %
                                </Text>
                              )}
                              {hasCustomerSpecifiedParts && (
                                <Text fontSize={"sm"} align="right">
                                  {t('features.InvestmentScreening.SimulationProductivityImprovement.label.realOperatingProfitRate')}: {combinedData.data.realProfitRateCashflow ?? combinedData.data.realProfitRate} %
                                </Text>
                              )}
                              <Box width="30vw" height="calc(30vw * 0.5625)">
                                <Chart
                                  type="bar"
                                  data={{ ...combinedData.data, labels: commonLabels }}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                      tooltip: {
                                        enabled: true,
                                        callbacks: {
                                          label: (context: any) => {
                                            let label = context.dataset.label || '';
                                            if (label) label += ': ';
                                            if (context.parsed.y !== null) {
                                              const dp = hasDecimal(selectedCurrency.name) ? 2 : 0;
                                              label += context.parsed.y.toLocaleString(undefined, {
                                                minimumFractionDigits: dp,
                                                maximumFractionDigits: dp,
                                              }) + ' ' + selectedCurrency.name;
                                            }
                                            return label;
                                          }
                                        }
                                      },
                                      legend: {
                                        labels: {
                                          // 凡例のカスタマイズ
                                          generateLabels: generateLabels,
                                        }
                                      },
                                      annotation: {
                                        annotations: {
                                          zeroLine: {
                                            type: "line",
                                            yMin: 0,
                                            yMax: 0,
                                            borderColor: "red",
                                            borderDash: [4, 4],
                                            borderWidth: 2,
                                          },
                                          ...configAnnotations, // 動的に生成したアノテーションをここで展開
                                        }
                                      },
                                      datalabels: {
                                        display: false
                                      },
                                    },
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(commonLabels[index]) },
                                      },
                                      y: {
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard",
                                            minimumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                            maximumFractionDigits: hasDecimal(selectedCurrency.name) ? 2 : 0,
                                          }
                                        }
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    </Box>
                  );
                })()}

                {/* 生産能力（ライン全体）チャート - 増産投資の場合のみ表示 */}
                {projectData?.purpose === PurposeType.IncreasedProduction.code && productionCapacityChartData && productionCapacityChartDataModified && (() => {
                  const data = productionCapacityChartData.datasets.flatMap((ds: any) =>
                    (ds?.data?.filter((v: any) => v !== null) || []).map((v: any) => Number(v))
                  );
                  const { yMin, yMax } = calcYAxisRange(data, false);

                  // 増産開始年月のインデックスを見つける
                  return (
                    <Box mt={4}>
                      <Heading size="md" mb={2}>
                        {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.productionCapacityTotal')}
                      </Heading>
                      <Text>
                        unit: pcs
                      </Text>
                      <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.initialPlan')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                            <Chart
                              type="bar"
                              data={productionCapacityChartData}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: function (context) {
                                        let label = context.dataset.label || '';
                                        if (label) {
                                          label += ': ';
                                        }
                                        if (context.parsed.y !== null) {
                                          label += context.parsed.y.toLocaleString() + ' pcs';
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    display: true,
                                    position: 'top' as const,
                                    labels: {
                                      generateLabels: (chart: any): LegendItem[] => {
                                        return chart.data.datasets.map((dataset: any, index: number) => {
                                          return {
                                            text: dataset.label,
                                            fillStyle: dataset.backgroundColor,
                                            strokeStyle: dataset.borderColor,
                                            hidden: !chart.isDatasetVisible(index),
                                            datasetIndex: index,
                                            pointStyle: dataset.pointStyle,
                                          }
                                        });
                                      },
                                      usePointStyle: true // 凡例で pointStyle を使う
                                    },
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                    }
                                  }
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(productionCapacityChartData.labels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Box textAlign="center">
                          <Heading size="sm" mb={1}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.downside')}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                            <Chart
                              type="bar"
                              data={productionCapacityChartDataModified}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                  tooltip: {
                                    enabled: true,
                                    callbacks: {
                                      label: function (context) {
                                        let label = context.dataset.label || '';
                                        if (label) {
                                          label += ': ';
                                        }
                                        if (context.parsed.y !== null) {
                                          label += context.parsed.y.toLocaleString() + ' pcs';
                                        }
                                        return label;
                                      }
                                    }
                                  },
                                  legend: {
                                    display: true,
                                    position: 'top' as const,
                                    labels: {
                                      generateLabels: (chart: any): LegendItem[] => {
                                        return chart.data.datasets.map((dataset: any, index: number) => {
                                          return {
                                            text: dataset.label,
                                            fillStyle: dataset.backgroundColor,
                                            strokeStyle: dataset.borderColor,
                                            hidden: !chart.isDatasetVisible(index),
                                            datasetIndex: index,
                                            pointStyle: dataset.pointStyle,
                                          }
                                        });
                                      },
                                      usePointStyle: true // 凡例で pointStyle を使う
                                    },
                                  },
                                  datalabels: {
                                    display: false
                                  },
                                  annotation: {
                                    annotations: {
                                      ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                    }
                                  }
                                },
                                scales: {
                                  x: {
                                    offset: true,
                                    ticks: { callback: (index: any) => formatYearMonthByLocale(productionCapacityChartData.labels[index]) },
                                  },
                                  y: {
                                    min: yMin,
                                    max: yMax,
                                    ticks: {
                                      format: {
                                        notation: "standard"
                                      }
                                    }
                                  },
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {/* 選択されたシミュレーション設定のグラフを追加 */}
                        {selectedConfigIds.map((configId, index) => {
                          const config = savedConfigs.find(c => c.id === configId);
                          const chartData = productionCapacityChartDataForSavedConfig.find(item => item.configId === configId);

                          if (!config || !chartData?.data) return null;

                          return (
                            <Box key={configId} textAlign="center">
                              <Heading size="sm" mb={1}>
                                {config.name}
                              </Heading>
                              <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                <Chart
                                  type="bar"
                                  data={chartData.data}
                                  options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                      tooltip: {
                                        enabled: true,
                                        callbacks: {
                                          label: function (context) {
                                            let label = context.dataset.label || '';
                                            if (label) {
                                              label += ': ';
                                            }
                                            if (context.parsed.y !== null) {
                                              label += context.parsed.y.toLocaleString() + ' pcs';
                                            }
                                            return label;
                                          }
                                        }
                                      },
                                      legend: {
                                        display: true,
                                        position: 'top' as const,
                                        labels: {
                                          generateLabels: (chart: any): LegendItem[] => {
                                            return chart.data.datasets.map((dataset: any, index: number) => {
                                              return {
                                                text: dataset.label,
                                                fillStyle: dataset.backgroundColor,
                                                strokeStyle: dataset.borderColor,
                                                hidden: !chart.isDatasetVisible(index),
                                                datasetIndex: index,
                                                pointStyle: dataset.pointStyle,
                                              }
                                            });
                                          },
                                          usePointStyle: true
                                        },
                                      },
                                      datalabels: {
                                        display: false
                                      },
                                      annotation: {
                                        annotations: {
                                          ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                                        }
                                      }
                                    },
                                    scales: {
                                      x: {
                                        offset: true,
                                        ticks: { callback: (index: any) => formatYearMonthByLocale(chartData.data.labels[index]) },
                                      },
                                      y: {
                                        min: yMin,
                                        max: yMax,
                                        ticks: {
                                          format: {
                                            notation: "standard"
                                          }
                                        }
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          );
                        })}
                      </Flex>
                    </Box>
                  );
                })()}

                {/* 生産キャパグラフ（既存ライン含む） - 増産投資の場合のみ表示 */}
                {projectData?.purpose === PurposeType.IncreasedProduction.code && (
                  <ExistingLineCapacityPanel
                    elq={elq}
                    labels={originalProfitAndLossByMonth?.labels ?? []}
                    selectedConfigIds={selectedConfigIds}
                    savedConfigs={savedConfigs}
                    annotationStartYearMonth={investmentStartYearMonth}
                    purpose={projectData?.purpose}
                    isEditable={!!pagePermissions?.isEditable}
                    showAnnotationOnSavedConfig
                  />
                )}

                {/* 生産能力（プロセス）チャート - 更新投資または合理化の場合のみ、プロセスごとに表示 */}
                {hasProcessCapacityData &&
                  (projectData?.purpose === PurposeType.UpdateAndOther.code || projectData?.purpose === PurposeType.Rationalization.code) &&
                  productionCapacityProcessChartDataList &&
                  productionCapacityProcessChartDataList.length > 0 && (
                    <>
                      {productionCapacityProcessChartDataList.map((processChartData) => {
                        const data = processChartData.beforeData.datasets.flatMap((ds: any) =>
                          (ds?.data?.filter((v: any) => v !== null) || []).map((v: any) => Number(v))
                        );
                        const { yMin, yMax } = calcYAxisRange(data, false);

                        // 共通のチャートオプション生成関数
                        const getChartOptions = (chartData: any) => ({
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            tooltip: {
                              enabled: true,
                              callbacks: {
                                label: function (context: any) {
                                  let label = context.dataset.label || '';
                                  if (label) {
                                    label += ': ';
                                  }
                                  if (context.parsed.y !== null) {
                                    label += context.parsed.y.toLocaleString() + ' pcs';
                                  }
                                  return label;
                                }
                              }
                            },
                            legend: {
                              display: true,
                              position: 'top' as const,
                              labels: {
                                generateLabels: (chart: any): LegendItem[] => {
                                  return chart.data.datasets.map((dataset: any, index: number) => {
                                    return {
                                      text: dataset.label,
                                      fillStyle: dataset.backgroundColor,
                                      strokeStyle: dataset.borderColor,
                                      hidden: !chart.isDatasetVisible(index),
                                      datasetIndex: index,
                                      pointStyle: dataset.pointStyle,
                                    }
                                  });
                                },
                                usePointStyle: true
                              },
                            },
                            datalabels: {
                              display: false
                            },
                            annotation: {
                              annotations: {
                                ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                              }
                            }
                          },
                          scales: {
                            x: {
                              offset: true,
                              ticks: { callback: (index: any) => formatYearMonthByLocale(chartData.labels[index]) },
                            },
                            y: {
                              min: yMin,
                              max: yMax,
                              ticks: {
                                format: {
                                  notation: "standard" as const
                                }
                              }
                            },
                          },
                        });

                        return (
                          <Box mt={4} key={processChartData.processId}>
                            <Heading size="md" mb={2}>
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.productionCapacityProcess', { processName: processChartData.processName || processChartData.processId })}
                            </Heading>
                            <Text>
                              unit: pcs
                            </Text>
                            {/* 1行目: 更新前/合理化前、更新前/合理化前（ダウンサイド） */}
                            <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4} mb={4}>
                              <Box textAlign="center">
                                <Heading size="sm" mb={1}>
                                  {getProcessCapacityLabel(projectData?.purpose, true, false)}
                                </Heading>
                                <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                  <Chart
                                    type="bar"
                                    data={processChartData.beforeData}
                                    options={getChartOptions(processChartData.beforeData)}
                                  />
                                </Box>
                              </Box>
                              <Box textAlign="center">
                                <Heading size="sm" mb={1}>
                                  {getProcessCapacityLabel(projectData?.purpose, true, true)}
                                </Heading>
                                <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                  <Chart
                                    type="bar"
                                    data={processChartData.beforeDownsideData}
                                    options={getChartOptions(processChartData.beforeDownsideData)}
                                  />
                                </Box>
                              </Box>
                            </Flex>
                            {/* 2行目: 更新後/合理化後、更新後/合理化後（ダウンサイド） */}
                            <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                              <Box textAlign="center">
                                <Heading size="sm" mb={1}>
                                  {getProcessCapacityLabel(projectData?.purpose, false, false)}
                                </Heading>
                                <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                  <Chart
                                    type="bar"
                                    data={processChartData.afterData}
                                    options={getChartOptions(processChartData.afterData)}
                                  />
                                </Box>
                              </Box>
                              <Box textAlign="center">
                                <Heading size="sm" mb={1}>
                                  {getProcessCapacityLabel(projectData?.purpose, false, true)}
                                </Heading>
                                <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                  <Chart
                                    type="bar"
                                    data={processChartData.afterDownsideData}
                                    options={getChartOptions(processChartData.afterDownsideData)}
                                  />
                                </Box>
                              </Box>
                            </Flex>
                            {/* 3行目以降: 保存済み設定のグラフ */}
                            {selectedConfigIds.length > 0 && (
                              <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4} mt={4}>
                                {selectedConfigIds.map((configId) => {
                                  const config = savedConfigs.find(c => c.id === configId);
                                  const savedConfigData = productionCapacityProcessChartDataForSavedConfig.find(
                                    item => item.configId === configId
                                  );
                                  const processData = savedConfigData?.processData.find(
                                    p => p.processId === processChartData.processId
                                  );

                                  if (!config || !processData?.afterData) return null;

                                  return (
                                    <Box key={configId} textAlign="center">
                                      <Heading size="sm" mb={1}>
                                        {config.name}
                                      </Heading>
                                      <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                                        <Chart
                                          type="bar"
                                          data={processData.afterData}
                                          options={getChartOptions(processData.afterData)}
                                        />
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </Flex>
                            )}
                          </Box>
                        );
                      })}
                    </>
                  )}

                {/* 合理化前後サマリーチャート - 合理化投資、または更新投資（簡易モード）の場合に表示 */}
                {/* processId単位で表示 */}
                {(projectData?.purpose === PurposeType.Rationalization.code ||
                  (isSimpleMode && projectData?.purpose === PurposeType.UpdateAndOther.code)) &&
                  rationalizationSummaryChartDataList.length > 0 &&
                  rationalizationSummaryChartDataList.map(processChartData => {
                    if (processChartData.items.length === 0) return null;

                    // グループ分け
                    const indicatorItems = processChartData.items.filter(item => item.group === "indicator");
                    const costItems = processChartData.items.filter(item => item.group === "cost");
                    const improvementEffectItems = processChartData.items.filter(item => item.group === "improvementEffect");

                    // 共通のチャートレンダリング関数
                    const renderChart = (item: RationalizationSummaryChartItem) => {
                      // 労務費チャート（減価償却費データがある場合）は複合チャートで表示
                      const hasDepreciation = item.depreciationData && item.depreciationData.length > 0;

                      // 合理化前後データの最小・最大値を計算してY軸スケールを統一
                      const allData = hasDepreciation
                        ? [...item.beforeData, ...item.afterData, ...item.depreciationData!].filter(v => v !== null)
                        : [...item.beforeData, ...item.afterData].filter(v => v !== null);
                      const { yMin, yMax } = calcYAxisRange(allData as number[], false);

                      // 投資目的に応じたチャートラベル
                      const isUpdatePurpose = projectData?.purpose === PurposeType.UpdateAndOther.code;
                      const beforeLaborCostLabel = isUpdatePurpose
                        ? t('features.InvestmentScreening.SimulationProductivityImprovement.chart.updateBeforeLaborCost')
                        : t('features.InvestmentScreening.SimulationProductivityImprovement.chart.rationalizationBeforeLaborCost');
                      const afterLaborCostLabel = isUpdatePurpose
                        ? t('features.InvestmentScreening.SimulationProductivityImprovement.chart.updateAfterLaborCost')
                        : t('features.InvestmentScreening.SimulationProductivityImprovement.chart.rationalizationAfterLaborCost');
                      const beforeLabel = isUpdatePurpose
                        ? t('features.InvestmentScreening.SimulationProductivityImprovement.chart.updateBefore')
                        : t('features.InvestmentScreening.SimulationProductivityImprovement.chart.rationalizationBefore');
                      const afterLabel = isUpdatePurpose
                        ? t('features.InvestmentScreening.SimulationProductivityImprovement.chart.updateAfter')
                        : t('features.InvestmentScreening.SimulationProductivityImprovement.chart.rationalizationAfter');

                      // Chart.jsデータ構造（複合チャート用）
                      const mixedChartData = {
                        labels: processChartData.labels,
                        datasets: [
                          {
                            type: 'line' as const,
                            label: beforeLaborCostLabel,
                            data: item.beforeData,
                            borderColor: "rgba(255, 99, 132, 1)",
                            backgroundColor: "rgba(255, 99, 132, 0.2)",
                            fill: false,
                            tension: 0.1,
                            pointRadius: 2,
                            pointHoverRadius: 5,
                            order: 1,
                          },
                          {
                            type: 'line' as const,
                            label: afterLaborCostLabel,
                            data: item.afterData,
                            borderColor: "rgba(75, 192, 192, 1)",
                            backgroundColor: "rgba(75, 192, 192, 0.2)",
                            fill: false,
                            tension: 0.1,
                            pointRadius: 2,
                            pointHoverRadius: 5,
                            order: 2,
                          },
                          {
                            type: 'bar' as const,
                            label: t('features.InvestmentScreening.SimulationProductivityImprovement.chart.depreciation'),
                            data: item.depreciationData,
                            backgroundColor: "rgba(54, 162, 235, 0.6)",
                            borderColor: "rgba(54, 162, 235, 1)",
                            borderWidth: 1,
                            order: 3,
                          },
                        ],
                      };

                      // Chart.jsデータ構造（折れ線チャート用）
                      const lineChartData = {
                        labels: processChartData.labels,
                        datasets: [
                          {
                            label: beforeLabel,
                            data: item.beforeData,
                            borderColor: "rgba(255, 99, 132, 1)",
                            backgroundColor: "rgba(255, 99, 132, 0.2)",
                            fill: false,
                            tension: 0.1,
                            pointRadius: 2,
                            pointHoverRadius: 5,
                          },
                          {
                            label: afterLabel,
                            data: item.afterData,
                            borderColor: "rgba(54, 162, 235, 1)",
                            backgroundColor: "rgba(54, 162, 235, 0.2)",
                            fill: false,
                            tension: 0.1,
                            pointRadius: 2,
                            pointHoverRadius: 5,
                          },
                        ],
                      };

                      const chartOptions = {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          tooltip: {
                            enabled: true,
                            callbacks: {
                              label: function (context: any) {
                                let label = context.dataset.label || '';
                                if (label) {
                                  label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                  label += context.parsed.y.toLocaleString() + ' ' + item.unit;
                                }
                                return label;
                              }
                            }
                          },
                          legend: {
                            display: true,
                            position: 'top' as const,
                          },
                          datalabels: {
                            display: false
                          },
                          annotation: {
                            annotations: {
                              ...generateAnnotationStarLabels(investmentStartYearMonth, projectData?.purpose),
                            }
                          }
                        },
                        scales: {
                          x: {
                            offset: true,
                            ticks: {
                              callback: (_: any, index: number) => {
                                return formatYearMonthByLocale(processChartData.labels[index]);
                              }
                            },
                          },
                          y: {
                            min: yMin,
                            max: yMax,
                            ticks: {
                              callback: (value: any) => value.toLocaleString(),
                            },
                            title: {
                              display: false,
                            }
                          },
                        },
                      };

                      return (
                        <Box key={item.itemId} textAlign="center">
                          <Heading size="sm" mb={1}>
                            {item.itemName}
                            {item.unit && (
                              <Text as="span" fontWeight="normal" fontSize="sm"> unit: {item.unit}</Text>
                            )}
                          </Heading>
                          <Box width="30vw" height="calc(30vw * 0.5625)" margin="0 auto">
                            {hasDepreciation ? (
                              <Chart
                                type="bar"
                                data={mixedChartData as any}
                                options={chartOptions}
                              />
                            ) : (
                              <Line
                                data={lineChartData}
                                options={chartOptions}
                              />
                            )}
                          </Box>
                        </Box>
                      );
                    };

                    return (
                      <Box mt={4} key={processChartData.processId}>
                        <Heading size="md" mb={4}>
                          {t(projectData?.purpose === PurposeType.Rationalization.code
                            ? 'features.InvestmentScreening.SimulationProductivityImprovement.heading.rationalizationSummaryProcess'
                            : 'features.InvestmentScreening.SimulationProductivityImprovement.heading.updateSummaryProcess',
                            { processName: processChartData.itemNo || processChartData.processId })}
                        </Heading>
                        {projectData?.purpose === PurposeType.Rationalization.code && (
                          <Text fontSize="sm" color="gray.600" mb={4}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.message.dummyDataNote')}
                          </Text>
                        )}

                        {/* 指標 */}
                        {indicatorItems.length > 0 && (
                          <Box mb={6}>
                            <Heading size="sm" mb={2} color="blue.600">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.indicator')}
                            </Heading>
                            <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                              {indicatorItems.map(renderChart)}
                            </Flex>
                          </Box>
                        )}

                        {/* 費用 */}
                        {costItems.length > 0 && (
                          <Box mb={6}>
                            <Heading size="sm" mb={2} color="blue.600">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.cost')}
                            </Heading>
                            <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                              {costItems.map(renderChart)}
                            </Flex>
                          </Box>
                        )}

                        {/* 改善効果 */}
                        {improvementEffectItems.length > 0 && (
                          <Box>
                            <Heading size="sm" mb={2} color="blue.600">
                              {t('features.InvestmentScreening.SimulationProductivityImprovement.heading.improvementEffect')}
                            </Heading>
                            <Flex direction="row" justify="center" align="center" wrap="wrap" gap={4}>
                              {improvementEffectItems.map(renderChart)}
                            </Flex>
                          </Box>
                        )}
                      </Box>
                    );
                  })}

              </>)}

              {/** 最終的な投資判断の理由 **/}
              <FinalInvestmentReasonTextarea
                ref={finalInvestmentReasonRef}
                initialValue={finalInvestmentReasonDraftRef.current}
                onValueChange={(v) => { finalInvestmentReasonDraftRef.current = v; }}
                error={errors.finalInvestmentReason}
              />
            </fieldset >

            {/* Excel出力・確認ボタン */}
            <Flex justify="space-between" mt="20px">
              <Box>
                {/* Excel出力（損益非表示モード時は出力対象の表が無いため非表示） */}
                {!isProfitLossHiddenMode && (
                  <Button
                    colorScheme="green"
                    onClick={exportMonthlyProfitLossToExcel}
                    isDisabled={!projectData || !originalProfitAndLossByMonth}
                  >
                    {t('features.InvestmentScreening.SimulationProductivityImprovement.button.excelExport')}
                  </Button>
                )}
              </Box>
              <Flex>
                <Box>
                  <Button
                    ml="10px"
                    colorScheme="blue"
                    name="companyDivision"
                    onClick={handleModalOpen}
                    isDisabled={!pagePermissions?.eabledCompanyDivision}
                    ref={refs["companyDivision"]}
                  >
                    {t('features.InvestmentScreening.SimulationProductivityImprovement.button.divisionConfirm')}
                  </Button>
                  <ConfirmorList confirmorInfo={names["companyDivision"]} width={buttonWidths["companyDivision"]} />
                </Box>
                <Box>
                  <Button
                    ml="10px"
                    colorScheme="blue"
                    name="companyHeadDivision"
                    onClick={handleModalOpen}
                    isDisabled={!pagePermissions?.eabledCompanyHeadDivision}
                    ref={refs["companyHeadDivision"]}
                  >
                    {t('features.InvestmentScreening.SimulationProductivityImprovement.button.headDivisionConfirm')}
                  </Button>
                  <ConfirmorList confirmorInfo={names["companyHeadDivision"]} width={buttonWidths["companyHeadDivision"]} />
                </Box>
              </Flex>
            </Flex>
          </Box>
        )}

        {/* シミュレーション設定 */}
        {mode === "settings" && (
          <>
            <fieldset disabled={!pagePermissions?.isEditable} style={{ minWidth: 0 }}>
              <HStack spacing={4} pt="16px" pb="16px" position="sticky" top="72px" zIndex={101} bgColor="white">
                <Heading size="md">{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.simulationSettings')}</Heading>
                {/* 入力モード切替ボタン */}
                <ButtonGroup spacing={4} isAttached>
                  <ReadOnlyExemptButton
                    colorScheme={inputModeSimulation === "manual" ? "green" : "gray"}
                    onClick={handleManualClick}
                    isLoading={isSpreadSheetLoading}
                  >
                    {t('features.InvestmentScreening.SimulationProductivityImprovement.button.manualInput')}
                  </ReadOnlyExemptButton>
                  <ReadOnlyExemptButton
                    colorScheme={inputModeSimulation === "google" ? "green" : "gray"}
                    onClick={handleGoogleSpreadClick}
                    isLoading={isSpreadSheetLoading}
                  >
                    GoogleSpread
                  </ReadOnlyExemptButton>
                </ButtonGroup>
                <Button
                  colorScheme="blue"
                  onClick={handleSyncData}
                  isDisabled={inputModeSimulation === "manual"}
                  isLoading={isSpreadSheetLoading}
                >
                  {t('features.InvestmentScreening.SimulationProductivityImprovement.button.dataSync')}
                </Button>
              </HStack>
              <Box>
                <Box m={1}>
                  {/* 設定保存 */}
                  <Box p={4} border="2px solid #3182ce" borderRadius="md" shadow="md" bg="blue.50">
                    <Heading size="md" mb={4}>{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.saveCurrentSettings')}</Heading>
                    <HStack mb={4}>
                      <Text fontWeight="bold">{t('features.InvestmentScreening.SimulationProductivityImprovement.label.configName')}</Text>
                      <input
                        key={configNameInput}
                        type="text"
                        defaultValue={configNameInput}
                        onBlur={(e) => setConfigNameInput(e.target.value)}
                        placeholder={t('features.InvestmentScreening.SimulationProductivityImprovement.placeholder.configNameInput')}
                        style={{
                          width: "300px",
                          padding: "8px 12px",
                          border: "1px solid #E2E8F0",
                          borderRadius: "4px",
                          fontSize: "14px",
                        }}
                      />
                      <Button colorScheme="blue" onClick={saveSimulationConfig}>
                        {t('common.button.save')}
                      </Button>
                      <Button colorScheme="gray" onClick={() => resetSimulationConfigInputs(true)}>
                        {t('common.button.reset')}
                      </Button>
                      <HStack spacing={2} ml={4} pl={4} borderLeft="1px solid" borderColor="gray.300">
                        <Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap" color={applyDownsideInput ? "red.600" : "gray.500"}>
                          {t('features.InvestmentScreening.SimulationProductivityImprovement.label.stressReflection')}
                        </Text>
                        <Switch
                          isChecked={applyDownsideInput}
                          onChange={(e) => setApplyDownsideInput(e.target.checked)}
                          colorScheme="red"
                          size="md"
                          isDisabled={!pagePermissions?.isEditable}
                        />
                      </HStack>
                    </HStack>

                    {/* 保存された設定一覧 */}
                    {savedConfigs.length > 0 && (
                      <Box
                        mt={4}
                        pointerEvents={inputModeSimulation === "google" ? "none" : "auto"}
                        opacity={inputModeSimulation === "google" ? 0.5 : 1}
                      >
                        <Text fontWeight="bold" mb={2}>{t('features.InvestmentScreening.SimulationProductivityImprovement.label.savedConfigList')}</Text>
                        <VStack align="stretch" spacing={2}>
                          {savedConfigs.map((config) => (
                            <Box
                              key={config.id}
                              p={4}
                              border="2px solid"
                              borderColor={selectedConfigIdForInput === config.id ? "blue.400" : "#E2E8F0"}
                              borderRadius="md"
                              bg={selectedConfigIdForInput === config.id ? "blue.50" : "white"}
                              transition="all 0.2s"
                              _hover={{ borderColor: "blue.300", shadow: "md" }}
                            >
                              <HStack justify="space-between">
                                <HStack spacing={3} flex={1}>
                                  <Checkbox
                                    isChecked={selectedConfigIdForInput === config.id}
                                    onChange={() => handleConfigSelectionForInput(config.id)}
                                    colorScheme="blue"
                                    size="lg"
                                    isDisabled={!pagePermissions?.isEditable}
                                  />
                                  <Text
                                    fontWeight="bold"
                                    fontSize="lg"
                                    cursor="pointer"
                                    onClick={() => pagePermissions?.isEditable && handleConfigSelectionForInput(config.id)}
                                    flex={1}
                                  >
                                    {config.name}
                                  </Text>
                                </HStack>
                                <Button
                                  colorScheme="red"
                                  size="sm"
                                  onClick={() => deleteSimulationConfig(config.id)}
                                >
                                  {t('common.button.delete')}
                                </Button>
                              </HStack>
                            </Box>
                          ))}
                        </VStack>
                      </Box>
                    )}
                  </Box>

                  {/* GoogleSpreadモード時は編集不可（スクロール・アコーディオンは操作可能・通常表示） */}
                  <Box
                    pointerEvents={inputModeSimulation === "google" ? "none" : "auto"}
                    sx={inputModeSimulation === "google" ? {
                      // 全体を半透明にする（直下の子要素に適用）
                      "& > *": { opacity: 0.5 },
                      // アコーディオンの開閉は操作可能・通常表示
                      ".chakra-accordion__button": { pointerEvents: "auto", opacity: 1 },
                      // スクロール可能なコンテナはスクロール操作を許可・通常表示（中の入力要素は引き続き無効）
                      ".chakra-table__container": { pointerEvents: "auto", opacity: 1 },
                      ".chakra-table__container *": { pointerEvents: "none" },
                      // 稼働日数・稼働率改善のスクロールコンテナはスクロール操作を許可（中の要素は全て無効、アコーディオン・タブのみ操作可能）
                      ".simulation-working-days-container": { pointerEvents: "auto", opacity: 1 },
                      ".simulation-working-days-container *": { pointerEvents: "none" },
                      ".simulation-working-days-container .chakra-accordion__button": { pointerEvents: "auto" },
                      ".simulation-working-days-container .chakra-tabs__tab": { pointerEvents: "auto" },
                    } : undefined}
                  >
                    {/* 設備・人員構成変更 */}
                    <EquipmentPersonnelChangeSection
                      equipmentAmounts={equipmentAmounts}
                      esSyncError={esSyncError}
                      conditionTable={conditionTable}
                      pagePermissions={pagePermissions}
                      changeEquipmentAmounts={changeEquipmentAmounts}
                      changeEquipmentQuantity={changeEquipmentQuantity}
                      sumEquipmentAmount={sumEquipmentAmount}
                      sumSelectedEquipmentAmount={sumSelectedEquipmentAmount}
                      rateOfChangeAmount={rateOfChangeAmount}
                    />

                    {/* 段階的設備投資 */}
                    <PhasedEquipmentInvestmentSection
                      equipmentAmounts={equipmentAmounts}
                      pciSyncError={pciSyncError}
                      conditionTable={conditionTable}
                      changeEquipmentAmounts={changeEquipmentAmounts}
                    />

                    {/* 稼働日数 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.workingDaysChange')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {workingDaysSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {workingDaysSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      <WorkingDays
                        showWorkOnHoliday={true}
                        workingDays={improvedWorkingDaysData}
                        setWorkingDays={setImprovedWorkingDaysData}
                        setIsValidWorkingDays={setIsValidWorkingDays}
                        projectStartDate={projectData?.projectStartDate || dayjs().format("YYYY-MM-DD")}
                        maxHeight="60dvh"
                      />
                    </Box>

                    {/* 稼働率改善 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.availabilityRateImprovement')}</Text>
                      {/* バリデーションエラーメッセージ */}
                      {nonWorkingHoursSyncError.workingHoursErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.workingHoursErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      {nonWorkingHoursSyncError.nonWorkingHourErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.nonWorkingHourErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      {/* 無効値エラーメッセージ */}
                      {nonWorkingHoursSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {nonWorkingHoursSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}
                      <NonWorkingHours
                        isSimulation={true}
                        nonWorkingHoursData={improvedNonWorkingHoursData}
                        setNonWorkingHoursData={setImprovedNonWorkingHoursData}
                        projectStartDate={projectData?.projectStartDate || dayjs().format("YYYY-MM-DD")}
                        maxHeight="60dvh"
                      />
                    </Box>

                    {/* 生産工場費用設定 */}
                    {/* 簡易モード時は費用画面の単価・通貨が未設定のため自動算出できず、算出値もシミュレーショングラフでは使用されないため非表示 */}
                    {!isSimpleMode && (
                      <ProductionFactoryCostSection
                        lcSyncError={lcSyncError}
                        scenarioProductionFactoryLaborUnitPrice={scenarioProductionFactoryLaborUnitPrice}
                        setScenarioProductionFactoryLaborUnitPrice={setScenarioProductionFactoryLaborUnitPrice}
                        scenarioProductionFactoryExpenseUnitPrice={scenarioProductionFactoryExpenseUnitPrice}
                        setScenarioProductionFactoryExpenseUnitPrice={setScenarioProductionFactoryExpenseUnitPrice}
                        scenarioBaseLaborCostIncreaseRate={scenarioBaseLaborCostIncreaseRate}
                        setScenarioBaseLaborCostIncreaseRate={setScenarioBaseLaborCostIncreaseRate}
                        currencyData={currencyData}
                        projectData={projectData}
                        originalProfitAndLossByMonth={originalProfitAndLossByMonth}
                        scenarioLaborCostByMonth={scenarioLaborCostByMonth}
                        setScenarioLaborCostByMonth={setScenarioLaborCostByMonth}
                        scenarioOverseasFactoryExpensesByMonth={scenarioOverseasFactoryExpensesByMonth}
                        setScenarioOverseasFactoryExpensesByMonth={setScenarioOverseasFactoryExpensesByMonth}
                        handleSimulationAutoCalculateLaborCost={handleSimulationAutoCalculateLaborCost}
                        isLaborCostCalculating={isLaborCostCalculating}
                      />
                    )}

                    {/* 歩留改善 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.yieldImprovement')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {yiSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {yiSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}

                      {/* 歩留改善リスト */}
                      <VStack mt={4} spacing={3} align="stretch">
                        {improvedYieldRateList.map((item, index) => (
                          <YieldImprovementRow
                            key={index}
                            item={item}
                            index={index}
                            isInvalid={errors.yieldRate.isError}
                            errorMessage={errors.yieldRate.errorMessage}
                            minMonth={getGraphStartMonth()}
                            maxMonth={getGraphEndMonth()}
                            isLast={index === improvedYieldRateList.length - 1}
                            isOnly={improvedYieldRateList.length <= 1}
                            getYieldRateFromBom={getYieldRateFromBom}
                            onMonthChange={updateYieldRateMonth}
                            onTextChange={updateYieldRateText}
                            onBlurCommit={updateYieldRateValue}
                            onAdd={addYieldRateImprovement}
                            onRemove={removeYieldRateImprovement}
                          />
                        ))}
                      </VStack>
                    </Box>

                    {/* サイクルタイム短縮 */}
                    <Box mt={6} p={4} border="1px solid #ccc" borderRadius="md" shadow="sm">
                      <Text mb={4} fontSize="lg" fontWeight="bold">{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.cycleTimeReduction')}</Text>
                      {/* 無効値エラーメッセージ */}
                      {ctrSyncError.invalidValueErrors.length > 0 && (
                        <Box mb={2}>
                          {ctrSyncError.invalidValueErrors.map((error, index) => (
                            <Text key={index} color="orange.500" fontSize="sm">{error}</Text>
                          ))}
                        </Box>
                      )}

                      {/* サイクルタイム改善リスト */}
                      <VStack mt={4} spacing={3} align="stretch">
                        {improvedCycleTimeList.map((item, index) => (
                          <CycleTimeImprovementRow
                            key={index}
                            item={item}
                            index={index}
                            isInvalid={errors.cycleTime.isError}
                            errorMessage={errors.cycleTime.errorMessage}
                            minMonth={getGraphStartMonth()}
                            maxMonth={getGraphEndMonth()}
                            cycleTimeMax={CYCLE_TIME_MAX}
                            isLast={index === improvedCycleTimeList.length - 1}
                            isOnly={improvedCycleTimeList.length <= 1}
                            getCycleTimeFromBom={getCycleTimeFromBom}
                            onMonthChange={updateCycleTimeMonth}
                            onTextChange={updateCycleTimeText}
                            onBlurCommit={updateCycleTimeValue}
                            onAdd={addCycleTimeImprovement}
                            onRemove={removeCycleTimeImprovement}
                          />
                        ))}
                      </VStack>
                    </Box>

                  </Box>{/* GoogleSpreadモード時編集不可ラッパー終了 */}

                </Box>
              </Box>
            </fieldset>
          </>
        )}

        {/* 表示対象選択 */}
        {mode === "selection" && (
          <>
            <fieldset disabled={!pagePermissions?.isEditable}>
              <Box mt={4}>
                <Box>
                  <Heading size="md" mb={4}>{t('features.InvestmentScreening.SimulationProductivityImprovement.heading.displayTargetSelection')}</Heading>

                  {savedConfigs.length === 0 ? (
                    <Box p={4} bg="gray.50" borderRadius="md">
                      <Text color="gray.600">
                        {t('features.InvestmentScreening.SimulationProductivityImprovement.message.simulationNotSaved')}
                        <br />
                        {t('features.InvestmentScreening.SimulationProductivityImprovement.message.saveSettingsInTab')}
                      </Text>
                    </Box>
                  ) : (
                    <>
                      <Text mb={4} color="gray.700">
                        {t('features.InvestmentScreening.SimulationProductivityImprovement.message.selectForComparison')}
                      </Text>

                      <VStack align="stretch" spacing={3}>
                        {savedConfigs.map((config) => (
                          <Box
                            key={config.id}
                            p={4}
                            border="2px solid"
                            borderColor={selectedConfigIds.includes(config.id) ? "blue.400" : "gray.200"}
                            borderRadius="md"
                            bg={selectedConfigIds.includes(config.id) ? "blue.50" : "white"}
                            transition="all 0.2s"
                            _hover={{ borderColor: "blue.300", shadow: "md" }}
                          >
                            <HStack>
                              <Checkbox
                                isChecked={selectedConfigIds.includes(config.id)}
                                onChange={() => toggleConfigSelection(config.id)}
                                colorScheme="blue"
                                size="lg"
                                isDisabled={!pagePermissions?.isEditable}
                              />
                              <Text
                                fontWeight="bold"
                                fontSize="lg"
                                cursor="pointer"
                                onClick={() => pagePermissions?.isEditable && toggleConfigSelection(config.id)}
                                flex={1}
                              >
                                {config.name}
                              </Text>
                            </HStack>
                          </Box>
                        ))}
                      </VStack>

                      {selectedConfigIds.length > 0 && (
                        <Box mt={6} p={4} bg="blue.50" borderRadius="md">
                          <Text fontWeight="bold" mb={2}>
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.selectedCount', { count: selectedConfigIds.length })}
                          </Text>
                          <Text fontSize="sm" color="gray.700">
                            {t('features.InvestmentScreening.SimulationProductivityImprovement.label.displayTabDescription')}
                          </Text>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            </fieldset>
          </>
        )}
      </Box>

      {/* ストレス指数 */}
      {isOpenDownsideIndex && (
        <Draggable defaultPosition={position} cancel="input,span,button,p">
          <Box
            position="fixed"
            top="0"
            left="0"
            bg="white"
            p={4}
            border="1px solid #ccc"
            borderRadius="md"
            shadow="lg"
            zIndex="1000"
            width={DOWNSIDE_INDEX_POPUP_WIDTH}
          >
            <Text mb={2} fontSize="large" fontWeight="bold" whiteSpace="nowrap" width="fit-content">{t('features.InvestmentScreening.SimulationProductivityImprovement.button.downsideIndex')}</Text>
            <Box style={!pagePermissions?.isEditable ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
              <Table
                id="downsideIndexTable"
                variant="simple"
                width={DOWNSIDE_INDEX_TABLE_WIDTH}
                sx={{
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  "& th, & td": {
                    border: "1px solid",
                    borderColor: "gray.200",
                    whiteSpace: "normal",
                    minHeight: "2em",
                    overflowWrap: "break-word",
                    padding: "0.5em",
                  },
                }}
              >
                <Thead>
                  <Tr>
                    <Th style={thStyle} bgColor={"transparent"} width="80px" maxWidth="80px">
                      {t('features.InvestmentScreening.SimulationProductivityImprovement.downsideIndex.column.year')}
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH} minWidth={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityChangeOverTime')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.quantityChangeOverTimeHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledQuantityChangeOverTime} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledQuantityChangeOverTime", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledFluctuationInQuantity ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.quantityFluctuation')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.quantityFluctuationHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledFluctuationInQuantity} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledFluctuationInQuantity", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledPriceChangeOverTime ? "transparent" : "#eee"} width={DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.priceChangeOverTime')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.priceChangeOverTimeHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledPriceChangeOverTime} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledPriceChangeOverTime", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"} width={i18n.language === "en" ? "145px" : DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.customerProductLifecycle')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.customerProductLifecycleHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCustomerProductLifecycle} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCustomerProductLifecycle", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} width={i18n.language === "en" ? "163px" : "140px"} bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? "transparent" : "#eee"}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.exchangeRateFluctuationToPrice')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.exchangeRateFluctuationToPriceHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCurrencyFluctuationToPrice", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} width={i18n.language === "en" ? "163px" : "140px"} bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? "transparent" : "#eee"}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.exchangeRateFluctuationToCost')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.exchangeRateFluctuationToCostHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledCurrencyFluctuationToCost} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCurrencyFluctuationToCost", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledRisingMaterialCosts ? "transparent" : "#eee"} width={i18n.language === "en" ? "150px" : DOWNSIDE_INDEX_COLUMN_WIDTH}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.materialCostIncrease')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.materialCostIncreaseHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledRisingMaterialCosts} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledRisingMaterialCosts", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={thStyle} bgColor={downsideIndexEnable.isEnabledRisingLaborCosts ? "transparent" : "#eee"} width={`calc(${DOWNSIDE_INDEX_COLUMN_WIDTH} + 10px)`}>
                      <Flex align="center">
                        {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.laborCostIncrease')}
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.laborCostIncreaseHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml={2} isChecked={downsideIndexEnable.isEnabledRisingLaborCosts} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledRisingLaborCosts", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={i18n.language === "en" ? { whiteSpace: "normal" } : thStyle} width={i18n.language === "en" ? "300px" : "260px"} bgColor={downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? "transparent" : "#eee"}>
                      <Flex align="center" justify="space-between" gap={2}>
                        <Text as="span">{t('features.InvestmentScreening.SimulationProductivityImprovement.downsideIndex.column.competitorStatusToQuantity')}</Text>
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.competitorStatusToQuantityHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml="auto" flexShrink={0} isChecked={downsideIndexEnable.isEnabledCompetitorConditionToQuantity} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCompetitorConditionToQuantity", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                    <Th style={i18n.language === "en" ? { whiteSpace: "normal" } : thStyle} width={i18n.language === "en" ? "300px" : "260px"} bgColor={downsideIndexEnable.isEnabledCompetitorConditionToPrice ? "transparent" : "#eee"}>
                      <Flex align="center" justify="space-between" gap={2}>
                        <Text as="span">{t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.column.competitorStatusToPrice')}</Text>
                        <HelpIcon size="20">
                          <Text>
                            {t('features.InvestmentScreening.SimulationNewProduct.downsideIndex.help.competitorStatusToPriceHelp')}
                          </Text>
                        </HelpIcon>
                        <Switch ml="auto" flexShrink={0} isChecked={downsideIndexEnable.isEnabledCompetitorConditionToPrice} onChange={(event) => {
                          changeDownsideIndexEnable("isEnabledCompetitorConditionToPrice", event.target.checked);
                        }} />
                      </Flex>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {
                    downsideIndexTableDisplay.map((row, index) => {
                      return <tr>
                        <Td
                          style={tdStyle}
                          bgColor={"transparent"}
                          width={"80px"}
                          maxWidth={"80px"}
                        >{t('features.InvestmentScreening.SimulationProductivityImprovement.label.yearSuffix', { year: row.yearString })}</Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledQuantityChangeOverTime ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 数量経時変化 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.quantityChangeOverTime}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "quantityChangeOverTime", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "quantityChangeOverTime")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledFluctuationInQuantity ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 数量上下変動 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.fluctuationInQuantity}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "fluctuationInQuantity", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "fluctuationInQuantity")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledPriceChangeOverTime ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 単価経時変化 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.priceChangeOverTime}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "priceChangeOverTime", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "priceChangeOverTime")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <Text
                              style={{
                                position: "absolute",
                                top: "-1px",
                                left: "-1px",
                                width: "calc(100% + 2px)",
                                height: "calc(100% + 2px)",
                                zIndex: "1"
                              }}
                              display={index > 0 ? "block" : "none"}
                              bgColor={downsideIndexEnable.isEnabledCustomerProductLifecycle ? "#fff" : "#eee"}
                            ></Text>
                            <HStack>
                              {/* 顧客製品寿命 */}
                              <NumberInput
                                isDisabled={index > 0}
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN}
                                max={DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX}
                                step={1}
                                value={row?.customerProductLifecycle}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  const val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", 0);
                                  } else if (val > DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MAX);
                                  } else if (val < DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", DOWNSIDE_INDEX_CUSTOMER_PRODUCT_LIFECYCLE_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "customerProductLifecycle", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "customerProductLifecycle")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToPrice ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 為替変動(単価) */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.currencyFluctuationToPrice}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToPrice", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "currencyFluctuationToPrice")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCurrencyFluctuationToCost ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 為替変動(原価) */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.currencyFluctuationToCost}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "currencyFluctuationToCost", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "currencyFluctuationToCost")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledRisingMaterialCosts ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 材料高騰 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.risingMaterialCosts}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "risingMaterialCosts", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "risingMaterialCosts")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledRisingLaborCosts ? "transparent" : "#eee"}
                        >
                          <HStack>
                            {/* 労務費高騰 */}
                            <NumberInput
                              width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                              min={DOWNSIDE_INDEX_MIN}
                              max={DOWNSIDE_INDEX_MAX}
                              precision={1}
                              step={0.1}
                              value={row?.risingLaborCosts}
                              clampValueOnBlur={false}
                              onFocus={(e) => {
                                focusedValueRef.current = Number(e.target.value);
                              }}
                              onChange={(value) => {
                                if (!isNaN(Number(value))) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", Number(value), false);
                                }
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                if (val === focusedValueRef.current) return;
                                if (val === -0) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", 0);
                                } else if (val > DOWNSIDE_INDEX_MAX) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", DOWNSIDE_INDEX_MAX);
                                } else if (val < DOWNSIDE_INDEX_MIN) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", DOWNSIDE_INDEX_MIN);
                                } else if (!isNaN(val)) {
                                  updateDownsideIndexTableValue(row.yearString, "risingLaborCosts", val);
                                }
                              }}
                            >
                              <NumberInputField
                                textAlign="right"
                                onKeyDown={handleKeyDown(row, "risingLaborCosts")}
                              />
                              <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                              </NumberInputStepper>
                            </NumberInput>
                            <Text>%</Text>
                          </HStack>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCompetitorConditionToQuantity ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <HStack>
                              {/* 競合状態(数量) */}
                              <Text>{
                                row.competitorConditionToQuantityStringPre === competitorType.NoCompetitor.value ? competitorType.NoCompetitor.name :
                                  row.competitorConditionToQuantityStringPre === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name :
                                    row.competitorConditionToQuantityStringPre === competitiorCondition.LowerRank.value ? competitiorCondition.LowerRank.name :
                                      row.competitorConditionToQuantityStringPre
                              }</Text>
                              <NumberInput
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_MIN}
                                max={DOWNSIDE_INDEX_MAX}
                                precision={1}
                                step={0.1}
                                value={row?.competitorConditionToQuantity}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  const val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", 0);
                                  } else if (val > DOWNSIDE_INDEX_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", DOWNSIDE_INDEX_MAX);
                                  } else if (val < DOWNSIDE_INDEX_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", DOWNSIDE_INDEX_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToQuantity", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "competitorConditionToQuantity")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                        <Td
                          style={tdStyle}
                          bgColor={downsideIndexEnable.isEnabledCompetitorConditionToPrice ? "transparent" : "#eee"}
                        >
                          <div style={{
                            position: "relative",
                            width: "100%",
                            height: "100%"
                          }}>
                            <HStack>
                              {/* 競合状態(単価) */}
                              <Text>{
                                row.competitorConditionToPriceStringPre === competitorType.NoCompetitor.value ? competitorType.NoCompetitor.name :
                                  row.competitorConditionToPriceStringPre === competitiorCondition.TopRank.value ? competitiorCondition.TopRank.name :
                                    row.competitorConditionToPriceStringPre === competitiorCondition.LowerRank.value ? competitiorCondition.LowerRank.name :
                                      row.competitorConditionToPriceStringPre
                              }</Text>
                              <NumberInput
                                width={DOWNSIDE_INDEX_NUMBER_INPUT_WIDTH}
                                min={DOWNSIDE_INDEX_MIN}
                                max={DOWNSIDE_INDEX_MAX}
                                precision={1}
                                step={0.1}
                                value={row?.competitorConditionToPrice}
                                clampValueOnBlur={false}
                                onFocus={(e) => {
                                  focusedValueRef.current = Number(e.target.value);
                                }}
                                onChange={(value) => {
                                  if (!isNaN(Number(value))) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", Number(value), false);
                                  }
                                }}
                                onBlur={(e) => {
                                  const val = Number(e.target.value);
                                  // 元の値と同じなら処理を終了する（-0とfocusedValueRefの比較を先に行うことで、値未変更時の早期returnを正しく機能させる）。
                                  if (val === focusedValueRef.current) return;
                                  if (val === -0) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", 0);
                                  } else if (val > DOWNSIDE_INDEX_MAX) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", DOWNSIDE_INDEX_MAX);
                                  } else if (val < DOWNSIDE_INDEX_MIN) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", DOWNSIDE_INDEX_MIN);
                                  } else if (!isNaN(val)) {
                                    updateDownsideIndexTableValue(row.yearString, "competitorConditionToPrice", val);
                                  }
                                }}
                              >
                                <NumberInputField
                                  textAlign="right"
                                  onKeyDown={handleKeyDown(row, "competitorConditionToPrice")}
                                />
                                <NumberInputStepper>
                                  <NumberIncrementStepper />
                                  <NumberDecrementStepper />
                                </NumberInputStepper>
                              </NumberInput>
                              <Text>%</Text>
                            </HStack>
                          </div>
                        </Td>
                      </tr>
                    })
                  }
                </Tbody>
              </Table>

            </Box>
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button colorScheme="gray" mr={3} isDisabled={!pagePermissions?.isEditable} onClick={() => { resetStressIndex(); }}>
                {t('common.button.reset')}
              </Button>
              <Button colorScheme="gray" mr={3} isDisabled={!pagePermissions?.isEditable} onClick={(e) => handleSaveDownsideIndex(e)}>
                {t('common.button.save')}
              </Button>
              <Button colorScheme="gray" mr={3} onClick={() => { setIsOpenDownsideIndex(false) }}>
                {t('common.button.close')}
              </Button>
            </Box>
          </Box>
        </Draggable>
      )}

      {/* 確認モーダル */}
      < Modal isOpen={isOpenConfirmModal} onClose={onCloseConfirmModal} size="md" >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('features.InvestmentScreening.SimulationProductivityImprovement.modal.confirmTitle', { title: TITLE })}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{t('features.InvestmentScreening.SimulationProductivityImprovement.modal.confirmMessage')}</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} isDisabled={isSaving} isLoading={isSaving} onClick={(e) => handleConfirm(e)}>
              {t('common.button.save')}
            </Button>
            <Button variant="ghost" onClick={onCloseConfirmModal}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >
    </Box>
  );
};

export default SimulationProductivityImprovement;